/* eslint-disable */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT
// Regenerate the file by running 'yarn compile:ajv'
'use strict';
import { fullFormats } from 'ajv-formats/dist/formats';
const formatWrapper = { ...fullFormats };
function ucs2length(str) {
    const len = str.length;
    let length = 0;
    let pos = 0;
    let value;
    while (pos < len) {
        length++;
        value = str.charCodeAt(pos++);
        if (value >= 0xd800 && value <= 0xdbff && pos < len) {
            value = str.charCodeAt(pos);
            if ((value & 0xfc00) === 0xdc00)
                pos++;
        }
    }
    return length;
}
function ajvEqual(a, b) {
    if (a === b)
        return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor)
            return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length)
                return false;
            for (i = length; i-- !== 0;)
                if (!ajvEqual(a[i], b[i]))
                    return false;
            return true;
        }
        if (a.constructor === RegExp)
            return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf)
            return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString)
            return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length)
            return false;
        for (i = length; i-- !== 0;)
            if (!Object.prototype.hasOwnProperty.call(b, keys[i]))
                return false;
        for (i = length; i-- !== 0;) {
            var key = keys[i];
            if (!ajvEqual(a[key], b[key]))
                return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function padString(input) {
    var segmentLength = 4;
    var stringLength = input.length;
    var diff = stringLength % segmentLength;
    if (!diff) {
        return input;
    }
    var position = stringLength;
    var padLength = segmentLength - diff;
    var paddedStringLength = stringLength + padLength;
    var buffer = Buffer.alloc(paddedStringLength);
    buffer.write(input);
    while (padLength--) {
        buffer.write('=', position++);
    }
    return buffer.toString();
}
function toBase64(base64url) {
    base64url = base64url.toString();
    return padString(base64url).replace(/\-/g, '+').replace(/_/g, '/');
}
function base64urlToBuffer(base64url) {
    return Buffer.from(toBase64(base64url), 'base64');
}
function fromBase64(base64) {
    return base64.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
function base64urlEncode(input, encoding) {
    if (encoding === void 0) {
        encoding = 'utf8';
    }
    if (Buffer.isBuffer(input)) {
        return fromBase64(input.toString('base64'));
    }
    return fromBase64(Buffer.from(input, encoding).toString('base64'));
}
export const agentSyncImportConfigSchemaValidation = validate12;
const schema29 = {
    $id: 'urn:wisepipe-common-data:AgentSyncImportConfig',
    type: 'object',
    properties: {},
    required: []
};
function validate12(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:AgentSyncImportConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate12.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate12.errors = vErrors;
    return errors === 0;
}
export const amazonAuroraImportConfigSchemaValidation = validate13;
const schema30 = {
    $id: 'urn:wisepipe-common-data:AmazonAuroraImportConfig',
    type: 'object',
    properties: {
        engineType: { type: 'string', enum: ['mySql', 'msSql', 'postgreSql'] },
        host: { type: 'string', minLength: 1 },
        port: { type: 'number', minimum: 0 },
        user: { type: 'string', minLength: 1 },
        password: { type: 'string', minLength: 1 },
        database: { type: 'string', minLength: 1 }
    },
    required: []
};
const func2 = ucs2length;
function validate13(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:AmazonAuroraImportConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.engineType !== undefined) {
                let data0 = data.engineType;
                const _errs1 = errors;
                if (typeof data0 !== 'string') {
                    validate13.errors = [
                        {
                            instancePath: instancePath + '/engineType',
                            schemaPath: '#/properties/engineType/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string'
                        }
                    ];
                    return false;
                }
                if (!(data0 === 'mySql' || data0 === 'msSql' || data0 === 'postgreSql')) {
                    validate13.errors = [
                        {
                            instancePath: instancePath + '/engineType',
                            schemaPath: '#/properties/engineType/enum',
                            keyword: 'enum',
                            params: { allowedValues: schema30.properties.engineType.enum },
                            message: 'must be equal to one of the allowed values'
                        }
                    ];
                    return false;
                }
                var valid0 = _errs1 === errors;
            }
            else {
                var valid0 = true;
            }
            if (valid0) {
                if (data.host !== undefined) {
                    let data1 = data.host;
                    const _errs3 = errors;
                    if (errors === _errs3) {
                        if (typeof data1 === 'string') {
                            if (func2(data1) < 1) {
                                validate13.errors = [
                                    {
                                        instancePath: instancePath + '/host',
                                        schemaPath: '#/properties/host/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate13.errors = [
                                {
                                    instancePath: instancePath + '/host',
                                    schemaPath: '#/properties/host/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs3 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.port !== undefined) {
                        let data2 = data.port;
                        const _errs5 = errors;
                        if (errors === _errs5) {
                            if (typeof data2 == 'number') {
                                if (data2 < 0 || isNaN(data2)) {
                                    validate13.errors = [
                                        {
                                            instancePath: instancePath + '/port',
                                            schemaPath: '#/properties/port/minimum',
                                            keyword: 'minimum',
                                            params: { comparison: '>=', limit: 0 },
                                            message: 'must be >= 0'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate13.errors = [
                                    {
                                        instancePath: instancePath + '/port',
                                        schemaPath: '#/properties/port/type',
                                        keyword: 'type',
                                        params: { type: 'number' },
                                        message: 'must be number'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.user !== undefined) {
                            let data3 = data.user;
                            const _errs7 = errors;
                            if (errors === _errs7) {
                                if (typeof data3 === 'string') {
                                    if (func2(data3) < 1) {
                                        validate13.errors = [
                                            {
                                                instancePath: instancePath + '/user',
                                                schemaPath: '#/properties/user/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate13.errors = [
                                        {
                                            instancePath: instancePath + '/user',
                                            schemaPath: '#/properties/user/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs7 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.password !== undefined) {
                                let data4 = data.password;
                                const _errs9 = errors;
                                if (errors === _errs9) {
                                    if (typeof data4 === 'string') {
                                        if (func2(data4) < 1) {
                                            validate13.errors = [
                                                {
                                                    instancePath: instancePath + '/password',
                                                    schemaPath: '#/properties/password/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate13.errors = [
                                            {
                                                instancePath: instancePath + '/password',
                                                schemaPath: '#/properties/password/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs9 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.database !== undefined) {
                                    let data5 = data.database;
                                    const _errs11 = errors;
                                    if (errors === _errs11) {
                                        if (typeof data5 === 'string') {
                                            if (func2(data5) < 1) {
                                                validate13.errors = [
                                                    {
                                                        instancePath: instancePath + '/database',
                                                        schemaPath: '#/properties/database/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate13.errors = [
                                                {
                                                    instancePath: instancePath + '/database',
                                                    schemaPath: '#/properties/database/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs11 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate13.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate13.errors = vErrors;
    return errors === 0;
}
export const amazonRedshiftImportConfigSchemaValidation = validate14;
const schema31 = {
    $id: 'urn:wisepipe-common-data:AmazonRedshiftImportConfig',
    type: 'object',
    properties: {
        host: { type: 'string', minLength: 1 },
        port: { type: 'number', minimum: 0 },
        user: { type: 'string', minLength: 1 },
        password: { type: 'string', minLength: 1 },
        database: { type: 'string', minLength: 1 },
        startDate: { type: 'string', format: 'date-time' }
    },
    required: []
};
const formats0 = formatWrapper['date-time'];
function validate14(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:AmazonRedshiftImportConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.host !== undefined) {
                let data0 = data.host;
                const _errs1 = errors;
                if (errors === _errs1) {
                    if (typeof data0 === 'string') {
                        if (func2(data0) < 1) {
                            validate14.errors = [
                                {
                                    instancePath: instancePath + '/host',
                                    schemaPath: '#/properties/host/minLength',
                                    keyword: 'minLength',
                                    params: { limit: 1 },
                                    message: 'must NOT have fewer than 1 characters'
                                }
                            ];
                            return false;
                        }
                    }
                    else {
                        validate14.errors = [
                            {
                                instancePath: instancePath + '/host',
                                schemaPath: '#/properties/host/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                }
                var valid0 = _errs1 === errors;
            }
            else {
                var valid0 = true;
            }
            if (valid0) {
                if (data.port !== undefined) {
                    let data1 = data.port;
                    const _errs3 = errors;
                    if (errors === _errs3) {
                        if (typeof data1 == 'number') {
                            if (data1 < 0 || isNaN(data1)) {
                                validate14.errors = [
                                    {
                                        instancePath: instancePath + '/port',
                                        schemaPath: '#/properties/port/minimum',
                                        keyword: 'minimum',
                                        params: { comparison: '>=', limit: 0 },
                                        message: 'must be >= 0'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate14.errors = [
                                {
                                    instancePath: instancePath + '/port',
                                    schemaPath: '#/properties/port/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs3 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.user !== undefined) {
                        let data2 = data.user;
                        const _errs5 = errors;
                        if (errors === _errs5) {
                            if (typeof data2 === 'string') {
                                if (func2(data2) < 1) {
                                    validate14.errors = [
                                        {
                                            instancePath: instancePath + '/user',
                                            schemaPath: '#/properties/user/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate14.errors = [
                                    {
                                        instancePath: instancePath + '/user',
                                        schemaPath: '#/properties/user/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.password !== undefined) {
                            let data3 = data.password;
                            const _errs7 = errors;
                            if (errors === _errs7) {
                                if (typeof data3 === 'string') {
                                    if (func2(data3) < 1) {
                                        validate14.errors = [
                                            {
                                                instancePath: instancePath + '/password',
                                                schemaPath: '#/properties/password/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate14.errors = [
                                        {
                                            instancePath: instancePath + '/password',
                                            schemaPath: '#/properties/password/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs7 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.database !== undefined) {
                                let data4 = data.database;
                                const _errs9 = errors;
                                if (errors === _errs9) {
                                    if (typeof data4 === 'string') {
                                        if (func2(data4) < 1) {
                                            validate14.errors = [
                                                {
                                                    instancePath: instancePath + '/database',
                                                    schemaPath: '#/properties/database/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate14.errors = [
                                            {
                                                instancePath: instancePath + '/database',
                                                schemaPath: '#/properties/database/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs9 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.startDate !== undefined) {
                                    let data5 = data.startDate;
                                    const _errs11 = errors;
                                    if (errors === _errs11) {
                                        if (errors === _errs11) {
                                            if (typeof data5 === 'string') {
                                                if (!formats0.validate(data5)) {
                                                    validate14.errors = [
                                                        {
                                                            instancePath: instancePath + '/startDate',
                                                            schemaPath: '#/properties/startDate/format',
                                                            keyword: 'format',
                                                            params: { format: 'date-time' },
                                                            message: 'must match format "' + 'date-time' + '"'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate14.errors = [
                                                    {
                                                        instancePath: instancePath + '/startDate',
                                                        schemaPath: '#/properties/startDate/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                    var valid0 = _errs11 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate14.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate14.errors = vErrors;
    return errors === 0;
}
export const amazonS3ImportConfigSchemaValidation = validate15;
const schema32 = {
    $id: 'urn:wisepipe-common-data:AmazonS3ImportConfig',
    type: 'object',
    properties: {
        filename: { type: 'string', minLength: 1 },
        delimiter: { type: 'string', minLength: 1, maxLength: 1 },
        quotechar: { type: 'string', minLength: 1, maxLength: 1 },
        filetype: { type: 'string', enum: ['.csv', '.xlsx|.xls', '.txt'] },
        prefix: { type: 'string' },
        hasHeader: { type: 'boolean' },
        dataPreprocessConfig: { $ref: 'urn:wisepipe-common-data:DataPreprocessConfig' }
    },
    if: { properties: { filetype: { enum: ['.csv', '.txt'] } }, required: ['filetype'] },
    then: { required: ['delimiter'] },
    required: ['filename', 'filetype']
};
const schema33 = {
    $id: 'urn:wisepipe-common-data:DataPreprocessConfig',
    type: 'object',
    properties: {
        skipHeaderRow: { type: 'number', minimum: 0, maximum: 100 },
        skipFooterRow: { type: 'number', minimum: 0, maximum: 100 }
    },
    required: ['skipHeaderRow', 'skipFooterRow']
};
function validate15(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:AmazonS3ImportConfig" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        let missing0;
        if (data.filetype === undefined && (missing0 = 'filetype')) {
            const err0 = {};
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
        else {
            if (data.filetype !== undefined) {
                let data0 = data.filetype;
                if (!(data0 === '.csv' || data0 === '.txt')) {
                    const err1 = {};
                    if (vErrors === null) {
                        vErrors = [err1];
                    }
                    else {
                        vErrors.push(err1);
                    }
                    errors++;
                }
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs4 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if (data.delimiter === undefined && (missing1 = 'delimiter')) {
                validate15.errors = [
                    {
                        instancePath,
                        schemaPath: '#/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs4 === errors;
        valid0 = _valid0;
    }
    if (!valid0) {
        const err2 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err2];
        }
        else {
            vErrors.push(err2);
        }
        errors++;
        validate15.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing2;
            if ((data.filename === undefined && (missing2 = 'filename')) ||
                (data.filetype === undefined && (missing2 = 'filetype'))) {
                validate15.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing2 },
                        message: "must have required property '" + missing2 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.filename !== undefined) {
                    let data1 = data.filename;
                    const _errs5 = errors;
                    if (errors === _errs5) {
                        if (typeof data1 === 'string') {
                            if (func2(data1) < 1) {
                                validate15.errors = [
                                    {
                                        instancePath: instancePath + '/filename',
                                        schemaPath: '#/properties/filename/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate15.errors = [
                                {
                                    instancePath: instancePath + '/filename',
                                    schemaPath: '#/properties/filename/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid2 = _errs5 === errors;
                }
                else {
                    var valid2 = true;
                }
                if (valid2) {
                    if (data.delimiter !== undefined) {
                        let data2 = data.delimiter;
                        const _errs7 = errors;
                        if (errors === _errs7) {
                            if (typeof data2 === 'string') {
                                if (func2(data2) > 1) {
                                    validate15.errors = [
                                        {
                                            instancePath: instancePath + '/delimiter',
                                            schemaPath: '#/properties/delimiter/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have more than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (func2(data2) < 1) {
                                        validate15.errors = [
                                            {
                                                instancePath: instancePath + '/delimiter',
                                                schemaPath: '#/properties/delimiter/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate15.errors = [
                                    {
                                        instancePath: instancePath + '/delimiter',
                                        schemaPath: '#/properties/delimiter/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid2 = _errs7 === errors;
                    }
                    else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.quotechar !== undefined) {
                            let data3 = data.quotechar;
                            const _errs9 = errors;
                            if (errors === _errs9) {
                                if (typeof data3 === 'string') {
                                    if (func2(data3) > 1) {
                                        validate15.errors = [
                                            {
                                                instancePath: instancePath + '/quotechar',
                                                schemaPath: '#/properties/quotechar/maxLength',
                                                keyword: 'maxLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have more than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        if (func2(data3) < 1) {
                                            validate15.errors = [
                                                {
                                                    instancePath: instancePath + '/quotechar',
                                                    schemaPath: '#/properties/quotechar/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                else {
                                    validate15.errors = [
                                        {
                                            instancePath: instancePath + '/quotechar',
                                            schemaPath: '#/properties/quotechar/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid2 = _errs9 === errors;
                        }
                        else {
                            var valid2 = true;
                        }
                        if (valid2) {
                            if (data.filetype !== undefined) {
                                let data4 = data.filetype;
                                const _errs11 = errors;
                                if (typeof data4 !== 'string') {
                                    validate15.errors = [
                                        {
                                            instancePath: instancePath + '/filetype',
                                            schemaPath: '#/properties/filetype/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                if (!(data4 === '.csv' || data4 === '.xlsx|.xls' || data4 === '.txt')) {
                                    validate15.errors = [
                                        {
                                            instancePath: instancePath + '/filetype',
                                            schemaPath: '#/properties/filetype/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema32.properties.filetype.enum },
                                            message: 'must be equal to one of the allowed values'
                                        }
                                    ];
                                    return false;
                                }
                                var valid2 = _errs11 === errors;
                            }
                            else {
                                var valid2 = true;
                            }
                            if (valid2) {
                                if (data.prefix !== undefined) {
                                    const _errs13 = errors;
                                    if (typeof data.prefix !== 'string') {
                                        validate15.errors = [
                                            {
                                                instancePath: instancePath + '/prefix',
                                                schemaPath: '#/properties/prefix/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid2 = _errs13 === errors;
                                }
                                else {
                                    var valid2 = true;
                                }
                                if (valid2) {
                                    if (data.hasHeader !== undefined) {
                                        const _errs15 = errors;
                                        if (typeof data.hasHeader !== 'boolean') {
                                            validate15.errors = [
                                                {
                                                    instancePath: instancePath + '/hasHeader',
                                                    schemaPath: '#/properties/hasHeader/type',
                                                    keyword: 'type',
                                                    params: { type: 'boolean' },
                                                    message: 'must be boolean'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid2 = _errs15 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                    if (valid2) {
                                        if (data.dataPreprocessConfig !== undefined) {
                                            let data7 = data.dataPreprocessConfig;
                                            const _errs17 = errors;
                                            const _errs18 = errors;
                                            if (errors === _errs18) {
                                                if (data7 && typeof data7 == 'object' && !Array.isArray(data7)) {
                                                    let missing3;
                                                    if ((data7.skipHeaderRow === undefined && (missing3 = 'skipHeaderRow')) ||
                                                        (data7.skipFooterRow === undefined && (missing3 = 'skipFooterRow'))) {
                                                        validate15.errors = [
                                                            {
                                                                instancePath: instancePath + '/dataPreprocessConfig',
                                                                schemaPath: 'urn:wisepipe-common-data:DataPreprocessConfig/required',
                                                                keyword: 'required',
                                                                params: { missingProperty: missing3 },
                                                                message: "must have required property '" + missing3 + "'"
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        if (data7.skipHeaderRow !== undefined) {
                                                            let data8 = data7.skipHeaderRow;
                                                            const _errs20 = errors;
                                                            if (errors === _errs20) {
                                                                if (typeof data8 == 'number') {
                                                                    if (data8 > 100 || isNaN(data8)) {
                                                                        validate15.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/dataPreprocessConfig/skipHeaderRow',
                                                                                schemaPath: 'urn:wisepipe-common-data:DataPreprocessConfig/properties/skipHeaderRow/maximum',
                                                                                keyword: 'maximum',
                                                                                params: { comparison: '<=', limit: 100 },
                                                                                message: 'must be <= 100'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    else {
                                                                        if (data8 < 0 || isNaN(data8)) {
                                                                            validate15.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/dataPreprocessConfig/skipHeaderRow',
                                                                                    schemaPath: 'urn:wisepipe-common-data:DataPreprocessConfig/properties/skipHeaderRow/minimum',
                                                                                    keyword: 'minimum',
                                                                                    params: { comparison: '>=', limit: 0 },
                                                                                    message: 'must be >= 0'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                }
                                                                else {
                                                                    validate15.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/dataPreprocessConfig/skipHeaderRow',
                                                                            schemaPath: 'urn:wisepipe-common-data:DataPreprocessConfig/properties/skipHeaderRow/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'number' },
                                                                            message: 'must be number'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid4 = _errs20 === errors;
                                                        }
                                                        else {
                                                            var valid4 = true;
                                                        }
                                                        if (valid4) {
                                                            if (data7.skipFooterRow !== undefined) {
                                                                let data9 = data7.skipFooterRow;
                                                                const _errs22 = errors;
                                                                if (errors === _errs22) {
                                                                    if (typeof data9 == 'number') {
                                                                        if (data9 > 100 || isNaN(data9)) {
                                                                            validate15.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/dataPreprocessConfig/skipFooterRow',
                                                                                    schemaPath: 'urn:wisepipe-common-data:DataPreprocessConfig/properties/skipFooterRow/maximum',
                                                                                    keyword: 'maximum',
                                                                                    params: { comparison: '<=', limit: 100 },
                                                                                    message: 'must be <= 100'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        else {
                                                                            if (data9 < 0 || isNaN(data9)) {
                                                                                validate15.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/dataPreprocessConfig/skipFooterRow',
                                                                                        schemaPath: 'urn:wisepipe-common-data:DataPreprocessConfig/properties/skipFooterRow/minimum',
                                                                                        keyword: 'minimum',
                                                                                        params: { comparison: '>=', limit: 0 },
                                                                                        message: 'must be >= 0'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate15.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/dataPreprocessConfig/skipFooterRow',
                                                                                schemaPath: 'urn:wisepipe-common-data:DataPreprocessConfig/properties/skipFooterRow/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'number' },
                                                                                message: 'must be number'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                var valid4 = _errs22 === errors;
                                                            }
                                                            else {
                                                                var valid4 = true;
                                                            }
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate15.errors = [
                                                        {
                                                            instancePath: instancePath + '/dataPreprocessConfig',
                                                            schemaPath: 'urn:wisepipe-common-data:DataPreprocessConfig/type',
                                                            keyword: 'type',
                                                            params: { type: 'object' },
                                                            message: 'must be object'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid2 = _errs17 === errors;
                                        }
                                        else {
                                            var valid2 = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate15.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate15.errors = vErrors;
    return errors === 0;
}
export const awsCredentialsSchemaValidation = validate16;
const schema34 = {
    $id: 'urn:wisepipe-common-auth:AwsCredentials',
    type: 'object',
    properties: {
        identityID: { type: 'string', pattern: '[\\w-]+:[0-9a-f-]+' },
        accessKeyID: { type: 'string', minLength: 1, pattern: '[\\w]+' },
        secretKey: { type: 'string', minLength: 1 },
        sessionToken: { type: 'string', minLength: 1 },
        expiration: { type: 'string', format: 'date-time' },
        region: { type: 'string' }
    },
    required: ['identityID', 'accessKeyID', 'secretKey', 'sessionToken', 'expiration', 'region']
};
const pattern0 = new RegExp('[\\w-]+:[0-9a-f-]+', 'u');
const pattern1 = new RegExp('[\\w]+', 'u');
function validate16(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-auth:AwsCredentials" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.identityID === undefined && (missing0 = 'identityID')) ||
                (data.accessKeyID === undefined && (missing0 = 'accessKeyID')) ||
                (data.secretKey === undefined && (missing0 = 'secretKey')) ||
                (data.sessionToken === undefined && (missing0 = 'sessionToken')) ||
                (data.expiration === undefined && (missing0 = 'expiration')) ||
                (data.region === undefined && (missing0 = 'region'))) {
                validate16.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.identityID !== undefined) {
                    let data0 = data.identityID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (!pattern0.test(data0)) {
                                validate16.errors = [
                                    {
                                        instancePath: instancePath + '/identityID',
                                        schemaPath: '#/properties/identityID/pattern',
                                        keyword: 'pattern',
                                        params: { pattern: '[\\w-]+:[0-9a-f-]+' },
                                        message: 'must match pattern "' + '[\\w-]+:[0-9a-f-]+' + '"'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate16.errors = [
                                {
                                    instancePath: instancePath + '/identityID',
                                    schemaPath: '#/properties/identityID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.accessKeyID !== undefined) {
                        let data1 = data.accessKeyID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate16.errors = [
                                        {
                                            instancePath: instancePath + '/accessKeyID',
                                            schemaPath: '#/properties/accessKeyID/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (!pattern1.test(data1)) {
                                        validate16.errors = [
                                            {
                                                instancePath: instancePath + '/accessKeyID',
                                                schemaPath: '#/properties/accessKeyID/pattern',
                                                keyword: 'pattern',
                                                params: { pattern: '[\\w]+' },
                                                message: 'must match pattern "' + '[\\w]+' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate16.errors = [
                                    {
                                        instancePath: instancePath + '/accessKeyID',
                                        schemaPath: '#/properties/accessKeyID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.secretKey !== undefined) {
                            let data2 = data.secretKey;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate16.errors = [
                                            {
                                                instancePath: instancePath + '/secretKey',
                                                schemaPath: '#/properties/secretKey/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate16.errors = [
                                        {
                                            instancePath: instancePath + '/secretKey',
                                            schemaPath: '#/properties/secretKey/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.sessionToken !== undefined) {
                                let data3 = data.sessionToken;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 === 'string') {
                                        if (func2(data3) < 1) {
                                            validate16.errors = [
                                                {
                                                    instancePath: instancePath + '/sessionToken',
                                                    schemaPath: '#/properties/sessionToken/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate16.errors = [
                                            {
                                                instancePath: instancePath + '/sessionToken',
                                                schemaPath: '#/properties/sessionToken/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.expiration !== undefined) {
                                    let data4 = data.expiration;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (errors === _errs9) {
                                            if (typeof data4 === 'string') {
                                                if (!formats0.validate(data4)) {
                                                    validate16.errors = [
                                                        {
                                                            instancePath: instancePath + '/expiration',
                                                            schemaPath: '#/properties/expiration/format',
                                                            keyword: 'format',
                                                            params: { format: 'date-time' },
                                                            message: 'must match format "' + 'date-time' + '"'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate16.errors = [
                                                    {
                                                        instancePath: instancePath + '/expiration',
                                                        schemaPath: '#/properties/expiration/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.region !== undefined) {
                                        const _errs11 = errors;
                                        if (typeof data.region !== 'string') {
                                            validate16.errors = [
                                                {
                                                    instancePath: instancePath + '/region',
                                                    schemaPath: '#/properties/region/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate16.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate16.errors = vErrors;
    return errors === 0;
}
export const columnSchemaValidation = validate17;
const schema35 = {
    $id: 'urn:wisepipe-common-data:Column',
    type: 'object',
    properties: {
        name: { type: 'string', minLength: 1, maxLength: 150 },
        type: { type: 'string', pattern: 'number|date|string|boolean|decimal|period' },
        metadata: {
            type: 'object',
            oneOf: [
                {
                    if: { properties: { type: { const: 'period' } } },
                    then: { $ref: 'urn:wisepipe-common-data:PeriodColumnMetadata' }
                },
                {
                    if: { properties: { type: { const: 'string' } } },
                    then: { $ref: 'urn:wisepipe-common-data:PicklistColumnMetadata' }
                }
            ]
        },
        isPrimaryKey: { type: 'boolean' }
    },
    required: ['name', 'type'],
    allOf: [
        {
            if: { properties: { type: { const: 'period' } } },
            then: {
                required: ['metadata'],
                properties: { metadata: { $ref: 'urn:wisepipe-common-data:PeriodColumnMetadata' } }
            }
        },
        {
            if: { properties: { type: { const: 'string' } } },
            then: { properties: { metadata: { $ref: 'urn:wisepipe-common-data:PicklistColumnMetadata' } } }
        },
        {
            if: { properties: { type: { enum: ['boolean', 'number', 'decimal', 'date'] } } },
            then: { not: { required: ['metadata'] } }
        }
    ]
};
const schema36 = {
    $id: 'urn:wisepipe-common-data:PeriodColumnMetadata',
    type: 'object',
    properties: { calendarID: { type: 'string', minLength: 1 }, level: { type: 'string', minLength: 1 } },
    required: ['calendarID', 'level']
};
const schema37 = {
    $id: 'urn:wisepipe-common-data:PicklistColumnMetadata',
    type: 'object',
    properties: { table: { type: 'string', minLength: 1 }, column: { type: 'string', minLength: 1 } },
    required: ['table', 'column']
};
const pattern2 = new RegExp('number|date|string|boolean|decimal|period', 'u');
function validate17(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:Column" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    const _errs2 = errors;
    let valid1 = true;
    const _errs3 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.type !== undefined) {
            if ('period' !== data.type) {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var _valid0 = _errs3 === errors;
    errors = _errs2;
    if (vErrors !== null) {
        if (_errs2) {
            vErrors.length = _errs2;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs5 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.metadata === undefined && (missing0 = 'metadata')) {
                validate17.errors = [
                    {
                        instancePath,
                        schemaPath: '#/allOf/0/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.metadata !== undefined) {
                    let data1 = data.metadata;
                    const _errs7 = errors;
                    if (errors === _errs7) {
                        if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                            let missing1;
                            if ((data1.calendarID === undefined && (missing1 = 'calendarID')) ||
                                (data1.level === undefined && (missing1 = 'level'))) {
                                validate17.errors = [
                                    {
                                        instancePath: instancePath + '/metadata',
                                        schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing1 },
                                        message: "must have required property '" + missing1 + "'"
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data1.calendarID !== undefined) {
                                    let data2 = data1.calendarID;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (typeof data2 === 'string') {
                                            if (func2(data2) < 1) {
                                                validate17.errors = [
                                                    {
                                                        instancePath: instancePath + '/metadata/calendarID',
                                                        schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/properties/calendarID/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate17.errors = [
                                                {
                                                    instancePath: instancePath + '/metadata/calendarID',
                                                    schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/properties/calendarID/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid5 = _errs9 === errors;
                                }
                                else {
                                    var valid5 = true;
                                }
                                if (valid5) {
                                    if (data1.level !== undefined) {
                                        let data3 = data1.level;
                                        const _errs11 = errors;
                                        if (errors === _errs11) {
                                            if (typeof data3 === 'string') {
                                                if (func2(data3) < 1) {
                                                    validate17.errors = [
                                                        {
                                                            instancePath: instancePath + '/metadata/level',
                                                            schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/properties/level/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate17.errors = [
                                                    {
                                                        instancePath: instancePath + '/metadata/level',
                                                        schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/properties/level/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid5 = _errs11 === errors;
                                    }
                                    else {
                                        var valid5 = true;
                                    }
                                }
                            }
                        }
                        else {
                            validate17.errors = [
                                {
                                    instancePath: instancePath + '/metadata',
                                    schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        var _valid0 = _errs5 === errors;
        valid1 = _valid0;
    }
    if (!valid1) {
        const err1 = {
            instancePath,
            schemaPath: '#/allOf/0/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
        validate17.errors = vErrors;
        return false;
    }
    var valid0 = _errs1 === errors;
    if (valid0) {
        const _errs13 = errors;
        const _errs14 = errors;
        let valid6 = true;
        const _errs15 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.type !== undefined) {
                if ('string' !== data.type) {
                    const err2 = {};
                    if (vErrors === null) {
                        vErrors = [err2];
                    }
                    else {
                        vErrors.push(err2);
                    }
                    errors++;
                }
            }
        }
        var _valid1 = _errs15 === errors;
        errors = _errs14;
        if (vErrors !== null) {
            if (_errs14) {
                vErrors.length = _errs14;
            }
            else {
                vErrors = null;
            }
        }
        if (_valid1) {
            const _errs17 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                if (data.metadata !== undefined) {
                    let data5 = data.metadata;
                    const _errs19 = errors;
                    if (errors === _errs19) {
                        if (data5 && typeof data5 == 'object' && !Array.isArray(data5)) {
                            let missing2;
                            if ((data5.table === undefined && (missing2 = 'table')) ||
                                (data5.column === undefined && (missing2 = 'column'))) {
                                validate17.errors = [
                                    {
                                        instancePath: instancePath + '/metadata',
                                        schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing2 },
                                        message: "must have required property '" + missing2 + "'"
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data5.table !== undefined) {
                                    let data6 = data5.table;
                                    const _errs21 = errors;
                                    if (errors === _errs21) {
                                        if (typeof data6 === 'string') {
                                            if (func2(data6) < 1) {
                                                validate17.errors = [
                                                    {
                                                        instancePath: instancePath + '/metadata/table',
                                                        schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/properties/table/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate17.errors = [
                                                {
                                                    instancePath: instancePath + '/metadata/table',
                                                    schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/properties/table/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid10 = _errs21 === errors;
                                }
                                else {
                                    var valid10 = true;
                                }
                                if (valid10) {
                                    if (data5.column !== undefined) {
                                        let data7 = data5.column;
                                        const _errs23 = errors;
                                        if (errors === _errs23) {
                                            if (typeof data7 === 'string') {
                                                if (func2(data7) < 1) {
                                                    validate17.errors = [
                                                        {
                                                            instancePath: instancePath + '/metadata/column',
                                                            schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/properties/column/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate17.errors = [
                                                    {
                                                        instancePath: instancePath + '/metadata/column',
                                                        schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/properties/column/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid10 = _errs23 === errors;
                                    }
                                    else {
                                        var valid10 = true;
                                    }
                                }
                            }
                        }
                        else {
                            validate17.errors = [
                                {
                                    instancePath: instancePath + '/metadata',
                                    schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
            var _valid1 = _errs17 === errors;
            valid6 = _valid1;
        }
        if (!valid6) {
            const err3 = {
                instancePath,
                schemaPath: '#/allOf/1/if',
                keyword: 'if',
                params: { failingKeyword: 'then' },
                message: 'must match "then" schema'
            };
            if (vErrors === null) {
                vErrors = [err3];
            }
            else {
                vErrors.push(err3);
            }
            errors++;
            validate17.errors = vErrors;
            return false;
        }
        var valid0 = _errs13 === errors;
        if (valid0) {
            const _errs25 = errors;
            const _errs26 = errors;
            let valid11 = true;
            const _errs27 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                if (data.type !== undefined) {
                    let data8 = data.type;
                    if (!(data8 === 'boolean' || data8 === 'number' || data8 === 'decimal' || data8 === 'date')) {
                        const err4 = {};
                        if (vErrors === null) {
                            vErrors = [err4];
                        }
                        else {
                            vErrors.push(err4);
                        }
                        errors++;
                    }
                }
            }
            var _valid2 = _errs27 === errors;
            errors = _errs26;
            if (vErrors !== null) {
                if (_errs26) {
                    vErrors.length = _errs26;
                }
                else {
                    vErrors = null;
                }
            }
            if (_valid2) {
                const _errs29 = errors;
                const _errs30 = errors;
                const _errs31 = errors;
                if (data && typeof data == 'object' && !Array.isArray(data)) {
                    let missing3;
                    if (data.metadata === undefined && (missing3 = 'metadata')) {
                        const err5 = {};
                        if (vErrors === null) {
                            vErrors = [err5];
                        }
                        else {
                            vErrors.push(err5);
                        }
                        errors++;
                    }
                }
                var valid13 = _errs31 === errors;
                if (valid13) {
                    validate17.errors = [
                        { instancePath, schemaPath: '#/allOf/2/then/not', keyword: 'not', params: {}, message: 'must NOT be valid' }
                    ];
                    return false;
                }
                else {
                    errors = _errs30;
                    if (vErrors !== null) {
                        if (_errs30) {
                            vErrors.length = _errs30;
                        }
                        else {
                            vErrors = null;
                        }
                    }
                }
                var _valid2 = _errs29 === errors;
                valid11 = _valid2;
            }
            if (!valid11) {
                const err6 = {
                    instancePath,
                    schemaPath: '#/allOf/2/if',
                    keyword: 'if',
                    params: { failingKeyword: 'then' },
                    message: 'must match "then" schema'
                };
                if (vErrors === null) {
                    vErrors = [err6];
                }
                else {
                    vErrors.push(err6);
                }
                errors++;
                validate17.errors = vErrors;
                return false;
            }
            var valid0 = _errs25 === errors;
        }
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing4;
            if ((data.name === undefined && (missing4 = 'name')) || (data.type === undefined && (missing4 = 'type'))) {
                validate17.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing4 },
                        message: "must have required property '" + missing4 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.name !== undefined) {
                    let data9 = data.name;
                    const _errs32 = errors;
                    if (errors === _errs32) {
                        if (typeof data9 === 'string') {
                            if (func2(data9) > 150) {
                                validate17.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 150 },
                                        message: 'must NOT have more than 150 characters'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (func2(data9) < 1) {
                                    validate17.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate17.errors = [
                                {
                                    instancePath: instancePath + '/name',
                                    schemaPath: '#/properties/name/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid14 = _errs32 === errors;
                }
                else {
                    var valid14 = true;
                }
                if (valid14) {
                    if (data.type !== undefined) {
                        let data10 = data.type;
                        const _errs34 = errors;
                        if (errors === _errs34) {
                            if (typeof data10 === 'string') {
                                if (!pattern2.test(data10)) {
                                    validate17.errors = [
                                        {
                                            instancePath: instancePath + '/type',
                                            schemaPath: '#/properties/type/pattern',
                                            keyword: 'pattern',
                                            params: { pattern: 'number|date|string|boolean|decimal|period' },
                                            message: 'must match pattern "' + 'number|date|string|boolean|decimal|period' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate17.errors = [
                                    {
                                        instancePath: instancePath + '/type',
                                        schemaPath: '#/properties/type/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid14 = _errs34 === errors;
                    }
                    else {
                        var valid14 = true;
                    }
                    if (valid14) {
                        if (data.metadata !== undefined) {
                            let data11 = data.metadata;
                            const _errs36 = errors;
                            if (!(data11 && typeof data11 == 'object' && !Array.isArray(data11))) {
                                validate17.errors = [
                                    {
                                        instancePath: instancePath + '/metadata',
                                        schemaPath: '#/properties/metadata/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    }
                                ];
                                return false;
                            }
                            const _errs38 = errors;
                            let valid15 = false;
                            let passing0 = null;
                            const _errs39 = errors;
                            const _errs40 = errors;
                            let valid16 = true;
                            const _errs41 = errors;
                            if (data11 && typeof data11 == 'object' && !Array.isArray(data11)) {
                                if (data11.type !== undefined) {
                                    if ('period' !== data11.type) {
                                        const err7 = {};
                                        if (vErrors === null) {
                                            vErrors = [err7];
                                        }
                                        else {
                                            vErrors.push(err7);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            var _valid4 = _errs41 === errors;
                            errors = _errs40;
                            if (vErrors !== null) {
                                if (_errs40) {
                                    vErrors.length = _errs40;
                                }
                                else {
                                    vErrors = null;
                                }
                            }
                            if (_valid4) {
                                const _errs43 = errors;
                                const _errs44 = errors;
                                if (errors === _errs44) {
                                    if (data11 && typeof data11 == 'object' && !Array.isArray(data11)) {
                                        let missing5;
                                        if ((data11.calendarID === undefined && (missing5 = 'calendarID')) ||
                                            (data11.level === undefined && (missing5 = 'level'))) {
                                            const err8 = {
                                                instancePath: instancePath + '/metadata',
                                                schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/required',
                                                keyword: 'required',
                                                params: { missingProperty: missing5 },
                                                message: "must have required property '" + missing5 + "'"
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err8];
                                            }
                                            else {
                                                vErrors.push(err8);
                                            }
                                            errors++;
                                        }
                                        else {
                                            if (data11.calendarID !== undefined) {
                                                let data13 = data11.calendarID;
                                                const _errs46 = errors;
                                                if (errors === _errs46) {
                                                    if (typeof data13 === 'string') {
                                                        if (func2(data13) < 1) {
                                                            const err9 = {
                                                                instancePath: instancePath + '/metadata/calendarID',
                                                                schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/properties/calendarID/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            };
                                                            if (vErrors === null) {
                                                                vErrors = [err9];
                                                            }
                                                            else {
                                                                vErrors.push(err9);
                                                            }
                                                            errors++;
                                                        }
                                                    }
                                                    else {
                                                        const err10 = {
                                                            instancePath: instancePath + '/metadata/calendarID',
                                                            schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/properties/calendarID/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err10];
                                                        }
                                                        else {
                                                            vErrors.push(err10);
                                                        }
                                                        errors++;
                                                    }
                                                }
                                                var valid19 = _errs46 === errors;
                                            }
                                            else {
                                                var valid19 = true;
                                            }
                                            if (valid19) {
                                                if (data11.level !== undefined) {
                                                    let data14 = data11.level;
                                                    const _errs48 = errors;
                                                    if (errors === _errs48) {
                                                        if (typeof data14 === 'string') {
                                                            if (func2(data14) < 1) {
                                                                const err11 = {
                                                                    instancePath: instancePath + '/metadata/level',
                                                                    schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/properties/level/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                };
                                                                if (vErrors === null) {
                                                                    vErrors = [err11];
                                                                }
                                                                else {
                                                                    vErrors.push(err11);
                                                                }
                                                                errors++;
                                                            }
                                                        }
                                                        else {
                                                            const err12 = {
                                                                instancePath: instancePath + '/metadata/level',
                                                                schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/properties/level/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            };
                                                            if (vErrors === null) {
                                                                vErrors = [err12];
                                                            }
                                                            else {
                                                                vErrors.push(err12);
                                                            }
                                                            errors++;
                                                        }
                                                    }
                                                    var valid19 = _errs48 === errors;
                                                }
                                                else {
                                                    var valid19 = true;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        const err13 = {
                                            instancePath: instancePath + '/metadata',
                                            schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err13];
                                        }
                                        else {
                                            vErrors.push(err13);
                                        }
                                        errors++;
                                    }
                                }
                                var _valid4 = _errs43 === errors;
                                valid16 = _valid4;
                            }
                            if (!valid16) {
                                const err14 = {
                                    instancePath: instancePath + '/metadata',
                                    schemaPath: '#/properties/metadata/oneOf/0/if',
                                    keyword: 'if',
                                    params: { failingKeyword: 'then' },
                                    message: 'must match "then" schema'
                                };
                                if (vErrors === null) {
                                    vErrors = [err14];
                                }
                                else {
                                    vErrors.push(err14);
                                }
                                errors++;
                            }
                            var _valid3 = _errs39 === errors;
                            if (_valid3) {
                                valid15 = true;
                                passing0 = 0;
                            }
                            const _errs50 = errors;
                            const _errs51 = errors;
                            let valid20 = true;
                            const _errs52 = errors;
                            if (data11 && typeof data11 == 'object' && !Array.isArray(data11)) {
                                if (data11.type !== undefined) {
                                    if ('string' !== data11.type) {
                                        const err15 = {};
                                        if (vErrors === null) {
                                            vErrors = [err15];
                                        }
                                        else {
                                            vErrors.push(err15);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            var _valid5 = _errs52 === errors;
                            errors = _errs51;
                            if (vErrors !== null) {
                                if (_errs51) {
                                    vErrors.length = _errs51;
                                }
                                else {
                                    vErrors = null;
                                }
                            }
                            if (_valid5) {
                                const _errs54 = errors;
                                const _errs55 = errors;
                                if (errors === _errs55) {
                                    if (data11 && typeof data11 == 'object' && !Array.isArray(data11)) {
                                        let missing6;
                                        if ((data11.table === undefined && (missing6 = 'table')) ||
                                            (data11.column === undefined && (missing6 = 'column'))) {
                                            const err16 = {
                                                instancePath: instancePath + '/metadata',
                                                schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/required',
                                                keyword: 'required',
                                                params: { missingProperty: missing6 },
                                                message: "must have required property '" + missing6 + "'"
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err16];
                                            }
                                            else {
                                                vErrors.push(err16);
                                            }
                                            errors++;
                                        }
                                        else {
                                            if (data11.table !== undefined) {
                                                let data16 = data11.table;
                                                const _errs57 = errors;
                                                if (errors === _errs57) {
                                                    if (typeof data16 === 'string') {
                                                        if (func2(data16) < 1) {
                                                            const err17 = {
                                                                instancePath: instancePath + '/metadata/table',
                                                                schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/properties/table/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            };
                                                            if (vErrors === null) {
                                                                vErrors = [err17];
                                                            }
                                                            else {
                                                                vErrors.push(err17);
                                                            }
                                                            errors++;
                                                        }
                                                    }
                                                    else {
                                                        const err18 = {
                                                            instancePath: instancePath + '/metadata/table',
                                                            schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/properties/table/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err18];
                                                        }
                                                        else {
                                                            vErrors.push(err18);
                                                        }
                                                        errors++;
                                                    }
                                                }
                                                var valid23 = _errs57 === errors;
                                            }
                                            else {
                                                var valid23 = true;
                                            }
                                            if (valid23) {
                                                if (data11.column !== undefined) {
                                                    let data17 = data11.column;
                                                    const _errs59 = errors;
                                                    if (errors === _errs59) {
                                                        if (typeof data17 === 'string') {
                                                            if (func2(data17) < 1) {
                                                                const err19 = {
                                                                    instancePath: instancePath + '/metadata/column',
                                                                    schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/properties/column/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                };
                                                                if (vErrors === null) {
                                                                    vErrors = [err19];
                                                                }
                                                                else {
                                                                    vErrors.push(err19);
                                                                }
                                                                errors++;
                                                            }
                                                        }
                                                        else {
                                                            const err20 = {
                                                                instancePath: instancePath + '/metadata/column',
                                                                schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/properties/column/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            };
                                                            if (vErrors === null) {
                                                                vErrors = [err20];
                                                            }
                                                            else {
                                                                vErrors.push(err20);
                                                            }
                                                            errors++;
                                                        }
                                                    }
                                                    var valid23 = _errs59 === errors;
                                                }
                                                else {
                                                    var valid23 = true;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        const err21 = {
                                            instancePath: instancePath + '/metadata',
                                            schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err21];
                                        }
                                        else {
                                            vErrors.push(err21);
                                        }
                                        errors++;
                                    }
                                }
                                var _valid5 = _errs54 === errors;
                                valid20 = _valid5;
                            }
                            if (!valid20) {
                                const err22 = {
                                    instancePath: instancePath + '/metadata',
                                    schemaPath: '#/properties/metadata/oneOf/1/if',
                                    keyword: 'if',
                                    params: { failingKeyword: 'then' },
                                    message: 'must match "then" schema'
                                };
                                if (vErrors === null) {
                                    vErrors = [err22];
                                }
                                else {
                                    vErrors.push(err22);
                                }
                                errors++;
                            }
                            var _valid3 = _errs50 === errors;
                            if (_valid3 && valid15) {
                                valid15 = false;
                                passing0 = [passing0, 1];
                            }
                            else {
                                if (_valid3) {
                                    valid15 = true;
                                    passing0 = 1;
                                }
                            }
                            if (!valid15) {
                                const err23 = {
                                    instancePath: instancePath + '/metadata',
                                    schemaPath: '#/properties/metadata/oneOf',
                                    keyword: 'oneOf',
                                    params: { passingSchemas: passing0 },
                                    message: 'must match exactly one schema in oneOf'
                                };
                                if (vErrors === null) {
                                    vErrors = [err23];
                                }
                                else {
                                    vErrors.push(err23);
                                }
                                errors++;
                                validate17.errors = vErrors;
                                return false;
                            }
                            else {
                                errors = _errs38;
                                if (vErrors !== null) {
                                    if (_errs38) {
                                        vErrors.length = _errs38;
                                    }
                                    else {
                                        vErrors = null;
                                    }
                                }
                            }
                            var valid14 = _errs36 === errors;
                        }
                        else {
                            var valid14 = true;
                        }
                        if (valid14) {
                            if (data.isPrimaryKey !== undefined) {
                                const _errs61 = errors;
                                if (typeof data.isPrimaryKey !== 'boolean') {
                                    validate17.errors = [
                                        {
                                            instancePath: instancePath + '/isPrimaryKey',
                                            schemaPath: '#/properties/isPrimaryKey/type',
                                            keyword: 'type',
                                            params: { type: 'boolean' },
                                            message: 'must be boolean'
                                        }
                                    ];
                                    return false;
                                }
                                var valid14 = _errs61 === errors;
                            }
                            else {
                                var valid14 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate17.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate17.errors = vErrors;
    return errors === 0;
}
export const columnUpdateSchemaValidation = validate18;
const schema40 = {
    $id: 'urn:wisepipe-common-data:ColumnUpdate',
    type: 'object',
    properties: {
        column: { type: 'string' },
        columnUpdateType: { type: 'string', enum: ['drop', 'mask', 'modify'] },
        type: { type: 'string', enum: ['number', 'string', 'boolean', 'date', 'decimal'] },
        targetType: { type: 'string', enum: ['number', 'string', 'boolean', 'date', 'decimal'] },
        dateFormat: { type: 'string', minLength: 1 }
    },
    if: { properties: { columnUpdateType: { const: 'modify' } } },
    then: {
        required: ['type', 'targetType'],
        if: { properties: { targetType: { const: 'date' } }, required: ['targetType'] },
        then: { required: ['dateFormat'] }
    },
    required: ['column', 'columnUpdateType']
};
function validate18(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:ColumnUpdate" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.columnUpdateType !== undefined) {
            if ('modify' !== data.columnUpdateType) {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs4 = errors;
        const _errs5 = errors;
        let valid2 = true;
        const _errs6 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.targetType === undefined && (missing0 = 'targetType')) {
                const err1 = {};
                if (vErrors === null) {
                    vErrors = [err1];
                }
                else {
                    vErrors.push(err1);
                }
                errors++;
            }
            else {
                if (data.targetType !== undefined) {
                    if ('date' !== data.targetType) {
                        const err2 = {};
                        if (vErrors === null) {
                            vErrors = [err2];
                        }
                        else {
                            vErrors.push(err2);
                        }
                        errors++;
                    }
                }
            }
        }
        var _valid1 = _errs6 === errors;
        errors = _errs5;
        if (vErrors !== null) {
            if (_errs5) {
                vErrors.length = _errs5;
            }
            else {
                vErrors = null;
            }
        }
        if (_valid1) {
            const _errs8 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                let missing1;
                if (data.dateFormat === undefined && (missing1 = 'dateFormat')) {
                    validate18.errors = [
                        {
                            instancePath,
                            schemaPath: '#/then/then/required',
                            keyword: 'required',
                            params: { missingProperty: missing1 },
                            message: "must have required property '" + missing1 + "'"
                        }
                    ];
                    return false;
                }
            }
            var _valid1 = _errs8 === errors;
            valid2 = _valid1;
        }
        if (!valid2) {
            const err3 = {
                instancePath,
                schemaPath: '#/then/if',
                keyword: 'if',
                params: { failingKeyword: 'then' },
                message: 'must match "then" schema'
            };
            if (vErrors === null) {
                vErrors = [err3];
            }
            else {
                vErrors.push(err3);
            }
            errors++;
            validate18.errors = vErrors;
            return false;
        }
        if (errors === _errs4) {
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                let missing2;
                if ((data.type === undefined && (missing2 = 'type')) ||
                    (data.targetType === undefined && (missing2 = 'targetType'))) {
                    validate18.errors = [
                        {
                            instancePath,
                            schemaPath: '#/then/required',
                            keyword: 'required',
                            params: { missingProperty: missing2 },
                            message: "must have required property '" + missing2 + "'"
                        }
                    ];
                    return false;
                }
            }
        }
        var _valid0 = _errs4 === errors;
        valid0 = _valid0;
    }
    if (!valid0) {
        const err4 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err4];
        }
        else {
            vErrors.push(err4);
        }
        errors++;
        validate18.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing3;
            if ((data.column === undefined && (missing3 = 'column')) ||
                (data.columnUpdateType === undefined && (missing3 = 'columnUpdateType'))) {
                validate18.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing3 },
                        message: "must have required property '" + missing3 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.column !== undefined) {
                    const _errs9 = errors;
                    if (typeof data.column !== 'string') {
                        validate18.errors = [
                            {
                                instancePath: instancePath + '/column',
                                schemaPath: '#/properties/column/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid4 = _errs9 === errors;
                }
                else {
                    var valid4 = true;
                }
                if (valid4) {
                    if (data.columnUpdateType !== undefined) {
                        let data3 = data.columnUpdateType;
                        const _errs11 = errors;
                        if (typeof data3 !== 'string') {
                            validate18.errors = [
                                {
                                    instancePath: instancePath + '/columnUpdateType',
                                    schemaPath: '#/properties/columnUpdateType/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data3 === 'drop' || data3 === 'mask' || data3 === 'modify')) {
                            validate18.errors = [
                                {
                                    instancePath: instancePath + '/columnUpdateType',
                                    schemaPath: '#/properties/columnUpdateType/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema40.properties.columnUpdateType.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid4 = _errs11 === errors;
                    }
                    else {
                        var valid4 = true;
                    }
                    if (valid4) {
                        if (data.type !== undefined) {
                            let data4 = data.type;
                            const _errs13 = errors;
                            if (typeof data4 !== 'string') {
                                validate18.errors = [
                                    {
                                        instancePath: instancePath + '/type',
                                        schemaPath: '#/properties/type/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            if (!(data4 === 'number' ||
                                data4 === 'string' ||
                                data4 === 'boolean' ||
                                data4 === 'date' ||
                                data4 === 'decimal')) {
                                validate18.errors = [
                                    {
                                        instancePath: instancePath + '/type',
                                        schemaPath: '#/properties/type/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema40.properties.type.enum },
                                        message: 'must be equal to one of the allowed values'
                                    }
                                ];
                                return false;
                            }
                            var valid4 = _errs13 === errors;
                        }
                        else {
                            var valid4 = true;
                        }
                        if (valid4) {
                            if (data.targetType !== undefined) {
                                let data5 = data.targetType;
                                const _errs15 = errors;
                                if (typeof data5 !== 'string') {
                                    validate18.errors = [
                                        {
                                            instancePath: instancePath + '/targetType',
                                            schemaPath: '#/properties/targetType/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                if (!(data5 === 'number' ||
                                    data5 === 'string' ||
                                    data5 === 'boolean' ||
                                    data5 === 'date' ||
                                    data5 === 'decimal')) {
                                    validate18.errors = [
                                        {
                                            instancePath: instancePath + '/targetType',
                                            schemaPath: '#/properties/targetType/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema40.properties.targetType.enum },
                                            message: 'must be equal to one of the allowed values'
                                        }
                                    ];
                                    return false;
                                }
                                var valid4 = _errs15 === errors;
                            }
                            else {
                                var valid4 = true;
                            }
                            if (valid4) {
                                if (data.dateFormat !== undefined) {
                                    let data6 = data.dateFormat;
                                    const _errs17 = errors;
                                    if (errors === _errs17) {
                                        if (typeof data6 === 'string') {
                                            if (func2(data6) < 1) {
                                                validate18.errors = [
                                                    {
                                                        instancePath: instancePath + '/dateFormat',
                                                        schemaPath: '#/properties/dateFormat/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate18.errors = [
                                                {
                                                    instancePath: instancePath + '/dateFormat',
                                                    schemaPath: '#/properties/dateFormat/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid4 = _errs17 === errors;
                                }
                                else {
                                    var valid4 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate18.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate18.errors = vErrors;
    return errors === 0;
}
export const connectionSchemaValidation = validate19;
const schema41 = {
    $id: 'urn:wisepipe-common-connection:Connection',
    type: 'object',
    properties: {
        connectionID: { type: 'string', uid: 9 },
        connectionType: {
            type: 'string',
            enum: [
                'google',
                'gsheetsImport',
                'gsheetsExport',
                'shopify',
                'salesForce',
                'postgreSql',
                'icm',
                'tq-postgres',
                'mySql',
                'msSql',
                'oracle',
                'amazonRedshift',
                'amazonAurora',
                'amazonS3',
                'amazonS3Export',
                'tqp',
                'hubspot',
                'symon',
                'snowflake',
                'dynamics',
                'agentSync',
                'workday',
                'workdayRaaS',
                'workdayExport',
                'tableau',
                'sftp',
                'powerbi',
                'rest',
                'gong',
                'netSuite',
                'oneDrive',
                'oneDriveExport',
                'sapSuccessFactors',
                'sapCrm',
                'ukg',
                'oracleHcm',
                'Adp',
                'dynamics365Sales',
                'ceridianDayforce',
                'oracleCrm',
                'oracleErpCloud',
                'sageIntacct',
                'bambooHr',
                'sapErp',
                'googleCloudPlatformCloudStorage',
                'sas',
                'dropbox',
                'googleDrive',
                'jira',
                'monday',
                'zuora',
                'adobeAnalytics',
                'zoomInfo',
                'marketo',
                'activeCampaign',
                'mailchimp',
                'infor',
                'cornerstoneOnDemand',
                'gusto',
                'paychexFlex',
                'zendesk',
                'serviceNow',
                'zohoCrm',
                'pipedrive',
                'quickBooks',
                'xero',
                'freshbooks',
                'zohoBooks',
                'waveFinancial'
            ]
        },
        name: { type: 'string', minLength: 1 },
        source: { type: 'string', minLength: 1 },
        failedOnLastTry: { type: 'boolean' },
        isDiscoveryFail: { type: 'boolean' },
        verificationErrorMessage: { type: 'string' }
    },
    required: ['connectionType', 'name']
};
const func29 = ucs2length;
const func30 = base64urlToBuffer;
const func31 = base64urlEncode;
const func32 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate19(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:Connection" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.connectionType === undefined && (missing0 = 'connectionType')) ||
                (data.name === undefined && (missing0 = 'name'))) {
                validate19.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.connectionID !== undefined) {
                    let data0 = data.connectionID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 9) / 3);
                            const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                            if (func29(data0) < b64min0 || func29(data0) > b64max0) {
                                validate19.errors = [
                                    {
                                        instancePath: instancePath + '/connectionID',
                                        schemaPath: '#/properties/connectionID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func29(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func29(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func30(data0);
                                if (decoded0.length !== 9) {
                                    validate19.errors = [
                                        {
                                            instancePath: instancePath + '/connectionID',
                                            schemaPath: '#/properties/connectionID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 9 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func31(decoded0);
                                    if (func32(encoded0) !== func32(data0)) {
                                        validate19.errors = [
                                            {
                                                instancePath: instancePath + '/connectionID',
                                                schemaPath: '#/properties/connectionID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate19.errors = [
                                {
                                    instancePath: instancePath + '/connectionID',
                                    schemaPath: '#/properties/connectionID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.connectionType !== undefined) {
                        let data1 = data.connectionType;
                        const _errs3 = errors;
                        if (typeof data1 !== 'string') {
                            validate19.errors = [
                                {
                                    instancePath: instancePath + '/connectionType',
                                    schemaPath: '#/properties/connectionType/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data1 === 'google' ||
                            data1 === 'gsheetsImport' ||
                            data1 === 'gsheetsExport' ||
                            data1 === 'shopify' ||
                            data1 === 'salesForce' ||
                            data1 === 'postgreSql' ||
                            data1 === 'icm' ||
                            data1 === 'tq-postgres' ||
                            data1 === 'mySql' ||
                            data1 === 'msSql' ||
                            data1 === 'oracle' ||
                            data1 === 'amazonRedshift' ||
                            data1 === 'amazonAurora' ||
                            data1 === 'amazonS3' ||
                            data1 === 'amazonS3Export' ||
                            data1 === 'tqp' ||
                            data1 === 'hubspot' ||
                            data1 === 'symon' ||
                            data1 === 'snowflake' ||
                            data1 === 'dynamics' ||
                            data1 === 'agentSync' ||
                            data1 === 'workday' ||
                            data1 === 'workdayRaaS' ||
                            data1 === 'workdayExport' ||
                            data1 === 'tableau' ||
                            data1 === 'sftp' ||
                            data1 === 'powerbi' ||
                            data1 === 'rest' ||
                            data1 === 'gong' ||
                            data1 === 'netSuite' ||
                            data1 === 'oneDrive' ||
                            data1 === 'oneDriveExport' ||
                            data1 === 'sapSuccessFactors' ||
                            data1 === 'sapCrm' ||
                            data1 === 'ukg' ||
                            data1 === 'oracleHcm' ||
                            data1 === 'Adp' ||
                            data1 === 'dynamics365Sales' ||
                            data1 === 'ceridianDayforce' ||
                            data1 === 'oracleCrm' ||
                            data1 === 'oracleErpCloud' ||
                            data1 === 'sageIntacct' ||
                            data1 === 'bambooHr' ||
                            data1 === 'sapErp' ||
                            data1 === 'googleCloudPlatformCloudStorage' ||
                            data1 === 'sas' ||
                            data1 === 'dropbox' ||
                            data1 === 'googleDrive' ||
                            data1 === 'jira' ||
                            data1 === 'monday' ||
                            data1 === 'zuora' ||
                            data1 === 'adobeAnalytics' ||
                            data1 === 'zoomInfo' ||
                            data1 === 'marketo' ||
                            data1 === 'activeCampaign' ||
                            data1 === 'mailchimp' ||
                            data1 === 'infor' ||
                            data1 === 'cornerstoneOnDemand' ||
                            data1 === 'gusto' ||
                            data1 === 'paychexFlex' ||
                            data1 === 'zendesk' ||
                            data1 === 'serviceNow' ||
                            data1 === 'zohoCrm' ||
                            data1 === 'pipedrive' ||
                            data1 === 'quickBooks' ||
                            data1 === 'xero' ||
                            data1 === 'freshbooks' ||
                            data1 === 'zohoBooks' ||
                            data1 === 'waveFinancial')) {
                            validate19.errors = [
                                {
                                    instancePath: instancePath + '/connectionType',
                                    schemaPath: '#/properties/connectionType/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema41.properties.connectionType.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.name !== undefined) {
                            let data2 = data.name;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate19.errors = [
                                            {
                                                instancePath: instancePath + '/name',
                                                schemaPath: '#/properties/name/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate19.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.source !== undefined) {
                                let data3 = data.source;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 === 'string') {
                                        if (func2(data3) < 1) {
                                            validate19.errors = [
                                                {
                                                    instancePath: instancePath + '/source',
                                                    schemaPath: '#/properties/source/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate19.errors = [
                                            {
                                                instancePath: instancePath + '/source',
                                                schemaPath: '#/properties/source/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.failedOnLastTry !== undefined) {
                                    const _errs9 = errors;
                                    if (typeof data.failedOnLastTry !== 'boolean') {
                                        validate19.errors = [
                                            {
                                                instancePath: instancePath + '/failedOnLastTry',
                                                schemaPath: '#/properties/failedOnLastTry/type',
                                                keyword: 'type',
                                                params: { type: 'boolean' },
                                                message: 'must be boolean'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.isDiscoveryFail !== undefined) {
                                        const _errs11 = errors;
                                        if (typeof data.isDiscoveryFail !== 'boolean') {
                                            validate19.errors = [
                                                {
                                                    instancePath: instancePath + '/isDiscoveryFail',
                                                    schemaPath: '#/properties/isDiscoveryFail/type',
                                                    keyword: 'type',
                                                    params: { type: 'boolean' },
                                                    message: 'must be boolean'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.verificationErrorMessage !== undefined) {
                                            const _errs13 = errors;
                                            if (typeof data.verificationErrorMessage !== 'string') {
                                                validate19.errors = [
                                                    {
                                                        instancePath: instancePath + '/verificationErrorMessage',
                                                        schemaPath: '#/properties/verificationErrorMessage/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid0 = _errs13 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate19.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate19.errors = vErrors;
    return errors === 0;
}
export const credentialsSchemaValidation = validate20;
const schema42 = {
    $id: 'urn:wisepipe-common:Credentials',
    type: 'object',
    properties: {
        credentialsType: {
            type: 'string',
            enum: [
                'oauth',
                'userPassword',
                's3Credentials',
                'apiKey',
                'symon',
                'awsRoleAssumption',
                'rest',
                'tokenBasedAuthentication'
            ]
        }
    },
    required: ['credentialsType']
};
function validate20(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common:Credentials" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.credentialsType === undefined && (missing0 = 'credentialsType')) {
                validate20.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.credentialsType !== undefined) {
                    let data0 = data.credentialsType;
                    if (typeof data0 !== 'string') {
                        validate20.errors = [
                            {
                                instancePath: instancePath + '/credentialsType',
                                schemaPath: '#/properties/credentialsType/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'oauth' ||
                        data0 === 'userPassword' ||
                        data0 === 's3Credentials' ||
                        data0 === 'apiKey' ||
                        data0 === 'symon' ||
                        data0 === 'awsRoleAssumption' ||
                        data0 === 'rest' ||
                        data0 === 'tokenBasedAuthentication')) {
                        validate20.errors = [
                            {
                                instancePath: instancePath + '/credentialsType',
                                schemaPath: '#/properties/credentialsType/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema42.properties.credentialsType.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                }
            }
        }
        else {
            validate20.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate20.errors = vErrors;
    return errors === 0;
}
export const dataPreprocessConfigSchemaValidation = validate21;
function validate21(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:DataPreprocessConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.skipHeaderRow === undefined && (missing0 = 'skipHeaderRow')) ||
                (data.skipFooterRow === undefined && (missing0 = 'skipFooterRow'))) {
                validate21.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.skipHeaderRow !== undefined) {
                    let data0 = data.skipHeaderRow;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 == 'number') {
                            if (data0 > 100 || isNaN(data0)) {
                                validate21.errors = [
                                    {
                                        instancePath: instancePath + '/skipHeaderRow',
                                        schemaPath: '#/properties/skipHeaderRow/maximum',
                                        keyword: 'maximum',
                                        params: { comparison: '<=', limit: 100 },
                                        message: 'must be <= 100'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0 < 0 || isNaN(data0)) {
                                    validate21.errors = [
                                        {
                                            instancePath: instancePath + '/skipHeaderRow',
                                            schemaPath: '#/properties/skipHeaderRow/minimum',
                                            keyword: 'minimum',
                                            params: { comparison: '>=', limit: 0 },
                                            message: 'must be >= 0'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate21.errors = [
                                {
                                    instancePath: instancePath + '/skipHeaderRow',
                                    schemaPath: '#/properties/skipHeaderRow/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.skipFooterRow !== undefined) {
                        let data1 = data.skipFooterRow;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 == 'number') {
                                if (data1 > 100 || isNaN(data1)) {
                                    validate21.errors = [
                                        {
                                            instancePath: instancePath + '/skipFooterRow',
                                            schemaPath: '#/properties/skipFooterRow/maximum',
                                            keyword: 'maximum',
                                            params: { comparison: '<=', limit: 100 },
                                            message: 'must be <= 100'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (data1 < 0 || isNaN(data1)) {
                                        validate21.errors = [
                                            {
                                                instancePath: instancePath + '/skipFooterRow',
                                                schemaPath: '#/properties/skipFooterRow/minimum',
                                                keyword: 'minimum',
                                                params: { comparison: '>=', limit: 0 },
                                                message: 'must be >= 0'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate21.errors = [
                                    {
                                        instancePath: instancePath + '/skipFooterRow',
                                        schemaPath: '#/properties/skipFooterRow/type',
                                        keyword: 'type',
                                        params: { type: 'number' },
                                        message: 'must be number'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate21.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate21.errors = vErrors;
    return errors === 0;
}
export const dataSourceEventSchemaValidation = validate22;
const schema44 = {
    $id: 'urn:wisepipe-common-data:DataSourceEvent',
    type: 'object',
    properties: {
        orgID: { type: 'string', format: 'uuid' },
        orgPlan: { type: 'string', enum: ['Social', 'Enterprise', 'Integration', 'Temp', 'Starter', 'Professional'] },
        dataSourceID: { type: 'string', uid: 9 },
        type: { type: 'string', enum: ['insert', 'update', 'remove'] }
    },
    required: ['orgID', 'dataSourceID', 'type']
};
const formats4 = /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i;
const func35 = ucs2length;
const func36 = base64urlToBuffer;
const func37 = base64urlEncode;
const func38 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate22(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:DataSourceEvent" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.orgID === undefined && (missing0 = 'orgID')) ||
                (data.dataSourceID === undefined && (missing0 = 'dataSourceID')) ||
                (data.type === undefined && (missing0 = 'type'))) {
                validate22.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.orgID !== undefined) {
                    let data0 = data.orgID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats4.test(data0)) {
                                    validate22.errors = [
                                        {
                                            instancePath: instancePath + '/orgID',
                                            schemaPath: '#/properties/orgID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate22.errors = [
                                    {
                                        instancePath: instancePath + '/orgID',
                                        schemaPath: '#/properties/orgID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.orgPlan !== undefined) {
                        let data1 = data.orgPlan;
                        const _errs3 = errors;
                        if (typeof data1 !== 'string') {
                            validate22.errors = [
                                {
                                    instancePath: instancePath + '/orgPlan',
                                    schemaPath: '#/properties/orgPlan/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data1 === 'Social' ||
                            data1 === 'Enterprise' ||
                            data1 === 'Integration' ||
                            data1 === 'Temp' ||
                            data1 === 'Starter' ||
                            data1 === 'Professional')) {
                            validate22.errors = [
                                {
                                    instancePath: instancePath + '/orgPlan',
                                    schemaPath: '#/properties/orgPlan/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema44.properties.orgPlan.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.dataSourceID !== undefined) {
                            let data2 = data.dataSourceID;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    const b64min0 = Math.ceil((4 * 9) / 3);
                                    const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                    if (func35(data2) < b64min0 || func35(data2) > b64max0) {
                                        validate22.errors = [
                                            {
                                                instancePath: instancePath + '/dataSourceID',
                                                schemaPath: '#/properties/dataSourceID/uid',
                                                keyword: 'uid',
                                                params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func35(data2) },
                                                message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func35(data2)
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const decoded0 = func36(data2);
                                        if (decoded0.length !== 9) {
                                            validate22.errors = [
                                                {
                                                    instancePath: instancePath + '/dataSourceID',
                                                    schemaPath: '#/properties/dataSourceID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'decoded' },
                                                    message: 'must decode to 9 bytes'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const encoded0 = func37(decoded0);
                                            if (func38(encoded0) !== func38(data2)) {
                                                validate22.errors = [
                                                    {
                                                        instancePath: instancePath + '/dataSourceID',
                                                        schemaPath: '#/properties/dataSourceID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'ambiguous' },
                                                        message: 'encoding is ambiguous'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate22.errors = [
                                        {
                                            instancePath: instancePath + '/dataSourceID',
                                            schemaPath: '#/properties/dataSourceID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.type !== undefined) {
                                let data3 = data.type;
                                const _errs7 = errors;
                                if (typeof data3 !== 'string') {
                                    validate22.errors = [
                                        {
                                            instancePath: instancePath + '/type',
                                            schemaPath: '#/properties/type/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                if (!(data3 === 'insert' || data3 === 'update' || data3 === 'remove')) {
                                    validate22.errors = [
                                        {
                                            instancePath: instancePath + '/type',
                                            schemaPath: '#/properties/type/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema44.properties.type.enum },
                                            message: 'must be equal to one of the allowed values'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate22.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate22.errors = vErrors;
    return errors === 0;
}
export const dataSourceSchemaSchemaValidation = validate23;
const schema45 = {
    $id: 'urn:wisepipe-common-data:DataSourceSchema',
    type: 'object',
    properties: {
        columns: { type: 'array', items: { $ref: 'urn:wisepipe-common-data:Column' }, minItems: 1, uniqueItems: true }
    },
    required: ['columns']
};
const func0 = ajvEqual;
function validate23(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:DataSourceSchema" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.columns === undefined && (missing0 = 'columns')) {
                validate23.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.columns !== undefined) {
                    let data0 = data.columns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            if (data0.length < 1) {
                                validate23.errors = [
                                    {
                                        instancePath: instancePath + '/columns',
                                        schemaPath: '#/properties/columns/minItems',
                                        keyword: 'minItems',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 items'
                                    }
                                ];
                                return false;
                            }
                            else {
                                var valid1 = true;
                                const len0 = data0.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    const _errs3 = errors;
                                    if (!validate17(data0[i0], {
                                        instancePath: instancePath + '/columns/' + i0,
                                        parentData: data0,
                                        parentDataProperty: i0,
                                        rootData
                                    })) {
                                        vErrors = vErrors === null ? validate17.errors : vErrors.concat(validate17.errors);
                                        errors = vErrors.length;
                                    }
                                    var valid1 = _errs3 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                                if (valid1) {
                                    let i1 = data0.length;
                                    let j0;
                                    if (i1 > 1) {
                                        outer0: for (; i1--;) {
                                            for (j0 = i1; j0--;) {
                                                if (func0(data0[i1], data0[j0])) {
                                                    validate23.errors = [
                                                        {
                                                            instancePath: instancePath + '/columns',
                                                            schemaPath: '#/properties/columns/uniqueItems',
                                                            keyword: 'uniqueItems',
                                                            params: { i: i1, j: j0 },
                                                            message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                        }
                                                    ];
                                                    return false;
                                                    break outer0;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate23.errors = [
                                {
                                    instancePath: instancePath + '/columns',
                                    schemaPath: '#/properties/columns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate23.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate23.errors = vErrors;
    return errors === 0;
}
export const dataSourceSchemaValidation = validate25;
const schema46 = {
    $id: 'urn:wisepipe-common-data:DataSource',
    type: 'object',
    properties: {
        dataSourceID: { type: 'string', uid: 9 },
        originID: { type: 'string', uid: 9 },
        name: { type: 'string', minLength: 1 },
        sourceFileName: { type: 'string' },
        importType: {
            type: 'string',
            enum: [
                's3csv',
                'gsheets',
                'adwords',
                'googleAnalytics',
                'shopify',
                'mySql',
                'oracle',
                'postgreSql',
                'amazonAurora',
                'amazonRedshift',
                'amazonS3',
                'icm',
                'salesForce',
                'parquet',
                'excel',
                'global',
                'hubspot',
                'symon',
                'dynamics',
                's3parquet',
                'snowflake',
                'msSql',
                'agentSync',
                'workday',
                'workdayRaaS',
                'tqp',
                'tableau',
                'sftp',
                'powerbi',
                'rest',
                'gong',
                'fwf',
                'netSuite',
                'oneDrive',
                'eltApi',
                'microsoftSqlServer',
                'stripe',
                'microsoftDynamics365',
                'github',
                'facebookAds',
                'amplitude',
                'appsFlyer',
                'customerIo',
                'freshDesk',
                'fullstory',
                'googleCloud',
                'googleEcommerce',
                'listrak',
                'livePerson',
                'onFleet',
                'saasquatch',
                'selligent',
                'userVoice',
                'vero',
                'adRoll',
                'afterShip',
                'asana',
                'autopilot',
                'azure',
                'bigCommerce',
                'bingAds',
                'brainTree',
                'bronto',
                'campaignManager',
                'campaignMonitor',
                'chargeBee',
                'closeIo',
                'clubspeed',
                'codat',
                'contentful',
                'delighted',
                'drip',
                'eloqua',
                'formkeep',
                'front',
                'ftp',
                'gitlab',
                'harvest',
                'heap',
                'helpScout',
                'heroku',
                'ibmDb2',
                'invoiced',
                'iterable',
                'klaviyo',
                'magento',
                'mailjet',
                'mariaDb',
                'mixpanel',
                'mongoDb',
                'outbrain',
                'particle',
                'purple',
                'quickBase',
                'recurly',
                'responsys',
                'revinate',
                'salesforceDesk',
                'salesforcePardot',
                'segment',
                'sendGrid',
                'sendWithUs',
                'shipHero',
                'shippo',
                'sparkPost',
                'square',
                'taboola',
                'toggl',
                'trello',
                'typeform',
                'urbanAirship',
                'webhooks',
                'yotpo',
                'zapier',
                'zendeskChat',
                'zendeskSupport',
                'googleBigQuery',
                'intercom',
                'sapSuccessFactors',
                'sapCrm',
                'ukg',
                'oracleHcm',
                'Adp',
                'dynamics365Sales',
                'ceridianDayforce',
                'oracleCrm',
                'oracleErpCloud',
                'sageIntacct',
                'bambooHr',
                'sapErp',
                'googleCloudPlatformCloudStorage',
                'sas',
                'dropbox',
                'googleDrive',
                'jira',
                'monday',
                'zuora',
                'adobeAnalytics',
                'zoomInfo',
                'marketo',
                'activeCampaign',
                'mailchimp',
                'infor',
                'cornerstoneOnDemand',
                'gusto',
                'paychexFlex',
                'zendesk',
                'serviceNow',
                'zohoCrm',
                'pipedrive',
                'quickBooks',
                'xero',
                'freshbooks',
                'zohoBooks',
                'waveFinancial'
            ]
        },
        csvLocation: { $ref: 'urn:wisepipe-common:S3File' },
        csvPartLocations: { type: 'array', items: { $ref: 'urn:wisepipe-common:S3File' }, uniqueItems: true },
        parquetLocation: { $ref: 'urn:wisepipe-common:S3File' },
        sampleLocation: { $ref: 'urn:wisepipe-common:S3File' },
        randomSampleLocation: { $ref: 'urn:wisepipe-common:S3File' },
        malformedLocation: { $ref: 'urn:wisepipe-common:S3File' },
        sparkSchemaLocation: { $ref: 'urn:wisepipe-common:S3File' },
        metadataLocation: { $ref: 'urn:wisepipe-common:S3File' },
        rootLocation: { $ref: 'urn:wisepipe-common:S3File' },
        rowcountLocation: { $ref: 'urn:wisepipe-common:S3File' },
        lastUpdated: { type: 'string', format: 'date-time' },
        columns: { type: 'array', items: { $ref: 'urn:wisepipe-common-data:Column' }, minItems: 1, uniqueItems: true },
        extractDelimiter: { type: 'string', minLength: 0, maxLength: 1 },
        extractQuoteChar: { type: 'string', minLength: 1, maxLength: 1 },
        obsolete: { type: 'boolean' },
        subType: {
            type: 'string',
            enum: [
                'netSuite',
                'sapSuccessFactors',
                'sapCrm',
                'ukg',
                'oracleHcm',
                'Adp',
                'dynamics365Sales',
                'ceridianDayforce',
                'oracleCrm',
                'oracleErpCloud',
                'sageIntacct',
                'bambooHr',
                'sapErp',
                'googleCloudPlatformCloudStorage',
                'sas',
                'oneDrive',
                'dropbox',
                'googleDrive',
                'jira',
                'monday',
                'zuora',
                'adobeAnalytics',
                'zoomInfo',
                'marketo',
                'activeCampaign',
                'mailchimp',
                'infor',
                'cornerstoneOnDemand',
                'gusto',
                'paychexFlex',
                'zendesk',
                'serviceNow',
                'zohoCrm',
                'pipedrive',
                'quickBooks',
                'xero',
                'freshbooks',
                'zohoBooks',
                'waveFinancial'
            ]
        },
        dataCategory: { type: 'string', enum: ['dataSource', 'unitTestDataSource', 'unitTestSnapshot'] }
    },
    required: [
        'dataSourceID',
        'originID',
        'name',
        'importType',
        'lastUpdated',
        'csvLocation',
        'parquetLocation',
        'sampleLocation',
        'malformedLocation',
        'sparkSchemaLocation',
        'metadataLocation'
    ]
};
const schema47 = {
    $id: 'urn:wisepipe-common:S3File',
    type: 'object',
    properties: {
        bucket: { type: 'string', minLength: 1 },
        key: { type: 'string', minLength: 1 },
        uploadID: { type: 'string', uid: 9 }
    },
    required: ['bucket', 'key']
};
const func40 = ucs2length;
const func41 = base64urlToBuffer;
const func42 = base64urlEncode;
const func43 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func44 = ucs2length;
const func45 = base64urlToBuffer;
const func46 = base64urlEncode;
const func47 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func51 = ucs2length;
const func52 = base64urlToBuffer;
const func53 = base64urlEncode;
const func54 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func57 = ucs2length;
const func58 = base64urlToBuffer;
const func59 = base64urlEncode;
const func60 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func64 = ucs2length;
const func65 = base64urlToBuffer;
const func66 = base64urlEncode;
const func67 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func70 = ucs2length;
const func71 = base64urlToBuffer;
const func72 = base64urlEncode;
const func73 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func76 = ucs2length;
const func77 = base64urlToBuffer;
const func78 = base64urlEncode;
const func79 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func82 = ucs2length;
const func83 = base64urlToBuffer;
const func84 = base64urlEncode;
const func85 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func88 = ucs2length;
const func89 = base64urlToBuffer;
const func90 = base64urlEncode;
const func91 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func94 = ucs2length;
const func95 = base64urlToBuffer;
const func96 = base64urlEncode;
const func97 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func100 = ucs2length;
const func101 = base64urlToBuffer;
const func102 = base64urlEncode;
const func103 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func106 = ucs2length;
const func107 = base64urlToBuffer;
const func108 = base64urlEncode;
const func109 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate25(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:DataSource" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.dataSourceID === undefined && (missing0 = 'dataSourceID')) ||
                (data.originID === undefined && (missing0 = 'originID')) ||
                (data.name === undefined && (missing0 = 'name')) ||
                (data.importType === undefined && (missing0 = 'importType')) ||
                (data.lastUpdated === undefined && (missing0 = 'lastUpdated')) ||
                (data.csvLocation === undefined && (missing0 = 'csvLocation')) ||
                (data.parquetLocation === undefined && (missing0 = 'parquetLocation')) ||
                (data.sampleLocation === undefined && (missing0 = 'sampleLocation')) ||
                (data.malformedLocation === undefined && (missing0 = 'malformedLocation')) ||
                (data.sparkSchemaLocation === undefined && (missing0 = 'sparkSchemaLocation')) ||
                (data.metadataLocation === undefined && (missing0 = 'metadataLocation'))) {
                validate25.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.dataSourceID !== undefined) {
                    let data0 = data.dataSourceID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 9) / 3);
                            const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                            if (func40(data0) < b64min0 || func40(data0) > b64max0) {
                                validate25.errors = [
                                    {
                                        instancePath: instancePath + '/dataSourceID',
                                        schemaPath: '#/properties/dataSourceID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func40(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func40(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func41(data0);
                                if (decoded0.length !== 9) {
                                    validate25.errors = [
                                        {
                                            instancePath: instancePath + '/dataSourceID',
                                            schemaPath: '#/properties/dataSourceID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 9 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func42(decoded0);
                                    if (func43(encoded0) !== func43(data0)) {
                                        validate25.errors = [
                                            {
                                                instancePath: instancePath + '/dataSourceID',
                                                schemaPath: '#/properties/dataSourceID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate25.errors = [
                                {
                                    instancePath: instancePath + '/dataSourceID',
                                    schemaPath: '#/properties/dataSourceID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.originID !== undefined) {
                        let data1 = data.originID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                const b64min1 = Math.ceil((4 * 9) / 3);
                                const b64max1 = Math.ceil((4 * 9) / 3) + 3;
                                if (func44(data1) < b64min1 || func44(data1) > b64max1) {
                                    validate25.errors = [
                                        {
                                            instancePath: instancePath + '/originID',
                                            schemaPath: '#/properties/originID/uid',
                                            keyword: 'uid',
                                            params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func44(data1) },
                                            message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func44(data1)
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const decoded1 = func45(data1);
                                    if (decoded1.length !== 9) {
                                        validate25.errors = [
                                            {
                                                instancePath: instancePath + '/originID',
                                                schemaPath: '#/properties/originID/uid',
                                                keyword: 'uid',
                                                params: { error: 'decoded' },
                                                message: 'must decode to 9 bytes'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const encoded1 = func46(decoded1);
                                        if (func47(encoded1) !== func47(data1)) {
                                            validate25.errors = [
                                                {
                                                    instancePath: instancePath + '/originID',
                                                    schemaPath: '#/properties/originID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'ambiguous' },
                                                    message: 'encoding is ambiguous'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            else {
                                validate25.errors = [
                                    {
                                        instancePath: instancePath + '/originID',
                                        schemaPath: '#/properties/originID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.name !== undefined) {
                            let data2 = data.name;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate25.errors = [
                                            {
                                                instancePath: instancePath + '/name',
                                                schemaPath: '#/properties/name/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate25.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.sourceFileName !== undefined) {
                                const _errs7 = errors;
                                if (typeof data.sourceFileName !== 'string') {
                                    validate25.errors = [
                                        {
                                            instancePath: instancePath + '/sourceFileName',
                                            schemaPath: '#/properties/sourceFileName/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.importType !== undefined) {
                                    let data4 = data.importType;
                                    const _errs9 = errors;
                                    if (typeof data4 !== 'string') {
                                        validate25.errors = [
                                            {
                                                instancePath: instancePath + '/importType',
                                                schemaPath: '#/properties/importType/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    if (!(data4 === 's3csv' ||
                                        data4 === 'gsheets' ||
                                        data4 === 'adwords' ||
                                        data4 === 'googleAnalytics' ||
                                        data4 === 'shopify' ||
                                        data4 === 'mySql' ||
                                        data4 === 'oracle' ||
                                        data4 === 'postgreSql' ||
                                        data4 === 'amazonAurora' ||
                                        data4 === 'amazonRedshift' ||
                                        data4 === 'amazonS3' ||
                                        data4 === 'icm' ||
                                        data4 === 'salesForce' ||
                                        data4 === 'parquet' ||
                                        data4 === 'excel' ||
                                        data4 === 'global' ||
                                        data4 === 'hubspot' ||
                                        data4 === 'symon' ||
                                        data4 === 'dynamics' ||
                                        data4 === 's3parquet' ||
                                        data4 === 'snowflake' ||
                                        data4 === 'msSql' ||
                                        data4 === 'agentSync' ||
                                        data4 === 'workday' ||
                                        data4 === 'workdayRaaS' ||
                                        data4 === 'tqp' ||
                                        data4 === 'tableau' ||
                                        data4 === 'sftp' ||
                                        data4 === 'powerbi' ||
                                        data4 === 'rest' ||
                                        data4 === 'gong' ||
                                        data4 === 'fwf' ||
                                        data4 === 'netSuite' ||
                                        data4 === 'oneDrive' ||
                                        data4 === 'eltApi' ||
                                        data4 === 'microsoftSqlServer' ||
                                        data4 === 'stripe' ||
                                        data4 === 'microsoftDynamics365' ||
                                        data4 === 'github' ||
                                        data4 === 'facebookAds' ||
                                        data4 === 'amplitude' ||
                                        data4 === 'appsFlyer' ||
                                        data4 === 'customerIo' ||
                                        data4 === 'freshDesk' ||
                                        data4 === 'fullstory' ||
                                        data4 === 'googleCloud' ||
                                        data4 === 'googleEcommerce' ||
                                        data4 === 'listrak' ||
                                        data4 === 'livePerson' ||
                                        data4 === 'onFleet' ||
                                        data4 === 'saasquatch' ||
                                        data4 === 'selligent' ||
                                        data4 === 'userVoice' ||
                                        data4 === 'vero' ||
                                        data4 === 'adRoll' ||
                                        data4 === 'afterShip' ||
                                        data4 === 'asana' ||
                                        data4 === 'autopilot' ||
                                        data4 === 'azure' ||
                                        data4 === 'bigCommerce' ||
                                        data4 === 'bingAds' ||
                                        data4 === 'brainTree' ||
                                        data4 === 'bronto' ||
                                        data4 === 'campaignManager' ||
                                        data4 === 'campaignMonitor' ||
                                        data4 === 'chargeBee' ||
                                        data4 === 'closeIo' ||
                                        data4 === 'clubspeed' ||
                                        data4 === 'codat' ||
                                        data4 === 'contentful' ||
                                        data4 === 'delighted' ||
                                        data4 === 'drip' ||
                                        data4 === 'eloqua' ||
                                        data4 === 'formkeep' ||
                                        data4 === 'front' ||
                                        data4 === 'ftp' ||
                                        data4 === 'gitlab' ||
                                        data4 === 'harvest' ||
                                        data4 === 'heap' ||
                                        data4 === 'helpScout' ||
                                        data4 === 'heroku' ||
                                        data4 === 'ibmDb2' ||
                                        data4 === 'invoiced' ||
                                        data4 === 'iterable' ||
                                        data4 === 'klaviyo' ||
                                        data4 === 'magento' ||
                                        data4 === 'mailjet' ||
                                        data4 === 'mariaDb' ||
                                        data4 === 'mixpanel' ||
                                        data4 === 'mongoDb' ||
                                        data4 === 'outbrain' ||
                                        data4 === 'particle' ||
                                        data4 === 'purple' ||
                                        data4 === 'quickBase' ||
                                        data4 === 'recurly' ||
                                        data4 === 'responsys' ||
                                        data4 === 'revinate' ||
                                        data4 === 'salesforceDesk' ||
                                        data4 === 'salesforcePardot' ||
                                        data4 === 'segment' ||
                                        data4 === 'sendGrid' ||
                                        data4 === 'sendWithUs' ||
                                        data4 === 'shipHero' ||
                                        data4 === 'shippo' ||
                                        data4 === 'sparkPost' ||
                                        data4 === 'square' ||
                                        data4 === 'taboola' ||
                                        data4 === 'toggl' ||
                                        data4 === 'trello' ||
                                        data4 === 'typeform' ||
                                        data4 === 'urbanAirship' ||
                                        data4 === 'webhooks' ||
                                        data4 === 'yotpo' ||
                                        data4 === 'zapier' ||
                                        data4 === 'zendeskChat' ||
                                        data4 === 'zendeskSupport' ||
                                        data4 === 'googleBigQuery' ||
                                        data4 === 'intercom' ||
                                        data4 === 'sapSuccessFactors' ||
                                        data4 === 'sapCrm' ||
                                        data4 === 'ukg' ||
                                        data4 === 'oracleHcm' ||
                                        data4 === 'Adp' ||
                                        data4 === 'dynamics365Sales' ||
                                        data4 === 'ceridianDayforce' ||
                                        data4 === 'oracleCrm' ||
                                        data4 === 'oracleErpCloud' ||
                                        data4 === 'sageIntacct' ||
                                        data4 === 'bambooHr' ||
                                        data4 === 'sapErp' ||
                                        data4 === 'googleCloudPlatformCloudStorage' ||
                                        data4 === 'sas' ||
                                        data4 === 'dropbox' ||
                                        data4 === 'googleDrive' ||
                                        data4 === 'jira' ||
                                        data4 === 'monday' ||
                                        data4 === 'zuora' ||
                                        data4 === 'adobeAnalytics' ||
                                        data4 === 'zoomInfo' ||
                                        data4 === 'marketo' ||
                                        data4 === 'activeCampaign' ||
                                        data4 === 'mailchimp' ||
                                        data4 === 'infor' ||
                                        data4 === 'cornerstoneOnDemand' ||
                                        data4 === 'gusto' ||
                                        data4 === 'paychexFlex' ||
                                        data4 === 'zendesk' ||
                                        data4 === 'serviceNow' ||
                                        data4 === 'zohoCrm' ||
                                        data4 === 'pipedrive' ||
                                        data4 === 'quickBooks' ||
                                        data4 === 'xero' ||
                                        data4 === 'freshbooks' ||
                                        data4 === 'zohoBooks' ||
                                        data4 === 'waveFinancial')) {
                                        validate25.errors = [
                                            {
                                                instancePath: instancePath + '/importType',
                                                schemaPath: '#/properties/importType/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema46.properties.importType.enum },
                                                message: 'must be equal to one of the allowed values'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.csvLocation !== undefined) {
                                        let data5 = data.csvLocation;
                                        const _errs11 = errors;
                                        const _errs12 = errors;
                                        if (errors === _errs12) {
                                            if (data5 && typeof data5 == 'object' && !Array.isArray(data5)) {
                                                let missing1;
                                                if ((data5.bucket === undefined && (missing1 = 'bucket')) ||
                                                    (data5.key === undefined && (missing1 = 'key'))) {
                                                    validate25.errors = [
                                                        {
                                                            instancePath: instancePath + '/csvLocation',
                                                            schemaPath: 'urn:wisepipe-common:S3File/required',
                                                            keyword: 'required',
                                                            params: { missingProperty: missing1 },
                                                            message: "must have required property '" + missing1 + "'"
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    if (data5.bucket !== undefined) {
                                                        let data6 = data5.bucket;
                                                        const _errs14 = errors;
                                                        if (errors === _errs14) {
                                                            if (typeof data6 === 'string') {
                                                                if (func2(data6) < 1) {
                                                                    validate25.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/csvLocation/bucket',
                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                                            keyword: 'minLength',
                                                                            params: { limit: 1 },
                                                                            message: 'must NOT have fewer than 1 characters'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            else {
                                                                validate25.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/csvLocation/bucket',
                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid4 = _errs14 === errors;
                                                    }
                                                    else {
                                                        var valid4 = true;
                                                    }
                                                    if (valid4) {
                                                        if (data5.key !== undefined) {
                                                            let data7 = data5.key;
                                                            const _errs16 = errors;
                                                            if (errors === _errs16) {
                                                                if (typeof data7 === 'string') {
                                                                    if (func2(data7) < 1) {
                                                                        validate25.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/csvLocation/key',
                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                                                keyword: 'minLength',
                                                                                params: { limit: 1 },
                                                                                message: 'must NOT have fewer than 1 characters'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                else {
                                                                    validate25.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/csvLocation/key',
                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid4 = _errs16 === errors;
                                                        }
                                                        else {
                                                            var valid4 = true;
                                                        }
                                                        if (valid4) {
                                                            if (data5.uploadID !== undefined) {
                                                                let data8 = data5.uploadID;
                                                                const _errs18 = errors;
                                                                if (errors === _errs18) {
                                                                    if (typeof data8 === 'string') {
                                                                        const b64min2 = Math.ceil((4 * 9) / 3);
                                                                        const b64max2 = Math.ceil((4 * 9) / 3) + 3;
                                                                        if (func51(data8) < b64min2 || func51(data8) > b64max2) {
                                                                            validate25.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/csvLocation/uploadID',
                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                    keyword: 'uid',
                                                                                    params: {
                                                                                        error: 'encoded',
                                                                                        b64min: b64min2,
                                                                                        b64max: b64max2,
                                                                                        length: func51(data8)
                                                                                    },
                                                                                    message: 'length must be between ' +
                                                                                        b64min2 +
                                                                                        ' and ' +
                                                                                        b64max2 +
                                                                                        ', but is ' +
                                                                                        func51(data8)
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        else {
                                                                            const decoded2 = func52(data8);
                                                                            if (decoded2.length !== 9) {
                                                                                validate25.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/csvLocation/uploadID',
                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                        keyword: 'uid',
                                                                                        params: { error: 'decoded' },
                                                                                        message: 'must decode to 9 bytes'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            else {
                                                                                const encoded2 = func53(decoded2);
                                                                                if (func54(encoded2) !== func54(data8)) {
                                                                                    validate25.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/csvLocation/uploadID',
                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                            keyword: 'uid',
                                                                                            params: { error: 'ambiguous' },
                                                                                            message: 'encoding is ambiguous'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate25.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/csvLocation/uploadID',
                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                var valid4 = _errs18 === errors;
                                                            }
                                                            else {
                                                                var valid4 = true;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate25.errors = [
                                                    {
                                                        instancePath: instancePath + '/csvLocation',
                                                        schemaPath: 'urn:wisepipe-common:S3File/type',
                                                        keyword: 'type',
                                                        params: { type: 'object' },
                                                        message: 'must be object'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.csvPartLocations !== undefined) {
                                            let data9 = data.csvPartLocations;
                                            const _errs20 = errors;
                                            if (errors === _errs20) {
                                                if (Array.isArray(data9)) {
                                                    var valid6 = true;
                                                    const len0 = data9.length;
                                                    for (let i0 = 0; i0 < len0; i0++) {
                                                        let data10 = data9[i0];
                                                        const _errs22 = errors;
                                                        const _errs23 = errors;
                                                        if (errors === _errs23) {
                                                            if (data10 && typeof data10 == 'object' && !Array.isArray(data10)) {
                                                                let missing2;
                                                                if ((data10.bucket === undefined && (missing2 = 'bucket')) ||
                                                                    (data10.key === undefined && (missing2 = 'key'))) {
                                                                    validate25.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/csvPartLocations/' + i0,
                                                                            schemaPath: 'urn:wisepipe-common:S3File/required',
                                                                            keyword: 'required',
                                                                            params: { missingProperty: missing2 },
                                                                            message: "must have required property '" + missing2 + "'"
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                else {
                                                                    if (data10.bucket !== undefined) {
                                                                        let data11 = data10.bucket;
                                                                        const _errs25 = errors;
                                                                        if (errors === _errs25) {
                                                                            if (typeof data11 === 'string') {
                                                                                if (func2(data11) < 1) {
                                                                                    validate25.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/csvPartLocations/' + i0 + '/bucket',
                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                                                            keyword: 'minLength',
                                                                                            params: { limit: 1 },
                                                                                            message: 'must NOT have fewer than 1 characters'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            else {
                                                                                validate25.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/csvPartLocations/' + i0 + '/bucket',
                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        var valid8 = _errs25 === errors;
                                                                    }
                                                                    else {
                                                                        var valid8 = true;
                                                                    }
                                                                    if (valid8) {
                                                                        if (data10.key !== undefined) {
                                                                            let data12 = data10.key;
                                                                            const _errs27 = errors;
                                                                            if (errors === _errs27) {
                                                                                if (typeof data12 === 'string') {
                                                                                    if (func2(data12) < 1) {
                                                                                        validate25.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/csvPartLocations/' + i0 + '/key',
                                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                                                                keyword: 'minLength',
                                                                                                params: { limit: 1 },
                                                                                                message: 'must NOT have fewer than 1 characters'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    validate25.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/csvPartLocations/' + i0 + '/key',
                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'string' },
                                                                                            message: 'must be string'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            var valid8 = _errs27 === errors;
                                                                        }
                                                                        else {
                                                                            var valid8 = true;
                                                                        }
                                                                        if (valid8) {
                                                                            if (data10.uploadID !== undefined) {
                                                                                let data13 = data10.uploadID;
                                                                                const _errs29 = errors;
                                                                                if (errors === _errs29) {
                                                                                    if (typeof data13 === 'string') {
                                                                                        const b64min3 = Math.ceil((4 * 9) / 3);
                                                                                        const b64max3 = Math.ceil((4 * 9) / 3) + 3;
                                                                                        if (func57(data13) < b64min3 || func57(data13) > b64max3) {
                                                                                            validate25.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/csvPartLocations/' + i0 + '/uploadID',
                                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                    keyword: 'uid',
                                                                                                    params: {
                                                                                                        error: 'encoded',
                                                                                                        b64min: b64min3,
                                                                                                        b64max: b64max3,
                                                                                                        length: func57(data13)
                                                                                                    },
                                                                                                    message: 'length must be between ' +
                                                                                                        b64min3 +
                                                                                                        ' and ' +
                                                                                                        b64max3 +
                                                                                                        ', but is ' +
                                                                                                        func57(data13)
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                        else {
                                                                                            const decoded3 = func58(data13);
                                                                                            if (decoded3.length !== 9) {
                                                                                                validate25.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/csvPartLocations/' + i0 + '/uploadID',
                                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                        keyword: 'uid',
                                                                                                        params: { error: 'decoded' },
                                                                                                        message: 'must decode to 9 bytes'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                            else {
                                                                                                const encoded3 = func59(decoded3);
                                                                                                if (func60(encoded3) !== func60(data13)) {
                                                                                                    validate25.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/csvPartLocations/' + i0 + '/uploadID',
                                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                            keyword: 'uid',
                                                                                                            params: { error: 'ambiguous' },
                                                                                                            message: 'encoding is ambiguous'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                    else {
                                                                                        validate25.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/csvPartLocations/' + i0 + '/uploadID',
                                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'string' },
                                                                                                message: 'must be string'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                var valid8 = _errs29 === errors;
                                                                            }
                                                                            else {
                                                                                var valid8 = true;
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                            else {
                                                                validate25.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/csvPartLocations/' + i0,
                                                                        schemaPath: 'urn:wisepipe-common:S3File/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'object' },
                                                                        message: 'must be object'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid6 = _errs22 === errors;
                                                        if (!valid6) {
                                                            break;
                                                        }
                                                    }
                                                    if (valid6) {
                                                        let i1 = data9.length;
                                                        let j0;
                                                        if (i1 > 1) {
                                                            outer0: for (; i1--;) {
                                                                for (j0 = i1; j0--;) {
                                                                    if (func0(data9[i1], data9[j0])) {
                                                                        validate25.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/csvPartLocations',
                                                                                schemaPath: '#/properties/csvPartLocations/uniqueItems',
                                                                                keyword: 'uniqueItems',
                                                                                params: { i: i1, j: j0 },
                                                                                message: 'must NOT have duplicate items (items ## ' +
                                                                                    j0 +
                                                                                    ' and ' +
                                                                                    i1 +
                                                                                    ' are identical)'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                        break outer0;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate25.errors = [
                                                        {
                                                            instancePath: instancePath + '/csvPartLocations',
                                                            schemaPath: '#/properties/csvPartLocations/type',
                                                            keyword: 'type',
                                                            params: { type: 'array' },
                                                            message: 'must be array'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs20 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.parquetLocation !== undefined) {
                                                let data14 = data.parquetLocation;
                                                const _errs31 = errors;
                                                const _errs32 = errors;
                                                if (errors === _errs32) {
                                                    if (data14 && typeof data14 == 'object' && !Array.isArray(data14)) {
                                                        let missing3;
                                                        if ((data14.bucket === undefined && (missing3 = 'bucket')) ||
                                                            (data14.key === undefined && (missing3 = 'key'))) {
                                                            validate25.errors = [
                                                                {
                                                                    instancePath: instancePath + '/parquetLocation',
                                                                    schemaPath: 'urn:wisepipe-common:S3File/required',
                                                                    keyword: 'required',
                                                                    params: { missingProperty: missing3 },
                                                                    message: "must have required property '" + missing3 + "'"
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            if (data14.bucket !== undefined) {
                                                                let data15 = data14.bucket;
                                                                const _errs34 = errors;
                                                                if (errors === _errs34) {
                                                                    if (typeof data15 === 'string') {
                                                                        if (func2(data15) < 1) {
                                                                            validate25.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/parquetLocation/bucket',
                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                                                    keyword: 'minLength',
                                                                                    params: { limit: 1 },
                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate25.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/parquetLocation/bucket',
                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                var valid12 = _errs34 === errors;
                                                            }
                                                            else {
                                                                var valid12 = true;
                                                            }
                                                            if (valid12) {
                                                                if (data14.key !== undefined) {
                                                                    let data16 = data14.key;
                                                                    const _errs36 = errors;
                                                                    if (errors === _errs36) {
                                                                        if (typeof data16 === 'string') {
                                                                            if (func2(data16) < 1) {
                                                                                validate25.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/parquetLocation/key',
                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                                                        keyword: 'minLength',
                                                                                        params: { limit: 1 },
                                                                                        message: 'must NOT have fewer than 1 characters'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        else {
                                                                            validate25.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/parquetLocation/key',
                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'string' },
                                                                                    message: 'must be string'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    var valid12 = _errs36 === errors;
                                                                }
                                                                else {
                                                                    var valid12 = true;
                                                                }
                                                                if (valid12) {
                                                                    if (data14.uploadID !== undefined) {
                                                                        let data17 = data14.uploadID;
                                                                        const _errs38 = errors;
                                                                        if (errors === _errs38) {
                                                                            if (typeof data17 === 'string') {
                                                                                const b64min4 = Math.ceil((4 * 9) / 3);
                                                                                const b64max4 = Math.ceil((4 * 9) / 3) + 3;
                                                                                if (func64(data17) < b64min4 || func64(data17) > b64max4) {
                                                                                    validate25.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/parquetLocation/uploadID',
                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                            keyword: 'uid',
                                                                                            params: {
                                                                                                error: 'encoded',
                                                                                                b64min: b64min4,
                                                                                                b64max: b64max4,
                                                                                                length: func64(data17)
                                                                                            },
                                                                                            message: 'length must be between ' +
                                                                                                b64min4 +
                                                                                                ' and ' +
                                                                                                b64max4 +
                                                                                                ', but is ' +
                                                                                                func64(data17)
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                                else {
                                                                                    const decoded4 = func65(data17);
                                                                                    if (decoded4.length !== 9) {
                                                                                        validate25.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/parquetLocation/uploadID',
                                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                keyword: 'uid',
                                                                                                params: { error: 'decoded' },
                                                                                                message: 'must decode to 9 bytes'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                    else {
                                                                                        const encoded4 = func66(decoded4);
                                                                                        if (func67(encoded4) !== func67(data17)) {
                                                                                            validate25.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/parquetLocation/uploadID',
                                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                    keyword: 'uid',
                                                                                                    params: { error: 'ambiguous' },
                                                                                                    message: 'encoding is ambiguous'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                            else {
                                                                                validate25.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/parquetLocation/uploadID',
                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        var valid12 = _errs38 === errors;
                                                                    }
                                                                    else {
                                                                        var valid12 = true;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate25.errors = [
                                                            {
                                                                instancePath: instancePath + '/parquetLocation',
                                                                schemaPath: 'urn:wisepipe-common:S3File/type',
                                                                keyword: 'type',
                                                                params: { type: 'object' },
                                                                message: 'must be object'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid0 = _errs31 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (data.sampleLocation !== undefined) {
                                                    let data18 = data.sampleLocation;
                                                    const _errs40 = errors;
                                                    const _errs41 = errors;
                                                    if (errors === _errs41) {
                                                        if (data18 && typeof data18 == 'object' && !Array.isArray(data18)) {
                                                            let missing4;
                                                            if ((data18.bucket === undefined && (missing4 = 'bucket')) ||
                                                                (data18.key === undefined && (missing4 = 'key'))) {
                                                                validate25.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/sampleLocation',
                                                                        schemaPath: 'urn:wisepipe-common:S3File/required',
                                                                        keyword: 'required',
                                                                        params: { missingProperty: missing4 },
                                                                        message: "must have required property '" + missing4 + "'"
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            else {
                                                                if (data18.bucket !== undefined) {
                                                                    let data19 = data18.bucket;
                                                                    const _errs43 = errors;
                                                                    if (errors === _errs43) {
                                                                        if (typeof data19 === 'string') {
                                                                            if (func2(data19) < 1) {
                                                                                validate25.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/sampleLocation/bucket',
                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                                                        keyword: 'minLength',
                                                                                        params: { limit: 1 },
                                                                                        message: 'must NOT have fewer than 1 characters'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        else {
                                                                            validate25.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/sampleLocation/bucket',
                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'string' },
                                                                                    message: 'must be string'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    var valid15 = _errs43 === errors;
                                                                }
                                                                else {
                                                                    var valid15 = true;
                                                                }
                                                                if (valid15) {
                                                                    if (data18.key !== undefined) {
                                                                        let data20 = data18.key;
                                                                        const _errs45 = errors;
                                                                        if (errors === _errs45) {
                                                                            if (typeof data20 === 'string') {
                                                                                if (func2(data20) < 1) {
                                                                                    validate25.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/sampleLocation/key',
                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                                                            keyword: 'minLength',
                                                                                            params: { limit: 1 },
                                                                                            message: 'must NOT have fewer than 1 characters'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            else {
                                                                                validate25.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/sampleLocation/key',
                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        var valid15 = _errs45 === errors;
                                                                    }
                                                                    else {
                                                                        var valid15 = true;
                                                                    }
                                                                    if (valid15) {
                                                                        if (data18.uploadID !== undefined) {
                                                                            let data21 = data18.uploadID;
                                                                            const _errs47 = errors;
                                                                            if (errors === _errs47) {
                                                                                if (typeof data21 === 'string') {
                                                                                    const b64min5 = Math.ceil((4 * 9) / 3);
                                                                                    const b64max5 = Math.ceil((4 * 9) / 3) + 3;
                                                                                    if (func70(data21) < b64min5 || func70(data21) > b64max5) {
                                                                                        validate25.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/sampleLocation/uploadID',
                                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                keyword: 'uid',
                                                                                                params: {
                                                                                                    error: 'encoded',
                                                                                                    b64min: b64min5,
                                                                                                    b64max: b64max5,
                                                                                                    length: func70(data21)
                                                                                                },
                                                                                                message: 'length must be between ' +
                                                                                                    b64min5 +
                                                                                                    ' and ' +
                                                                                                    b64max5 +
                                                                                                    ', but is ' +
                                                                                                    func70(data21)
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                    else {
                                                                                        const decoded5 = func71(data21);
                                                                                        if (decoded5.length !== 9) {
                                                                                            validate25.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/sampleLocation/uploadID',
                                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                    keyword: 'uid',
                                                                                                    params: { error: 'decoded' },
                                                                                                    message: 'must decode to 9 bytes'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                        else {
                                                                                            const encoded5 = func72(decoded5);
                                                                                            if (func73(encoded5) !== func73(data21)) {
                                                                                                validate25.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/sampleLocation/uploadID',
                                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                        keyword: 'uid',
                                                                                                        params: { error: 'ambiguous' },
                                                                                                        message: 'encoding is ambiguous'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    validate25.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/sampleLocation/uploadID',
                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'string' },
                                                                                            message: 'must be string'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            var valid15 = _errs47 === errors;
                                                                        }
                                                                        else {
                                                                            var valid15 = true;
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                        else {
                                                            validate25.errors = [
                                                                {
                                                                    instancePath: instancePath + '/sampleLocation',
                                                                    schemaPath: 'urn:wisepipe-common:S3File/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'object' },
                                                                    message: 'must be object'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid0 = _errs40 === errors;
                                                }
                                                else {
                                                    var valid0 = true;
                                                }
                                                if (valid0) {
                                                    if (data.randomSampleLocation !== undefined) {
                                                        let data22 = data.randomSampleLocation;
                                                        const _errs49 = errors;
                                                        const _errs50 = errors;
                                                        if (errors === _errs50) {
                                                            if (data22 && typeof data22 == 'object' && !Array.isArray(data22)) {
                                                                let missing5;
                                                                if ((data22.bucket === undefined && (missing5 = 'bucket')) ||
                                                                    (data22.key === undefined && (missing5 = 'key'))) {
                                                                    validate25.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/randomSampleLocation',
                                                                            schemaPath: 'urn:wisepipe-common:S3File/required',
                                                                            keyword: 'required',
                                                                            params: { missingProperty: missing5 },
                                                                            message: "must have required property '" + missing5 + "'"
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                else {
                                                                    if (data22.bucket !== undefined) {
                                                                        let data23 = data22.bucket;
                                                                        const _errs52 = errors;
                                                                        if (errors === _errs52) {
                                                                            if (typeof data23 === 'string') {
                                                                                if (func2(data23) < 1) {
                                                                                    validate25.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/randomSampleLocation/bucket',
                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                                                            keyword: 'minLength',
                                                                                            params: { limit: 1 },
                                                                                            message: 'must NOT have fewer than 1 characters'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            else {
                                                                                validate25.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/randomSampleLocation/bucket',
                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        var valid18 = _errs52 === errors;
                                                                    }
                                                                    else {
                                                                        var valid18 = true;
                                                                    }
                                                                    if (valid18) {
                                                                        if (data22.key !== undefined) {
                                                                            let data24 = data22.key;
                                                                            const _errs54 = errors;
                                                                            if (errors === _errs54) {
                                                                                if (typeof data24 === 'string') {
                                                                                    if (func2(data24) < 1) {
                                                                                        validate25.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/randomSampleLocation/key',
                                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                                                                keyword: 'minLength',
                                                                                                params: { limit: 1 },
                                                                                                message: 'must NOT have fewer than 1 characters'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    validate25.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/randomSampleLocation/key',
                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'string' },
                                                                                            message: 'must be string'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            var valid18 = _errs54 === errors;
                                                                        }
                                                                        else {
                                                                            var valid18 = true;
                                                                        }
                                                                        if (valid18) {
                                                                            if (data22.uploadID !== undefined) {
                                                                                let data25 = data22.uploadID;
                                                                                const _errs56 = errors;
                                                                                if (errors === _errs56) {
                                                                                    if (typeof data25 === 'string') {
                                                                                        const b64min6 = Math.ceil((4 * 9) / 3);
                                                                                        const b64max6 = Math.ceil((4 * 9) / 3) + 3;
                                                                                        if (func76(data25) < b64min6 || func76(data25) > b64max6) {
                                                                                            validate25.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/randomSampleLocation/uploadID',
                                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                    keyword: 'uid',
                                                                                                    params: {
                                                                                                        error: 'encoded',
                                                                                                        b64min: b64min6,
                                                                                                        b64max: b64max6,
                                                                                                        length: func76(data25)
                                                                                                    },
                                                                                                    message: 'length must be between ' +
                                                                                                        b64min6 +
                                                                                                        ' and ' +
                                                                                                        b64max6 +
                                                                                                        ', but is ' +
                                                                                                        func76(data25)
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                        else {
                                                                                            const decoded6 = func77(data25);
                                                                                            if (decoded6.length !== 9) {
                                                                                                validate25.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/randomSampleLocation/uploadID',
                                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                        keyword: 'uid',
                                                                                                        params: { error: 'decoded' },
                                                                                                        message: 'must decode to 9 bytes'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                            else {
                                                                                                const encoded6 = func78(decoded6);
                                                                                                if (func79(encoded6) !== func79(data25)) {
                                                                                                    validate25.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/randomSampleLocation/uploadID',
                                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                            keyword: 'uid',
                                                                                                            params: { error: 'ambiguous' },
                                                                                                            message: 'encoding is ambiguous'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                    else {
                                                                                        validate25.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/randomSampleLocation/uploadID',
                                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'string' },
                                                                                                message: 'must be string'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                var valid18 = _errs56 === errors;
                                                                            }
                                                                            else {
                                                                                var valid18 = true;
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                            else {
                                                                validate25.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/randomSampleLocation',
                                                                        schemaPath: 'urn:wisepipe-common:S3File/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'object' },
                                                                        message: 'must be object'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid0 = _errs49 === errors;
                                                    }
                                                    else {
                                                        var valid0 = true;
                                                    }
                                                    if (valid0) {
                                                        if (data.malformedLocation !== undefined) {
                                                            let data26 = data.malformedLocation;
                                                            const _errs58 = errors;
                                                            const _errs59 = errors;
                                                            if (errors === _errs59) {
                                                                if (data26 && typeof data26 == 'object' && !Array.isArray(data26)) {
                                                                    let missing6;
                                                                    if ((data26.bucket === undefined && (missing6 = 'bucket')) ||
                                                                        (data26.key === undefined && (missing6 = 'key'))) {
                                                                        validate25.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/malformedLocation',
                                                                                schemaPath: 'urn:wisepipe-common:S3File/required',
                                                                                keyword: 'required',
                                                                                params: { missingProperty: missing6 },
                                                                                message: "must have required property '" + missing6 + "'"
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    else {
                                                                        if (data26.bucket !== undefined) {
                                                                            let data27 = data26.bucket;
                                                                            const _errs61 = errors;
                                                                            if (errors === _errs61) {
                                                                                if (typeof data27 === 'string') {
                                                                                    if (func2(data27) < 1) {
                                                                                        validate25.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/malformedLocation/bucket',
                                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                                                                keyword: 'minLength',
                                                                                                params: { limit: 1 },
                                                                                                message: 'must NOT have fewer than 1 characters'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    validate25.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/malformedLocation/bucket',
                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'string' },
                                                                                            message: 'must be string'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            var valid21 = _errs61 === errors;
                                                                        }
                                                                        else {
                                                                            var valid21 = true;
                                                                        }
                                                                        if (valid21) {
                                                                            if (data26.key !== undefined) {
                                                                                let data28 = data26.key;
                                                                                const _errs63 = errors;
                                                                                if (errors === _errs63) {
                                                                                    if (typeof data28 === 'string') {
                                                                                        if (func2(data28) < 1) {
                                                                                            validate25.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/malformedLocation/key',
                                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                                                                    keyword: 'minLength',
                                                                                                    params: { limit: 1 },
                                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                    else {
                                                                                        validate25.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/malformedLocation/key',
                                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'string' },
                                                                                                message: 'must be string'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                var valid21 = _errs63 === errors;
                                                                            }
                                                                            else {
                                                                                var valid21 = true;
                                                                            }
                                                                            if (valid21) {
                                                                                if (data26.uploadID !== undefined) {
                                                                                    let data29 = data26.uploadID;
                                                                                    const _errs65 = errors;
                                                                                    if (errors === _errs65) {
                                                                                        if (typeof data29 === 'string') {
                                                                                            const b64min7 = Math.ceil((4 * 9) / 3);
                                                                                            const b64max7 = Math.ceil((4 * 9) / 3) + 3;
                                                                                            if (func82(data29) < b64min7 || func82(data29) > b64max7) {
                                                                                                validate25.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/malformedLocation/uploadID',
                                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                        keyword: 'uid',
                                                                                                        params: {
                                                                                                            error: 'encoded',
                                                                                                            b64min: b64min7,
                                                                                                            b64max: b64max7,
                                                                                                            length: func82(data29)
                                                                                                        },
                                                                                                        message: 'length must be between ' +
                                                                                                            b64min7 +
                                                                                                            ' and ' +
                                                                                                            b64max7 +
                                                                                                            ', but is ' +
                                                                                                            func82(data29)
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                            else {
                                                                                                const decoded7 = func83(data29);
                                                                                                if (decoded7.length !== 9) {
                                                                                                    validate25.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/malformedLocation/uploadID',
                                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                            keyword: 'uid',
                                                                                                            params: { error: 'decoded' },
                                                                                                            message: 'must decode to 9 bytes'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                                else {
                                                                                                    const encoded7 = func84(decoded7);
                                                                                                    if (func85(encoded7) !== func85(data29)) {
                                                                                                        validate25.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/malformedLocation/uploadID',
                                                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                                keyword: 'uid',
                                                                                                                params: { error: 'ambiguous' },
                                                                                                                message: 'encoding is ambiguous'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                        else {
                                                                                            validate25.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/malformedLocation/uploadID',
                                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                                                                    keyword: 'type',
                                                                                                    params: { type: 'string' },
                                                                                                    message: 'must be string'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                    var valid21 = _errs65 === errors;
                                                                                }
                                                                                else {
                                                                                    var valid21 = true;
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                                else {
                                                                    validate25.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/malformedLocation',
                                                                            schemaPath: 'urn:wisepipe-common:S3File/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'object' },
                                                                            message: 'must be object'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid0 = _errs58 === errors;
                                                        }
                                                        else {
                                                            var valid0 = true;
                                                        }
                                                        if (valid0) {
                                                            if (data.sparkSchemaLocation !== undefined) {
                                                                let data30 = data.sparkSchemaLocation;
                                                                const _errs67 = errors;
                                                                const _errs68 = errors;
                                                                if (errors === _errs68) {
                                                                    if (data30 && typeof data30 == 'object' && !Array.isArray(data30)) {
                                                                        let missing7;
                                                                        if ((data30.bucket === undefined && (missing7 = 'bucket')) ||
                                                                            (data30.key === undefined && (missing7 = 'key'))) {
                                                                            validate25.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/sparkSchemaLocation',
                                                                                    schemaPath: 'urn:wisepipe-common:S3File/required',
                                                                                    keyword: 'required',
                                                                                    params: { missingProperty: missing7 },
                                                                                    message: "must have required property '" + missing7 + "'"
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        else {
                                                                            if (data30.bucket !== undefined) {
                                                                                let data31 = data30.bucket;
                                                                                const _errs70 = errors;
                                                                                if (errors === _errs70) {
                                                                                    if (typeof data31 === 'string') {
                                                                                        if (func2(data31) < 1) {
                                                                                            validate25.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/sparkSchemaLocation/bucket',
                                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                                                                    keyword: 'minLength',
                                                                                                    params: { limit: 1 },
                                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                    else {
                                                                                        validate25.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/sparkSchemaLocation/bucket',
                                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'string' },
                                                                                                message: 'must be string'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                var valid24 = _errs70 === errors;
                                                                            }
                                                                            else {
                                                                                var valid24 = true;
                                                                            }
                                                                            if (valid24) {
                                                                                if (data30.key !== undefined) {
                                                                                    let data32 = data30.key;
                                                                                    const _errs72 = errors;
                                                                                    if (errors === _errs72) {
                                                                                        if (typeof data32 === 'string') {
                                                                                            if (func2(data32) < 1) {
                                                                                                validate25.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/sparkSchemaLocation/key',
                                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                                                                        keyword: 'minLength',
                                                                                                        params: { limit: 1 },
                                                                                                        message: 'must NOT have fewer than 1 characters'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                        }
                                                                                        else {
                                                                                            validate25.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/sparkSchemaLocation/key',
                                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                                                                    keyword: 'type',
                                                                                                    params: { type: 'string' },
                                                                                                    message: 'must be string'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                    var valid24 = _errs72 === errors;
                                                                                }
                                                                                else {
                                                                                    var valid24 = true;
                                                                                }
                                                                                if (valid24) {
                                                                                    if (data30.uploadID !== undefined) {
                                                                                        let data33 = data30.uploadID;
                                                                                        const _errs74 = errors;
                                                                                        if (errors === _errs74) {
                                                                                            if (typeof data33 === 'string') {
                                                                                                const b64min8 = Math.ceil((4 * 9) / 3);
                                                                                                const b64max8 = Math.ceil((4 * 9) / 3) + 3;
                                                                                                if (func88(data33) < b64min8 || func88(data33) > b64max8) {
                                                                                                    validate25.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/sparkSchemaLocation/uploadID',
                                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                            keyword: 'uid',
                                                                                                            params: {
                                                                                                                error: 'encoded',
                                                                                                                b64min: b64min8,
                                                                                                                b64max: b64max8,
                                                                                                                length: func88(data33)
                                                                                                            },
                                                                                                            message: 'length must be between ' +
                                                                                                                b64min8 +
                                                                                                                ' and ' +
                                                                                                                b64max8 +
                                                                                                                ', but is ' +
                                                                                                                func88(data33)
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                                else {
                                                                                                    const decoded8 = func89(data33);
                                                                                                    if (decoded8.length !== 9) {
                                                                                                        validate25.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/sparkSchemaLocation/uploadID',
                                                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                                keyword: 'uid',
                                                                                                                params: { error: 'decoded' },
                                                                                                                message: 'must decode to 9 bytes'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                    else {
                                                                                                        const encoded8 = func90(decoded8);
                                                                                                        if (func91(encoded8) !== func91(data33)) {
                                                                                                            validate25.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/sparkSchemaLocation/uploadID',
                                                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                                    keyword: 'uid',
                                                                                                                    params: { error: 'ambiguous' },
                                                                                                                    message: 'encoding is ambiguous'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                            else {
                                                                                                validate25.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/sparkSchemaLocation/uploadID',
                                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                                                                        keyword: 'type',
                                                                                                        params: { type: 'string' },
                                                                                                        message: 'must be string'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                        }
                                                                                        var valid24 = _errs74 === errors;
                                                                                    }
                                                                                    else {
                                                                                        var valid24 = true;
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate25.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/sparkSchemaLocation',
                                                                                schemaPath: 'urn:wisepipe-common:S3File/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'object' },
                                                                                message: 'must be object'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                var valid0 = _errs67 === errors;
                                                            }
                                                            else {
                                                                var valid0 = true;
                                                            }
                                                            if (valid0) {
                                                                if (data.metadataLocation !== undefined) {
                                                                    let data34 = data.metadataLocation;
                                                                    const _errs76 = errors;
                                                                    const _errs77 = errors;
                                                                    if (errors === _errs77) {
                                                                        if (data34 && typeof data34 == 'object' && !Array.isArray(data34)) {
                                                                            let missing8;
                                                                            if ((data34.bucket === undefined && (missing8 = 'bucket')) ||
                                                                                (data34.key === undefined && (missing8 = 'key'))) {
                                                                                validate25.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/metadataLocation',
                                                                                        schemaPath: 'urn:wisepipe-common:S3File/required',
                                                                                        keyword: 'required',
                                                                                        params: { missingProperty: missing8 },
                                                                                        message: "must have required property '" + missing8 + "'"
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            else {
                                                                                if (data34.bucket !== undefined) {
                                                                                    let data35 = data34.bucket;
                                                                                    const _errs79 = errors;
                                                                                    if (errors === _errs79) {
                                                                                        if (typeof data35 === 'string') {
                                                                                            if (func2(data35) < 1) {
                                                                                                validate25.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/metadataLocation/bucket',
                                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                                                                        keyword: 'minLength',
                                                                                                        params: { limit: 1 },
                                                                                                        message: 'must NOT have fewer than 1 characters'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                        }
                                                                                        else {
                                                                                            validate25.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/metadataLocation/bucket',
                                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                                                                    keyword: 'type',
                                                                                                    params: { type: 'string' },
                                                                                                    message: 'must be string'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                    var valid27 = _errs79 === errors;
                                                                                }
                                                                                else {
                                                                                    var valid27 = true;
                                                                                }
                                                                                if (valid27) {
                                                                                    if (data34.key !== undefined) {
                                                                                        let data36 = data34.key;
                                                                                        const _errs81 = errors;
                                                                                        if (errors === _errs81) {
                                                                                            if (typeof data36 === 'string') {
                                                                                                if (func2(data36) < 1) {
                                                                                                    validate25.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/metadataLocation/key',
                                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                                                                            keyword: 'minLength',
                                                                                                            params: { limit: 1 },
                                                                                                            message: 'must NOT have fewer than 1 characters'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                            else {
                                                                                                validate25.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/metadataLocation/key',
                                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                                                                        keyword: 'type',
                                                                                                        params: { type: 'string' },
                                                                                                        message: 'must be string'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                        }
                                                                                        var valid27 = _errs81 === errors;
                                                                                    }
                                                                                    else {
                                                                                        var valid27 = true;
                                                                                    }
                                                                                    if (valid27) {
                                                                                        if (data34.uploadID !== undefined) {
                                                                                            let data37 = data34.uploadID;
                                                                                            const _errs83 = errors;
                                                                                            if (errors === _errs83) {
                                                                                                if (typeof data37 === 'string') {
                                                                                                    const b64min9 = Math.ceil((4 * 9) / 3);
                                                                                                    const b64max9 = Math.ceil((4 * 9) / 3) + 3;
                                                                                                    if (func94(data37) < b64min9 || func94(data37) > b64max9) {
                                                                                                        validate25.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/metadataLocation/uploadID',
                                                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                                keyword: 'uid',
                                                                                                                params: {
                                                                                                                    error: 'encoded',
                                                                                                                    b64min: b64min9,
                                                                                                                    b64max: b64max9,
                                                                                                                    length: func94(data37)
                                                                                                                },
                                                                                                                message: 'length must be between ' +
                                                                                                                    b64min9 +
                                                                                                                    ' and ' +
                                                                                                                    b64max9 +
                                                                                                                    ', but is ' +
                                                                                                                    func94(data37)
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                    else {
                                                                                                        const decoded9 = func95(data37);
                                                                                                        if (decoded9.length !== 9) {
                                                                                                            validate25.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/metadataLocation/uploadID',
                                                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                                    keyword: 'uid',
                                                                                                                    params: { error: 'decoded' },
                                                                                                                    message: 'must decode to 9 bytes'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                        else {
                                                                                                            const encoded9 = func96(decoded9);
                                                                                                            if (func97(encoded9) !== func97(data37)) {
                                                                                                                validate25.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/metadataLocation/uploadID',
                                                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                                        keyword: 'uid',
                                                                                                                        params: { error: 'ambiguous' },
                                                                                                                        message: 'encoding is ambiguous'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                                else {
                                                                                                    validate25.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/metadataLocation/uploadID',
                                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                                                                            keyword: 'type',
                                                                                                            params: { type: 'string' },
                                                                                                            message: 'must be string'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                            var valid27 = _errs83 === errors;
                                                                                        }
                                                                                        else {
                                                                                            var valid27 = true;
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                        else {
                                                                            validate25.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/metadataLocation',
                                                                                    schemaPath: 'urn:wisepipe-common:S3File/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'object' },
                                                                                    message: 'must be object'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    var valid0 = _errs76 === errors;
                                                                }
                                                                else {
                                                                    var valid0 = true;
                                                                }
                                                                if (valid0) {
                                                                    if (data.rootLocation !== undefined) {
                                                                        let data38 = data.rootLocation;
                                                                        const _errs85 = errors;
                                                                        const _errs86 = errors;
                                                                        if (errors === _errs86) {
                                                                            if (data38 && typeof data38 == 'object' && !Array.isArray(data38)) {
                                                                                let missing9;
                                                                                if ((data38.bucket === undefined && (missing9 = 'bucket')) ||
                                                                                    (data38.key === undefined && (missing9 = 'key'))) {
                                                                                    validate25.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/rootLocation',
                                                                                            schemaPath: 'urn:wisepipe-common:S3File/required',
                                                                                            keyword: 'required',
                                                                                            params: { missingProperty: missing9 },
                                                                                            message: "must have required property '" + missing9 + "'"
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                                else {
                                                                                    if (data38.bucket !== undefined) {
                                                                                        let data39 = data38.bucket;
                                                                                        const _errs88 = errors;
                                                                                        if (errors === _errs88) {
                                                                                            if (typeof data39 === 'string') {
                                                                                                if (func2(data39) < 1) {
                                                                                                    validate25.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/rootLocation/bucket',
                                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                                                                            keyword: 'minLength',
                                                                                                            params: { limit: 1 },
                                                                                                            message: 'must NOT have fewer than 1 characters'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                            else {
                                                                                                validate25.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/rootLocation/bucket',
                                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                                                                        keyword: 'type',
                                                                                                        params: { type: 'string' },
                                                                                                        message: 'must be string'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                        }
                                                                                        var valid30 = _errs88 === errors;
                                                                                    }
                                                                                    else {
                                                                                        var valid30 = true;
                                                                                    }
                                                                                    if (valid30) {
                                                                                        if (data38.key !== undefined) {
                                                                                            let data40 = data38.key;
                                                                                            const _errs90 = errors;
                                                                                            if (errors === _errs90) {
                                                                                                if (typeof data40 === 'string') {
                                                                                                    if (func2(data40) < 1) {
                                                                                                        validate25.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/rootLocation/key',
                                                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                                                                                keyword: 'minLength',
                                                                                                                params: { limit: 1 },
                                                                                                                message: 'must NOT have fewer than 1 characters'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                }
                                                                                                else {
                                                                                                    validate25.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/rootLocation/key',
                                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                                                                            keyword: 'type',
                                                                                                            params: { type: 'string' },
                                                                                                            message: 'must be string'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                            var valid30 = _errs90 === errors;
                                                                                        }
                                                                                        else {
                                                                                            var valid30 = true;
                                                                                        }
                                                                                        if (valid30) {
                                                                                            if (data38.uploadID !== undefined) {
                                                                                                let data41 = data38.uploadID;
                                                                                                const _errs92 = errors;
                                                                                                if (errors === _errs92) {
                                                                                                    if (typeof data41 === 'string') {
                                                                                                        const b64min10 = Math.ceil((4 * 9) / 3);
                                                                                                        const b64max10 = Math.ceil((4 * 9) / 3) + 3;
                                                                                                        if (func100(data41) < b64min10 || func100(data41) > b64max10) {
                                                                                                            validate25.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/rootLocation/uploadID',
                                                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                                    keyword: 'uid',
                                                                                                                    params: {
                                                                                                                        error: 'encoded',
                                                                                                                        b64min: b64min10,
                                                                                                                        b64max: b64max10,
                                                                                                                        length: func100(data41)
                                                                                                                    },
                                                                                                                    message: 'length must be between ' +
                                                                                                                        b64min10 +
                                                                                                                        ' and ' +
                                                                                                                        b64max10 +
                                                                                                                        ', but is ' +
                                                                                                                        func100(data41)
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                        else {
                                                                                                            const decoded10 = func101(data41);
                                                                                                            if (decoded10.length !== 9) {
                                                                                                                validate25.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/rootLocation/uploadID',
                                                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                                        keyword: 'uid',
                                                                                                                        params: { error: 'decoded' },
                                                                                                                        message: 'must decode to 9 bytes'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                            else {
                                                                                                                const encoded10 = func102(decoded10);
                                                                                                                if (func103(encoded10) !== func103(data41)) {
                                                                                                                    validate25.errors = [
                                                                                                                        {
                                                                                                                            instancePath: instancePath + '/rootLocation/uploadID',
                                                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                                            keyword: 'uid',
                                                                                                                            params: { error: 'ambiguous' },
                                                                                                                            message: 'encoding is ambiguous'
                                                                                                                        }
                                                                                                                    ];
                                                                                                                    return false;
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                    else {
                                                                                                        validate25.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/rootLocation/uploadID',
                                                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                                                                                keyword: 'type',
                                                                                                                params: { type: 'string' },
                                                                                                                message: 'must be string'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                }
                                                                                                var valid30 = _errs92 === errors;
                                                                                            }
                                                                                            else {
                                                                                                var valid30 = true;
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                            else {
                                                                                validate25.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/rootLocation',
                                                                                        schemaPath: 'urn:wisepipe-common:S3File/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'object' },
                                                                                        message: 'must be object'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        var valid0 = _errs85 === errors;
                                                                    }
                                                                    else {
                                                                        var valid0 = true;
                                                                    }
                                                                    if (valid0) {
                                                                        if (data.rowcountLocation !== undefined) {
                                                                            let data42 = data.rowcountLocation;
                                                                            const _errs94 = errors;
                                                                            const _errs95 = errors;
                                                                            if (errors === _errs95) {
                                                                                if (data42 && typeof data42 == 'object' && !Array.isArray(data42)) {
                                                                                    let missing10;
                                                                                    if ((data42.bucket === undefined && (missing10 = 'bucket')) ||
                                                                                        (data42.key === undefined && (missing10 = 'key'))) {
                                                                                        validate25.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/rowcountLocation',
                                                                                                schemaPath: 'urn:wisepipe-common:S3File/required',
                                                                                                keyword: 'required',
                                                                                                params: { missingProperty: missing10 },
                                                                                                message: "must have required property '" + missing10 + "'"
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                    else {
                                                                                        if (data42.bucket !== undefined) {
                                                                                            let data43 = data42.bucket;
                                                                                            const _errs97 = errors;
                                                                                            if (errors === _errs97) {
                                                                                                if (typeof data43 === 'string') {
                                                                                                    if (func2(data43) < 1) {
                                                                                                        validate25.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/rowcountLocation/bucket',
                                                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                                                                                keyword: 'minLength',
                                                                                                                params: { limit: 1 },
                                                                                                                message: 'must NOT have fewer than 1 characters'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                }
                                                                                                else {
                                                                                                    validate25.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/rowcountLocation/bucket',
                                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                                                                            keyword: 'type',
                                                                                                            params: { type: 'string' },
                                                                                                            message: 'must be string'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                            var valid33 = _errs97 === errors;
                                                                                        }
                                                                                        else {
                                                                                            var valid33 = true;
                                                                                        }
                                                                                        if (valid33) {
                                                                                            if (data42.key !== undefined) {
                                                                                                let data44 = data42.key;
                                                                                                const _errs99 = errors;
                                                                                                if (errors === _errs99) {
                                                                                                    if (typeof data44 === 'string') {
                                                                                                        if (func2(data44) < 1) {
                                                                                                            validate25.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/rowcountLocation/key',
                                                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                                                                                    keyword: 'minLength',
                                                                                                                    params: { limit: 1 },
                                                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                    }
                                                                                                    else {
                                                                                                        validate25.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/rowcountLocation/key',
                                                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                                                                                keyword: 'type',
                                                                                                                params: { type: 'string' },
                                                                                                                message: 'must be string'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                }
                                                                                                var valid33 = _errs99 === errors;
                                                                                            }
                                                                                            else {
                                                                                                var valid33 = true;
                                                                                            }
                                                                                            if (valid33) {
                                                                                                if (data42.uploadID !== undefined) {
                                                                                                    let data45 = data42.uploadID;
                                                                                                    const _errs101 = errors;
                                                                                                    if (errors === _errs101) {
                                                                                                        if (typeof data45 === 'string') {
                                                                                                            const b64min11 = Math.ceil((4 * 9) / 3);
                                                                                                            const b64max11 = Math.ceil((4 * 9) / 3) + 3;
                                                                                                            if (func106(data45) < b64min11 || func106(data45) > b64max11) {
                                                                                                                validate25.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/rowcountLocation/uploadID',
                                                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                                        keyword: 'uid',
                                                                                                                        params: {
                                                                                                                            error: 'encoded',
                                                                                                                            b64min: b64min11,
                                                                                                                            b64max: b64max11,
                                                                                                                            length: func106(data45)
                                                                                                                        },
                                                                                                                        message: 'length must be between ' +
                                                                                                                            b64min11 +
                                                                                                                            ' and ' +
                                                                                                                            b64max11 +
                                                                                                                            ', but is ' +
                                                                                                                            func106(data45)
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                            else {
                                                                                                                const decoded11 = func107(data45);
                                                                                                                if (decoded11.length !== 9) {
                                                                                                                    validate25.errors = [
                                                                                                                        {
                                                                                                                            instancePath: instancePath + '/rowcountLocation/uploadID',
                                                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                                            keyword: 'uid',
                                                                                                                            params: { error: 'decoded' },
                                                                                                                            message: 'must decode to 9 bytes'
                                                                                                                        }
                                                                                                                    ];
                                                                                                                    return false;
                                                                                                                }
                                                                                                                else {
                                                                                                                    const encoded11 = func108(decoded11);
                                                                                                                    if (func109(encoded11) !== func109(data45)) {
                                                                                                                        validate25.errors = [
                                                                                                                            {
                                                                                                                                instancePath: instancePath + '/rowcountLocation/uploadID',
                                                                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                                                keyword: 'uid',
                                                                                                                                params: { error: 'ambiguous' },
                                                                                                                                message: 'encoding is ambiguous'
                                                                                                                            }
                                                                                                                        ];
                                                                                                                        return false;
                                                                                                                    }
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                        else {
                                                                                                            validate25.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/rowcountLocation/uploadID',
                                                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                                                                                    keyword: 'type',
                                                                                                                    params: { type: 'string' },
                                                                                                                    message: 'must be string'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                    }
                                                                                                    var valid33 = _errs101 === errors;
                                                                                                }
                                                                                                else {
                                                                                                    var valid33 = true;
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    validate25.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/rowcountLocation',
                                                                                            schemaPath: 'urn:wisepipe-common:S3File/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'object' },
                                                                                            message: 'must be object'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            var valid0 = _errs94 === errors;
                                                                        }
                                                                        else {
                                                                            var valid0 = true;
                                                                        }
                                                                        if (valid0) {
                                                                            if (data.lastUpdated !== undefined) {
                                                                                let data46 = data.lastUpdated;
                                                                                const _errs103 = errors;
                                                                                if (errors === _errs103) {
                                                                                    if (errors === _errs103) {
                                                                                        if (typeof data46 === 'string') {
                                                                                            if (!formats0.validate(data46)) {
                                                                                                validate25.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/lastUpdated',
                                                                                                        schemaPath: '#/properties/lastUpdated/format',
                                                                                                        keyword: 'format',
                                                                                                        params: { format: 'date-time' },
                                                                                                        message: 'must match format "' + 'date-time' + '"'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                        }
                                                                                        else {
                                                                                            validate25.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/lastUpdated',
                                                                                                    schemaPath: '#/properties/lastUpdated/type',
                                                                                                    keyword: 'type',
                                                                                                    params: { type: 'string' },
                                                                                                    message: 'must be string'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                }
                                                                                var valid0 = _errs103 === errors;
                                                                            }
                                                                            else {
                                                                                var valid0 = true;
                                                                            }
                                                                            if (valid0) {
                                                                                if (data.columns !== undefined) {
                                                                                    let data47 = data.columns;
                                                                                    const _errs105 = errors;
                                                                                    if (errors === _errs105) {
                                                                                        if (Array.isArray(data47)) {
                                                                                            if (data47.length < 1) {
                                                                                                validate25.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/columns',
                                                                                                        schemaPath: '#/properties/columns/minItems',
                                                                                                        keyword: 'minItems',
                                                                                                        params: { limit: 1 },
                                                                                                        message: 'must NOT have fewer than 1 items'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                            else {
                                                                                                var valid35 = true;
                                                                                                const len1 = data47.length;
                                                                                                for (let i2 = 0; i2 < len1; i2++) {
                                                                                                    const _errs107 = errors;
                                                                                                    if (!validate17(data47[i2], {
                                                                                                        instancePath: instancePath + '/columns/' + i2,
                                                                                                        parentData: data47,
                                                                                                        parentDataProperty: i2,
                                                                                                        rootData
                                                                                                    })) {
                                                                                                        vErrors =
                                                                                                            vErrors === null
                                                                                                                ? validate17.errors
                                                                                                                : vErrors.concat(validate17.errors);
                                                                                                        errors = vErrors.length;
                                                                                                    }
                                                                                                    var valid35 = _errs107 === errors;
                                                                                                    if (!valid35) {
                                                                                                        break;
                                                                                                    }
                                                                                                }
                                                                                                if (valid35) {
                                                                                                    let i3 = data47.length;
                                                                                                    let j1;
                                                                                                    if (i3 > 1) {
                                                                                                        outer1: for (; i3--;) {
                                                                                                            for (j1 = i3; j1--;) {
                                                                                                                if (func0(data47[i3], data47[j1])) {
                                                                                                                    validate25.errors = [
                                                                                                                        {
                                                                                                                            instancePath: instancePath + '/columns',
                                                                                                                            schemaPath: '#/properties/columns/uniqueItems',
                                                                                                                            keyword: 'uniqueItems',
                                                                                                                            params: { i: i3, j: j1 },
                                                                                                                            message: 'must NOT have duplicate items (items ## ' +
                                                                                                                                j1 +
                                                                                                                                ' and ' +
                                                                                                                                i3 +
                                                                                                                                ' are identical)'
                                                                                                                        }
                                                                                                                    ];
                                                                                                                    return false;
                                                                                                                    break outer1;
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                        else {
                                                                                            validate25.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/columns',
                                                                                                    schemaPath: '#/properties/columns/type',
                                                                                                    keyword: 'type',
                                                                                                    params: { type: 'array' },
                                                                                                    message: 'must be array'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                    var valid0 = _errs105 === errors;
                                                                                }
                                                                                else {
                                                                                    var valid0 = true;
                                                                                }
                                                                                if (valid0) {
                                                                                    if (data.extractDelimiter !== undefined) {
                                                                                        let data49 = data.extractDelimiter;
                                                                                        const _errs108 = errors;
                                                                                        if (errors === _errs108) {
                                                                                            if (typeof data49 === 'string') {
                                                                                                if (func2(data49) > 1) {
                                                                                                    validate25.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/extractDelimiter',
                                                                                                            schemaPath: '#/properties/extractDelimiter/maxLength',
                                                                                                            keyword: 'maxLength',
                                                                                                            params: { limit: 1 },
                                                                                                            message: 'must NOT have more than 1 characters'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                                else {
                                                                                                    if (func2(data49) < 0) {
                                                                                                        validate25.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/extractDelimiter',
                                                                                                                schemaPath: '#/properties/extractDelimiter/minLength',
                                                                                                                keyword: 'minLength',
                                                                                                                params: { limit: 0 },
                                                                                                                message: 'must NOT have fewer than 0 characters'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                            else {
                                                                                                validate25.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/extractDelimiter',
                                                                                                        schemaPath: '#/properties/extractDelimiter/type',
                                                                                                        keyword: 'type',
                                                                                                        params: { type: 'string' },
                                                                                                        message: 'must be string'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                        }
                                                                                        var valid0 = _errs108 === errors;
                                                                                    }
                                                                                    else {
                                                                                        var valid0 = true;
                                                                                    }
                                                                                    if (valid0) {
                                                                                        if (data.extractQuoteChar !== undefined) {
                                                                                            let data50 = data.extractQuoteChar;
                                                                                            const _errs110 = errors;
                                                                                            if (errors === _errs110) {
                                                                                                if (typeof data50 === 'string') {
                                                                                                    if (func2(data50) > 1) {
                                                                                                        validate25.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/extractQuoteChar',
                                                                                                                schemaPath: '#/properties/extractQuoteChar/maxLength',
                                                                                                                keyword: 'maxLength',
                                                                                                                params: { limit: 1 },
                                                                                                                message: 'must NOT have more than 1 characters'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                    else {
                                                                                                        if (func2(data50) < 1) {
                                                                                                            validate25.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/extractQuoteChar',
                                                                                                                    schemaPath: '#/properties/extractQuoteChar/minLength',
                                                                                                                    keyword: 'minLength',
                                                                                                                    params: { limit: 1 },
                                                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                                else {
                                                                                                    validate25.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/extractQuoteChar',
                                                                                                            schemaPath: '#/properties/extractQuoteChar/type',
                                                                                                            keyword: 'type',
                                                                                                            params: { type: 'string' },
                                                                                                            message: 'must be string'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                            var valid0 = _errs110 === errors;
                                                                                        }
                                                                                        else {
                                                                                            var valid0 = true;
                                                                                        }
                                                                                        if (valid0) {
                                                                                            if (data.obsolete !== undefined) {
                                                                                                const _errs112 = errors;
                                                                                                if (typeof data.obsolete !== 'boolean') {
                                                                                                    validate25.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/obsolete',
                                                                                                            schemaPath: '#/properties/obsolete/type',
                                                                                                            keyword: 'type',
                                                                                                            params: { type: 'boolean' },
                                                                                                            message: 'must be boolean'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                                var valid0 = _errs112 === errors;
                                                                                            }
                                                                                            else {
                                                                                                var valid0 = true;
                                                                                            }
                                                                                            if (valid0) {
                                                                                                if (data.subType !== undefined) {
                                                                                                    let data52 = data.subType;
                                                                                                    const _errs114 = errors;
                                                                                                    if (typeof data52 !== 'string') {
                                                                                                        validate25.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/subType',
                                                                                                                schemaPath: '#/properties/subType/type',
                                                                                                                keyword: 'type',
                                                                                                                params: { type: 'string' },
                                                                                                                message: 'must be string'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                    if (!(data52 === 'netSuite' ||
                                                                                                        data52 === 'sapSuccessFactors' ||
                                                                                                        data52 === 'sapCrm' ||
                                                                                                        data52 === 'ukg' ||
                                                                                                        data52 === 'oracleHcm' ||
                                                                                                        data52 === 'Adp' ||
                                                                                                        data52 === 'dynamics365Sales' ||
                                                                                                        data52 === 'ceridianDayforce' ||
                                                                                                        data52 === 'oracleCrm' ||
                                                                                                        data52 === 'oracleErpCloud' ||
                                                                                                        data52 === 'sageIntacct' ||
                                                                                                        data52 === 'bambooHr' ||
                                                                                                        data52 === 'sapErp' ||
                                                                                                        data52 === 'googleCloudPlatformCloudStorage' ||
                                                                                                        data52 === 'sas' ||
                                                                                                        data52 === 'oneDrive' ||
                                                                                                        data52 === 'dropbox' ||
                                                                                                        data52 === 'googleDrive' ||
                                                                                                        data52 === 'jira' ||
                                                                                                        data52 === 'monday' ||
                                                                                                        data52 === 'zuora' ||
                                                                                                        data52 === 'adobeAnalytics' ||
                                                                                                        data52 === 'zoomInfo' ||
                                                                                                        data52 === 'marketo' ||
                                                                                                        data52 === 'activeCampaign' ||
                                                                                                        data52 === 'mailchimp' ||
                                                                                                        data52 === 'infor' ||
                                                                                                        data52 === 'cornerstoneOnDemand' ||
                                                                                                        data52 === 'gusto' ||
                                                                                                        data52 === 'paychexFlex' ||
                                                                                                        data52 === 'zendesk' ||
                                                                                                        data52 === 'serviceNow' ||
                                                                                                        data52 === 'zohoCrm' ||
                                                                                                        data52 === 'pipedrive' ||
                                                                                                        data52 === 'quickBooks' ||
                                                                                                        data52 === 'xero' ||
                                                                                                        data52 === 'freshbooks' ||
                                                                                                        data52 === 'zohoBooks' ||
                                                                                                        data52 === 'waveFinancial')) {
                                                                                                        validate25.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/subType',
                                                                                                                schemaPath: '#/properties/subType/enum',
                                                                                                                keyword: 'enum',
                                                                                                                params: { allowedValues: schema46.properties.subType.enum },
                                                                                                                message: 'must be equal to one of the allowed values'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                    var valid0 = _errs114 === errors;
                                                                                                }
                                                                                                else {
                                                                                                    var valid0 = true;
                                                                                                }
                                                                                                if (valid0) {
                                                                                                    if (data.dataCategory !== undefined) {
                                                                                                        let data53 = data.dataCategory;
                                                                                                        const _errs116 = errors;
                                                                                                        if (typeof data53 !== 'string') {
                                                                                                            validate25.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/dataCategory',
                                                                                                                    schemaPath: '#/properties/dataCategory/type',
                                                                                                                    keyword: 'type',
                                                                                                                    params: { type: 'string' },
                                                                                                                    message: 'must be string'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                        if (!(data53 === 'dataSource' ||
                                                                                                            data53 === 'unitTestDataSource' ||
                                                                                                            data53 === 'unitTestSnapshot')) {
                                                                                                            validate25.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/dataCategory',
                                                                                                                    schemaPath: '#/properties/dataCategory/enum',
                                                                                                                    keyword: 'enum',
                                                                                                                    params: {
                                                                                                                        allowedValues: schema46.properties.dataCategory.enum
                                                                                                                    },
                                                                                                                    message: 'must be equal to one of the allowed values'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                        var valid0 = _errs116 === errors;
                                                                                                    }
                                                                                                    else {
                                                                                                        var valid0 = true;
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate25.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate25.errors = vErrors;
    return errors === 0;
}
export const dynamicsImportConfigSchemaValidation = validate27;
const schema57 = {
    $id: 'urn:wisepipe-common-data:DynamicsImportConfig',
    type: 'object',
    properties: {
        startDate: { type: 'string', format: 'date-time' },
        userAgent: { type: 'string' },
        object: { type: 'string' }
    },
    required: ['startDate', 'userAgent']
};
function validate27(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:DynamicsImportConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.startDate === undefined && (missing0 = 'startDate')) ||
                (data.userAgent === undefined && (missing0 = 'userAgent'))) {
                validate27.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.startDate !== undefined) {
                    let data0 = data.startDate;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats0.validate(data0)) {
                                    validate27.errors = [
                                        {
                                            instancePath: instancePath + '/startDate',
                                            schemaPath: '#/properties/startDate/format',
                                            keyword: 'format',
                                            params: { format: 'date-time' },
                                            message: 'must match format "' + 'date-time' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate27.errors = [
                                    {
                                        instancePath: instancePath + '/startDate',
                                        schemaPath: '#/properties/startDate/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.userAgent !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.userAgent !== 'string') {
                            validate27.errors = [
                                {
                                    instancePath: instancePath + '/userAgent',
                                    schemaPath: '#/properties/userAgent/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.object !== undefined) {
                            const _errs5 = errors;
                            if (typeof data.object !== 'string') {
                                validate27.errors = [
                                    {
                                        instancePath: instancePath + '/object',
                                        schemaPath: '#/properties/object/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate27.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate27.errors = vErrors;
    return errors === 0;
}
export const eltApiImportConfigSchemaValidation = validate28;
const schema58 = {
    $id: 'urn:wisepipe-common-data:EltApiImportConfigSchema',
    type: 'object',
    properties: { apiType: { type: 'string', enum: ['userList'] } },
    required: ['apiType']
};
function validate28(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:EltApiImportConfigSchema" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.apiType === undefined && (missing0 = 'apiType')) {
                validate28.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.apiType !== undefined) {
                    let data0 = data.apiType;
                    if (typeof data0 !== 'string') {
                        validate28.errors = [
                            {
                                instancePath: instancePath + '/apiType',
                                schemaPath: '#/properties/apiType/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'userList')) {
                        validate28.errors = [
                            {
                                instancePath: instancePath + '/apiType',
                                schemaPath: '#/properties/apiType/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema58.properties.apiType.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                }
            }
        }
        else {
            validate28.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate28.errors = vErrors;
    return errors === 0;
}
export const excelImportConfigSchemaValidation = validate29;
const schema59 = {
    $id: 'urn:wisepipe-common-data:ExcelImportConfig',
    type: 'object',
    properties: { hasHeader: { type: 'boolean' } },
    required: ['hasHeader']
};
function validate29(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:ExcelImportConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.hasHeader === undefined && (missing0 = 'hasHeader')) {
                validate29.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.hasHeader !== undefined) {
                    if (typeof data.hasHeader !== 'boolean') {
                        validate29.errors = [
                            {
                                instancePath: instancePath + '/hasHeader',
                                schemaPath: '#/properties/hasHeader/type',
                                keyword: 'type',
                                params: { type: 'boolean' },
                                message: 'must be boolean'
                            }
                        ];
                        return false;
                    }
                }
            }
        }
        else {
            validate29.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate29.errors = vErrors;
    return errors === 0;
}
export const extractionParametersSchemaValidation = validate30;
const schema60 = {
    $id: 'urn:wisepipe-common-data:ExtractionParameters',
    type: 'object',
    properties: {
        connection: { $ref: 'urn:wisepipe-common-connection:Connection' },
        credentials: { $ref: 'urn:wisepipe-common:Credentials' },
        csvExtractionFolder: { $ref: 'urn:wisepipe-common:S3File' },
        streamID: { type: 'string', minLength: 1 }
    },
    required: ['csvExtractionFolder']
};
const func115 = ucs2length;
const func116 = base64urlToBuffer;
const func117 = base64urlEncode;
const func118 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func123 = ucs2length;
const func124 = base64urlToBuffer;
const func125 = base64urlEncode;
const func126 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate30(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:ExtractionParameters" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.csvExtractionFolder === undefined && (missing0 = 'csvExtractionFolder')) {
                validate30.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.connection !== undefined) {
                    let data0 = data.connection;
                    const _errs1 = errors;
                    const _errs2 = errors;
                    if (errors === _errs2) {
                        if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                            let missing1;
                            if ((data0.connectionType === undefined && (missing1 = 'connectionType')) ||
                                (data0.name === undefined && (missing1 = 'name'))) {
                                validate30.errors = [
                                    {
                                        instancePath: instancePath + '/connection',
                                        schemaPath: 'urn:wisepipe-common-connection:Connection/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing1 },
                                        message: "must have required property '" + missing1 + "'"
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0.connectionID !== undefined) {
                                    let data1 = data0.connectionID;
                                    const _errs4 = errors;
                                    if (errors === _errs4) {
                                        if (typeof data1 === 'string') {
                                            const b64min0 = Math.ceil((4 * 9) / 3);
                                            const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                            if (func115(data1) < b64min0 || func115(data1) > b64max0) {
                                                validate30.errors = [
                                                    {
                                                        instancePath: instancePath + '/connection/connectionID',
                                                        schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func115(data1) },
                                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func115(data1)
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                const decoded0 = func116(data1);
                                                if (decoded0.length !== 9) {
                                                    validate30.errors = [
                                                        {
                                                            instancePath: instancePath + '/connection/connectionID',
                                                            schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionID/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'decoded' },
                                                            message: 'must decode to 9 bytes'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    const encoded0 = func117(decoded0);
                                                    if (func118(encoded0) !== func118(data1)) {
                                                        validate30.errors = [
                                                            {
                                                                instancePath: instancePath + '/connection/connectionID',
                                                                schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionID/uid',
                                                                keyword: 'uid',
                                                                params: { error: 'ambiguous' },
                                                                message: 'encoding is ambiguous'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate30.errors = [
                                                {
                                                    instancePath: instancePath + '/connection/connectionID',
                                                    schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionID/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid2 = _errs4 === errors;
                                }
                                else {
                                    var valid2 = true;
                                }
                                if (valid2) {
                                    if (data0.connectionType !== undefined) {
                                        let data2 = data0.connectionType;
                                        const _errs6 = errors;
                                        if (typeof data2 !== 'string') {
                                            validate30.errors = [
                                                {
                                                    instancePath: instancePath + '/connection/connectionType',
                                                    schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionType/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        if (!(data2 === 'google' ||
                                            data2 === 'gsheetsImport' ||
                                            data2 === 'gsheetsExport' ||
                                            data2 === 'shopify' ||
                                            data2 === 'salesForce' ||
                                            data2 === 'postgreSql' ||
                                            data2 === 'icm' ||
                                            data2 === 'tq-postgres' ||
                                            data2 === 'mySql' ||
                                            data2 === 'msSql' ||
                                            data2 === 'oracle' ||
                                            data2 === 'amazonRedshift' ||
                                            data2 === 'amazonAurora' ||
                                            data2 === 'amazonS3' ||
                                            data2 === 'amazonS3Export' ||
                                            data2 === 'tqp' ||
                                            data2 === 'hubspot' ||
                                            data2 === 'symon' ||
                                            data2 === 'snowflake' ||
                                            data2 === 'dynamics' ||
                                            data2 === 'agentSync' ||
                                            data2 === 'workday' ||
                                            data2 === 'workdayRaaS' ||
                                            data2 === 'workdayExport' ||
                                            data2 === 'tableau' ||
                                            data2 === 'sftp' ||
                                            data2 === 'powerbi' ||
                                            data2 === 'rest' ||
                                            data2 === 'gong' ||
                                            data2 === 'netSuite' ||
                                            data2 === 'oneDrive' ||
                                            data2 === 'oneDriveExport' ||
                                            data2 === 'sapSuccessFactors' ||
                                            data2 === 'sapCrm' ||
                                            data2 === 'ukg' ||
                                            data2 === 'oracleHcm' ||
                                            data2 === 'Adp' ||
                                            data2 === 'dynamics365Sales' ||
                                            data2 === 'ceridianDayforce' ||
                                            data2 === 'oracleCrm' ||
                                            data2 === 'oracleErpCloud' ||
                                            data2 === 'sageIntacct' ||
                                            data2 === 'bambooHr' ||
                                            data2 === 'sapErp' ||
                                            data2 === 'googleCloudPlatformCloudStorage' ||
                                            data2 === 'sas' ||
                                            data2 === 'dropbox' ||
                                            data2 === 'googleDrive' ||
                                            data2 === 'jira' ||
                                            data2 === 'monday' ||
                                            data2 === 'zuora' ||
                                            data2 === 'adobeAnalytics' ||
                                            data2 === 'zoomInfo' ||
                                            data2 === 'marketo' ||
                                            data2 === 'activeCampaign' ||
                                            data2 === 'mailchimp' ||
                                            data2 === 'infor' ||
                                            data2 === 'cornerstoneOnDemand' ||
                                            data2 === 'gusto' ||
                                            data2 === 'paychexFlex' ||
                                            data2 === 'zendesk' ||
                                            data2 === 'serviceNow' ||
                                            data2 === 'zohoCrm' ||
                                            data2 === 'pipedrive' ||
                                            data2 === 'quickBooks' ||
                                            data2 === 'xero' ||
                                            data2 === 'freshbooks' ||
                                            data2 === 'zohoBooks' ||
                                            data2 === 'waveFinancial')) {
                                            validate30.errors = [
                                                {
                                                    instancePath: instancePath + '/connection/connectionType',
                                                    schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionType/enum',
                                                    keyword: 'enum',
                                                    params: { allowedValues: schema41.properties.connectionType.enum },
                                                    message: 'must be equal to one of the allowed values'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid2 = _errs6 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                    if (valid2) {
                                        if (data0.name !== undefined) {
                                            let data3 = data0.name;
                                            const _errs8 = errors;
                                            if (errors === _errs8) {
                                                if (typeof data3 === 'string') {
                                                    if (func2(data3) < 1) {
                                                        validate30.errors = [
                                                            {
                                                                instancePath: instancePath + '/connection/name',
                                                                schemaPath: 'urn:wisepipe-common-connection:Connection/properties/name/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate30.errors = [
                                                        {
                                                            instancePath: instancePath + '/connection/name',
                                                            schemaPath: 'urn:wisepipe-common-connection:Connection/properties/name/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid2 = _errs8 === errors;
                                        }
                                        else {
                                            var valid2 = true;
                                        }
                                        if (valid2) {
                                            if (data0.source !== undefined) {
                                                let data4 = data0.source;
                                                const _errs10 = errors;
                                                if (errors === _errs10) {
                                                    if (typeof data4 === 'string') {
                                                        if (func2(data4) < 1) {
                                                            validate30.errors = [
                                                                {
                                                                    instancePath: instancePath + '/connection/source',
                                                                    schemaPath: 'urn:wisepipe-common-connection:Connection/properties/source/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate30.errors = [
                                                            {
                                                                instancePath: instancePath + '/connection/source',
                                                                schemaPath: 'urn:wisepipe-common-connection:Connection/properties/source/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid2 = _errs10 === errors;
                                            }
                                            else {
                                                var valid2 = true;
                                            }
                                            if (valid2) {
                                                if (data0.failedOnLastTry !== undefined) {
                                                    const _errs12 = errors;
                                                    if (typeof data0.failedOnLastTry !== 'boolean') {
                                                        validate30.errors = [
                                                            {
                                                                instancePath: instancePath + '/connection/failedOnLastTry',
                                                                schemaPath: 'urn:wisepipe-common-connection:Connection/properties/failedOnLastTry/type',
                                                                keyword: 'type',
                                                                params: { type: 'boolean' },
                                                                message: 'must be boolean'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid2 = _errs12 === errors;
                                                }
                                                else {
                                                    var valid2 = true;
                                                }
                                                if (valid2) {
                                                    if (data0.isDiscoveryFail !== undefined) {
                                                        const _errs14 = errors;
                                                        if (typeof data0.isDiscoveryFail !== 'boolean') {
                                                            validate30.errors = [
                                                                {
                                                                    instancePath: instancePath + '/connection/isDiscoveryFail',
                                                                    schemaPath: 'urn:wisepipe-common-connection:Connection/properties/isDiscoveryFail/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'boolean' },
                                                                    message: 'must be boolean'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid2 = _errs14 === errors;
                                                    }
                                                    else {
                                                        var valid2 = true;
                                                    }
                                                    if (valid2) {
                                                        if (data0.verificationErrorMessage !== undefined) {
                                                            const _errs16 = errors;
                                                            if (typeof data0.verificationErrorMessage !== 'string') {
                                                                validate30.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/connection/verificationErrorMessage',
                                                                        schemaPath: 'urn:wisepipe-common-connection:Connection/properties/verificationErrorMessage/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid2 = _errs16 === errors;
                                                        }
                                                        else {
                                                            var valid2 = true;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate30.errors = [
                                {
                                    instancePath: instancePath + '/connection',
                                    schemaPath: 'urn:wisepipe-common-connection:Connection/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.credentials !== undefined) {
                        let data8 = data.credentials;
                        const _errs18 = errors;
                        const _errs19 = errors;
                        if (errors === _errs19) {
                            if (data8 && typeof data8 == 'object' && !Array.isArray(data8)) {
                                let missing2;
                                if (data8.credentialsType === undefined && (missing2 = 'credentialsType')) {
                                    validate30.errors = [
                                        {
                                            instancePath: instancePath + '/credentials',
                                            schemaPath: 'urn:wisepipe-common:Credentials/required',
                                            keyword: 'required',
                                            params: { missingProperty: missing2 },
                                            message: "must have required property '" + missing2 + "'"
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (data8.credentialsType !== undefined) {
                                        let data9 = data8.credentialsType;
                                        if (typeof data9 !== 'string') {
                                            validate30.errors = [
                                                {
                                                    instancePath: instancePath + '/credentials/credentialsType',
                                                    schemaPath: 'urn:wisepipe-common:Credentials/properties/credentialsType/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        if (!(data9 === 'oauth' ||
                                            data9 === 'userPassword' ||
                                            data9 === 's3Credentials' ||
                                            data9 === 'apiKey' ||
                                            data9 === 'symon' ||
                                            data9 === 'awsRoleAssumption' ||
                                            data9 === 'rest' ||
                                            data9 === 'tokenBasedAuthentication')) {
                                            validate30.errors = [
                                                {
                                                    instancePath: instancePath + '/credentials/credentialsType',
                                                    schemaPath: 'urn:wisepipe-common:Credentials/properties/credentialsType/enum',
                                                    keyword: 'enum',
                                                    params: { allowedValues: schema42.properties.credentialsType.enum },
                                                    message: 'must be equal to one of the allowed values'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            else {
                                validate30.errors = [
                                    {
                                        instancePath: instancePath + '/credentials',
                                        schemaPath: 'urn:wisepipe-common:Credentials/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs18 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.csvExtractionFolder !== undefined) {
                            let data10 = data.csvExtractionFolder;
                            const _errs23 = errors;
                            const _errs24 = errors;
                            if (errors === _errs24) {
                                if (data10 && typeof data10 == 'object' && !Array.isArray(data10)) {
                                    let missing3;
                                    if ((data10.bucket === undefined && (missing3 = 'bucket')) ||
                                        (data10.key === undefined && (missing3 = 'key'))) {
                                        validate30.errors = [
                                            {
                                                instancePath: instancePath + '/csvExtractionFolder',
                                                schemaPath: 'urn:wisepipe-common:S3File/required',
                                                keyword: 'required',
                                                params: { missingProperty: missing3 },
                                                message: "must have required property '" + missing3 + "'"
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        if (data10.bucket !== undefined) {
                                            let data11 = data10.bucket;
                                            const _errs26 = errors;
                                            if (errors === _errs26) {
                                                if (typeof data11 === 'string') {
                                                    if (func2(data11) < 1) {
                                                        validate30.errors = [
                                                            {
                                                                instancePath: instancePath + '/csvExtractionFolder/bucket',
                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate30.errors = [
                                                        {
                                                            instancePath: instancePath + '/csvExtractionFolder/bucket',
                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid7 = _errs26 === errors;
                                        }
                                        else {
                                            var valid7 = true;
                                        }
                                        if (valid7) {
                                            if (data10.key !== undefined) {
                                                let data12 = data10.key;
                                                const _errs28 = errors;
                                                if (errors === _errs28) {
                                                    if (typeof data12 === 'string') {
                                                        if (func2(data12) < 1) {
                                                            validate30.errors = [
                                                                {
                                                                    instancePath: instancePath + '/csvExtractionFolder/key',
                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate30.errors = [
                                                            {
                                                                instancePath: instancePath + '/csvExtractionFolder/key',
                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid7 = _errs28 === errors;
                                            }
                                            else {
                                                var valid7 = true;
                                            }
                                            if (valid7) {
                                                if (data10.uploadID !== undefined) {
                                                    let data13 = data10.uploadID;
                                                    const _errs30 = errors;
                                                    if (errors === _errs30) {
                                                        if (typeof data13 === 'string') {
                                                            const b64min1 = Math.ceil((4 * 9) / 3);
                                                            const b64max1 = Math.ceil((4 * 9) / 3) + 3;
                                                            if (func123(data13) < b64min1 || func123(data13) > b64max1) {
                                                                validate30.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/csvExtractionFolder/uploadID',
                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                        keyword: 'uid',
                                                                        params: {
                                                                            error: 'encoded',
                                                                            b64min: b64min1,
                                                                            b64max: b64max1,
                                                                            length: func123(data13)
                                                                        },
                                                                        message: 'length must be between ' +
                                                                            b64min1 +
                                                                            ' and ' +
                                                                            b64max1 +
                                                                            ', but is ' +
                                                                            func123(data13)
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            else {
                                                                const decoded1 = func124(data13);
                                                                if (decoded1.length !== 9) {
                                                                    validate30.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/csvExtractionFolder/uploadID',
                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                            keyword: 'uid',
                                                                            params: { error: 'decoded' },
                                                                            message: 'must decode to 9 bytes'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                else {
                                                                    const encoded1 = func125(decoded1);
                                                                    if (func126(encoded1) !== func126(data13)) {
                                                                        validate30.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/csvExtractionFolder/uploadID',
                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                keyword: 'uid',
                                                                                params: { error: 'ambiguous' },
                                                                                message: 'encoding is ambiguous'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                        else {
                                                            validate30.errors = [
                                                                {
                                                                    instancePath: instancePath + '/csvExtractionFolder/uploadID',
                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid7 = _errs30 === errors;
                                                }
                                                else {
                                                    var valid7 = true;
                                                }
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate30.errors = [
                                        {
                                            instancePath: instancePath + '/csvExtractionFolder',
                                            schemaPath: 'urn:wisepipe-common:S3File/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs23 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.streamID !== undefined) {
                                let data14 = data.streamID;
                                const _errs32 = errors;
                                if (errors === _errs32) {
                                    if (typeof data14 === 'string') {
                                        if (func2(data14) < 1) {
                                            validate30.errors = [
                                                {
                                                    instancePath: instancePath + '/streamID',
                                                    schemaPath: '#/properties/streamID/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate30.errors = [
                                            {
                                                instancePath: instancePath + '/streamID',
                                                schemaPath: '#/properties/streamID/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs32 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate30.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate30.errors = vErrors;
    return errors === 0;
}
export const extractionSplitConfigSchemaValidation = validate31;
const schema64 = {
    $id: 'urn:wisepipe-common-data:ExtractionSplitConfig',
    type: 'object',
    properties: {
        splits: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-data:ExtractionSplit' },
            minItems: 1,
            uniqueItemProperties: ['index']
        },
        rangeSize: { type: 'integer', minimum: 1048576, maximum: 134217728 }
    },
    required: ['splits', 'rangeSize']
};
const schema65 = {
    $id: 'urn:wisepipe-common-data:ExtractionSplit',
    type: 'object',
    properties: {
        index: { type: 'integer', minimum: 0 },
        isFirst: { type: 'boolean' },
        isLast: { type: 'boolean' },
        start: { type: 'integer' },
        end: { type: 'integer' }
    },
    required: ['index', 'isFirst', 'isLast']
};
const func128 = ajvEqual;
function validate31(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:ExtractionSplitConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.splits === undefined && (missing0 = 'splits')) ||
                (data.rangeSize === undefined && (missing0 = 'rangeSize'))) {
                validate31.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.splits !== undefined) {
                    let data0 = data.splits;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            if (data0.length < 1) {
                                validate31.errors = [
                                    {
                                        instancePath: instancePath + '/splits',
                                        schemaPath: '#/properties/splits/minItems',
                                        keyword: 'minItems',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 items'
                                    }
                                ];
                                return false;
                            }
                            else {
                                var valid1 = true;
                                const len0 = data0.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data1 = data0[i0];
                                    const _errs3 = errors;
                                    const _errs4 = errors;
                                    if (errors === _errs4) {
                                        if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                            let missing1;
                                            if ((data1.index === undefined && (missing1 = 'index')) ||
                                                (data1.isFirst === undefined && (missing1 = 'isFirst')) ||
                                                (data1.isLast === undefined && (missing1 = 'isLast'))) {
                                                validate31.errors = [
                                                    {
                                                        instancePath: instancePath + '/splits/' + i0,
                                                        schemaPath: 'urn:wisepipe-common-data:ExtractionSplit/required',
                                                        keyword: 'required',
                                                        params: { missingProperty: missing1 },
                                                        message: "must have required property '" + missing1 + "'"
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (data1.index !== undefined) {
                                                    let data2 = data1.index;
                                                    const _errs6 = errors;
                                                    if (!(typeof data2 == 'number' && !(data2 % 1) && !isNaN(data2))) {
                                                        validate31.errors = [
                                                            {
                                                                instancePath: instancePath + '/splits/' + i0 + '/index',
                                                                schemaPath: 'urn:wisepipe-common-data:ExtractionSplit/properties/index/type',
                                                                keyword: 'type',
                                                                params: { type: 'integer' },
                                                                message: 'must be integer'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    if (errors === _errs6) {
                                                        if (typeof data2 == 'number') {
                                                            if (data2 < 0 || isNaN(data2)) {
                                                                validate31.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/splits/' + i0 + '/index',
                                                                        schemaPath: 'urn:wisepipe-common-data:ExtractionSplit/properties/index/minimum',
                                                                        keyword: 'minimum',
                                                                        params: { comparison: '>=', limit: 0 },
                                                                        message: 'must be >= 0'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                    }
                                                    var valid3 = _errs6 === errors;
                                                }
                                                else {
                                                    var valid3 = true;
                                                }
                                                if (valid3) {
                                                    if (data1.isFirst !== undefined) {
                                                        const _errs8 = errors;
                                                        if (typeof data1.isFirst !== 'boolean') {
                                                            validate31.errors = [
                                                                {
                                                                    instancePath: instancePath + '/splits/' + i0 + '/isFirst',
                                                                    schemaPath: 'urn:wisepipe-common-data:ExtractionSplit/properties/isFirst/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'boolean' },
                                                                    message: 'must be boolean'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid3 = _errs8 === errors;
                                                    }
                                                    else {
                                                        var valid3 = true;
                                                    }
                                                    if (valid3) {
                                                        if (data1.isLast !== undefined) {
                                                            const _errs10 = errors;
                                                            if (typeof data1.isLast !== 'boolean') {
                                                                validate31.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/splits/' + i0 + '/isLast',
                                                                        schemaPath: 'urn:wisepipe-common-data:ExtractionSplit/properties/isLast/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'boolean' },
                                                                        message: 'must be boolean'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid3 = _errs10 === errors;
                                                        }
                                                        else {
                                                            var valid3 = true;
                                                        }
                                                        if (valid3) {
                                                            if (data1.start !== undefined) {
                                                                let data5 = data1.start;
                                                                const _errs12 = errors;
                                                                if (!(typeof data5 == 'number' && !(data5 % 1) && !isNaN(data5))) {
                                                                    validate31.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/splits/' + i0 + '/start',
                                                                            schemaPath: 'urn:wisepipe-common-data:ExtractionSplit/properties/start/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'integer' },
                                                                            message: 'must be integer'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid3 = _errs12 === errors;
                                                            }
                                                            else {
                                                                var valid3 = true;
                                                            }
                                                            if (valid3) {
                                                                if (data1.end !== undefined) {
                                                                    let data6 = data1.end;
                                                                    const _errs14 = errors;
                                                                    if (!(typeof data6 == 'number' && !(data6 % 1) && !isNaN(data6))) {
                                                                        validate31.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/splits/' + i0 + '/end',
                                                                                schemaPath: 'urn:wisepipe-common-data:ExtractionSplit/properties/end/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'integer' },
                                                                                message: 'must be integer'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    var valid3 = _errs14 === errors;
                                                                }
                                                                else {
                                                                    var valid3 = true;
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate31.errors = [
                                                {
                                                    instancePath: instancePath + '/splits/' + i0,
                                                    schemaPath: 'urn:wisepipe-common-data:ExtractionSplit/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid1 = _errs3 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                                if (valid1) {
                                    const keys0 = schema64.properties.splits.uniqueItemProperties;
                                    let k0;
                                    let i1 = data0.length;
                                    let j0;
                                    if (i1 > 1) {
                                        outer0: for (k0 = 0; k0 < keys0.length; k0++) {
                                            let key0 = keys0[k0];
                                            for (i1 = data0.length; i1--;) {
                                                let x0 = data0[i1];
                                                if (!(x0 && typeof x0 == 'object' && !Array.isArray(x0))) {
                                                    continue;
                                                }
                                                for (j0 = i1; j0--;) {
                                                    let y0 = data0[j0];
                                                    if (y0 && typeof y0 == 'object' && !Array.isArray(y0) && func128(x0[key0], y0[key0])) {
                                                        validate31.errors = [
                                                            {
                                                                instancePath: instancePath + '/splits',
                                                                schemaPath: '#/properties/splits/uniqueItemProperties',
                                                                keyword: 'uniqueItemProperties',
                                                                params: {},
                                                                message: 'must pass "uniqueItemProperties" keyword validation'
                                                            }
                                                        ];
                                                        return false;
                                                        break outer0;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate31.errors = [
                                {
                                    instancePath: instancePath + '/splits',
                                    schemaPath: '#/properties/splits/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.rangeSize !== undefined) {
                        let data7 = data.rangeSize;
                        const _errs16 = errors;
                        if (!(typeof data7 == 'number' && !(data7 % 1) && !isNaN(data7))) {
                            validate31.errors = [
                                {
                                    instancePath: instancePath + '/rangeSize',
                                    schemaPath: '#/properties/rangeSize/type',
                                    keyword: 'type',
                                    params: { type: 'integer' },
                                    message: 'must be integer'
                                }
                            ];
                            return false;
                        }
                        if (errors === _errs16) {
                            if (typeof data7 == 'number') {
                                if (data7 > 134217728 || isNaN(data7)) {
                                    validate31.errors = [
                                        {
                                            instancePath: instancePath + '/rangeSize',
                                            schemaPath: '#/properties/rangeSize/maximum',
                                            keyword: 'maximum',
                                            params: { comparison: '<=', limit: 134217728 },
                                            message: 'must be <= 134217728'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (data7 < 1048576 || isNaN(data7)) {
                                        validate31.errors = [
                                            {
                                                instancePath: instancePath + '/rangeSize',
                                                schemaPath: '#/properties/rangeSize/minimum',
                                                keyword: 'minimum',
                                                params: { comparison: '>=', limit: 1048576 },
                                                message: 'must be >= 1048576'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        var valid0 = _errs16 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate31.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate31.errors = vErrors;
    return errors === 0;
}
export const extractionSplitSchemaValidation = validate32;
function validate32(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:ExtractionSplit" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.index === undefined && (missing0 = 'index')) ||
                (data.isFirst === undefined && (missing0 = 'isFirst')) ||
                (data.isLast === undefined && (missing0 = 'isLast'))) {
                validate32.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.index !== undefined) {
                    let data0 = data.index;
                    const _errs1 = errors;
                    if (!(typeof data0 == 'number' && !(data0 % 1) && !isNaN(data0))) {
                        validate32.errors = [
                            {
                                instancePath: instancePath + '/index',
                                schemaPath: '#/properties/index/type',
                                keyword: 'type',
                                params: { type: 'integer' },
                                message: 'must be integer'
                            }
                        ];
                        return false;
                    }
                    if (errors === _errs1) {
                        if (typeof data0 == 'number') {
                            if (data0 < 0 || isNaN(data0)) {
                                validate32.errors = [
                                    {
                                        instancePath: instancePath + '/index',
                                        schemaPath: '#/properties/index/minimum',
                                        keyword: 'minimum',
                                        params: { comparison: '>=', limit: 0 },
                                        message: 'must be >= 0'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.isFirst !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.isFirst !== 'boolean') {
                            validate32.errors = [
                                {
                                    instancePath: instancePath + '/isFirst',
                                    schemaPath: '#/properties/isFirst/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.isLast !== undefined) {
                            const _errs5 = errors;
                            if (typeof data.isLast !== 'boolean') {
                                validate32.errors = [
                                    {
                                        instancePath: instancePath + '/isLast',
                                        schemaPath: '#/properties/isLast/type',
                                        keyword: 'type',
                                        params: { type: 'boolean' },
                                        message: 'must be boolean'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.start !== undefined) {
                                let data3 = data.start;
                                const _errs7 = errors;
                                if (!(typeof data3 == 'number' && !(data3 % 1) && !isNaN(data3))) {
                                    validate32.errors = [
                                        {
                                            instancePath: instancePath + '/start',
                                            schemaPath: '#/properties/start/type',
                                            keyword: 'type',
                                            params: { type: 'integer' },
                                            message: 'must be integer'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.end !== undefined) {
                                    let data4 = data.end;
                                    const _errs9 = errors;
                                    if (!(typeof data4 == 'number' && !(data4 % 1) && !isNaN(data4))) {
                                        validate32.errors = [
                                            {
                                                instancePath: instancePath + '/end',
                                                schemaPath: '#/properties/end/type',
                                                keyword: 'type',
                                                params: { type: 'integer' },
                                                message: 'must be integer'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate32.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate32.errors = vErrors;
    return errors === 0;
}
export const flatFileImportConfigSchemaValidation = validate33;
const schema67 = {
    $id: 'urn:wisepipe-common-data:FlatFileImportConfig',
    type: 'object',
    properties: { s3File: { $ref: 'urn:wisepipe-common:S3File' } },
    required: ['s3File']
};
const func131 = ucs2length;
const func132 = base64urlToBuffer;
const func133 = base64urlEncode;
const func134 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate33(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:FlatFileImportConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.s3File === undefined && (missing0 = 's3File')) {
                validate33.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.s3File !== undefined) {
                    let data0 = data.s3File;
                    const _errs2 = errors;
                    if (errors === _errs2) {
                        if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                            let missing1;
                            if ((data0.bucket === undefined && (missing1 = 'bucket')) ||
                                (data0.key === undefined && (missing1 = 'key'))) {
                                validate33.errors = [
                                    {
                                        instancePath: instancePath + '/s3File',
                                        schemaPath: 'urn:wisepipe-common:S3File/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing1 },
                                        message: "must have required property '" + missing1 + "'"
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0.bucket !== undefined) {
                                    let data1 = data0.bucket;
                                    const _errs4 = errors;
                                    if (errors === _errs4) {
                                        if (typeof data1 === 'string') {
                                            if (func2(data1) < 1) {
                                                validate33.errors = [
                                                    {
                                                        instancePath: instancePath + '/s3File/bucket',
                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate33.errors = [
                                                {
                                                    instancePath: instancePath + '/s3File/bucket',
                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid2 = _errs4 === errors;
                                }
                                else {
                                    var valid2 = true;
                                }
                                if (valid2) {
                                    if (data0.key !== undefined) {
                                        let data2 = data0.key;
                                        const _errs6 = errors;
                                        if (errors === _errs6) {
                                            if (typeof data2 === 'string') {
                                                if (func2(data2) < 1) {
                                                    validate33.errors = [
                                                        {
                                                            instancePath: instancePath + '/s3File/key',
                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate33.errors = [
                                                    {
                                                        instancePath: instancePath + '/s3File/key',
                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid2 = _errs6 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                    if (valid2) {
                                        if (data0.uploadID !== undefined) {
                                            let data3 = data0.uploadID;
                                            const _errs8 = errors;
                                            if (errors === _errs8) {
                                                if (typeof data3 === 'string') {
                                                    const b64min0 = Math.ceil((4 * 9) / 3);
                                                    const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                                    if (func131(data3) < b64min0 || func131(data3) > b64max0) {
                                                        validate33.errors = [
                                                            {
                                                                instancePath: instancePath + '/s3File/uploadID',
                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                keyword: 'uid',
                                                                params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func131(data3) },
                                                                message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func131(data3)
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        const decoded0 = func132(data3);
                                                        if (decoded0.length !== 9) {
                                                            validate33.errors = [
                                                                {
                                                                    instancePath: instancePath + '/s3File/uploadID',
                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                    keyword: 'uid',
                                                                    params: { error: 'decoded' },
                                                                    message: 'must decode to 9 bytes'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            const encoded0 = func133(decoded0);
                                                            if (func134(encoded0) !== func134(data3)) {
                                                                validate33.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/s3File/uploadID',
                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                        keyword: 'uid',
                                                                        params: { error: 'ambiguous' },
                                                                        message: 'encoding is ambiguous'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate33.errors = [
                                                        {
                                                            instancePath: instancePath + '/s3File/uploadID',
                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid2 = _errs8 === errors;
                                        }
                                        else {
                                            var valid2 = true;
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate33.errors = [
                                {
                                    instancePath: instancePath + '/s3File',
                                    schemaPath: 'urn:wisepipe-common:S3File/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate33.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate33.errors = vErrors;
    return errors === 0;
}
export const fwfColumnConfigurationSchemaValidation = validate34;
const schema69 = {
    $id: 'urn:wisepipe-common-data:FwfColumnConfiguration',
    type: 'object',
    properties: {
        columnSpecs: { type: 'array', items: { type: 'array', items: { type: 'number' } } },
        columnsToRename: { type: 'array', items: { type: 'array', items: { type: 'string' } } }
    },
    required: ['columnSpecs']
};
function validate34(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:FwfColumnConfiguration" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.columnSpecs === undefined && (missing0 = 'columnSpecs')) {
                validate34.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.columnSpecs !== undefined) {
                    let data0 = data.columnSpecs;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            var valid1 = true;
                            const len0 = data0.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                                let data1 = data0[i0];
                                const _errs3 = errors;
                                if (errors === _errs3) {
                                    if (Array.isArray(data1)) {
                                        var valid2 = true;
                                        const len1 = data1.length;
                                        for (let i1 = 0; i1 < len1; i1++) {
                                            const _errs5 = errors;
                                            if (!(typeof data1[i1] == 'number')) {
                                                validate34.errors = [
                                                    {
                                                        instancePath: instancePath + '/columnSpecs/' + i0 + '/' + i1,
                                                        schemaPath: '#/properties/columnSpecs/items/items/type',
                                                        keyword: 'type',
                                                        params: { type: 'number' },
                                                        message: 'must be number'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid2 = _errs5 === errors;
                                            if (!valid2) {
                                                break;
                                            }
                                        }
                                    }
                                    else {
                                        validate34.errors = [
                                            {
                                                instancePath: instancePath + '/columnSpecs/' + i0,
                                                schemaPath: '#/properties/columnSpecs/items/type',
                                                keyword: 'type',
                                                params: { type: 'array' },
                                                message: 'must be array'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid1 = _errs3 === errors;
                                if (!valid1) {
                                    break;
                                }
                            }
                        }
                        else {
                            validate34.errors = [
                                {
                                    instancePath: instancePath + '/columnSpecs',
                                    schemaPath: '#/properties/columnSpecs/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.columnsToRename !== undefined) {
                        let data3 = data.columnsToRename;
                        const _errs7 = errors;
                        if (errors === _errs7) {
                            if (Array.isArray(data3)) {
                                var valid3 = true;
                                const len2 = data3.length;
                                for (let i2 = 0; i2 < len2; i2++) {
                                    let data4 = data3[i2];
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (Array.isArray(data4)) {
                                            var valid4 = true;
                                            const len3 = data4.length;
                                            for (let i3 = 0; i3 < len3; i3++) {
                                                const _errs11 = errors;
                                                if (typeof data4[i3] !== 'string') {
                                                    validate34.errors = [
                                                        {
                                                            instancePath: instancePath + '/columnsToRename/' + i2 + '/' + i3,
                                                            schemaPath: '#/properties/columnsToRename/items/items/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid4 = _errs11 === errors;
                                                if (!valid4) {
                                                    break;
                                                }
                                            }
                                        }
                                        else {
                                            validate34.errors = [
                                                {
                                                    instancePath: instancePath + '/columnsToRename/' + i2,
                                                    schemaPath: '#/properties/columnsToRename/items/type',
                                                    keyword: 'type',
                                                    params: { type: 'array' },
                                                    message: 'must be array'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid3 = _errs9 === errors;
                                    if (!valid3) {
                                        break;
                                    }
                                }
                            }
                            else {
                                validate34.errors = [
                                    {
                                        instancePath: instancePath + '/columnsToRename',
                                        schemaPath: '#/properties/columnsToRename/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs7 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate34.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate34.errors = vErrors;
    return errors === 0;
}
export const fwfImportConfigSchemaValidation = validate35;
const schema70 = {
    $id: 'urn:wisepipe-common-data:FwfImportConfig',
    type: 'object',
    properties: {
        hasHeader: { type: 'boolean' },
        delimiter: { type: 'string', minLength: 1, maxLength: 1 },
        columnConfiguration: { $ref: 'urn:wisepipe-common-data:FwfColumnConfiguration' },
        dataPreprocessConfig: { $ref: 'urn:wisepipe-common-data:DataPreprocessConfig' }
    },
    required: ['hasHeader']
};
function validate35(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:FwfImportConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.hasHeader === undefined && (missing0 = 'hasHeader')) {
                validate35.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.hasHeader !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.hasHeader !== 'boolean') {
                        validate35.errors = [
                            {
                                instancePath: instancePath + '/hasHeader',
                                schemaPath: '#/properties/hasHeader/type',
                                keyword: 'type',
                                params: { type: 'boolean' },
                                message: 'must be boolean'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.delimiter !== undefined) {
                        let data1 = data.delimiter;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) > 1) {
                                    validate35.errors = [
                                        {
                                            instancePath: instancePath + '/delimiter',
                                            schemaPath: '#/properties/delimiter/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have more than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (func2(data1) < 1) {
                                        validate35.errors = [
                                            {
                                                instancePath: instancePath + '/delimiter',
                                                schemaPath: '#/properties/delimiter/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate35.errors = [
                                    {
                                        instancePath: instancePath + '/delimiter',
                                        schemaPath: '#/properties/delimiter/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.columnConfiguration !== undefined) {
                            let data2 = data.columnConfiguration;
                            const _errs5 = errors;
                            const _errs6 = errors;
                            if (errors === _errs6) {
                                if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                    let missing1;
                                    if (data2.columnSpecs === undefined && (missing1 = 'columnSpecs')) {
                                        validate35.errors = [
                                            {
                                                instancePath: instancePath + '/columnConfiguration',
                                                schemaPath: 'urn:wisepipe-common-data:FwfColumnConfiguration/required',
                                                keyword: 'required',
                                                params: { missingProperty: missing1 },
                                                message: "must have required property '" + missing1 + "'"
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        if (data2.columnSpecs !== undefined) {
                                            let data3 = data2.columnSpecs;
                                            const _errs8 = errors;
                                            if (errors === _errs8) {
                                                if (Array.isArray(data3)) {
                                                    var valid3 = true;
                                                    const len0 = data3.length;
                                                    for (let i0 = 0; i0 < len0; i0++) {
                                                        let data4 = data3[i0];
                                                        const _errs10 = errors;
                                                        if (errors === _errs10) {
                                                            if (Array.isArray(data4)) {
                                                                var valid4 = true;
                                                                const len1 = data4.length;
                                                                for (let i1 = 0; i1 < len1; i1++) {
                                                                    const _errs12 = errors;
                                                                    if (!(typeof data4[i1] == 'number')) {
                                                                        validate35.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/columnConfiguration/columnSpecs/' + i0 + '/' + i1,
                                                                                schemaPath: 'urn:wisepipe-common-data:FwfColumnConfiguration/properties/columnSpecs/items/items/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'number' },
                                                                                message: 'must be number'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    var valid4 = _errs12 === errors;
                                                                    if (!valid4) {
                                                                        break;
                                                                    }
                                                                }
                                                            }
                                                            else {
                                                                validate35.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/columnConfiguration/columnSpecs/' + i0,
                                                                        schemaPath: 'urn:wisepipe-common-data:FwfColumnConfiguration/properties/columnSpecs/items/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'array' },
                                                                        message: 'must be array'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid3 = _errs10 === errors;
                                                        if (!valid3) {
                                                            break;
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate35.errors = [
                                                        {
                                                            instancePath: instancePath + '/columnConfiguration/columnSpecs',
                                                            schemaPath: 'urn:wisepipe-common-data:FwfColumnConfiguration/properties/columnSpecs/type',
                                                            keyword: 'type',
                                                            params: { type: 'array' },
                                                            message: 'must be array'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid2 = _errs8 === errors;
                                        }
                                        else {
                                            var valid2 = true;
                                        }
                                        if (valid2) {
                                            if (data2.columnsToRename !== undefined) {
                                                let data6 = data2.columnsToRename;
                                                const _errs14 = errors;
                                                if (errors === _errs14) {
                                                    if (Array.isArray(data6)) {
                                                        var valid5 = true;
                                                        const len2 = data6.length;
                                                        for (let i2 = 0; i2 < len2; i2++) {
                                                            let data7 = data6[i2];
                                                            const _errs16 = errors;
                                                            if (errors === _errs16) {
                                                                if (Array.isArray(data7)) {
                                                                    var valid6 = true;
                                                                    const len3 = data7.length;
                                                                    for (let i3 = 0; i3 < len3; i3++) {
                                                                        const _errs18 = errors;
                                                                        if (typeof data7[i3] !== 'string') {
                                                                            validate35.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/columnConfiguration/columnsToRename/' + i2 + '/' + i3,
                                                                                    schemaPath: 'urn:wisepipe-common-data:FwfColumnConfiguration/properties/columnsToRename/items/items/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'string' },
                                                                                    message: 'must be string'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        var valid6 = _errs18 === errors;
                                                                        if (!valid6) {
                                                                            break;
                                                                        }
                                                                    }
                                                                }
                                                                else {
                                                                    validate35.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/columnConfiguration/columnsToRename/' + i2,
                                                                            schemaPath: 'urn:wisepipe-common-data:FwfColumnConfiguration/properties/columnsToRename/items/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'array' },
                                                                            message: 'must be array'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid5 = _errs16 === errors;
                                                            if (!valid5) {
                                                                break;
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate35.errors = [
                                                            {
                                                                instancePath: instancePath + '/columnConfiguration/columnsToRename',
                                                                schemaPath: 'urn:wisepipe-common-data:FwfColumnConfiguration/properties/columnsToRename/type',
                                                                keyword: 'type',
                                                                params: { type: 'array' },
                                                                message: 'must be array'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid2 = _errs14 === errors;
                                            }
                                            else {
                                                var valid2 = true;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate35.errors = [
                                        {
                                            instancePath: instancePath + '/columnConfiguration',
                                            schemaPath: 'urn:wisepipe-common-data:FwfColumnConfiguration/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.dataPreprocessConfig !== undefined) {
                                let data9 = data.dataPreprocessConfig;
                                const _errs20 = errors;
                                const _errs21 = errors;
                                if (errors === _errs21) {
                                    if (data9 && typeof data9 == 'object' && !Array.isArray(data9)) {
                                        let missing2;
                                        if ((data9.skipHeaderRow === undefined && (missing2 = 'skipHeaderRow')) ||
                                            (data9.skipFooterRow === undefined && (missing2 = 'skipFooterRow'))) {
                                            validate35.errors = [
                                                {
                                                    instancePath: instancePath + '/dataPreprocessConfig',
                                                    schemaPath: 'urn:wisepipe-common-data:DataPreprocessConfig/required',
                                                    keyword: 'required',
                                                    params: { missingProperty: missing2 },
                                                    message: "must have required property '" + missing2 + "'"
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            if (data9.skipHeaderRow !== undefined) {
                                                let data10 = data9.skipHeaderRow;
                                                const _errs23 = errors;
                                                if (errors === _errs23) {
                                                    if (typeof data10 == 'number') {
                                                        if (data10 > 100 || isNaN(data10)) {
                                                            validate35.errors = [
                                                                {
                                                                    instancePath: instancePath + '/dataPreprocessConfig/skipHeaderRow',
                                                                    schemaPath: 'urn:wisepipe-common-data:DataPreprocessConfig/properties/skipHeaderRow/maximum',
                                                                    keyword: 'maximum',
                                                                    params: { comparison: '<=', limit: 100 },
                                                                    message: 'must be <= 100'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            if (data10 < 0 || isNaN(data10)) {
                                                                validate35.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/dataPreprocessConfig/skipHeaderRow',
                                                                        schemaPath: 'urn:wisepipe-common-data:DataPreprocessConfig/properties/skipHeaderRow/minimum',
                                                                        keyword: 'minimum',
                                                                        params: { comparison: '>=', limit: 0 },
                                                                        message: 'must be >= 0'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate35.errors = [
                                                            {
                                                                instancePath: instancePath + '/dataPreprocessConfig/skipHeaderRow',
                                                                schemaPath: 'urn:wisepipe-common-data:DataPreprocessConfig/properties/skipHeaderRow/type',
                                                                keyword: 'type',
                                                                params: { type: 'number' },
                                                                message: 'must be number'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid8 = _errs23 === errors;
                                            }
                                            else {
                                                var valid8 = true;
                                            }
                                            if (valid8) {
                                                if (data9.skipFooterRow !== undefined) {
                                                    let data11 = data9.skipFooterRow;
                                                    const _errs25 = errors;
                                                    if (errors === _errs25) {
                                                        if (typeof data11 == 'number') {
                                                            if (data11 > 100 || isNaN(data11)) {
                                                                validate35.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/dataPreprocessConfig/skipFooterRow',
                                                                        schemaPath: 'urn:wisepipe-common-data:DataPreprocessConfig/properties/skipFooterRow/maximum',
                                                                        keyword: 'maximum',
                                                                        params: { comparison: '<=', limit: 100 },
                                                                        message: 'must be <= 100'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            else {
                                                                if (data11 < 0 || isNaN(data11)) {
                                                                    validate35.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/dataPreprocessConfig/skipFooterRow',
                                                                            schemaPath: 'urn:wisepipe-common-data:DataPreprocessConfig/properties/skipFooterRow/minimum',
                                                                            keyword: 'minimum',
                                                                            params: { comparison: '>=', limit: 0 },
                                                                            message: 'must be >= 0'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                        }
                                                        else {
                                                            validate35.errors = [
                                                                {
                                                                    instancePath: instancePath + '/dataPreprocessConfig/skipFooterRow',
                                                                    schemaPath: 'urn:wisepipe-common-data:DataPreprocessConfig/properties/skipFooterRow/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'number' },
                                                                    message: 'must be number'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid8 = _errs25 === errors;
                                                }
                                                else {
                                                    var valid8 = true;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate35.errors = [
                                            {
                                                instancePath: instancePath + '/dataPreprocessConfig',
                                                schemaPath: 'urn:wisepipe-common-data:DataPreprocessConfig/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs20 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate35.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate35.errors = vErrors;
    return errors === 0;
}
export const gSheetsImportConfigSchemaValidation = validate36;
const schema73 = {
    $id: 'urn:wisepipe-common-data:GSheetsImportConfig',
    type: 'object',
    properties: { spreadsheetID: { type: 'string', minLength: 1 }, isExcel: { type: 'boolean' } },
    required: ['spreadsheetID']
};
function validate36(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:GSheetsImportConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.spreadsheetID === undefined && (missing0 = 'spreadsheetID')) {
                validate36.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.spreadsheetID !== undefined) {
                    let data0 = data.spreadsheetID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate36.errors = [
                                    {
                                        instancePath: instancePath + '/spreadsheetID',
                                        schemaPath: '#/properties/spreadsheetID/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate36.errors = [
                                {
                                    instancePath: instancePath + '/spreadsheetID',
                                    schemaPath: '#/properties/spreadsheetID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.isExcel !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.isExcel !== 'boolean') {
                            validate36.errors = [
                                {
                                    instancePath: instancePath + '/isExcel',
                                    schemaPath: '#/properties/isExcel/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate36.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate36.errors = vErrors;
    return errors === 0;
}
export const globalImportConfigSchemaValidation = validate37;
const schema74 = {
    $id: 'urn:wisepipe-common-data:GlobalImportConfig',
    type: 'object',
    properties: {
        globalDataType: {
            type: 'string',
            enum: [
                'sampleCustomers',
                'adjustments',
                'commissions',
                'payouts',
                'transactions',
                'forecasting',
                'diversity',
                'sellerPerformance',
                'genderPay',
                'sellerChurn',
                'sellerChurnTest',
                'diversityCandidates',
                'leadScoring',
                'sellerCapacity',
                'sellerCapacityPerformance',
                'smartMatcherTransactionsTrain',
                'smartMatcherLookupTrain',
                'smartMatcherTransactionsTest',
                'smartMatcherLookupTest',
                'benchmarking',
                'oneColumnOneRow',
                'combinationMatcherData',
                'combinationMatcherValidCombination',
                'financialAdvisorTurnoverTrain',
                'financialAdvisorTurnoverTest',
                'customerLifetimeValueSMBRevenue',
                'customerLifetimeValueMMRevenue',
                'customerLifetimeValueEnterpriseRevenue',
                'dealValueChangesCRMOpportunities',
                'discountingDiagnosticsOrders',
                'discountingDiagnosticsIndustryBenchmarks',
                'discountingDiagnosticsDealSizeBenchmarks',
                'asc606PrepBaseCommission',
                'asc606PrepTransactionCredits',
                'asc606PrepTransactionMaster',
                'asc606TransactionalCommissions',
                'asc606DateString',
                'asc606AmortizationSetup',
                'opportunityScores',
                'rosterValidationICM',
                'rosterValidationSP',
                'orderValidationOrders',
                'orderValidationValidOrders',
                'orderValidationTransactions',
                'orderConsolidationOrders',
                'orderConsolidationValidOrders',
                'recordAndAdjustmentCurrentPeriodTransactions',
                'recordAndAdjustmentPriorPeriodTransactions',
                'identifyNewHiresAllEmployees',
                'identifyNewHiresNewHires',
                'trackTerritoryChangesCurrentCycle',
                'trackTerritoryChangesPreviousCycle',
                'transactionReconciliationBillingData',
                'transactionReconciliationOrders',
                'transactionValidationTransactions',
                'entityResolutionAccountLookup',
                'entityResolutionTransactions',
                'hierarchyCreationAccountList',
                'hierarchyCreationUSStatesCode',
                'hierarchyValidatorCustomerAccounts',
                'discountingDiagnosticsOverall',
                'discountingDiagnostics0_1000',
                'discountingDiagnostics1001_5000',
                'fuzzyMatcherCustomerLookup',
                'fuzzyMatcherSurveyResults',
                'hotelBookings',
                'netflixTitles',
                'netflix',
                'renewableEnergyProduction',
                'predictCOVID-19Deaths',
                'marketingCampaignTargetCustomer',
                'salesForecast',
                'vehicleTransactions',
                'telecommunicationsCustomers',
                'onlineRetailTransactions',
                'salesOpportunities',
                'salesForecasting',
                'crmData',
                'zoomInfoData',
                'wholesaleInvoice',
                'wholesaleProducts',
                'dynamicDashboard',
                'financialStatement',
                'gamification01',
                'forecastingSolutions'
            ]
        },
        version: { type: 'integer', minimum: 1 }
    },
    required: ['globalDataType', 'version']
};
function validate37(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:GlobalImportConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.globalDataType === undefined && (missing0 = 'globalDataType')) ||
                (data.version === undefined && (missing0 = 'version'))) {
                validate37.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.globalDataType !== undefined) {
                    let data0 = data.globalDataType;
                    const _errs1 = errors;
                    if (typeof data0 !== 'string') {
                        validate37.errors = [
                            {
                                instancePath: instancePath + '/globalDataType',
                                schemaPath: '#/properties/globalDataType/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'sampleCustomers' ||
                        data0 === 'adjustments' ||
                        data0 === 'commissions' ||
                        data0 === 'payouts' ||
                        data0 === 'transactions' ||
                        data0 === 'forecasting' ||
                        data0 === 'diversity' ||
                        data0 === 'sellerPerformance' ||
                        data0 === 'genderPay' ||
                        data0 === 'sellerChurn' ||
                        data0 === 'sellerChurnTest' ||
                        data0 === 'diversityCandidates' ||
                        data0 === 'leadScoring' ||
                        data0 === 'sellerCapacity' ||
                        data0 === 'sellerCapacityPerformance' ||
                        data0 === 'smartMatcherTransactionsTrain' ||
                        data0 === 'smartMatcherLookupTrain' ||
                        data0 === 'smartMatcherTransactionsTest' ||
                        data0 === 'smartMatcherLookupTest' ||
                        data0 === 'benchmarking' ||
                        data0 === 'oneColumnOneRow' ||
                        data0 === 'combinationMatcherData' ||
                        data0 === 'combinationMatcherValidCombination' ||
                        data0 === 'financialAdvisorTurnoverTrain' ||
                        data0 === 'financialAdvisorTurnoverTest' ||
                        data0 === 'customerLifetimeValueSMBRevenue' ||
                        data0 === 'customerLifetimeValueMMRevenue' ||
                        data0 === 'customerLifetimeValueEnterpriseRevenue' ||
                        data0 === 'dealValueChangesCRMOpportunities' ||
                        data0 === 'discountingDiagnosticsOrders' ||
                        data0 === 'discountingDiagnosticsIndustryBenchmarks' ||
                        data0 === 'discountingDiagnosticsDealSizeBenchmarks' ||
                        data0 === 'asc606PrepBaseCommission' ||
                        data0 === 'asc606PrepTransactionCredits' ||
                        data0 === 'asc606PrepTransactionMaster' ||
                        data0 === 'asc606TransactionalCommissions' ||
                        data0 === 'asc606DateString' ||
                        data0 === 'asc606AmortizationSetup' ||
                        data0 === 'opportunityScores' ||
                        data0 === 'rosterValidationICM' ||
                        data0 === 'rosterValidationSP' ||
                        data0 === 'orderValidationOrders' ||
                        data0 === 'orderValidationValidOrders' ||
                        data0 === 'orderValidationTransactions' ||
                        data0 === 'orderConsolidationOrders' ||
                        data0 === 'orderConsolidationValidOrders' ||
                        data0 === 'recordAndAdjustmentCurrentPeriodTransactions' ||
                        data0 === 'recordAndAdjustmentPriorPeriodTransactions' ||
                        data0 === 'identifyNewHiresAllEmployees' ||
                        data0 === 'identifyNewHiresNewHires' ||
                        data0 === 'trackTerritoryChangesCurrentCycle' ||
                        data0 === 'trackTerritoryChangesPreviousCycle' ||
                        data0 === 'transactionReconciliationBillingData' ||
                        data0 === 'transactionReconciliationOrders' ||
                        data0 === 'transactionValidationTransactions' ||
                        data0 === 'entityResolutionAccountLookup' ||
                        data0 === 'entityResolutionTransactions' ||
                        data0 === 'hierarchyCreationAccountList' ||
                        data0 === 'hierarchyCreationUSStatesCode' ||
                        data0 === 'hierarchyValidatorCustomerAccounts' ||
                        data0 === 'discountingDiagnosticsOverall' ||
                        data0 === 'discountingDiagnostics0_1000' ||
                        data0 === 'discountingDiagnostics1001_5000' ||
                        data0 === 'fuzzyMatcherCustomerLookup' ||
                        data0 === 'fuzzyMatcherSurveyResults' ||
                        data0 === 'hotelBookings' ||
                        data0 === 'netflixTitles' ||
                        data0 === 'netflix' ||
                        data0 === 'renewableEnergyProduction' ||
                        data0 === 'predictCOVID-19Deaths' ||
                        data0 === 'marketingCampaignTargetCustomer' ||
                        data0 === 'salesForecast' ||
                        data0 === 'vehicleTransactions' ||
                        data0 === 'telecommunicationsCustomers' ||
                        data0 === 'onlineRetailTransactions' ||
                        data0 === 'salesOpportunities' ||
                        data0 === 'salesForecasting' ||
                        data0 === 'crmData' ||
                        data0 === 'zoomInfoData' ||
                        data0 === 'wholesaleInvoice' ||
                        data0 === 'wholesaleProducts' ||
                        data0 === 'dynamicDashboard' ||
                        data0 === 'financialStatement' ||
                        data0 === 'gamification01' ||
                        data0 === 'forecastingSolutions')) {
                        validate37.errors = [
                            {
                                instancePath: instancePath + '/globalDataType',
                                schemaPath: '#/properties/globalDataType/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema74.properties.globalDataType.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.version !== undefined) {
                        let data1 = data.version;
                        const _errs3 = errors;
                        if (!(typeof data1 == 'number' && !(data1 % 1) && !isNaN(data1))) {
                            validate37.errors = [
                                {
                                    instancePath: instancePath + '/version',
                                    schemaPath: '#/properties/version/type',
                                    keyword: 'type',
                                    params: { type: 'integer' },
                                    message: 'must be integer'
                                }
                            ];
                            return false;
                        }
                        if (errors === _errs3) {
                            if (typeof data1 == 'number') {
                                if (data1 < 1 || isNaN(data1)) {
                                    validate37.errors = [
                                        {
                                            instancePath: instancePath + '/version',
                                            schemaPath: '#/properties/version/minimum',
                                            keyword: 'minimum',
                                            params: { comparison: '>=', limit: 1 },
                                            message: 'must be >= 1'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate37.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate37.errors = vErrors;
    return errors === 0;
}
export const gongImportConfigSchemaValidation = validate38;
const schema75 = {
    $id: 'urn:wisepipe-common-data:GongImportConfig',
    type: 'object',
    properties: { startDate: { type: 'string', format: 'date-time' }, endDate: { type: 'string', format: 'date-time' } },
    required: ['startDate', 'endDate']
};
function validate38(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:GongImportConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.startDate === undefined && (missing0 = 'startDate')) ||
                (data.endDate === undefined && (missing0 = 'endDate'))) {
                validate38.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.startDate !== undefined) {
                    let data0 = data.startDate;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats0.validate(data0)) {
                                    validate38.errors = [
                                        {
                                            instancePath: instancePath + '/startDate',
                                            schemaPath: '#/properties/startDate/format',
                                            keyword: 'format',
                                            params: { format: 'date-time' },
                                            message: 'must match format "' + 'date-time' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate38.errors = [
                                    {
                                        instancePath: instancePath + '/startDate',
                                        schemaPath: '#/properties/startDate/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.endDate !== undefined) {
                        let data1 = data.endDate;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (errors === _errs3) {
                                if (typeof data1 === 'string') {
                                    if (!formats0.validate(data1)) {
                                        validate38.errors = [
                                            {
                                                instancePath: instancePath + '/endDate',
                                                schemaPath: '#/properties/endDate/format',
                                                keyword: 'format',
                                                params: { format: 'date-time' },
                                                message: 'must match format "' + 'date-time' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate38.errors = [
                                        {
                                            instancePath: instancePath + '/endDate',
                                            schemaPath: '#/properties/endDate/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate38.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate38.errors = vErrors;
    return errors === 0;
}
export const googleAdWordsImportConfigSchemaValidation = validate39;
const schema76 = {
    $id: 'urn:wisepipe-common-data:GoogleAdWordsImportConfig',
    type: 'object',
    properties: { customerID: { type: 'string', minLength: 1 }, startDate: { type: 'string', format: 'date-time' } },
    required: ['customerID', 'startDate']
};
function validate39(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:GoogleAdWordsImportConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.customerID === undefined && (missing0 = 'customerID')) ||
                (data.startDate === undefined && (missing0 = 'startDate'))) {
                validate39.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.customerID !== undefined) {
                    let data0 = data.customerID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate39.errors = [
                                    {
                                        instancePath: instancePath + '/customerID',
                                        schemaPath: '#/properties/customerID/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate39.errors = [
                                {
                                    instancePath: instancePath + '/customerID',
                                    schemaPath: '#/properties/customerID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.startDate !== undefined) {
                        let data1 = data.startDate;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (errors === _errs3) {
                                if (typeof data1 === 'string') {
                                    if (!formats0.validate(data1)) {
                                        validate39.errors = [
                                            {
                                                instancePath: instancePath + '/startDate',
                                                schemaPath: '#/properties/startDate/format',
                                                keyword: 'format',
                                                params: { format: 'date-time' },
                                                message: 'must match format "' + 'date-time' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate39.errors = [
                                        {
                                            instancePath: instancePath + '/startDate',
                                            schemaPath: '#/properties/startDate/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate39.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate39.errors = vErrors;
    return errors === 0;
}
export const googleAnalyticsImportConfigSchemaValidation = validate40;
const schema77 = {
    $id: 'urn:wisepipe-common-data:GoogleAnalyticsImportConfig',
    type: 'object',
    properties: {
        viewID: { type: 'string', minLength: 1 },
        startDate: { type: 'string', format: 'date-time' },
        endDate: { type: 'string', format: 'date-time' }
    },
    required: ['viewID', 'startDate']
};
function validate40(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:GoogleAnalyticsImportConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.viewID === undefined && (missing0 = 'viewID')) ||
                (data.startDate === undefined && (missing0 = 'startDate'))) {
                validate40.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.viewID !== undefined) {
                    let data0 = data.viewID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate40.errors = [
                                    {
                                        instancePath: instancePath + '/viewID',
                                        schemaPath: '#/properties/viewID/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate40.errors = [
                                {
                                    instancePath: instancePath + '/viewID',
                                    schemaPath: '#/properties/viewID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.startDate !== undefined) {
                        let data1 = data.startDate;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (errors === _errs3) {
                                if (typeof data1 === 'string') {
                                    if (!formats0.validate(data1)) {
                                        validate40.errors = [
                                            {
                                                instancePath: instancePath + '/startDate',
                                                schemaPath: '#/properties/startDate/format',
                                                keyword: 'format',
                                                params: { format: 'date-time' },
                                                message: 'must match format "' + 'date-time' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate40.errors = [
                                        {
                                            instancePath: instancePath + '/startDate',
                                            schemaPath: '#/properties/startDate/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.endDate !== undefined) {
                            let data2 = data.endDate;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (errors === _errs5) {
                                    if (typeof data2 === 'string') {
                                        if (!formats0.validate(data2)) {
                                            validate40.errors = [
                                                {
                                                    instancePath: instancePath + '/endDate',
                                                    schemaPath: '#/properties/endDate/format',
                                                    keyword: 'format',
                                                    params: { format: 'date-time' },
                                                    message: 'must match format "' + 'date-time' + '"'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate40.errors = [
                                            {
                                                instancePath: instancePath + '/endDate',
                                                schemaPath: '#/properties/endDate/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate40.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate40.errors = vErrors;
    return errors === 0;
}
export const hubspotImportConfigSchemaValidation = validate41;
const schema78 = {
    $id: 'urn:wisepipe-common-data:HubspotImportConfig',
    type: 'object',
    properties: { startDate: { type: 'string', format: 'date-time' } },
    required: ['startDate']
};
function validate41(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:HubspotImportConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.startDate === undefined && (missing0 = 'startDate')) {
                validate41.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.startDate !== undefined) {
                    let data0 = data.startDate;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats0.validate(data0)) {
                                    validate41.errors = [
                                        {
                                            instancePath: instancePath + '/startDate',
                                            schemaPath: '#/properties/startDate/format',
                                            keyword: 'format',
                                            params: { format: 'date-time' },
                                            message: 'must match format "' + 'date-time' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate41.errors = [
                                    {
                                        instancePath: instancePath + '/startDate',
                                        schemaPath: '#/properties/startDate/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate41.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate41.errors = vErrors;
    return errors === 0;
}
export const icmImportConfigSchemaValidation = validate42;
const schema79 = {
    $id: 'urn:wisepipe-common-data:IcmImportConfig',
    type: 'object',
    properties: {
        apiKey: { type: 'string', minLength: 1 },
        model: { type: 'string', minLength: 1 },
        domainName: { type: 'string', minLength: 1 },
        sourceType: { type: 'string', enum: ['calculation', 'customTable', 'dataStore'] },
        tablename: { type: 'string', minLength: 1 },
        calculationID: { type: 'string', minLength: 1 },
        dataStoreID: { type: 'string', minLength: 1 }
    },
    if: { properties: { sourceType: { const: 'calculation' } }, required: ['sourceType'] },
    then: { required: ['calculationID'] },
    else: {
        if: { properties: { sourceType: { const: 'customTable' } }, required: ['sourceType'] },
        then: { required: ['tablename'] },
        else: {
            if: { properties: { sourceType: { const: 'dataStore' } }, required: ['sourceType'] },
            then: { required: ['dataStoreID'] }
        }
    },
    required: ['sourceType']
};
function validate42(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:IcmImportConfig" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        let missing0;
        if (data.sourceType === undefined && (missing0 = 'sourceType')) {
            const err0 = {};
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
        else {
            if (data.sourceType !== undefined) {
                if ('calculation' !== data.sourceType) {
                    const err1 = {};
                    if (vErrors === null) {
                        vErrors = [err1];
                    }
                    else {
                        vErrors.push(err1);
                    }
                    errors++;
                }
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    let ifClause0;
    if (_valid0) {
        const _errs4 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if (data.calculationID === undefined && (missing1 = 'calculationID')) {
                validate42.errors = [
                    {
                        instancePath,
                        schemaPath: '#/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs4 === errors;
        valid0 = _valid0;
        ifClause0 = 'then';
    }
    else {
        const _errs5 = errors;
        const _errs6 = errors;
        let valid2 = true;
        const _errs7 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing2;
            if (data.sourceType === undefined && (missing2 = 'sourceType')) {
                const err2 = {};
                if (vErrors === null) {
                    vErrors = [err2];
                }
                else {
                    vErrors.push(err2);
                }
                errors++;
            }
            else {
                if (data.sourceType !== undefined) {
                    if ('customTable' !== data.sourceType) {
                        const err3 = {};
                        if (vErrors === null) {
                            vErrors = [err3];
                        }
                        else {
                            vErrors.push(err3);
                        }
                        errors++;
                    }
                }
            }
        }
        var _valid1 = _errs7 === errors;
        errors = _errs6;
        if (vErrors !== null) {
            if (_errs6) {
                vErrors.length = _errs6;
            }
            else {
                vErrors = null;
            }
        }
        let ifClause1;
        if (_valid1) {
            const _errs9 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                let missing3;
                if (data.tablename === undefined && (missing3 = 'tablename')) {
                    validate42.errors = [
                        {
                            instancePath,
                            schemaPath: '#/else/then/required',
                            keyword: 'required',
                            params: { missingProperty: missing3 },
                            message: "must have required property '" + missing3 + "'"
                        }
                    ];
                    return false;
                }
            }
            var _valid1 = _errs9 === errors;
            valid2 = _valid1;
            ifClause1 = 'then';
        }
        else {
            const _errs10 = errors;
            const _errs11 = errors;
            let valid4 = true;
            const _errs12 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                let missing4;
                if (data.sourceType === undefined && (missing4 = 'sourceType')) {
                    const err4 = {};
                    if (vErrors === null) {
                        vErrors = [err4];
                    }
                    else {
                        vErrors.push(err4);
                    }
                    errors++;
                }
                else {
                    if (data.sourceType !== undefined) {
                        if ('dataStore' !== data.sourceType) {
                            const err5 = {};
                            if (vErrors === null) {
                                vErrors = [err5];
                            }
                            else {
                                vErrors.push(err5);
                            }
                            errors++;
                        }
                    }
                }
            }
            var _valid2 = _errs12 === errors;
            errors = _errs11;
            if (vErrors !== null) {
                if (_errs11) {
                    vErrors.length = _errs11;
                }
                else {
                    vErrors = null;
                }
            }
            if (_valid2) {
                const _errs14 = errors;
                if (data && typeof data == 'object' && !Array.isArray(data)) {
                    let missing5;
                    if (data.dataStoreID === undefined && (missing5 = 'dataStoreID')) {
                        validate42.errors = [
                            {
                                instancePath,
                                schemaPath: '#/else/else/then/required',
                                keyword: 'required',
                                params: { missingProperty: missing5 },
                                message: "must have required property '" + missing5 + "'"
                            }
                        ];
                        return false;
                    }
                }
                var _valid2 = _errs14 === errors;
                valid4 = _valid2;
            }
            if (!valid4) {
                const err6 = {
                    instancePath,
                    schemaPath: '#/else/else/if',
                    keyword: 'if',
                    params: { failingKeyword: 'then' },
                    message: 'must match "then" schema'
                };
                if (vErrors === null) {
                    vErrors = [err6];
                }
                else {
                    vErrors.push(err6);
                }
                errors++;
                validate42.errors = vErrors;
                return false;
            }
            var _valid1 = _errs10 === errors;
            valid2 = _valid1;
            ifClause1 = 'else';
        }
        if (!valid2) {
            const err7 = {
                instancePath,
                schemaPath: '#/else/if',
                keyword: 'if',
                params: { failingKeyword: ifClause1 },
                message: 'must match "' + ifClause1 + '" schema'
            };
            if (vErrors === null) {
                vErrors = [err7];
            }
            else {
                vErrors.push(err7);
            }
            errors++;
            validate42.errors = vErrors;
            return false;
        }
        var _valid0 = _errs5 === errors;
        valid0 = _valid0;
        ifClause0 = 'else';
    }
    if (!valid0) {
        const err8 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: ifClause0 },
            message: 'must match "' + ifClause0 + '" schema'
        };
        if (vErrors === null) {
            vErrors = [err8];
        }
        else {
            vErrors.push(err8);
        }
        errors++;
        validate42.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing6;
            if (data.sourceType === undefined && (missing6 = 'sourceType')) {
                validate42.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing6 },
                        message: "must have required property '" + missing6 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.apiKey !== undefined) {
                    let data3 = data.apiKey;
                    const _errs15 = errors;
                    if (errors === _errs15) {
                        if (typeof data3 === 'string') {
                            if (func2(data3) < 1) {
                                validate42.errors = [
                                    {
                                        instancePath: instancePath + '/apiKey',
                                        schemaPath: '#/properties/apiKey/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate42.errors = [
                                {
                                    instancePath: instancePath + '/apiKey',
                                    schemaPath: '#/properties/apiKey/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid6 = _errs15 === errors;
                }
                else {
                    var valid6 = true;
                }
                if (valid6) {
                    if (data.model !== undefined) {
                        let data4 = data.model;
                        const _errs17 = errors;
                        if (errors === _errs17) {
                            if (typeof data4 === 'string') {
                                if (func2(data4) < 1) {
                                    validate42.errors = [
                                        {
                                            instancePath: instancePath + '/model',
                                            schemaPath: '#/properties/model/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate42.errors = [
                                    {
                                        instancePath: instancePath + '/model',
                                        schemaPath: '#/properties/model/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid6 = _errs17 === errors;
                    }
                    else {
                        var valid6 = true;
                    }
                    if (valid6) {
                        if (data.domainName !== undefined) {
                            let data5 = data.domainName;
                            const _errs19 = errors;
                            if (errors === _errs19) {
                                if (typeof data5 === 'string') {
                                    if (func2(data5) < 1) {
                                        validate42.errors = [
                                            {
                                                instancePath: instancePath + '/domainName',
                                                schemaPath: '#/properties/domainName/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate42.errors = [
                                        {
                                            instancePath: instancePath + '/domainName',
                                            schemaPath: '#/properties/domainName/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid6 = _errs19 === errors;
                        }
                        else {
                            var valid6 = true;
                        }
                        if (valid6) {
                            if (data.sourceType !== undefined) {
                                let data6 = data.sourceType;
                                const _errs21 = errors;
                                if (typeof data6 !== 'string') {
                                    validate42.errors = [
                                        {
                                            instancePath: instancePath + '/sourceType',
                                            schemaPath: '#/properties/sourceType/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                if (!(data6 === 'calculation' || data6 === 'customTable' || data6 === 'dataStore')) {
                                    validate42.errors = [
                                        {
                                            instancePath: instancePath + '/sourceType',
                                            schemaPath: '#/properties/sourceType/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema79.properties.sourceType.enum },
                                            message: 'must be equal to one of the allowed values'
                                        }
                                    ];
                                    return false;
                                }
                                var valid6 = _errs21 === errors;
                            }
                            else {
                                var valid6 = true;
                            }
                            if (valid6) {
                                if (data.tablename !== undefined) {
                                    let data7 = data.tablename;
                                    const _errs23 = errors;
                                    if (errors === _errs23) {
                                        if (typeof data7 === 'string') {
                                            if (func2(data7) < 1) {
                                                validate42.errors = [
                                                    {
                                                        instancePath: instancePath + '/tablename',
                                                        schemaPath: '#/properties/tablename/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate42.errors = [
                                                {
                                                    instancePath: instancePath + '/tablename',
                                                    schemaPath: '#/properties/tablename/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid6 = _errs23 === errors;
                                }
                                else {
                                    var valid6 = true;
                                }
                                if (valid6) {
                                    if (data.calculationID !== undefined) {
                                        let data8 = data.calculationID;
                                        const _errs25 = errors;
                                        if (errors === _errs25) {
                                            if (typeof data8 === 'string') {
                                                if (func2(data8) < 1) {
                                                    validate42.errors = [
                                                        {
                                                            instancePath: instancePath + '/calculationID',
                                                            schemaPath: '#/properties/calculationID/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate42.errors = [
                                                    {
                                                        instancePath: instancePath + '/calculationID',
                                                        schemaPath: '#/properties/calculationID/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid6 = _errs25 === errors;
                                    }
                                    else {
                                        var valid6 = true;
                                    }
                                    if (valid6) {
                                        if (data.dataStoreID !== undefined) {
                                            let data9 = data.dataStoreID;
                                            const _errs27 = errors;
                                            if (errors === _errs27) {
                                                if (typeof data9 === 'string') {
                                                    if (func2(data9) < 1) {
                                                        validate42.errors = [
                                                            {
                                                                instancePath: instancePath + '/dataStoreID',
                                                                schemaPath: '#/properties/dataStoreID/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate42.errors = [
                                                        {
                                                            instancePath: instancePath + '/dataStoreID',
                                                            schemaPath: '#/properties/dataStoreID/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid6 = _errs27 === errors;
                                        }
                                        else {
                                            var valid6 = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate42.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate42.errors = vErrors;
    return errors === 0;
}
export const importComputeTaskSchemaValidation = validate43;
const schema80 = {
    $id: 'urn:wisepipe-common-data:ImportComputeTask',
    type: 'object',
    properties: { taskInput: { $ref: 'urn:wisepipe-compute-activity-domain:TaskInput' }, hasWork: { type: 'boolean' } },
    required: ['taskInput', 'hasWork']
};
const schema81 = {
    $id: 'urn:wisepipe-compute-activity-domain:TaskInput',
    type: 'object',
    properties: {
        type: { type: 'string', enum: ['spark', 'spark-v2', 'python', 'python-eks', 'stepFunction'] },
        id: { type: 'string', minLength: 1, maxLength: 200 },
        orgID: { type: 'string', format: 'uuid' },
        orgPlan: { type: 'string', enum: ['Social', 'Enterprise', 'Integration', 'Temp', 'Starter', 'Professional'] },
        highMemory: { type: 'boolean' },
        enableUsagesStream: { type: 'boolean' },
        logGroup: { type: 'string' },
        logStreamPrefix: { type: 'string' }
    },
    required: ['type', 'id', 'orgID']
};
function validate43(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:ImportComputeTask" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.taskInput === undefined && (missing0 = 'taskInput')) ||
                (data.hasWork === undefined && (missing0 = 'hasWork'))) {
                validate43.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.taskInput !== undefined) {
                    let data0 = data.taskInput;
                    const _errs1 = errors;
                    const _errs2 = errors;
                    if (errors === _errs2) {
                        if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                            let missing1;
                            if ((data0.type === undefined && (missing1 = 'type')) ||
                                (data0.id === undefined && (missing1 = 'id')) ||
                                (data0.orgID === undefined && (missing1 = 'orgID'))) {
                                validate43.errors = [
                                    {
                                        instancePath: instancePath + '/taskInput',
                                        schemaPath: 'urn:wisepipe-compute-activity-domain:TaskInput/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing1 },
                                        message: "must have required property '" + missing1 + "'"
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0.type !== undefined) {
                                    let data1 = data0.type;
                                    const _errs4 = errors;
                                    if (typeof data1 !== 'string') {
                                        validate43.errors = [
                                            {
                                                instancePath: instancePath + '/taskInput/type',
                                                schemaPath: 'urn:wisepipe-compute-activity-domain:TaskInput/properties/type/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    if (!(data1 === 'spark' ||
                                        data1 === 'spark-v2' ||
                                        data1 === 'python' ||
                                        data1 === 'python-eks' ||
                                        data1 === 'stepFunction')) {
                                        validate43.errors = [
                                            {
                                                instancePath: instancePath + '/taskInput/type',
                                                schemaPath: 'urn:wisepipe-compute-activity-domain:TaskInput/properties/type/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema81.properties.type.enum },
                                                message: 'must be equal to one of the allowed values'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid2 = _errs4 === errors;
                                }
                                else {
                                    var valid2 = true;
                                }
                                if (valid2) {
                                    if (data0.id !== undefined) {
                                        let data2 = data0.id;
                                        const _errs6 = errors;
                                        if (errors === _errs6) {
                                            if (typeof data2 === 'string') {
                                                if (func2(data2) > 200) {
                                                    validate43.errors = [
                                                        {
                                                            instancePath: instancePath + '/taskInput/id',
                                                            schemaPath: 'urn:wisepipe-compute-activity-domain:TaskInput/properties/id/maxLength',
                                                            keyword: 'maxLength',
                                                            params: { limit: 200 },
                                                            message: 'must NOT have more than 200 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    if (func2(data2) < 1) {
                                                        validate43.errors = [
                                                            {
                                                                instancePath: instancePath + '/taskInput/id',
                                                                schemaPath: 'urn:wisepipe-compute-activity-domain:TaskInput/properties/id/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                            }
                                            else {
                                                validate43.errors = [
                                                    {
                                                        instancePath: instancePath + '/taskInput/id',
                                                        schemaPath: 'urn:wisepipe-compute-activity-domain:TaskInput/properties/id/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid2 = _errs6 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                    if (valid2) {
                                        if (data0.orgID !== undefined) {
                                            let data3 = data0.orgID;
                                            const _errs8 = errors;
                                            if (errors === _errs8) {
                                                if (errors === _errs8) {
                                                    if (typeof data3 === 'string') {
                                                        if (!formats4.test(data3)) {
                                                            validate43.errors = [
                                                                {
                                                                    instancePath: instancePath + '/taskInput/orgID',
                                                                    schemaPath: 'urn:wisepipe-compute-activity-domain:TaskInput/properties/orgID/format',
                                                                    keyword: 'format',
                                                                    params: { format: 'uuid' },
                                                                    message: 'must match format "' + 'uuid' + '"'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate43.errors = [
                                                            {
                                                                instancePath: instancePath + '/taskInput/orgID',
                                                                schemaPath: 'urn:wisepipe-compute-activity-domain:TaskInput/properties/orgID/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                            }
                                            var valid2 = _errs8 === errors;
                                        }
                                        else {
                                            var valid2 = true;
                                        }
                                        if (valid2) {
                                            if (data0.orgPlan !== undefined) {
                                                let data4 = data0.orgPlan;
                                                const _errs10 = errors;
                                                if (typeof data4 !== 'string') {
                                                    validate43.errors = [
                                                        {
                                                            instancePath: instancePath + '/taskInput/orgPlan',
                                                            schemaPath: 'urn:wisepipe-compute-activity-domain:TaskInput/properties/orgPlan/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                if (!(data4 === 'Social' ||
                                                    data4 === 'Enterprise' ||
                                                    data4 === 'Integration' ||
                                                    data4 === 'Temp' ||
                                                    data4 === 'Starter' ||
                                                    data4 === 'Professional')) {
                                                    validate43.errors = [
                                                        {
                                                            instancePath: instancePath + '/taskInput/orgPlan',
                                                            schemaPath: 'urn:wisepipe-compute-activity-domain:TaskInput/properties/orgPlan/enum',
                                                            keyword: 'enum',
                                                            params: { allowedValues: schema81.properties.orgPlan.enum },
                                                            message: 'must be equal to one of the allowed values'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid2 = _errs10 === errors;
                                            }
                                            else {
                                                var valid2 = true;
                                            }
                                            if (valid2) {
                                                if (data0.highMemory !== undefined) {
                                                    const _errs12 = errors;
                                                    if (typeof data0.highMemory !== 'boolean') {
                                                        validate43.errors = [
                                                            {
                                                                instancePath: instancePath + '/taskInput/highMemory',
                                                                schemaPath: 'urn:wisepipe-compute-activity-domain:TaskInput/properties/highMemory/type',
                                                                keyword: 'type',
                                                                params: { type: 'boolean' },
                                                                message: 'must be boolean'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid2 = _errs12 === errors;
                                                }
                                                else {
                                                    var valid2 = true;
                                                }
                                                if (valid2) {
                                                    if (data0.enableUsagesStream !== undefined) {
                                                        const _errs14 = errors;
                                                        if (typeof data0.enableUsagesStream !== 'boolean') {
                                                            validate43.errors = [
                                                                {
                                                                    instancePath: instancePath + '/taskInput/enableUsagesStream',
                                                                    schemaPath: 'urn:wisepipe-compute-activity-domain:TaskInput/properties/enableUsagesStream/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'boolean' },
                                                                    message: 'must be boolean'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid2 = _errs14 === errors;
                                                    }
                                                    else {
                                                        var valid2 = true;
                                                    }
                                                    if (valid2) {
                                                        if (data0.logGroup !== undefined) {
                                                            const _errs16 = errors;
                                                            if (typeof data0.logGroup !== 'string') {
                                                                validate43.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/taskInput/logGroup',
                                                                        schemaPath: 'urn:wisepipe-compute-activity-domain:TaskInput/properties/logGroup/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid2 = _errs16 === errors;
                                                        }
                                                        else {
                                                            var valid2 = true;
                                                        }
                                                        if (valid2) {
                                                            if (data0.logStreamPrefix !== undefined) {
                                                                const _errs18 = errors;
                                                                if (typeof data0.logStreamPrefix !== 'string') {
                                                                    validate43.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/taskInput/logStreamPrefix',
                                                                            schemaPath: 'urn:wisepipe-compute-activity-domain:TaskInput/properties/logStreamPrefix/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid2 = _errs18 === errors;
                                                            }
                                                            else {
                                                                var valid2 = true;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate43.errors = [
                                {
                                    instancePath: instancePath + '/taskInput',
                                    schemaPath: 'urn:wisepipe-compute-activity-domain:TaskInput/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.hasWork !== undefined) {
                        const _errs20 = errors;
                        if (typeof data.hasWork !== 'boolean') {
                            validate43.errors = [
                                {
                                    instancePath: instancePath + '/hasWork',
                                    schemaPath: '#/properties/hasWork/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs20 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate43.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate43.errors = vErrors;
    return errors === 0;
}
export const importConfigSchemaValidation = validate44;
const schema82 = {
    $id: 'urn:wisepipe-common-data:ImportConfig',
    type: 'object',
    properties: {
        importConfigType: {
            type: 'string',
            enum: [
                's3csv',
                'gsheets',
                'adwords',
                'googleAnalytics',
                'shopify',
                'mySql',
                'oracle',
                'postgreSql',
                'amazonAurora',
                'amazonRedshift',
                'amazonS3',
                'icm',
                'salesForce',
                'parquet',
                'excel',
                'global',
                'hubspot',
                'symon',
                'dynamics',
                's3parquet',
                'snowflake',
                'msSql',
                'agentSync',
                'workday',
                'workdayRaaS',
                'tqp',
                'tableau',
                'sftp',
                'powerbi',
                'rest',
                'gong',
                'fwf',
                'netSuite',
                'oneDrive',
                'eltApi',
                'microsoftSqlServer',
                'stripe',
                'microsoftDynamics365',
                'github',
                'facebookAds',
                'amplitude',
                'appsFlyer',
                'customerIo',
                'freshDesk',
                'fullstory',
                'googleCloud',
                'googleEcommerce',
                'listrak',
                'livePerson',
                'onFleet',
                'saasquatch',
                'selligent',
                'userVoice',
                'vero',
                'adRoll',
                'afterShip',
                'asana',
                'autopilot',
                'azure',
                'bigCommerce',
                'bingAds',
                'brainTree',
                'bronto',
                'campaignManager',
                'campaignMonitor',
                'chargeBee',
                'closeIo',
                'clubspeed',
                'codat',
                'contentful',
                'delighted',
                'drip',
                'eloqua',
                'formkeep',
                'front',
                'ftp',
                'gitlab',
                'harvest',
                'heap',
                'helpScout',
                'heroku',
                'ibmDb2',
                'invoiced',
                'iterable',
                'klaviyo',
                'magento',
                'mailjet',
                'mariaDb',
                'mixpanel',
                'mongoDb',
                'outbrain',
                'particle',
                'purple',
                'quickBase',
                'recurly',
                'responsys',
                'revinate',
                'salesforceDesk',
                'salesforcePardot',
                'segment',
                'sendGrid',
                'sendWithUs',
                'shipHero',
                'shippo',
                'sparkPost',
                'square',
                'taboola',
                'toggl',
                'trello',
                'typeform',
                'urbanAirship',
                'webhooks',
                'yotpo',
                'zapier',
                'zendeskChat',
                'zendeskSupport',
                'googleBigQuery',
                'intercom',
                'sapSuccessFactors',
                'sapCrm',
                'ukg',
                'oracleHcm',
                'Adp',
                'dynamics365Sales',
                'ceridianDayforce',
                'oracleCrm',
                'oracleErpCloud',
                'sageIntacct',
                'bambooHr',
                'sapErp',
                'googleCloudPlatformCloudStorage',
                'sas',
                'dropbox',
                'googleDrive',
                'jira',
                'monday',
                'zuora',
                'adobeAnalytics',
                'zoomInfo',
                'marketo',
                'activeCampaign',
                'mailchimp',
                'infor',
                'cornerstoneOnDemand',
                'gusto',
                'paychexFlex',
                'zendesk',
                'serviceNow',
                'zohoCrm',
                'pipedrive',
                'quickBooks',
                'xero',
                'freshbooks',
                'zohoBooks',
                'waveFinancial'
            ]
        },
        columnsToUpdate: {
            type: 'object',
            additionalProperties: {
                type: 'array',
                items: { $ref: 'urn:wisepipe-common-data:ColumnUpdate' },
                uniqueItems: true
            }
        },
        columnsToDrop: {
            type: 'object',
            additionalProperties: { type: 'array', items: { type: 'string' }, uniqueItems: true }
        },
        columnsToMask: {
            type: 'object',
            additionalProperties: { type: 'array', items: { type: 'string' }, uniqueItems: true }
        },
        filters: { type: 'object', additionalProperties: { $ref: 'urn:wisepipe-common-data:ImportFilter' } },
        dataCategory: { type: 'string', enum: ['dataSource', 'unitTestDataSource', 'unitTestSnapshot'] }
    },
    required: ['importConfigType']
};
const schema84 = {
    $id: 'urn:wisepipe-common-data:ImportFilter',
    type: 'object',
    properties: {
        op: {
            type: 'string',
            enum: [
                'and',
                'or',
                'less_than',
                'less_than_equals',
                'equals',
                'not_equals',
                'greater_than_equals',
                'greater_than',
                'is_null',
                'is_not_null',
                'starts_with',
                'ends_with',
                'contains',
                'not_contains'
            ]
        },
        filterType: { type: 'string', enum: ['statement', 'group'] },
        filters: { type: 'array', items: { $ref: 'urn:wisepipe-common-data:ImportFilter' } },
        lhs: { $ref: 'urn:wisepipe-common-data:ImportFilterOperand' },
        rhs: { $ref: 'urn:wisepipe-common-data:ImportFilterOperand' }
    },
    required: ['op', 'filterType'],
    if: { properties: { filterType: { const: 'group' } } },
    then: { required: ['filters'] },
    else: { required: ['lhs', 'op'] }
};
const schema85 = {
    $id: 'urn:wisepipe-common-data:ImportFilterOperand',
    type: 'object',
    properties: {
        operandType: { type: 'string', enum: ['column', 'literal'] },
        name: { type: 'string' },
        litType: { type: 'string', enum: ['string', 'number', 'date', 'boolean'] },
        value: { type: 'string' }
    },
    required: ['operandType'],
    if: { properties: { operandType: { const: 'column' } } },
    then: { required: ['name'] },
    else: { required: ['litType', 'value'] }
};
const wrapper0 = { validate: validate45 };
function validate45(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:ImportFilter" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.filterType !== undefined) {
            if ('group' !== data.filterType) {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    let ifClause0;
    if (_valid0) {
        const _errs4 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.filters === undefined && (missing0 = 'filters')) {
                validate45.errors = [
                    {
                        instancePath,
                        schemaPath: '#/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs4 === errors;
        valid0 = _valid0;
        ifClause0 = 'then';
    }
    else {
        const _errs5 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if ((data.lhs === undefined && (missing1 = 'lhs')) || (data.op === undefined && (missing1 = 'op'))) {
                validate45.errors = [
                    {
                        instancePath,
                        schemaPath: '#/else/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs5 === errors;
        valid0 = _valid0;
        ifClause0 = 'else';
    }
    if (!valid0) {
        const err1 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: ifClause0 },
            message: 'must match "' + ifClause0 + '" schema'
        };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
        validate45.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing2;
            if ((data.op === undefined && (missing2 = 'op')) ||
                (data.filterType === undefined && (missing2 = 'filterType'))) {
                validate45.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing2 },
                        message: "must have required property '" + missing2 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.op !== undefined) {
                    let data1 = data.op;
                    const _errs6 = errors;
                    if (typeof data1 !== 'string') {
                        validate45.errors = [
                            {
                                instancePath: instancePath + '/op',
                                schemaPath: '#/properties/op/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data1 === 'and' ||
                        data1 === 'or' ||
                        data1 === 'less_than' ||
                        data1 === 'less_than_equals' ||
                        data1 === 'equals' ||
                        data1 === 'not_equals' ||
                        data1 === 'greater_than_equals' ||
                        data1 === 'greater_than' ||
                        data1 === 'is_null' ||
                        data1 === 'is_not_null' ||
                        data1 === 'starts_with' ||
                        data1 === 'ends_with' ||
                        data1 === 'contains' ||
                        data1 === 'not_contains')) {
                        validate45.errors = [
                            {
                                instancePath: instancePath + '/op',
                                schemaPath: '#/properties/op/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema84.properties.op.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid2 = _errs6 === errors;
                }
                else {
                    var valid2 = true;
                }
                if (valid2) {
                    if (data.filterType !== undefined) {
                        let data2 = data.filterType;
                        const _errs8 = errors;
                        if (typeof data2 !== 'string') {
                            validate45.errors = [
                                {
                                    instancePath: instancePath + '/filterType',
                                    schemaPath: '#/properties/filterType/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data2 === 'statement' || data2 === 'group')) {
                            validate45.errors = [
                                {
                                    instancePath: instancePath + '/filterType',
                                    schemaPath: '#/properties/filterType/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema84.properties.filterType.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid2 = _errs8 === errors;
                    }
                    else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.filters !== undefined) {
                            let data3 = data.filters;
                            const _errs10 = errors;
                            if (errors === _errs10) {
                                if (Array.isArray(data3)) {
                                    var valid3 = true;
                                    const len0 = data3.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        const _errs12 = errors;
                                        if (!wrapper0.validate(data3[i0], {
                                            instancePath: instancePath + '/filters/' + i0,
                                            parentData: data3,
                                            parentDataProperty: i0,
                                            rootData
                                        })) {
                                            vErrors = vErrors === null ? wrapper0.validate.errors : vErrors.concat(wrapper0.validate.errors);
                                            errors = vErrors.length;
                                        }
                                        var valid3 = _errs12 === errors;
                                        if (!valid3) {
                                            break;
                                        }
                                    }
                                }
                                else {
                                    validate45.errors = [
                                        {
                                            instancePath: instancePath + '/filters',
                                            schemaPath: '#/properties/filters/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid2 = _errs10 === errors;
                        }
                        else {
                            var valid2 = true;
                        }
                        if (valid2) {
                            if (data.lhs !== undefined) {
                                let data5 = data.lhs;
                                const _errs13 = errors;
                                const _errs14 = errors;
                                const _errs16 = errors;
                                let valid5 = true;
                                const _errs17 = errors;
                                if (data5 && typeof data5 == 'object' && !Array.isArray(data5)) {
                                    if (data5.operandType !== undefined) {
                                        if ('column' !== data5.operandType) {
                                            const err2 = {};
                                            if (vErrors === null) {
                                                vErrors = [err2];
                                            }
                                            else {
                                                vErrors.push(err2);
                                            }
                                            errors++;
                                        }
                                    }
                                }
                                var _valid1 = _errs17 === errors;
                                errors = _errs16;
                                if (vErrors !== null) {
                                    if (_errs16) {
                                        vErrors.length = _errs16;
                                    }
                                    else {
                                        vErrors = null;
                                    }
                                }
                                let ifClause1;
                                if (_valid1) {
                                    const _errs19 = errors;
                                    if (data5 && typeof data5 == 'object' && !Array.isArray(data5)) {
                                        let missing3;
                                        if (data5.name === undefined && (missing3 = 'name')) {
                                            validate45.errors = [
                                                {
                                                    instancePath: instancePath + '/lhs',
                                                    schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/then/required',
                                                    keyword: 'required',
                                                    params: { missingProperty: missing3 },
                                                    message: "must have required property '" + missing3 + "'"
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var _valid1 = _errs19 === errors;
                                    valid5 = _valid1;
                                    ifClause1 = 'then';
                                }
                                else {
                                    const _errs20 = errors;
                                    if (data5 && typeof data5 == 'object' && !Array.isArray(data5)) {
                                        let missing4;
                                        if ((data5.litType === undefined && (missing4 = 'litType')) ||
                                            (data5.value === undefined && (missing4 = 'value'))) {
                                            validate45.errors = [
                                                {
                                                    instancePath: instancePath + '/lhs',
                                                    schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/else/required',
                                                    keyword: 'required',
                                                    params: { missingProperty: missing4 },
                                                    message: "must have required property '" + missing4 + "'"
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var _valid1 = _errs20 === errors;
                                    valid5 = _valid1;
                                    ifClause1 = 'else';
                                }
                                if (!valid5) {
                                    const err3 = {
                                        instancePath: instancePath + '/lhs',
                                        schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/if',
                                        keyword: 'if',
                                        params: { failingKeyword: ifClause1 },
                                        message: 'must match "' + ifClause1 + '" schema'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err3];
                                    }
                                    else {
                                        vErrors.push(err3);
                                    }
                                    errors++;
                                    validate45.errors = vErrors;
                                    return false;
                                }
                                if (errors === _errs14) {
                                    if (data5 && typeof data5 == 'object' && !Array.isArray(data5)) {
                                        let missing5;
                                        if (data5.operandType === undefined && (missing5 = 'operandType')) {
                                            validate45.errors = [
                                                {
                                                    instancePath: instancePath + '/lhs',
                                                    schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/required',
                                                    keyword: 'required',
                                                    params: { missingProperty: missing5 },
                                                    message: "must have required property '" + missing5 + "'"
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            if (data5.operandType !== undefined) {
                                                let data7 = data5.operandType;
                                                const _errs21 = errors;
                                                if (typeof data7 !== 'string') {
                                                    validate45.errors = [
                                                        {
                                                            instancePath: instancePath + '/lhs/operandType',
                                                            schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/properties/operandType/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                if (!(data7 === 'column' || data7 === 'literal')) {
                                                    validate45.errors = [
                                                        {
                                                            instancePath: instancePath + '/lhs/operandType',
                                                            schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/properties/operandType/enum',
                                                            keyword: 'enum',
                                                            params: { allowedValues: schema85.properties.operandType.enum },
                                                            message: 'must be equal to one of the allowed values'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid7 = _errs21 === errors;
                                            }
                                            else {
                                                var valid7 = true;
                                            }
                                            if (valid7) {
                                                if (data5.name !== undefined) {
                                                    const _errs23 = errors;
                                                    if (typeof data5.name !== 'string') {
                                                        validate45.errors = [
                                                            {
                                                                instancePath: instancePath + '/lhs/name',
                                                                schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/properties/name/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid7 = _errs23 === errors;
                                                }
                                                else {
                                                    var valid7 = true;
                                                }
                                                if (valid7) {
                                                    if (data5.litType !== undefined) {
                                                        let data9 = data5.litType;
                                                        const _errs25 = errors;
                                                        if (typeof data9 !== 'string') {
                                                            validate45.errors = [
                                                                {
                                                                    instancePath: instancePath + '/lhs/litType',
                                                                    schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/properties/litType/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        if (!(data9 === 'string' || data9 === 'number' || data9 === 'date' || data9 === 'boolean')) {
                                                            validate45.errors = [
                                                                {
                                                                    instancePath: instancePath + '/lhs/litType',
                                                                    schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/properties/litType/enum',
                                                                    keyword: 'enum',
                                                                    params: { allowedValues: schema85.properties.litType.enum },
                                                                    message: 'must be equal to one of the allowed values'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid7 = _errs25 === errors;
                                                    }
                                                    else {
                                                        var valid7 = true;
                                                    }
                                                    if (valid7) {
                                                        if (data5.value !== undefined) {
                                                            const _errs27 = errors;
                                                            if (typeof data5.value !== 'string') {
                                                                validate45.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/lhs/value',
                                                                        schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/properties/value/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid7 = _errs27 === errors;
                                                        }
                                                        else {
                                                            var valid7 = true;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate45.errors = [
                                            {
                                                instancePath: instancePath + '/lhs',
                                                schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid2 = _errs13 === errors;
                            }
                            else {
                                var valid2 = true;
                            }
                            if (valid2) {
                                if (data.rhs !== undefined) {
                                    let data11 = data.rhs;
                                    const _errs29 = errors;
                                    const _errs30 = errors;
                                    const _errs32 = errors;
                                    let valid9 = true;
                                    const _errs33 = errors;
                                    if (data11 && typeof data11 == 'object' && !Array.isArray(data11)) {
                                        if (data11.operandType !== undefined) {
                                            if ('column' !== data11.operandType) {
                                                const err4 = {};
                                                if (vErrors === null) {
                                                    vErrors = [err4];
                                                }
                                                else {
                                                    vErrors.push(err4);
                                                }
                                                errors++;
                                            }
                                        }
                                    }
                                    var _valid2 = _errs33 === errors;
                                    errors = _errs32;
                                    if (vErrors !== null) {
                                        if (_errs32) {
                                            vErrors.length = _errs32;
                                        }
                                        else {
                                            vErrors = null;
                                        }
                                    }
                                    let ifClause2;
                                    if (_valid2) {
                                        const _errs35 = errors;
                                        if (data11 && typeof data11 == 'object' && !Array.isArray(data11)) {
                                            let missing6;
                                            if (data11.name === undefined && (missing6 = 'name')) {
                                                validate45.errors = [
                                                    {
                                                        instancePath: instancePath + '/rhs',
                                                        schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/then/required',
                                                        keyword: 'required',
                                                        params: { missingProperty: missing6 },
                                                        message: "must have required property '" + missing6 + "'"
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var _valid2 = _errs35 === errors;
                                        valid9 = _valid2;
                                        ifClause2 = 'then';
                                    }
                                    else {
                                        const _errs36 = errors;
                                        if (data11 && typeof data11 == 'object' && !Array.isArray(data11)) {
                                            let missing7;
                                            if ((data11.litType === undefined && (missing7 = 'litType')) ||
                                                (data11.value === undefined && (missing7 = 'value'))) {
                                                validate45.errors = [
                                                    {
                                                        instancePath: instancePath + '/rhs',
                                                        schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/else/required',
                                                        keyword: 'required',
                                                        params: { missingProperty: missing7 },
                                                        message: "must have required property '" + missing7 + "'"
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var _valid2 = _errs36 === errors;
                                        valid9 = _valid2;
                                        ifClause2 = 'else';
                                    }
                                    if (!valid9) {
                                        const err5 = {
                                            instancePath: instancePath + '/rhs',
                                            schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/if',
                                            keyword: 'if',
                                            params: { failingKeyword: ifClause2 },
                                            message: 'must match "' + ifClause2 + '" schema'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err5];
                                        }
                                        else {
                                            vErrors.push(err5);
                                        }
                                        errors++;
                                        validate45.errors = vErrors;
                                        return false;
                                    }
                                    if (errors === _errs30) {
                                        if (data11 && typeof data11 == 'object' && !Array.isArray(data11)) {
                                            let missing8;
                                            if (data11.operandType === undefined && (missing8 = 'operandType')) {
                                                validate45.errors = [
                                                    {
                                                        instancePath: instancePath + '/rhs',
                                                        schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/required',
                                                        keyword: 'required',
                                                        params: { missingProperty: missing8 },
                                                        message: "must have required property '" + missing8 + "'"
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (data11.operandType !== undefined) {
                                                    let data13 = data11.operandType;
                                                    const _errs37 = errors;
                                                    if (typeof data13 !== 'string') {
                                                        validate45.errors = [
                                                            {
                                                                instancePath: instancePath + '/rhs/operandType',
                                                                schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/properties/operandType/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    if (!(data13 === 'column' || data13 === 'literal')) {
                                                        validate45.errors = [
                                                            {
                                                                instancePath: instancePath + '/rhs/operandType',
                                                                schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/properties/operandType/enum',
                                                                keyword: 'enum',
                                                                params: { allowedValues: schema85.properties.operandType.enum },
                                                                message: 'must be equal to one of the allowed values'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid11 = _errs37 === errors;
                                                }
                                                else {
                                                    var valid11 = true;
                                                }
                                                if (valid11) {
                                                    if (data11.name !== undefined) {
                                                        const _errs39 = errors;
                                                        if (typeof data11.name !== 'string') {
                                                            validate45.errors = [
                                                                {
                                                                    instancePath: instancePath + '/rhs/name',
                                                                    schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/properties/name/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid11 = _errs39 === errors;
                                                    }
                                                    else {
                                                        var valid11 = true;
                                                    }
                                                    if (valid11) {
                                                        if (data11.litType !== undefined) {
                                                            let data15 = data11.litType;
                                                            const _errs41 = errors;
                                                            if (typeof data15 !== 'string') {
                                                                validate45.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/rhs/litType',
                                                                        schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/properties/litType/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            if (!(data15 === 'string' ||
                                                                data15 === 'number' ||
                                                                data15 === 'date' ||
                                                                data15 === 'boolean')) {
                                                                validate45.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/rhs/litType',
                                                                        schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/properties/litType/enum',
                                                                        keyword: 'enum',
                                                                        params: { allowedValues: schema85.properties.litType.enum },
                                                                        message: 'must be equal to one of the allowed values'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid11 = _errs41 === errors;
                                                        }
                                                        else {
                                                            var valid11 = true;
                                                        }
                                                        if (valid11) {
                                                            if (data11.value !== undefined) {
                                                                const _errs43 = errors;
                                                                if (typeof data11.value !== 'string') {
                                                                    validate45.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/rhs/value',
                                                                            schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/properties/value/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid11 = _errs43 === errors;
                                                            }
                                                            else {
                                                                var valid11 = true;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate45.errors = [
                                                {
                                                    instancePath: instancePath + '/rhs',
                                                    schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid2 = _errs29 === errors;
                                }
                                else {
                                    var valid2 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate45.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate45.errors = vErrors;
    return errors === 0;
}
function validate44(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:ImportConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.importConfigType === undefined && (missing0 = 'importConfigType')) {
                validate44.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.importConfigType !== undefined) {
                    let data0 = data.importConfigType;
                    const _errs1 = errors;
                    if (typeof data0 !== 'string') {
                        validate44.errors = [
                            {
                                instancePath: instancePath + '/importConfigType',
                                schemaPath: '#/properties/importConfigType/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 's3csv' ||
                        data0 === 'gsheets' ||
                        data0 === 'adwords' ||
                        data0 === 'googleAnalytics' ||
                        data0 === 'shopify' ||
                        data0 === 'mySql' ||
                        data0 === 'oracle' ||
                        data0 === 'postgreSql' ||
                        data0 === 'amazonAurora' ||
                        data0 === 'amazonRedshift' ||
                        data0 === 'amazonS3' ||
                        data0 === 'icm' ||
                        data0 === 'salesForce' ||
                        data0 === 'parquet' ||
                        data0 === 'excel' ||
                        data0 === 'global' ||
                        data0 === 'hubspot' ||
                        data0 === 'symon' ||
                        data0 === 'dynamics' ||
                        data0 === 's3parquet' ||
                        data0 === 'snowflake' ||
                        data0 === 'msSql' ||
                        data0 === 'agentSync' ||
                        data0 === 'workday' ||
                        data0 === 'workdayRaaS' ||
                        data0 === 'tqp' ||
                        data0 === 'tableau' ||
                        data0 === 'sftp' ||
                        data0 === 'powerbi' ||
                        data0 === 'rest' ||
                        data0 === 'gong' ||
                        data0 === 'fwf' ||
                        data0 === 'netSuite' ||
                        data0 === 'oneDrive' ||
                        data0 === 'eltApi' ||
                        data0 === 'microsoftSqlServer' ||
                        data0 === 'stripe' ||
                        data0 === 'microsoftDynamics365' ||
                        data0 === 'github' ||
                        data0 === 'facebookAds' ||
                        data0 === 'amplitude' ||
                        data0 === 'appsFlyer' ||
                        data0 === 'customerIo' ||
                        data0 === 'freshDesk' ||
                        data0 === 'fullstory' ||
                        data0 === 'googleCloud' ||
                        data0 === 'googleEcommerce' ||
                        data0 === 'listrak' ||
                        data0 === 'livePerson' ||
                        data0 === 'onFleet' ||
                        data0 === 'saasquatch' ||
                        data0 === 'selligent' ||
                        data0 === 'userVoice' ||
                        data0 === 'vero' ||
                        data0 === 'adRoll' ||
                        data0 === 'afterShip' ||
                        data0 === 'asana' ||
                        data0 === 'autopilot' ||
                        data0 === 'azure' ||
                        data0 === 'bigCommerce' ||
                        data0 === 'bingAds' ||
                        data0 === 'brainTree' ||
                        data0 === 'bronto' ||
                        data0 === 'campaignManager' ||
                        data0 === 'campaignMonitor' ||
                        data0 === 'chargeBee' ||
                        data0 === 'closeIo' ||
                        data0 === 'clubspeed' ||
                        data0 === 'codat' ||
                        data0 === 'contentful' ||
                        data0 === 'delighted' ||
                        data0 === 'drip' ||
                        data0 === 'eloqua' ||
                        data0 === 'formkeep' ||
                        data0 === 'front' ||
                        data0 === 'ftp' ||
                        data0 === 'gitlab' ||
                        data0 === 'harvest' ||
                        data0 === 'heap' ||
                        data0 === 'helpScout' ||
                        data0 === 'heroku' ||
                        data0 === 'ibmDb2' ||
                        data0 === 'invoiced' ||
                        data0 === 'iterable' ||
                        data0 === 'klaviyo' ||
                        data0 === 'magento' ||
                        data0 === 'mailjet' ||
                        data0 === 'mariaDb' ||
                        data0 === 'mixpanel' ||
                        data0 === 'mongoDb' ||
                        data0 === 'outbrain' ||
                        data0 === 'particle' ||
                        data0 === 'purple' ||
                        data0 === 'quickBase' ||
                        data0 === 'recurly' ||
                        data0 === 'responsys' ||
                        data0 === 'revinate' ||
                        data0 === 'salesforceDesk' ||
                        data0 === 'salesforcePardot' ||
                        data0 === 'segment' ||
                        data0 === 'sendGrid' ||
                        data0 === 'sendWithUs' ||
                        data0 === 'shipHero' ||
                        data0 === 'shippo' ||
                        data0 === 'sparkPost' ||
                        data0 === 'square' ||
                        data0 === 'taboola' ||
                        data0 === 'toggl' ||
                        data0 === 'trello' ||
                        data0 === 'typeform' ||
                        data0 === 'urbanAirship' ||
                        data0 === 'webhooks' ||
                        data0 === 'yotpo' ||
                        data0 === 'zapier' ||
                        data0 === 'zendeskChat' ||
                        data0 === 'zendeskSupport' ||
                        data0 === 'googleBigQuery' ||
                        data0 === 'intercom' ||
                        data0 === 'sapSuccessFactors' ||
                        data0 === 'sapCrm' ||
                        data0 === 'ukg' ||
                        data0 === 'oracleHcm' ||
                        data0 === 'Adp' ||
                        data0 === 'dynamics365Sales' ||
                        data0 === 'ceridianDayforce' ||
                        data0 === 'oracleCrm' ||
                        data0 === 'oracleErpCloud' ||
                        data0 === 'sageIntacct' ||
                        data0 === 'bambooHr' ||
                        data0 === 'sapErp' ||
                        data0 === 'googleCloudPlatformCloudStorage' ||
                        data0 === 'sas' ||
                        data0 === 'dropbox' ||
                        data0 === 'googleDrive' ||
                        data0 === 'jira' ||
                        data0 === 'monday' ||
                        data0 === 'zuora' ||
                        data0 === 'adobeAnalytics' ||
                        data0 === 'zoomInfo' ||
                        data0 === 'marketo' ||
                        data0 === 'activeCampaign' ||
                        data0 === 'mailchimp' ||
                        data0 === 'infor' ||
                        data0 === 'cornerstoneOnDemand' ||
                        data0 === 'gusto' ||
                        data0 === 'paychexFlex' ||
                        data0 === 'zendesk' ||
                        data0 === 'serviceNow' ||
                        data0 === 'zohoCrm' ||
                        data0 === 'pipedrive' ||
                        data0 === 'quickBooks' ||
                        data0 === 'xero' ||
                        data0 === 'freshbooks' ||
                        data0 === 'zohoBooks' ||
                        data0 === 'waveFinancial')) {
                        validate44.errors = [
                            {
                                instancePath: instancePath + '/importConfigType',
                                schemaPath: '#/properties/importConfigType/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema82.properties.importConfigType.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.columnsToUpdate !== undefined) {
                        let data1 = data.columnsToUpdate;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                for (const key0 in data1) {
                                    let data2 = data1[key0];
                                    const _errs6 = errors;
                                    if (errors === _errs6) {
                                        if (Array.isArray(data2)) {
                                            var valid2 = true;
                                            const len0 = data2.length;
                                            for (let i0 = 0; i0 < len0; i0++) {
                                                let data3 = data2[i0];
                                                const _errs8 = errors;
                                                const _errs9 = errors;
                                                const _errs11 = errors;
                                                let valid4 = true;
                                                const _errs12 = errors;
                                                if (data3 && typeof data3 == 'object' && !Array.isArray(data3)) {
                                                    if (data3.columnUpdateType !== undefined) {
                                                        if ('modify' !== data3.columnUpdateType) {
                                                            const err0 = {};
                                                            if (vErrors === null) {
                                                                vErrors = [err0];
                                                            }
                                                            else {
                                                                vErrors.push(err0);
                                                            }
                                                            errors++;
                                                        }
                                                    }
                                                }
                                                var _valid0 = _errs12 === errors;
                                                errors = _errs11;
                                                if (vErrors !== null) {
                                                    if (_errs11) {
                                                        vErrors.length = _errs11;
                                                    }
                                                    else {
                                                        vErrors = null;
                                                    }
                                                }
                                                if (_valid0) {
                                                    const _errs14 = errors;
                                                    const _errs15 = errors;
                                                    let valid6 = true;
                                                    const _errs16 = errors;
                                                    if (data3 && typeof data3 == 'object' && !Array.isArray(data3)) {
                                                        let missing1;
                                                        if (data3.targetType === undefined && (missing1 = 'targetType')) {
                                                            const err1 = {};
                                                            if (vErrors === null) {
                                                                vErrors = [err1];
                                                            }
                                                            else {
                                                                vErrors.push(err1);
                                                            }
                                                            errors++;
                                                        }
                                                        else {
                                                            if (data3.targetType !== undefined) {
                                                                if ('date' !== data3.targetType) {
                                                                    const err2 = {};
                                                                    if (vErrors === null) {
                                                                        vErrors = [err2];
                                                                    }
                                                                    else {
                                                                        vErrors.push(err2);
                                                                    }
                                                                    errors++;
                                                                }
                                                            }
                                                        }
                                                    }
                                                    var _valid1 = _errs16 === errors;
                                                    errors = _errs15;
                                                    if (vErrors !== null) {
                                                        if (_errs15) {
                                                            vErrors.length = _errs15;
                                                        }
                                                        else {
                                                            vErrors = null;
                                                        }
                                                    }
                                                    if (_valid1) {
                                                        const _errs18 = errors;
                                                        if (data3 && typeof data3 == 'object' && !Array.isArray(data3)) {
                                                            let missing2;
                                                            if (data3.dateFormat === undefined && (missing2 = 'dateFormat')) {
                                                                validate44.errors = [
                                                                    {
                                                                        instancePath: instancePath +
                                                                            '/columnsToUpdate/' +
                                                                            key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                            '/' +
                                                                            i0,
                                                                        schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/then/then/required',
                                                                        keyword: 'required',
                                                                        params: { missingProperty: missing2 },
                                                                        message: "must have required property '" + missing2 + "'"
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var _valid1 = _errs18 === errors;
                                                        valid6 = _valid1;
                                                    }
                                                    if (!valid6) {
                                                        const err3 = {
                                                            instancePath: instancePath +
                                                                '/columnsToUpdate/' +
                                                                key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                '/' +
                                                                i0,
                                                            schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/then/if',
                                                            keyword: 'if',
                                                            params: { failingKeyword: 'then' },
                                                            message: 'must match "then" schema'
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err3];
                                                        }
                                                        else {
                                                            vErrors.push(err3);
                                                        }
                                                        errors++;
                                                        validate44.errors = vErrors;
                                                        return false;
                                                    }
                                                    if (errors === _errs14) {
                                                        if (data3 && typeof data3 == 'object' && !Array.isArray(data3)) {
                                                            let missing3;
                                                            if ((data3.type === undefined && (missing3 = 'type')) ||
                                                                (data3.targetType === undefined && (missing3 = 'targetType'))) {
                                                                validate44.errors = [
                                                                    {
                                                                        instancePath: instancePath +
                                                                            '/columnsToUpdate/' +
                                                                            key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                            '/' +
                                                                            i0,
                                                                        schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/then/required',
                                                                        keyword: 'required',
                                                                        params: { missingProperty: missing3 },
                                                                        message: "must have required property '" + missing3 + "'"
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                    }
                                                    var _valid0 = _errs14 === errors;
                                                    valid4 = _valid0;
                                                }
                                                if (!valid4) {
                                                    const err4 = {
                                                        instancePath: instancePath +
                                                            '/columnsToUpdate/' +
                                                            key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                            '/' +
                                                            i0,
                                                        schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/if',
                                                        keyword: 'if',
                                                        params: { failingKeyword: 'then' },
                                                        message: 'must match "then" schema'
                                                    };
                                                    if (vErrors === null) {
                                                        vErrors = [err4];
                                                    }
                                                    else {
                                                        vErrors.push(err4);
                                                    }
                                                    errors++;
                                                    validate44.errors = vErrors;
                                                    return false;
                                                }
                                                if (errors === _errs9) {
                                                    if (data3 && typeof data3 == 'object' && !Array.isArray(data3)) {
                                                        let missing4;
                                                        if ((data3.column === undefined && (missing4 = 'column')) ||
                                                            (data3.columnUpdateType === undefined && (missing4 = 'columnUpdateType'))) {
                                                            validate44.errors = [
                                                                {
                                                                    instancePath: instancePath +
                                                                        '/columnsToUpdate/' +
                                                                        key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                        '/' +
                                                                        i0,
                                                                    schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/required',
                                                                    keyword: 'required',
                                                                    params: { missingProperty: missing4 },
                                                                    message: "must have required property '" + missing4 + "'"
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            if (data3.column !== undefined) {
                                                                const _errs19 = errors;
                                                                if (typeof data3.column !== 'string') {
                                                                    validate44.errors = [
                                                                        {
                                                                            instancePath: instancePath +
                                                                                '/columnsToUpdate/' +
                                                                                key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                '/' +
                                                                                i0 +
                                                                                '/column',
                                                                            schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/properties/column/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid8 = _errs19 === errors;
                                                            }
                                                            else {
                                                                var valid8 = true;
                                                            }
                                                            if (valid8) {
                                                                if (data3.columnUpdateType !== undefined) {
                                                                    let data7 = data3.columnUpdateType;
                                                                    const _errs21 = errors;
                                                                    if (typeof data7 !== 'string') {
                                                                        validate44.errors = [
                                                                            {
                                                                                instancePath: instancePath +
                                                                                    '/columnsToUpdate/' +
                                                                                    key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                    '/' +
                                                                                    i0 +
                                                                                    '/columnUpdateType',
                                                                                schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/properties/columnUpdateType/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    if (!(data7 === 'drop' || data7 === 'mask' || data7 === 'modify')) {
                                                                        validate44.errors = [
                                                                            {
                                                                                instancePath: instancePath +
                                                                                    '/columnsToUpdate/' +
                                                                                    key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                    '/' +
                                                                                    i0 +
                                                                                    '/columnUpdateType',
                                                                                schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/properties/columnUpdateType/enum',
                                                                                keyword: 'enum',
                                                                                params: { allowedValues: schema40.properties.columnUpdateType.enum },
                                                                                message: 'must be equal to one of the allowed values'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    var valid8 = _errs21 === errors;
                                                                }
                                                                else {
                                                                    var valid8 = true;
                                                                }
                                                                if (valid8) {
                                                                    if (data3.type !== undefined) {
                                                                        let data8 = data3.type;
                                                                        const _errs23 = errors;
                                                                        if (typeof data8 !== 'string') {
                                                                            validate44.errors = [
                                                                                {
                                                                                    instancePath: instancePath +
                                                                                        '/columnsToUpdate/' +
                                                                                        key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                        '/' +
                                                                                        i0 +
                                                                                        '/type',
                                                                                    schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/properties/type/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'string' },
                                                                                    message: 'must be string'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        if (!(data8 === 'number' ||
                                                                            data8 === 'string' ||
                                                                            data8 === 'boolean' ||
                                                                            data8 === 'date' ||
                                                                            data8 === 'decimal')) {
                                                                            validate44.errors = [
                                                                                {
                                                                                    instancePath: instancePath +
                                                                                        '/columnsToUpdate/' +
                                                                                        key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                        '/' +
                                                                                        i0 +
                                                                                        '/type',
                                                                                    schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/properties/type/enum',
                                                                                    keyword: 'enum',
                                                                                    params: { allowedValues: schema40.properties.type.enum },
                                                                                    message: 'must be equal to one of the allowed values'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        var valid8 = _errs23 === errors;
                                                                    }
                                                                    else {
                                                                        var valid8 = true;
                                                                    }
                                                                    if (valid8) {
                                                                        if (data3.targetType !== undefined) {
                                                                            let data9 = data3.targetType;
                                                                            const _errs25 = errors;
                                                                            if (typeof data9 !== 'string') {
                                                                                validate44.errors = [
                                                                                    {
                                                                                        instancePath: instancePath +
                                                                                            '/columnsToUpdate/' +
                                                                                            key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                            '/' +
                                                                                            i0 +
                                                                                            '/targetType',
                                                                                        schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/properties/targetType/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            if (!(data9 === 'number' ||
                                                                                data9 === 'string' ||
                                                                                data9 === 'boolean' ||
                                                                                data9 === 'date' ||
                                                                                data9 === 'decimal')) {
                                                                                validate44.errors = [
                                                                                    {
                                                                                        instancePath: instancePath +
                                                                                            '/columnsToUpdate/' +
                                                                                            key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                            '/' +
                                                                                            i0 +
                                                                                            '/targetType',
                                                                                        schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/properties/targetType/enum',
                                                                                        keyword: 'enum',
                                                                                        params: { allowedValues: schema40.properties.targetType.enum },
                                                                                        message: 'must be equal to one of the allowed values'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            var valid8 = _errs25 === errors;
                                                                        }
                                                                        else {
                                                                            var valid8 = true;
                                                                        }
                                                                        if (valid8) {
                                                                            if (data3.dateFormat !== undefined) {
                                                                                let data10 = data3.dateFormat;
                                                                                const _errs27 = errors;
                                                                                if (errors === _errs27) {
                                                                                    if (typeof data10 === 'string') {
                                                                                        if (func2(data10) < 1) {
                                                                                            validate44.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath +
                                                                                                        '/columnsToUpdate/' +
                                                                                                        key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                        '/' +
                                                                                                        i0 +
                                                                                                        '/dateFormat',
                                                                                                    schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/properties/dateFormat/minLength',
                                                                                                    keyword: 'minLength',
                                                                                                    params: { limit: 1 },
                                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                    else {
                                                                                        validate44.errors = [
                                                                                            {
                                                                                                instancePath: instancePath +
                                                                                                    '/columnsToUpdate/' +
                                                                                                    key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                    '/' +
                                                                                                    i0 +
                                                                                                    '/dateFormat',
                                                                                                schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/properties/dateFormat/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'string' },
                                                                                                message: 'must be string'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                var valid8 = _errs27 === errors;
                                                                            }
                                                                            else {
                                                                                var valid8 = true;
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate44.errors = [
                                                            {
                                                                instancePath: instancePath +
                                                                    '/columnsToUpdate/' +
                                                                    key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                    '/' +
                                                                    i0,
                                                                schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/type',
                                                                keyword: 'type',
                                                                params: { type: 'object' },
                                                                message: 'must be object'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid2 = _errs8 === errors;
                                                if (!valid2) {
                                                    break;
                                                }
                                            }
                                            if (valid2) {
                                                let i1 = data2.length;
                                                let j0;
                                                if (i1 > 1) {
                                                    outer0: for (; i1--;) {
                                                        for (j0 = i1; j0--;) {
                                                            if (func0(data2[i1], data2[j0])) {
                                                                validate44.errors = [
                                                                    {
                                                                        instancePath: instancePath +
                                                                            '/columnsToUpdate/' +
                                                                            key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                        schemaPath: '#/properties/columnsToUpdate/additionalProperties/uniqueItems',
                                                                        keyword: 'uniqueItems',
                                                                        params: { i: i1, j: j0 },
                                                                        message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                                    }
                                                                ];
                                                                return false;
                                                                break outer0;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate44.errors = [
                                                {
                                                    instancePath: instancePath + '/columnsToUpdate/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                    schemaPath: '#/properties/columnsToUpdate/additionalProperties/type',
                                                    keyword: 'type',
                                                    params: { type: 'array' },
                                                    message: 'must be array'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid1 = _errs6 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                            }
                            else {
                                validate44.errors = [
                                    {
                                        instancePath: instancePath + '/columnsToUpdate',
                                        schemaPath: '#/properties/columnsToUpdate/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.columnsToDrop !== undefined) {
                            let data11 = data.columnsToDrop;
                            const _errs29 = errors;
                            if (errors === _errs29) {
                                if (data11 && typeof data11 == 'object' && !Array.isArray(data11)) {
                                    for (const key1 in data11) {
                                        let data12 = data11[key1];
                                        const _errs32 = errors;
                                        if (errors === _errs32) {
                                            if (Array.isArray(data12)) {
                                                var valid11 = true;
                                                const len1 = data12.length;
                                                for (let i2 = 0; i2 < len1; i2++) {
                                                    const _errs34 = errors;
                                                    if (typeof data12[i2] !== 'string') {
                                                        validate44.errors = [
                                                            {
                                                                instancePath: instancePath +
                                                                    '/columnsToDrop/' +
                                                                    key1.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                    '/' +
                                                                    i2,
                                                                schemaPath: '#/properties/columnsToDrop/additionalProperties/items/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid11 = _errs34 === errors;
                                                    if (!valid11) {
                                                        break;
                                                    }
                                                }
                                                if (valid11) {
                                                    let i3 = data12.length;
                                                    let j1;
                                                    if (i3 > 1) {
                                                        const indices0 = {};
                                                        for (; i3--;) {
                                                            let item0 = data12[i3];
                                                            if (typeof item0 !== 'string') {
                                                                continue;
                                                            }
                                                            if (typeof indices0[item0] == 'number') {
                                                                j1 = indices0[item0];
                                                                validate44.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/columnsToDrop/' + key1.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                        schemaPath: '#/properties/columnsToDrop/additionalProperties/uniqueItems',
                                                                        keyword: 'uniqueItems',
                                                                        params: { i: i3, j: j1 },
                                                                        message: 'must NOT have duplicate items (items ## ' + j1 + ' and ' + i3 + ' are identical)'
                                                                    }
                                                                ];
                                                                return false;
                                                                break;
                                                            }
                                                            indices0[item0] = i3;
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate44.errors = [
                                                    {
                                                        instancePath: instancePath + '/columnsToDrop/' + key1.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                        schemaPath: '#/properties/columnsToDrop/additionalProperties/type',
                                                        keyword: 'type',
                                                        params: { type: 'array' },
                                                        message: 'must be array'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid10 = _errs32 === errors;
                                        if (!valid10) {
                                            break;
                                        }
                                    }
                                }
                                else {
                                    validate44.errors = [
                                        {
                                            instancePath: instancePath + '/columnsToDrop',
                                            schemaPath: '#/properties/columnsToDrop/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs29 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.columnsToMask !== undefined) {
                                let data14 = data.columnsToMask;
                                const _errs36 = errors;
                                if (errors === _errs36) {
                                    if (data14 && typeof data14 == 'object' && !Array.isArray(data14)) {
                                        for (const key2 in data14) {
                                            let data15 = data14[key2];
                                            const _errs39 = errors;
                                            if (errors === _errs39) {
                                                if (Array.isArray(data15)) {
                                                    var valid14 = true;
                                                    const len2 = data15.length;
                                                    for (let i4 = 0; i4 < len2; i4++) {
                                                        const _errs41 = errors;
                                                        if (typeof data15[i4] !== 'string') {
                                                            validate44.errors = [
                                                                {
                                                                    instancePath: instancePath +
                                                                        '/columnsToMask/' +
                                                                        key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                        '/' +
                                                                        i4,
                                                                    schemaPath: '#/properties/columnsToMask/additionalProperties/items/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid14 = _errs41 === errors;
                                                        if (!valid14) {
                                                            break;
                                                        }
                                                    }
                                                    if (valid14) {
                                                        let i5 = data15.length;
                                                        let j2;
                                                        if (i5 > 1) {
                                                            const indices1 = {};
                                                            for (; i5--;) {
                                                                let item1 = data15[i5];
                                                                if (typeof item1 !== 'string') {
                                                                    continue;
                                                                }
                                                                if (typeof indices1[item1] == 'number') {
                                                                    j2 = indices1[item1];
                                                                    validate44.errors = [
                                                                        {
                                                                            instancePath: instancePath +
                                                                                '/columnsToMask/' +
                                                                                key2.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                            schemaPath: '#/properties/columnsToMask/additionalProperties/uniqueItems',
                                                                            keyword: 'uniqueItems',
                                                                            params: { i: i5, j: j2 },
                                                                            message: 'must NOT have duplicate items (items ## ' +
                                                                                j2 +
                                                                                ' and ' +
                                                                                i5 +
                                                                                ' are identical)'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                    break;
                                                                }
                                                                indices1[item1] = i5;
                                                            }
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate44.errors = [
                                                        {
                                                            instancePath: instancePath + '/columnsToMask/' + key2.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                            schemaPath: '#/properties/columnsToMask/additionalProperties/type',
                                                            keyword: 'type',
                                                            params: { type: 'array' },
                                                            message: 'must be array'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid13 = _errs39 === errors;
                                            if (!valid13) {
                                                break;
                                            }
                                        }
                                    }
                                    else {
                                        validate44.errors = [
                                            {
                                                instancePath: instancePath + '/columnsToMask',
                                                schemaPath: '#/properties/columnsToMask/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs36 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.filters !== undefined) {
                                    let data17 = data.filters;
                                    const _errs43 = errors;
                                    if (errors === _errs43) {
                                        if (data17 && typeof data17 == 'object' && !Array.isArray(data17)) {
                                            for (const key3 in data17) {
                                                const _errs46 = errors;
                                                if (!validate45(data17[key3], {
                                                    instancePath: instancePath + '/filters/' + key3.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                    parentData: data17,
                                                    parentDataProperty: key3,
                                                    rootData
                                                })) {
                                                    vErrors = vErrors === null ? validate45.errors : vErrors.concat(validate45.errors);
                                                    errors = vErrors.length;
                                                }
                                                var valid16 = _errs46 === errors;
                                                if (!valid16) {
                                                    break;
                                                }
                                            }
                                        }
                                        else {
                                            validate44.errors = [
                                                {
                                                    instancePath: instancePath + '/filters',
                                                    schemaPath: '#/properties/filters/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs43 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.dataCategory !== undefined) {
                                        let data19 = data.dataCategory;
                                        const _errs47 = errors;
                                        if (typeof data19 !== 'string') {
                                            validate44.errors = [
                                                {
                                                    instancePath: instancePath + '/dataCategory',
                                                    schemaPath: '#/properties/dataCategory/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        if (!(data19 === 'dataSource' || data19 === 'unitTestDataSource' || data19 === 'unitTestSnapshot')) {
                                            validate44.errors = [
                                                {
                                                    instancePath: instancePath + '/dataCategory',
                                                    schemaPath: '#/properties/dataCategory/enum',
                                                    keyword: 'enum',
                                                    params: { allowedValues: schema82.properties.dataCategory.enum },
                                                    message: 'must be equal to one of the allowed values'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs47 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate44.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate44.errors = vErrors;
    return errors === 0;
}
export const importCsvToParquetTaskSchemaValidation = validate47;
const schema87 = {
    $id: 'urn:wisepipe-common-data:ImportCsvToParquetTask',
    type: 'object',
    properties: {
        spark: { $ref: 'urn:wisepipe-common-data:ImportComputeTask' },
        python: { $ref: 'urn:wisepipe-common-data:ImportComputeTask' },
        sparkRetry: { $ref: 'urn:wisepipe-common-data:ImportComputeTask' }
    },
    required: ['spark', 'python']
};
function validate47(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:ImportCsvToParquetTask" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.spark === undefined && (missing0 = 'spark')) || (data.python === undefined && (missing0 = 'python'))) {
                validate47.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.spark !== undefined) {
                    const _errs1 = errors;
                    if (!validate43(data.spark, {
                        instancePath: instancePath + '/spark',
                        parentData: data,
                        parentDataProperty: 'spark',
                        rootData
                    })) {
                        vErrors = vErrors === null ? validate43.errors : vErrors.concat(validate43.errors);
                        errors = vErrors.length;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.python !== undefined) {
                        const _errs2 = errors;
                        if (!validate43(data.python, {
                            instancePath: instancePath + '/python',
                            parentData: data,
                            parentDataProperty: 'python',
                            rootData
                        })) {
                            vErrors = vErrors === null ? validate43.errors : vErrors.concat(validate43.errors);
                            errors = vErrors.length;
                        }
                        var valid0 = _errs2 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.sparkRetry !== undefined) {
                            const _errs3 = errors;
                            if (!validate43(data.sparkRetry, {
                                instancePath: instancePath + '/sparkRetry',
                                parentData: data,
                                parentDataProperty: 'sparkRetry',
                                rootData
                            })) {
                                vErrors = vErrors === null ? validate43.errors : vErrors.concat(validate43.errors);
                                errors = vErrors.length;
                            }
                            var valid0 = _errs3 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate47.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate47.errors = vErrors;
    return errors === 0;
}
export const importDetailsSchemaValidation = validate51;
const schema88 = {
    $id: 'urn:wisepipe-common-data:ImportDetails',
    type: 'object',
    properties: {
        userID: { type: 'string', format: 'uuid' },
        importID: { type: 'string', uid: 9 },
        name: { type: 'string', minLength: 1 },
        operation: { type: 'string', enum: ['new', 'append', 'overwrite'] },
        status: { type: 'string', enum: ['waiting', 'running', 'completed', 'failed', 'cancelled'] },
        config: { $ref: 'urn:wisepipe-common-data:ImportConfig' },
        discoveryID: { type: 'string', uid: 9 },
        originID: { type: 'string', uid: 9 },
        streamID: { type: 'string', minLength: 1 },
        startTime: { type: 'string', format: 'date-time' },
        endTime: { type: 'string', format: 'date-time' },
        connectionID: { type: 'string', uid: 9 },
        firstDataSourceID: { type: 'string', uid: 9 },
        error: { type: 'object' },
        progress: { type: 'number', minimum: 0, maximum: 1 },
        rowsProcessed: { type: 'number', minimum: 0 }
    },
    if: { properties: { status: { const: 'completed' } } },
    then: { required: ['endTime'] },
    else: {
        if: { properties: { status: { const: 'failed' } } },
        then: { required: ['error', 'endTime'] },
        else: { if: { properties: { status: { const: 'cancelled' } } }, then: { required: ['endTime'] } }
    },
    required: ['userID', 'importID', 'name', 'operation', 'status', 'config', 'originID', 'startTime', 'progress']
};
const func150 = ucs2length;
const func151 = base64urlToBuffer;
const func152 = base64urlEncode;
const func153 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func155 = ucs2length;
const func156 = base64urlToBuffer;
const func157 = base64urlEncode;
const func158 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func159 = ucs2length;
const func160 = base64urlToBuffer;
const func161 = base64urlEncode;
const func162 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func164 = ucs2length;
const func165 = base64urlToBuffer;
const func166 = base64urlEncode;
const func167 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func168 = ucs2length;
const func169 = base64urlToBuffer;
const func170 = base64urlEncode;
const func171 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate51(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:ImportDetails" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.status !== undefined) {
            if ('completed' !== data.status) {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    let ifClause0;
    if (_valid0) {
        const _errs4 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.endTime === undefined && (missing0 = 'endTime')) {
                validate51.errors = [
                    {
                        instancePath,
                        schemaPath: '#/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs4 === errors;
        valid0 = _valid0;
        ifClause0 = 'then';
    }
    else {
        const _errs5 = errors;
        const _errs6 = errors;
        let valid2 = true;
        const _errs7 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.status !== undefined) {
                if ('failed' !== data.status) {
                    const err1 = {};
                    if (vErrors === null) {
                        vErrors = [err1];
                    }
                    else {
                        vErrors.push(err1);
                    }
                    errors++;
                }
            }
        }
        var _valid1 = _errs7 === errors;
        errors = _errs6;
        if (vErrors !== null) {
            if (_errs6) {
                vErrors.length = _errs6;
            }
            else {
                vErrors = null;
            }
        }
        let ifClause1;
        if (_valid1) {
            const _errs9 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                let missing1;
                if ((data.error === undefined && (missing1 = 'error')) ||
                    (data.endTime === undefined && (missing1 = 'endTime'))) {
                    validate51.errors = [
                        {
                            instancePath,
                            schemaPath: '#/else/then/required',
                            keyword: 'required',
                            params: { missingProperty: missing1 },
                            message: "must have required property '" + missing1 + "'"
                        }
                    ];
                    return false;
                }
            }
            var _valid1 = _errs9 === errors;
            valid2 = _valid1;
            ifClause1 = 'then';
        }
        else {
            const _errs10 = errors;
            const _errs11 = errors;
            let valid4 = true;
            const _errs12 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                if (data.status !== undefined) {
                    if ('cancelled' !== data.status) {
                        const err2 = {};
                        if (vErrors === null) {
                            vErrors = [err2];
                        }
                        else {
                            vErrors.push(err2);
                        }
                        errors++;
                    }
                }
            }
            var _valid2 = _errs12 === errors;
            errors = _errs11;
            if (vErrors !== null) {
                if (_errs11) {
                    vErrors.length = _errs11;
                }
                else {
                    vErrors = null;
                }
            }
            if (_valid2) {
                const _errs14 = errors;
                if (data && typeof data == 'object' && !Array.isArray(data)) {
                    let missing2;
                    if (data.endTime === undefined && (missing2 = 'endTime')) {
                        validate51.errors = [
                            {
                                instancePath,
                                schemaPath: '#/else/else/then/required',
                                keyword: 'required',
                                params: { missingProperty: missing2 },
                                message: "must have required property '" + missing2 + "'"
                            }
                        ];
                        return false;
                    }
                }
                var _valid2 = _errs14 === errors;
                valid4 = _valid2;
            }
            if (!valid4) {
                const err3 = {
                    instancePath,
                    schemaPath: '#/else/else/if',
                    keyword: 'if',
                    params: { failingKeyword: 'then' },
                    message: 'must match "then" schema'
                };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
                validate51.errors = vErrors;
                return false;
            }
            var _valid1 = _errs10 === errors;
            valid2 = _valid1;
            ifClause1 = 'else';
        }
        if (!valid2) {
            const err4 = {
                instancePath,
                schemaPath: '#/else/if',
                keyword: 'if',
                params: { failingKeyword: ifClause1 },
                message: 'must match "' + ifClause1 + '" schema'
            };
            if (vErrors === null) {
                vErrors = [err4];
            }
            else {
                vErrors.push(err4);
            }
            errors++;
            validate51.errors = vErrors;
            return false;
        }
        var _valid0 = _errs5 === errors;
        valid0 = _valid0;
        ifClause0 = 'else';
    }
    if (!valid0) {
        const err5 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: ifClause0 },
            message: 'must match "' + ifClause0 + '" schema'
        };
        if (vErrors === null) {
            vErrors = [err5];
        }
        else {
            vErrors.push(err5);
        }
        errors++;
        validate51.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing3;
            if ((data.userID === undefined && (missing3 = 'userID')) ||
                (data.importID === undefined && (missing3 = 'importID')) ||
                (data.name === undefined && (missing3 = 'name')) ||
                (data.operation === undefined && (missing3 = 'operation')) ||
                (data.status === undefined && (missing3 = 'status')) ||
                (data.config === undefined && (missing3 = 'config')) ||
                (data.originID === undefined && (missing3 = 'originID')) ||
                (data.startTime === undefined && (missing3 = 'startTime')) ||
                (data.progress === undefined && (missing3 = 'progress'))) {
                validate51.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing3 },
                        message: "must have required property '" + missing3 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.userID !== undefined) {
                    let data3 = data.userID;
                    const _errs15 = errors;
                    if (errors === _errs15) {
                        if (errors === _errs15) {
                            if (typeof data3 === 'string') {
                                if (!formats4.test(data3)) {
                                    validate51.errors = [
                                        {
                                            instancePath: instancePath + '/userID',
                                            schemaPath: '#/properties/userID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate51.errors = [
                                    {
                                        instancePath: instancePath + '/userID',
                                        schemaPath: '#/properties/userID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid6 = _errs15 === errors;
                }
                else {
                    var valid6 = true;
                }
                if (valid6) {
                    if (data.importID !== undefined) {
                        let data4 = data.importID;
                        const _errs17 = errors;
                        if (errors === _errs17) {
                            if (typeof data4 === 'string') {
                                const b64min0 = Math.ceil((4 * 9) / 3);
                                const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                if (func150(data4) < b64min0 || func150(data4) > b64max0) {
                                    validate51.errors = [
                                        {
                                            instancePath: instancePath + '/importID',
                                            schemaPath: '#/properties/importID/uid',
                                            keyword: 'uid',
                                            params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func150(data4) },
                                            message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func150(data4)
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const decoded0 = func151(data4);
                                    if (decoded0.length !== 9) {
                                        validate51.errors = [
                                            {
                                                instancePath: instancePath + '/importID',
                                                schemaPath: '#/properties/importID/uid',
                                                keyword: 'uid',
                                                params: { error: 'decoded' },
                                                message: 'must decode to 9 bytes'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const encoded0 = func152(decoded0);
                                        if (func153(encoded0) !== func153(data4)) {
                                            validate51.errors = [
                                                {
                                                    instancePath: instancePath + '/importID',
                                                    schemaPath: '#/properties/importID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'ambiguous' },
                                                    message: 'encoding is ambiguous'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            else {
                                validate51.errors = [
                                    {
                                        instancePath: instancePath + '/importID',
                                        schemaPath: '#/properties/importID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid6 = _errs17 === errors;
                    }
                    else {
                        var valid6 = true;
                    }
                    if (valid6) {
                        if (data.name !== undefined) {
                            let data5 = data.name;
                            const _errs19 = errors;
                            if (errors === _errs19) {
                                if (typeof data5 === 'string') {
                                    if (func2(data5) < 1) {
                                        validate51.errors = [
                                            {
                                                instancePath: instancePath + '/name',
                                                schemaPath: '#/properties/name/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate51.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid6 = _errs19 === errors;
                        }
                        else {
                            var valid6 = true;
                        }
                        if (valid6) {
                            if (data.operation !== undefined) {
                                let data6 = data.operation;
                                const _errs21 = errors;
                                if (typeof data6 !== 'string') {
                                    validate51.errors = [
                                        {
                                            instancePath: instancePath + '/operation',
                                            schemaPath: '#/properties/operation/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                if (!(data6 === 'new' || data6 === 'append' || data6 === 'overwrite')) {
                                    validate51.errors = [
                                        {
                                            instancePath: instancePath + '/operation',
                                            schemaPath: '#/properties/operation/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema88.properties.operation.enum },
                                            message: 'must be equal to one of the allowed values'
                                        }
                                    ];
                                    return false;
                                }
                                var valid6 = _errs21 === errors;
                            }
                            else {
                                var valid6 = true;
                            }
                            if (valid6) {
                                if (data.status !== undefined) {
                                    let data7 = data.status;
                                    const _errs23 = errors;
                                    if (typeof data7 !== 'string') {
                                        validate51.errors = [
                                            {
                                                instancePath: instancePath + '/status',
                                                schemaPath: '#/properties/status/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    if (!(data7 === 'waiting' ||
                                        data7 === 'running' ||
                                        data7 === 'completed' ||
                                        data7 === 'failed' ||
                                        data7 === 'cancelled')) {
                                        validate51.errors = [
                                            {
                                                instancePath: instancePath + '/status',
                                                schemaPath: '#/properties/status/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema88.properties.status.enum },
                                                message: 'must be equal to one of the allowed values'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid6 = _errs23 === errors;
                                }
                                else {
                                    var valid6 = true;
                                }
                                if (valid6) {
                                    if (data.config !== undefined) {
                                        const _errs25 = errors;
                                        if (!validate44(data.config, {
                                            instancePath: instancePath + '/config',
                                            parentData: data,
                                            parentDataProperty: 'config',
                                            rootData
                                        })) {
                                            vErrors = vErrors === null ? validate44.errors : vErrors.concat(validate44.errors);
                                            errors = vErrors.length;
                                        }
                                        var valid6 = _errs25 === errors;
                                    }
                                    else {
                                        var valid6 = true;
                                    }
                                    if (valid6) {
                                        if (data.discoveryID !== undefined) {
                                            let data9 = data.discoveryID;
                                            const _errs26 = errors;
                                            if (errors === _errs26) {
                                                if (typeof data9 === 'string') {
                                                    const b64min1 = Math.ceil((4 * 9) / 3);
                                                    const b64max1 = Math.ceil((4 * 9) / 3) + 3;
                                                    if (func155(data9) < b64min1 || func155(data9) > b64max1) {
                                                        validate51.errors = [
                                                            {
                                                                instancePath: instancePath + '/discoveryID',
                                                                schemaPath: '#/properties/discoveryID/uid',
                                                                keyword: 'uid',
                                                                params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func155(data9) },
                                                                message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func155(data9)
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        const decoded1 = func156(data9);
                                                        if (decoded1.length !== 9) {
                                                            validate51.errors = [
                                                                {
                                                                    instancePath: instancePath + '/discoveryID',
                                                                    schemaPath: '#/properties/discoveryID/uid',
                                                                    keyword: 'uid',
                                                                    params: { error: 'decoded' },
                                                                    message: 'must decode to 9 bytes'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            const encoded1 = func157(decoded1);
                                                            if (func158(encoded1) !== func158(data9)) {
                                                                validate51.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/discoveryID',
                                                                        schemaPath: '#/properties/discoveryID/uid',
                                                                        keyword: 'uid',
                                                                        params: { error: 'ambiguous' },
                                                                        message: 'encoding is ambiguous'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate51.errors = [
                                                        {
                                                            instancePath: instancePath + '/discoveryID',
                                                            schemaPath: '#/properties/discoveryID/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid6 = _errs26 === errors;
                                        }
                                        else {
                                            var valid6 = true;
                                        }
                                        if (valid6) {
                                            if (data.originID !== undefined) {
                                                let data10 = data.originID;
                                                const _errs28 = errors;
                                                if (errors === _errs28) {
                                                    if (typeof data10 === 'string') {
                                                        const b64min2 = Math.ceil((4 * 9) / 3);
                                                        const b64max2 = Math.ceil((4 * 9) / 3) + 3;
                                                        if (func159(data10) < b64min2 || func159(data10) > b64max2) {
                                                            validate51.errors = [
                                                                {
                                                                    instancePath: instancePath + '/originID',
                                                                    schemaPath: '#/properties/originID/uid',
                                                                    keyword: 'uid',
                                                                    params: {
                                                                        error: 'encoded',
                                                                        b64min: b64min2,
                                                                        b64max: b64max2,
                                                                        length: func159(data10)
                                                                    },
                                                                    message: 'length must be between ' +
                                                                        b64min2 +
                                                                        ' and ' +
                                                                        b64max2 +
                                                                        ', but is ' +
                                                                        func159(data10)
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            const decoded2 = func160(data10);
                                                            if (decoded2.length !== 9) {
                                                                validate51.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/originID',
                                                                        schemaPath: '#/properties/originID/uid',
                                                                        keyword: 'uid',
                                                                        params: { error: 'decoded' },
                                                                        message: 'must decode to 9 bytes'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            else {
                                                                const encoded2 = func161(decoded2);
                                                                if (func162(encoded2) !== func162(data10)) {
                                                                    validate51.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/originID',
                                                                            schemaPath: '#/properties/originID/uid',
                                                                            keyword: 'uid',
                                                                            params: { error: 'ambiguous' },
                                                                            message: 'encoding is ambiguous'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate51.errors = [
                                                            {
                                                                instancePath: instancePath + '/originID',
                                                                schemaPath: '#/properties/originID/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid6 = _errs28 === errors;
                                            }
                                            else {
                                                var valid6 = true;
                                            }
                                            if (valid6) {
                                                if (data.streamID !== undefined) {
                                                    let data11 = data.streamID;
                                                    const _errs30 = errors;
                                                    if (errors === _errs30) {
                                                        if (typeof data11 === 'string') {
                                                            if (func2(data11) < 1) {
                                                                validate51.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/streamID',
                                                                        schemaPath: '#/properties/streamID/minLength',
                                                                        keyword: 'minLength',
                                                                        params: { limit: 1 },
                                                                        message: 'must NOT have fewer than 1 characters'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate51.errors = [
                                                                {
                                                                    instancePath: instancePath + '/streamID',
                                                                    schemaPath: '#/properties/streamID/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid6 = _errs30 === errors;
                                                }
                                                else {
                                                    var valid6 = true;
                                                }
                                                if (valid6) {
                                                    if (data.startTime !== undefined) {
                                                        let data12 = data.startTime;
                                                        const _errs32 = errors;
                                                        if (errors === _errs32) {
                                                            if (errors === _errs32) {
                                                                if (typeof data12 === 'string') {
                                                                    if (!formats0.validate(data12)) {
                                                                        validate51.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/startTime',
                                                                                schemaPath: '#/properties/startTime/format',
                                                                                keyword: 'format',
                                                                                params: { format: 'date-time' },
                                                                                message: 'must match format "' + 'date-time' + '"'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                else {
                                                                    validate51.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/startTime',
                                                                            schemaPath: '#/properties/startTime/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                        }
                                                        var valid6 = _errs32 === errors;
                                                    }
                                                    else {
                                                        var valid6 = true;
                                                    }
                                                    if (valid6) {
                                                        if (data.endTime !== undefined) {
                                                            let data13 = data.endTime;
                                                            const _errs34 = errors;
                                                            if (errors === _errs34) {
                                                                if (errors === _errs34) {
                                                                    if (typeof data13 === 'string') {
                                                                        if (!formats0.validate(data13)) {
                                                                            validate51.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/endTime',
                                                                                    schemaPath: '#/properties/endTime/format',
                                                                                    keyword: 'format',
                                                                                    params: { format: 'date-time' },
                                                                                    message: 'must match format "' + 'date-time' + '"'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate51.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/endTime',
                                                                                schemaPath: '#/properties/endTime/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                            }
                                                            var valid6 = _errs34 === errors;
                                                        }
                                                        else {
                                                            var valid6 = true;
                                                        }
                                                        if (valid6) {
                                                            if (data.connectionID !== undefined) {
                                                                let data14 = data.connectionID;
                                                                const _errs36 = errors;
                                                                if (errors === _errs36) {
                                                                    if (typeof data14 === 'string') {
                                                                        const b64min3 = Math.ceil((4 * 9) / 3);
                                                                        const b64max3 = Math.ceil((4 * 9) / 3) + 3;
                                                                        if (func164(data14) < b64min3 || func164(data14) > b64max3) {
                                                                            validate51.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/connectionID',
                                                                                    schemaPath: '#/properties/connectionID/uid',
                                                                                    keyword: 'uid',
                                                                                    params: {
                                                                                        error: 'encoded',
                                                                                        b64min: b64min3,
                                                                                        b64max: b64max3,
                                                                                        length: func164(data14)
                                                                                    },
                                                                                    message: 'length must be between ' +
                                                                                        b64min3 +
                                                                                        ' and ' +
                                                                                        b64max3 +
                                                                                        ', but is ' +
                                                                                        func164(data14)
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        else {
                                                                            const decoded3 = func165(data14);
                                                                            if (decoded3.length !== 9) {
                                                                                validate51.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/connectionID',
                                                                                        schemaPath: '#/properties/connectionID/uid',
                                                                                        keyword: 'uid',
                                                                                        params: { error: 'decoded' },
                                                                                        message: 'must decode to 9 bytes'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            else {
                                                                                const encoded3 = func166(decoded3);
                                                                                if (func167(encoded3) !== func167(data14)) {
                                                                                    validate51.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/connectionID',
                                                                                            schemaPath: '#/properties/connectionID/uid',
                                                                                            keyword: 'uid',
                                                                                            params: { error: 'ambiguous' },
                                                                                            message: 'encoding is ambiguous'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate51.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/connectionID',
                                                                                schemaPath: '#/properties/connectionID/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                var valid6 = _errs36 === errors;
                                                            }
                                                            else {
                                                                var valid6 = true;
                                                            }
                                                            if (valid6) {
                                                                if (data.firstDataSourceID !== undefined) {
                                                                    let data15 = data.firstDataSourceID;
                                                                    const _errs38 = errors;
                                                                    if (errors === _errs38) {
                                                                        if (typeof data15 === 'string') {
                                                                            const b64min4 = Math.ceil((4 * 9) / 3);
                                                                            const b64max4 = Math.ceil((4 * 9) / 3) + 3;
                                                                            if (func168(data15) < b64min4 || func168(data15) > b64max4) {
                                                                                validate51.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/firstDataSourceID',
                                                                                        schemaPath: '#/properties/firstDataSourceID/uid',
                                                                                        keyword: 'uid',
                                                                                        params: {
                                                                                            error: 'encoded',
                                                                                            b64min: b64min4,
                                                                                            b64max: b64max4,
                                                                                            length: func168(data15)
                                                                                        },
                                                                                        message: 'length must be between ' +
                                                                                            b64min4 +
                                                                                            ' and ' +
                                                                                            b64max4 +
                                                                                            ', but is ' +
                                                                                            func168(data15)
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            else {
                                                                                const decoded4 = func169(data15);
                                                                                if (decoded4.length !== 9) {
                                                                                    validate51.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/firstDataSourceID',
                                                                                            schemaPath: '#/properties/firstDataSourceID/uid',
                                                                                            keyword: 'uid',
                                                                                            params: { error: 'decoded' },
                                                                                            message: 'must decode to 9 bytes'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                                else {
                                                                                    const encoded4 = func170(decoded4);
                                                                                    if (func171(encoded4) !== func171(data15)) {
                                                                                        validate51.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/firstDataSourceID',
                                                                                                schemaPath: '#/properties/firstDataSourceID/uid',
                                                                                                keyword: 'uid',
                                                                                                params: { error: 'ambiguous' },
                                                                                                message: 'encoding is ambiguous'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                        else {
                                                                            validate51.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/firstDataSourceID',
                                                                                    schemaPath: '#/properties/firstDataSourceID/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'string' },
                                                                                    message: 'must be string'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    var valid6 = _errs38 === errors;
                                                                }
                                                                else {
                                                                    var valid6 = true;
                                                                }
                                                                if (valid6) {
                                                                    if (data.error !== undefined) {
                                                                        let data16 = data.error;
                                                                        const _errs40 = errors;
                                                                        if (!(data16 && typeof data16 == 'object' && !Array.isArray(data16))) {
                                                                            validate51.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/error',
                                                                                    schemaPath: '#/properties/error/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'object' },
                                                                                    message: 'must be object'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        var valid6 = _errs40 === errors;
                                                                    }
                                                                    else {
                                                                        var valid6 = true;
                                                                    }
                                                                    if (valid6) {
                                                                        if (data.progress !== undefined) {
                                                                            let data17 = data.progress;
                                                                            const _errs42 = errors;
                                                                            if (errors === _errs42) {
                                                                                if (typeof data17 == 'number') {
                                                                                    if (data17 > 1 || isNaN(data17)) {
                                                                                        validate51.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/progress',
                                                                                                schemaPath: '#/properties/progress/maximum',
                                                                                                keyword: 'maximum',
                                                                                                params: { comparison: '<=', limit: 1 },
                                                                                                message: 'must be <= 1'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                    else {
                                                                                        if (data17 < 0 || isNaN(data17)) {
                                                                                            validate51.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/progress',
                                                                                                    schemaPath: '#/properties/progress/minimum',
                                                                                                    keyword: 'minimum',
                                                                                                    params: { comparison: '>=', limit: 0 },
                                                                                                    message: 'must be >= 0'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    validate51.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/progress',
                                                                                            schemaPath: '#/properties/progress/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'number' },
                                                                                            message: 'must be number'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            var valid6 = _errs42 === errors;
                                                                        }
                                                                        else {
                                                                            var valid6 = true;
                                                                        }
                                                                        if (valid6) {
                                                                            if (data.rowsProcessed !== undefined) {
                                                                                let data18 = data.rowsProcessed;
                                                                                const _errs44 = errors;
                                                                                if (errors === _errs44) {
                                                                                    if (typeof data18 == 'number') {
                                                                                        if (data18 < 0 || isNaN(data18)) {
                                                                                            validate51.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/rowsProcessed',
                                                                                                    schemaPath: '#/properties/rowsProcessed/minimum',
                                                                                                    keyword: 'minimum',
                                                                                                    params: { comparison: '>=', limit: 0 },
                                                                                                    message: 'must be >= 0'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                    else {
                                                                                        validate51.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/rowsProcessed',
                                                                                                schemaPath: '#/properties/rowsProcessed/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'number' },
                                                                                                message: 'must be number'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                var valid6 = _errs44 === errors;
                                                                            }
                                                                            else {
                                                                                var valid6 = true;
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate51.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate51.errors = vErrors;
    return errors === 0;
}
export const importDirectorySchemaValidation = validate53;
const schema89 = {
    $id: 'urn:wisepipe-common-data:ImportDirectory',
    type: 'object',
    properties: {
        id: { type: 'string', minLength: 1 },
        displayName: { type: 'string', minLength: 1 },
        sourceType: { type: 'string', minLength: 1 },
        isSelectable: { type: 'boolean' },
        children: { type: 'array', items: { $ref: 'urn:wisepipe-common-data:ImportDirectory' } },
        fileSize: { type: 'number', minimum: 0 },
        modifyTime: { type: 'number', minimum: 0 },
        root: { type: 'string' }
    },
    required: ['id', 'displayName', 'isSelectable', 'children']
};
const wrapper1 = { validate: validate53 };
function validate53(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:ImportDirectory" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.id === undefined && (missing0 = 'id')) ||
                (data.displayName === undefined && (missing0 = 'displayName')) ||
                (data.isSelectable === undefined && (missing0 = 'isSelectable')) ||
                (data.children === undefined && (missing0 = 'children'))) {
                validate53.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.id !== undefined) {
                    let data0 = data.id;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate53.errors = [
                                    {
                                        instancePath: instancePath + '/id',
                                        schemaPath: '#/properties/id/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate53.errors = [
                                {
                                    instancePath: instancePath + '/id',
                                    schemaPath: '#/properties/id/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.displayName !== undefined) {
                        let data1 = data.displayName;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate53.errors = [
                                        {
                                            instancePath: instancePath + '/displayName',
                                            schemaPath: '#/properties/displayName/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate53.errors = [
                                    {
                                        instancePath: instancePath + '/displayName',
                                        schemaPath: '#/properties/displayName/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.sourceType !== undefined) {
                            let data2 = data.sourceType;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate53.errors = [
                                            {
                                                instancePath: instancePath + '/sourceType',
                                                schemaPath: '#/properties/sourceType/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate53.errors = [
                                        {
                                            instancePath: instancePath + '/sourceType',
                                            schemaPath: '#/properties/sourceType/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.isSelectable !== undefined) {
                                const _errs7 = errors;
                                if (typeof data.isSelectable !== 'boolean') {
                                    validate53.errors = [
                                        {
                                            instancePath: instancePath + '/isSelectable',
                                            schemaPath: '#/properties/isSelectable/type',
                                            keyword: 'type',
                                            params: { type: 'boolean' },
                                            message: 'must be boolean'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.children !== undefined) {
                                    let data4 = data.children;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (Array.isArray(data4)) {
                                            var valid1 = true;
                                            const len0 = data4.length;
                                            for (let i0 = 0; i0 < len0; i0++) {
                                                const _errs11 = errors;
                                                if (!wrapper1.validate(data4[i0], {
                                                    instancePath: instancePath + '/children/' + i0,
                                                    parentData: data4,
                                                    parentDataProperty: i0,
                                                    rootData
                                                })) {
                                                    vErrors =
                                                        vErrors === null ? wrapper1.validate.errors : vErrors.concat(wrapper1.validate.errors);
                                                    errors = vErrors.length;
                                                }
                                                var valid1 = _errs11 === errors;
                                                if (!valid1) {
                                                    break;
                                                }
                                            }
                                        }
                                        else {
                                            validate53.errors = [
                                                {
                                                    instancePath: instancePath + '/children',
                                                    schemaPath: '#/properties/children/type',
                                                    keyword: 'type',
                                                    params: { type: 'array' },
                                                    message: 'must be array'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.fileSize !== undefined) {
                                        let data6 = data.fileSize;
                                        const _errs12 = errors;
                                        if (errors === _errs12) {
                                            if (typeof data6 == 'number') {
                                                if (data6 < 0 || isNaN(data6)) {
                                                    validate53.errors = [
                                                        {
                                                            instancePath: instancePath + '/fileSize',
                                                            schemaPath: '#/properties/fileSize/minimum',
                                                            keyword: 'minimum',
                                                            params: { comparison: '>=', limit: 0 },
                                                            message: 'must be >= 0'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate53.errors = [
                                                    {
                                                        instancePath: instancePath + '/fileSize',
                                                        schemaPath: '#/properties/fileSize/type',
                                                        keyword: 'type',
                                                        params: { type: 'number' },
                                                        message: 'must be number'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs12 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.modifyTime !== undefined) {
                                            let data7 = data.modifyTime;
                                            const _errs14 = errors;
                                            if (errors === _errs14) {
                                                if (typeof data7 == 'number') {
                                                    if (data7 < 0 || isNaN(data7)) {
                                                        validate53.errors = [
                                                            {
                                                                instancePath: instancePath + '/modifyTime',
                                                                schemaPath: '#/properties/modifyTime/minimum',
                                                                keyword: 'minimum',
                                                                params: { comparison: '>=', limit: 0 },
                                                                message: 'must be >= 0'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate53.errors = [
                                                        {
                                                            instancePath: instancePath + '/modifyTime',
                                                            schemaPath: '#/properties/modifyTime/type',
                                                            keyword: 'type',
                                                            params: { type: 'number' },
                                                            message: 'must be number'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs14 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.root !== undefined) {
                                                const _errs16 = errors;
                                                if (typeof data.root !== 'string') {
                                                    validate53.errors = [
                                                        {
                                                            instancePath: instancePath + '/root',
                                                            schemaPath: '#/properties/root/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid0 = _errs16 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate53.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate53.errors = vErrors;
    return errors === 0;
}
export const importDiscoveryCatalogColumnSchemaValidation = validate54;
const schema90 = {
    $id: 'urn:wisepipe-common-data:ImportDiscoveryCatalogColumn',
    type: 'object',
    properties: {
        name: { type: 'string' },
        type: { type: 'array', items: { type: 'string' } },
        inclusion: { type: 'string', enum: ['automatic', 'available', 'unsupported'] },
        format: { type: 'string' },
        dateFormat: { type: 'string' }
    },
    required: ['name', 'type']
};
function validate54(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:ImportDiscoveryCatalogColumn" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.name === undefined && (missing0 = 'name')) || (data.type === undefined && (missing0 = 'type'))) {
                validate54.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.name !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.name !== 'string') {
                        validate54.errors = [
                            {
                                instancePath: instancePath + '/name',
                                schemaPath: '#/properties/name/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.type !== undefined) {
                        let data1 = data.type;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (Array.isArray(data1)) {
                                var valid1 = true;
                                const len0 = data1.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    const _errs5 = errors;
                                    if (typeof data1[i0] !== 'string') {
                                        validate54.errors = [
                                            {
                                                instancePath: instancePath + '/type/' + i0,
                                                schemaPath: '#/properties/type/items/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid1 = _errs5 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                            }
                            else {
                                validate54.errors = [
                                    {
                                        instancePath: instancePath + '/type',
                                        schemaPath: '#/properties/type/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.inclusion !== undefined) {
                            let data3 = data.inclusion;
                            const _errs7 = errors;
                            if (typeof data3 !== 'string') {
                                validate54.errors = [
                                    {
                                        instancePath: instancePath + '/inclusion',
                                        schemaPath: '#/properties/inclusion/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            if (!(data3 === 'automatic' || data3 === 'available' || data3 === 'unsupported')) {
                                validate54.errors = [
                                    {
                                        instancePath: instancePath + '/inclusion',
                                        schemaPath: '#/properties/inclusion/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema90.properties.inclusion.enum },
                                        message: 'must be equal to one of the allowed values'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs7 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.format !== undefined) {
                                const _errs9 = errors;
                                if (typeof data.format !== 'string') {
                                    validate54.errors = [
                                        {
                                            instancePath: instancePath + '/format',
                                            schemaPath: '#/properties/format/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs9 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.dateFormat !== undefined) {
                                    const _errs11 = errors;
                                    if (typeof data.dateFormat !== 'string') {
                                        validate54.errors = [
                                            {
                                                instancePath: instancePath + '/dateFormat',
                                                schemaPath: '#/properties/dateFormat/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs11 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate54.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate54.errors = vErrors;
    return errors === 0;
}
export const importDiscoveryCatalogEntrySchemaValidation = validate55;
const schema91 = {
    $id: 'urn:wisepipe-common-data:ImportDiscoveryCatalogEntry',
    type: 'object',
    properties: {
        streamID: { type: 'string', minLength: 1 },
        name: { type: 'string', minLength: 1 },
        columns: { type: 'array', items: { type: 'string' } },
        columnsWithSchema: { type: 'array', items: { $ref: 'urn:wisepipe-common-data:ImportDiscoveryCatalogColumn' } },
        columnSpecs: { type: 'array', items: { type: 'array', items: { type: 'number' } } }
    },
    required: ['streamID', 'name', 'columns']
};
function validate55(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:ImportDiscoveryCatalogEntry" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.streamID === undefined && (missing0 = 'streamID')) ||
                (data.name === undefined && (missing0 = 'name')) ||
                (data.columns === undefined && (missing0 = 'columns'))) {
                validate55.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.streamID !== undefined) {
                    let data0 = data.streamID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate55.errors = [
                                    {
                                        instancePath: instancePath + '/streamID',
                                        schemaPath: '#/properties/streamID/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate55.errors = [
                                {
                                    instancePath: instancePath + '/streamID',
                                    schemaPath: '#/properties/streamID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.name !== undefined) {
                        let data1 = data.name;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate55.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate55.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.columns !== undefined) {
                            let data2 = data.columns;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (Array.isArray(data2)) {
                                    var valid1 = true;
                                    const len0 = data2.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        const _errs7 = errors;
                                        if (typeof data2[i0] !== 'string') {
                                            validate55.errors = [
                                                {
                                                    instancePath: instancePath + '/columns/' + i0,
                                                    schemaPath: '#/properties/columns/items/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid1 = _errs7 === errors;
                                        if (!valid1) {
                                            break;
                                        }
                                    }
                                }
                                else {
                                    validate55.errors = [
                                        {
                                            instancePath: instancePath + '/columns',
                                            schemaPath: '#/properties/columns/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.columnsWithSchema !== undefined) {
                                let data4 = data.columnsWithSchema;
                                const _errs9 = errors;
                                if (errors === _errs9) {
                                    if (Array.isArray(data4)) {
                                        var valid2 = true;
                                        const len1 = data4.length;
                                        for (let i1 = 0; i1 < len1; i1++) {
                                            let data5 = data4[i1];
                                            const _errs11 = errors;
                                            const _errs12 = errors;
                                            if (errors === _errs12) {
                                                if (data5 && typeof data5 == 'object' && !Array.isArray(data5)) {
                                                    let missing1;
                                                    if ((data5.name === undefined && (missing1 = 'name')) ||
                                                        (data5.type === undefined && (missing1 = 'type'))) {
                                                        validate55.errors = [
                                                            {
                                                                instancePath: instancePath + '/columnsWithSchema/' + i1,
                                                                schemaPath: 'urn:wisepipe-common-data:ImportDiscoveryCatalogColumn/required',
                                                                keyword: 'required',
                                                                params: { missingProperty: missing1 },
                                                                message: "must have required property '" + missing1 + "'"
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        if (data5.name !== undefined) {
                                                            const _errs14 = errors;
                                                            if (typeof data5.name !== 'string') {
                                                                validate55.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/columnsWithSchema/' + i1 + '/name',
                                                                        schemaPath: 'urn:wisepipe-common-data:ImportDiscoveryCatalogColumn/properties/name/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid4 = _errs14 === errors;
                                                        }
                                                        else {
                                                            var valid4 = true;
                                                        }
                                                        if (valid4) {
                                                            if (data5.type !== undefined) {
                                                                let data7 = data5.type;
                                                                const _errs16 = errors;
                                                                if (errors === _errs16) {
                                                                    if (Array.isArray(data7)) {
                                                                        var valid5 = true;
                                                                        const len2 = data7.length;
                                                                        for (let i2 = 0; i2 < len2; i2++) {
                                                                            const _errs18 = errors;
                                                                            if (typeof data7[i2] !== 'string') {
                                                                                validate55.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/columnsWithSchema/' + i1 + '/type/' + i2,
                                                                                        schemaPath: 'urn:wisepipe-common-data:ImportDiscoveryCatalogColumn/properties/type/items/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            var valid5 = _errs18 === errors;
                                                                            if (!valid5) {
                                                                                break;
                                                                            }
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate55.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/columnsWithSchema/' + i1 + '/type',
                                                                                schemaPath: 'urn:wisepipe-common-data:ImportDiscoveryCatalogColumn/properties/type/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'array' },
                                                                                message: 'must be array'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                var valid4 = _errs16 === errors;
                                                            }
                                                            else {
                                                                var valid4 = true;
                                                            }
                                                            if (valid4) {
                                                                if (data5.inclusion !== undefined) {
                                                                    let data9 = data5.inclusion;
                                                                    const _errs20 = errors;
                                                                    if (typeof data9 !== 'string') {
                                                                        validate55.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/columnsWithSchema/' + i1 + '/inclusion',
                                                                                schemaPath: 'urn:wisepipe-common-data:ImportDiscoveryCatalogColumn/properties/inclusion/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    if (!(data9 === 'automatic' || data9 === 'available' || data9 === 'unsupported')) {
                                                                        validate55.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/columnsWithSchema/' + i1 + '/inclusion',
                                                                                schemaPath: 'urn:wisepipe-common-data:ImportDiscoveryCatalogColumn/properties/inclusion/enum',
                                                                                keyword: 'enum',
                                                                                params: { allowedValues: schema90.properties.inclusion.enum },
                                                                                message: 'must be equal to one of the allowed values'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    var valid4 = _errs20 === errors;
                                                                }
                                                                else {
                                                                    var valid4 = true;
                                                                }
                                                                if (valid4) {
                                                                    if (data5.format !== undefined) {
                                                                        const _errs22 = errors;
                                                                        if (typeof data5.format !== 'string') {
                                                                            validate55.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/columnsWithSchema/' + i1 + '/format',
                                                                                    schemaPath: 'urn:wisepipe-common-data:ImportDiscoveryCatalogColumn/properties/format/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'string' },
                                                                                    message: 'must be string'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        var valid4 = _errs22 === errors;
                                                                    }
                                                                    else {
                                                                        var valid4 = true;
                                                                    }
                                                                    if (valid4) {
                                                                        if (data5.dateFormat !== undefined) {
                                                                            const _errs24 = errors;
                                                                            if (typeof data5.dateFormat !== 'string') {
                                                                                validate55.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/columnsWithSchema/' + i1 + '/dateFormat',
                                                                                        schemaPath: 'urn:wisepipe-common-data:ImportDiscoveryCatalogColumn/properties/dateFormat/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            var valid4 = _errs24 === errors;
                                                                        }
                                                                        else {
                                                                            var valid4 = true;
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate55.errors = [
                                                        {
                                                            instancePath: instancePath + '/columnsWithSchema/' + i1,
                                                            schemaPath: 'urn:wisepipe-common-data:ImportDiscoveryCatalogColumn/type',
                                                            keyword: 'type',
                                                            params: { type: 'object' },
                                                            message: 'must be object'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid2 = _errs11 === errors;
                                            if (!valid2) {
                                                break;
                                            }
                                        }
                                    }
                                    else {
                                        validate55.errors = [
                                            {
                                                instancePath: instancePath + '/columnsWithSchema',
                                                schemaPath: '#/properties/columnsWithSchema/type',
                                                keyword: 'type',
                                                params: { type: 'array' },
                                                message: 'must be array'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs9 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.columnSpecs !== undefined) {
                                    let data12 = data.columnSpecs;
                                    const _errs26 = errors;
                                    if (errors === _errs26) {
                                        if (Array.isArray(data12)) {
                                            var valid6 = true;
                                            const len3 = data12.length;
                                            for (let i3 = 0; i3 < len3; i3++) {
                                                let data13 = data12[i3];
                                                const _errs28 = errors;
                                                if (errors === _errs28) {
                                                    if (Array.isArray(data13)) {
                                                        var valid7 = true;
                                                        const len4 = data13.length;
                                                        for (let i4 = 0; i4 < len4; i4++) {
                                                            const _errs30 = errors;
                                                            if (!(typeof data13[i4] == 'number')) {
                                                                validate55.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/columnSpecs/' + i3 + '/' + i4,
                                                                        schemaPath: '#/properties/columnSpecs/items/items/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'number' },
                                                                        message: 'must be number'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid7 = _errs30 === errors;
                                                            if (!valid7) {
                                                                break;
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate55.errors = [
                                                            {
                                                                instancePath: instancePath + '/columnSpecs/' + i3,
                                                                schemaPath: '#/properties/columnSpecs/items/type',
                                                                keyword: 'type',
                                                                params: { type: 'array' },
                                                                message: 'must be array'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid6 = _errs28 === errors;
                                                if (!valid6) {
                                                    break;
                                                }
                                            }
                                        }
                                        else {
                                            validate55.errors = [
                                                {
                                                    instancePath: instancePath + '/columnSpecs',
                                                    schemaPath: '#/properties/columnSpecs/type',
                                                    keyword: 'type',
                                                    params: { type: 'array' },
                                                    message: 'must be array'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs26 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate55.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate55.errors = vErrors;
    return errors === 0;
}
export const importDiscoveryDetailsSchemaValidation = validate56;
const schema93 = {
    $id: 'urn:wisepipe-common-data:ImportDiscoveryDetails',
    type: 'object',
    properties: {
        orgID: { type: 'string', format: 'uuid' },
        orgPlan: { type: 'string', enum: ['Social', 'Enterprise', 'Integration', 'Temp', 'Starter', 'Professional'] },
        discoveryID: { type: 'string', uid: 9 },
        status: { type: 'string', enum: ['running', 'completed', 'failed'] },
        config: { $ref: 'urn:wisepipe-common-data:ImportConfig' },
        transient: { type: 'boolean' },
        startTime: { type: 'string', format: 'date-time' },
        error: { type: 'object' }
    },
    if: { properties: { status: { const: 'failed' } } },
    then: { required: ['error'] },
    required: ['discoveryID', 'status', 'config']
};
const func177 = ucs2length;
const func178 = base64urlToBuffer;
const func179 = base64urlEncode;
const func180 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate56(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:ImportDiscoveryDetails" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.status !== undefined) {
            if ('failed' !== data.status) {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs4 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.error === undefined && (missing0 = 'error')) {
                validate56.errors = [
                    {
                        instancePath,
                        schemaPath: '#/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs4 === errors;
        valid0 = _valid0;
    }
    if (!valid0) {
        const err1 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
        validate56.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if ((data.discoveryID === undefined && (missing1 = 'discoveryID')) ||
                (data.status === undefined && (missing1 = 'status')) ||
                (data.config === undefined && (missing1 = 'config'))) {
                validate56.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.orgID !== undefined) {
                    let data1 = data.orgID;
                    const _errs5 = errors;
                    if (errors === _errs5) {
                        if (errors === _errs5) {
                            if (typeof data1 === 'string') {
                                if (!formats4.test(data1)) {
                                    validate56.errors = [
                                        {
                                            instancePath: instancePath + '/orgID',
                                            schemaPath: '#/properties/orgID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate56.errors = [
                                    {
                                        instancePath: instancePath + '/orgID',
                                        schemaPath: '#/properties/orgID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid2 = _errs5 === errors;
                }
                else {
                    var valid2 = true;
                }
                if (valid2) {
                    if (data.orgPlan !== undefined) {
                        let data2 = data.orgPlan;
                        const _errs7 = errors;
                        if (typeof data2 !== 'string') {
                            validate56.errors = [
                                {
                                    instancePath: instancePath + '/orgPlan',
                                    schemaPath: '#/properties/orgPlan/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data2 === 'Social' ||
                            data2 === 'Enterprise' ||
                            data2 === 'Integration' ||
                            data2 === 'Temp' ||
                            data2 === 'Starter' ||
                            data2 === 'Professional')) {
                            validate56.errors = [
                                {
                                    instancePath: instancePath + '/orgPlan',
                                    schemaPath: '#/properties/orgPlan/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema93.properties.orgPlan.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid2 = _errs7 === errors;
                    }
                    else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.discoveryID !== undefined) {
                            let data3 = data.discoveryID;
                            const _errs9 = errors;
                            if (errors === _errs9) {
                                if (typeof data3 === 'string') {
                                    const b64min0 = Math.ceil((4 * 9) / 3);
                                    const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                    if (func177(data3) < b64min0 || func177(data3) > b64max0) {
                                        validate56.errors = [
                                            {
                                                instancePath: instancePath + '/discoveryID',
                                                schemaPath: '#/properties/discoveryID/uid',
                                                keyword: 'uid',
                                                params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func177(data3) },
                                                message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func177(data3)
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const decoded0 = func178(data3);
                                        if (decoded0.length !== 9) {
                                            validate56.errors = [
                                                {
                                                    instancePath: instancePath + '/discoveryID',
                                                    schemaPath: '#/properties/discoveryID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'decoded' },
                                                    message: 'must decode to 9 bytes'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const encoded0 = func179(decoded0);
                                            if (func180(encoded0) !== func180(data3)) {
                                                validate56.errors = [
                                                    {
                                                        instancePath: instancePath + '/discoveryID',
                                                        schemaPath: '#/properties/discoveryID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'ambiguous' },
                                                        message: 'encoding is ambiguous'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate56.errors = [
                                        {
                                            instancePath: instancePath + '/discoveryID',
                                            schemaPath: '#/properties/discoveryID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid2 = _errs9 === errors;
                        }
                        else {
                            var valid2 = true;
                        }
                        if (valid2) {
                            if (data.status !== undefined) {
                                let data4 = data.status;
                                const _errs11 = errors;
                                if (typeof data4 !== 'string') {
                                    validate56.errors = [
                                        {
                                            instancePath: instancePath + '/status',
                                            schemaPath: '#/properties/status/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                if (!(data4 === 'running' || data4 === 'completed' || data4 === 'failed')) {
                                    validate56.errors = [
                                        {
                                            instancePath: instancePath + '/status',
                                            schemaPath: '#/properties/status/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema93.properties.status.enum },
                                            message: 'must be equal to one of the allowed values'
                                        }
                                    ];
                                    return false;
                                }
                                var valid2 = _errs11 === errors;
                            }
                            else {
                                var valid2 = true;
                            }
                            if (valid2) {
                                if (data.config !== undefined) {
                                    const _errs13 = errors;
                                    if (!validate44(data.config, {
                                        instancePath: instancePath + '/config',
                                        parentData: data,
                                        parentDataProperty: 'config',
                                        rootData
                                    })) {
                                        vErrors = vErrors === null ? validate44.errors : vErrors.concat(validate44.errors);
                                        errors = vErrors.length;
                                    }
                                    var valid2 = _errs13 === errors;
                                }
                                else {
                                    var valid2 = true;
                                }
                                if (valid2) {
                                    if (data.transient !== undefined) {
                                        const _errs14 = errors;
                                        if (typeof data.transient !== 'boolean') {
                                            validate56.errors = [
                                                {
                                                    instancePath: instancePath + '/transient',
                                                    schemaPath: '#/properties/transient/type',
                                                    keyword: 'type',
                                                    params: { type: 'boolean' },
                                                    message: 'must be boolean'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid2 = _errs14 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                    if (valid2) {
                                        if (data.startTime !== undefined) {
                                            let data7 = data.startTime;
                                            const _errs16 = errors;
                                            if (errors === _errs16) {
                                                if (errors === _errs16) {
                                                    if (typeof data7 === 'string') {
                                                        if (!formats0.validate(data7)) {
                                                            validate56.errors = [
                                                                {
                                                                    instancePath: instancePath + '/startTime',
                                                                    schemaPath: '#/properties/startTime/format',
                                                                    keyword: 'format',
                                                                    params: { format: 'date-time' },
                                                                    message: 'must match format "' + 'date-time' + '"'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate56.errors = [
                                                            {
                                                                instancePath: instancePath + '/startTime',
                                                                schemaPath: '#/properties/startTime/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                            }
                                            var valid2 = _errs16 === errors;
                                        }
                                        else {
                                            var valid2 = true;
                                        }
                                        if (valid2) {
                                            if (data.error !== undefined) {
                                                let data8 = data.error;
                                                const _errs18 = errors;
                                                if (!(data8 && typeof data8 == 'object' && !Array.isArray(data8))) {
                                                    validate56.errors = [
                                                        {
                                                            instancePath: instancePath + '/error',
                                                            schemaPath: '#/properties/error/type',
                                                            keyword: 'type',
                                                            params: { type: 'object' },
                                                            message: 'must be object'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid2 = _errs18 === errors;
                                            }
                                            else {
                                                var valid2 = true;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate56.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate56.errors = vErrors;
    return errors === 0;
}
export const importDiscoveryInputSchemaValidation = validate58;
const schema94 = {
    $id: 'urn:wisepipe-common-data:ImportDiscoveryInput',
    type: 'object',
    properties: {
        discovery: { $ref: 'urn:wisepipe-common-data:ImportDiscoveryTask' },
        discoveryEnv: { $ref: 'urn:wisepipe-common-data:ImportDiscoveryTaskEnv' }
    },
    required: []
};
const schema95 = {
    $id: 'urn:wisepipe-common-data:ImportDiscoveryTask',
    type: 'object',
    properties: {
        orgID: { type: 'string', format: 'uuid' },
        orgPlan: { type: 'string', enum: ['Social', 'Enterprise', 'Integration', 'Temp', 'Starter', 'Professional'] },
        discoveryID: { type: 'string', uid: 9 },
        status: { type: 'string', enum: ['running', 'completed', 'failed'] },
        importConfig: { $ref: 'urn:wisepipe-common-data:ImportConfig' },
        transient: { type: 'boolean' },
        startTime: { type: 'string', format: 'date-time' },
        endTime: { type: 'string', format: 'date-time' },
        connection: { $ref: 'urn:wisepipe-common-connection:Connection' },
        catalog: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-data:ImportDiscoveryCatalogEntry' },
            uniqueItems: true
        },
        error: { type: 'object' },
        extractionParameters: { $ref: 'urn:wisepipe-common-data:ExtractionParameters' },
        catalogS3Url: { $ref: 'urn:wisepipe-common:S3File' },
        importID: { type: 'string', uid: 9 },
        columnsToUpdateS3Url: { $ref: 'urn:wisepipe-common:S3File' },
        sourceFileName: { type: 'string' }
    },
    if: { properties: { status: { const: 'failed' } } },
    then: { required: ['error'] },
    required: ['discoveryID', 'status', 'importConfig']
};
const func181 = ucs2length;
const func182 = base64urlToBuffer;
const func183 = base64urlEncode;
const func184 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func185 = ucs2length;
const func186 = base64urlToBuffer;
const func187 = base64urlEncode;
const func188 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func194 = ucs2length;
const func195 = base64urlToBuffer;
const func196 = base64urlEncode;
const func197 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func198 = ucs2length;
const func199 = base64urlToBuffer;
const func200 = base64urlEncode;
const func201 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func204 = ucs2length;
const func205 = base64urlToBuffer;
const func206 = base64urlEncode;
const func207 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate59(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:ImportDiscoveryTask" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.status !== undefined) {
            if ('failed' !== data.status) {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs4 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.error === undefined && (missing0 = 'error')) {
                validate59.errors = [
                    {
                        instancePath,
                        schemaPath: '#/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs4 === errors;
        valid0 = _valid0;
    }
    if (!valid0) {
        const err1 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
        validate59.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if ((data.discoveryID === undefined && (missing1 = 'discoveryID')) ||
                (data.status === undefined && (missing1 = 'status')) ||
                (data.importConfig === undefined && (missing1 = 'importConfig'))) {
                validate59.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.orgID !== undefined) {
                    let data1 = data.orgID;
                    const _errs5 = errors;
                    if (errors === _errs5) {
                        if (errors === _errs5) {
                            if (typeof data1 === 'string') {
                                if (!formats4.test(data1)) {
                                    validate59.errors = [
                                        {
                                            instancePath: instancePath + '/orgID',
                                            schemaPath: '#/properties/orgID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate59.errors = [
                                    {
                                        instancePath: instancePath + '/orgID',
                                        schemaPath: '#/properties/orgID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid2 = _errs5 === errors;
                }
                else {
                    var valid2 = true;
                }
                if (valid2) {
                    if (data.orgPlan !== undefined) {
                        let data2 = data.orgPlan;
                        const _errs7 = errors;
                        if (typeof data2 !== 'string') {
                            validate59.errors = [
                                {
                                    instancePath: instancePath + '/orgPlan',
                                    schemaPath: '#/properties/orgPlan/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data2 === 'Social' ||
                            data2 === 'Enterprise' ||
                            data2 === 'Integration' ||
                            data2 === 'Temp' ||
                            data2 === 'Starter' ||
                            data2 === 'Professional')) {
                            validate59.errors = [
                                {
                                    instancePath: instancePath + '/orgPlan',
                                    schemaPath: '#/properties/orgPlan/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema95.properties.orgPlan.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid2 = _errs7 === errors;
                    }
                    else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.discoveryID !== undefined) {
                            let data3 = data.discoveryID;
                            const _errs9 = errors;
                            if (errors === _errs9) {
                                if (typeof data3 === 'string') {
                                    const b64min0 = Math.ceil((4 * 9) / 3);
                                    const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                    if (func181(data3) < b64min0 || func181(data3) > b64max0) {
                                        validate59.errors = [
                                            {
                                                instancePath: instancePath + '/discoveryID',
                                                schemaPath: '#/properties/discoveryID/uid',
                                                keyword: 'uid',
                                                params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func181(data3) },
                                                message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func181(data3)
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const decoded0 = func182(data3);
                                        if (decoded0.length !== 9) {
                                            validate59.errors = [
                                                {
                                                    instancePath: instancePath + '/discoveryID',
                                                    schemaPath: '#/properties/discoveryID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'decoded' },
                                                    message: 'must decode to 9 bytes'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const encoded0 = func183(decoded0);
                                            if (func184(encoded0) !== func184(data3)) {
                                                validate59.errors = [
                                                    {
                                                        instancePath: instancePath + '/discoveryID',
                                                        schemaPath: '#/properties/discoveryID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'ambiguous' },
                                                        message: 'encoding is ambiguous'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate59.errors = [
                                        {
                                            instancePath: instancePath + '/discoveryID',
                                            schemaPath: '#/properties/discoveryID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid2 = _errs9 === errors;
                        }
                        else {
                            var valid2 = true;
                        }
                        if (valid2) {
                            if (data.status !== undefined) {
                                let data4 = data.status;
                                const _errs11 = errors;
                                if (typeof data4 !== 'string') {
                                    validate59.errors = [
                                        {
                                            instancePath: instancePath + '/status',
                                            schemaPath: '#/properties/status/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                if (!(data4 === 'running' || data4 === 'completed' || data4 === 'failed')) {
                                    validate59.errors = [
                                        {
                                            instancePath: instancePath + '/status',
                                            schemaPath: '#/properties/status/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema95.properties.status.enum },
                                            message: 'must be equal to one of the allowed values'
                                        }
                                    ];
                                    return false;
                                }
                                var valid2 = _errs11 === errors;
                            }
                            else {
                                var valid2 = true;
                            }
                            if (valid2) {
                                if (data.importConfig !== undefined) {
                                    const _errs13 = errors;
                                    if (!validate44(data.importConfig, {
                                        instancePath: instancePath + '/importConfig',
                                        parentData: data,
                                        parentDataProperty: 'importConfig',
                                        rootData
                                    })) {
                                        vErrors = vErrors === null ? validate44.errors : vErrors.concat(validate44.errors);
                                        errors = vErrors.length;
                                    }
                                    var valid2 = _errs13 === errors;
                                }
                                else {
                                    var valid2 = true;
                                }
                                if (valid2) {
                                    if (data.transient !== undefined) {
                                        const _errs14 = errors;
                                        if (typeof data.transient !== 'boolean') {
                                            validate59.errors = [
                                                {
                                                    instancePath: instancePath + '/transient',
                                                    schemaPath: '#/properties/transient/type',
                                                    keyword: 'type',
                                                    params: { type: 'boolean' },
                                                    message: 'must be boolean'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid2 = _errs14 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                    if (valid2) {
                                        if (data.startTime !== undefined) {
                                            let data7 = data.startTime;
                                            const _errs16 = errors;
                                            if (errors === _errs16) {
                                                if (errors === _errs16) {
                                                    if (typeof data7 === 'string') {
                                                        if (!formats0.validate(data7)) {
                                                            validate59.errors = [
                                                                {
                                                                    instancePath: instancePath + '/startTime',
                                                                    schemaPath: '#/properties/startTime/format',
                                                                    keyword: 'format',
                                                                    params: { format: 'date-time' },
                                                                    message: 'must match format "' + 'date-time' + '"'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate59.errors = [
                                                            {
                                                                instancePath: instancePath + '/startTime',
                                                                schemaPath: '#/properties/startTime/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                            }
                                            var valid2 = _errs16 === errors;
                                        }
                                        else {
                                            var valid2 = true;
                                        }
                                        if (valid2) {
                                            if (data.endTime !== undefined) {
                                                let data8 = data.endTime;
                                                const _errs18 = errors;
                                                if (errors === _errs18) {
                                                    if (errors === _errs18) {
                                                        if (typeof data8 === 'string') {
                                                            if (!formats0.validate(data8)) {
                                                                validate59.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/endTime',
                                                                        schemaPath: '#/properties/endTime/format',
                                                                        keyword: 'format',
                                                                        params: { format: 'date-time' },
                                                                        message: 'must match format "' + 'date-time' + '"'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate59.errors = [
                                                                {
                                                                    instancePath: instancePath + '/endTime',
                                                                    schemaPath: '#/properties/endTime/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                                var valid2 = _errs18 === errors;
                                            }
                                            else {
                                                var valid2 = true;
                                            }
                                            if (valid2) {
                                                if (data.connection !== undefined) {
                                                    let data9 = data.connection;
                                                    const _errs20 = errors;
                                                    const _errs21 = errors;
                                                    if (errors === _errs21) {
                                                        if (data9 && typeof data9 == 'object' && !Array.isArray(data9)) {
                                                            let missing2;
                                                            if ((data9.connectionType === undefined && (missing2 = 'connectionType')) ||
                                                                (data9.name === undefined && (missing2 = 'name'))) {
                                                                validate59.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/connection',
                                                                        schemaPath: 'urn:wisepipe-common-connection:Connection/required',
                                                                        keyword: 'required',
                                                                        params: { missingProperty: missing2 },
                                                                        message: "must have required property '" + missing2 + "'"
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            else {
                                                                if (data9.connectionID !== undefined) {
                                                                    let data10 = data9.connectionID;
                                                                    const _errs23 = errors;
                                                                    if (errors === _errs23) {
                                                                        if (typeof data10 === 'string') {
                                                                            const b64min1 = Math.ceil((4 * 9) / 3);
                                                                            const b64max1 = Math.ceil((4 * 9) / 3) + 3;
                                                                            if (func185(data10) < b64min1 || func185(data10) > b64max1) {
                                                                                validate59.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/connection/connectionID',
                                                                                        schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionID/uid',
                                                                                        keyword: 'uid',
                                                                                        params: {
                                                                                            error: 'encoded',
                                                                                            b64min: b64min1,
                                                                                            b64max: b64max1,
                                                                                            length: func185(data10)
                                                                                        },
                                                                                        message: 'length must be between ' +
                                                                                            b64min1 +
                                                                                            ' and ' +
                                                                                            b64max1 +
                                                                                            ', but is ' +
                                                                                            func185(data10)
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            else {
                                                                                const decoded1 = func186(data10);
                                                                                if (decoded1.length !== 9) {
                                                                                    validate59.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/connection/connectionID',
                                                                                            schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionID/uid',
                                                                                            keyword: 'uid',
                                                                                            params: { error: 'decoded' },
                                                                                            message: 'must decode to 9 bytes'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                                else {
                                                                                    const encoded1 = func187(decoded1);
                                                                                    if (func188(encoded1) !== func188(data10)) {
                                                                                        validate59.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/connection/connectionID',
                                                                                                schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionID/uid',
                                                                                                keyword: 'uid',
                                                                                                params: { error: 'ambiguous' },
                                                                                                message: 'encoding is ambiguous'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                        else {
                                                                            validate59.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/connection/connectionID',
                                                                                    schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionID/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'string' },
                                                                                    message: 'must be string'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    var valid5 = _errs23 === errors;
                                                                }
                                                                else {
                                                                    var valid5 = true;
                                                                }
                                                                if (valid5) {
                                                                    if (data9.connectionType !== undefined) {
                                                                        let data11 = data9.connectionType;
                                                                        const _errs25 = errors;
                                                                        if (typeof data11 !== 'string') {
                                                                            validate59.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/connection/connectionType',
                                                                                    schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionType/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'string' },
                                                                                    message: 'must be string'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        if (!(data11 === 'google' ||
                                                                            data11 === 'gsheetsImport' ||
                                                                            data11 === 'gsheetsExport' ||
                                                                            data11 === 'shopify' ||
                                                                            data11 === 'salesForce' ||
                                                                            data11 === 'postgreSql' ||
                                                                            data11 === 'icm' ||
                                                                            data11 === 'tq-postgres' ||
                                                                            data11 === 'mySql' ||
                                                                            data11 === 'msSql' ||
                                                                            data11 === 'oracle' ||
                                                                            data11 === 'amazonRedshift' ||
                                                                            data11 === 'amazonAurora' ||
                                                                            data11 === 'amazonS3' ||
                                                                            data11 === 'amazonS3Export' ||
                                                                            data11 === 'tqp' ||
                                                                            data11 === 'hubspot' ||
                                                                            data11 === 'symon' ||
                                                                            data11 === 'snowflake' ||
                                                                            data11 === 'dynamics' ||
                                                                            data11 === 'agentSync' ||
                                                                            data11 === 'workday' ||
                                                                            data11 === 'workdayRaaS' ||
                                                                            data11 === 'workdayExport' ||
                                                                            data11 === 'tableau' ||
                                                                            data11 === 'sftp' ||
                                                                            data11 === 'powerbi' ||
                                                                            data11 === 'rest' ||
                                                                            data11 === 'gong' ||
                                                                            data11 === 'netSuite' ||
                                                                            data11 === 'oneDrive' ||
                                                                            data11 === 'oneDriveExport' ||
                                                                            data11 === 'sapSuccessFactors' ||
                                                                            data11 === 'sapCrm' ||
                                                                            data11 === 'ukg' ||
                                                                            data11 === 'oracleHcm' ||
                                                                            data11 === 'Adp' ||
                                                                            data11 === 'dynamics365Sales' ||
                                                                            data11 === 'ceridianDayforce' ||
                                                                            data11 === 'oracleCrm' ||
                                                                            data11 === 'oracleErpCloud' ||
                                                                            data11 === 'sageIntacct' ||
                                                                            data11 === 'bambooHr' ||
                                                                            data11 === 'sapErp' ||
                                                                            data11 === 'googleCloudPlatformCloudStorage' ||
                                                                            data11 === 'sas' ||
                                                                            data11 === 'dropbox' ||
                                                                            data11 === 'googleDrive' ||
                                                                            data11 === 'jira' ||
                                                                            data11 === 'monday' ||
                                                                            data11 === 'zuora' ||
                                                                            data11 === 'adobeAnalytics' ||
                                                                            data11 === 'zoomInfo' ||
                                                                            data11 === 'marketo' ||
                                                                            data11 === 'activeCampaign' ||
                                                                            data11 === 'mailchimp' ||
                                                                            data11 === 'infor' ||
                                                                            data11 === 'cornerstoneOnDemand' ||
                                                                            data11 === 'gusto' ||
                                                                            data11 === 'paychexFlex' ||
                                                                            data11 === 'zendesk' ||
                                                                            data11 === 'serviceNow' ||
                                                                            data11 === 'zohoCrm' ||
                                                                            data11 === 'pipedrive' ||
                                                                            data11 === 'quickBooks' ||
                                                                            data11 === 'xero' ||
                                                                            data11 === 'freshbooks' ||
                                                                            data11 === 'zohoBooks' ||
                                                                            data11 === 'waveFinancial')) {
                                                                            validate59.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/connection/connectionType',
                                                                                    schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionType/enum',
                                                                                    keyword: 'enum',
                                                                                    params: { allowedValues: schema41.properties.connectionType.enum },
                                                                                    message: 'must be equal to one of the allowed values'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        var valid5 = _errs25 === errors;
                                                                    }
                                                                    else {
                                                                        var valid5 = true;
                                                                    }
                                                                    if (valid5) {
                                                                        if (data9.name !== undefined) {
                                                                            let data12 = data9.name;
                                                                            const _errs27 = errors;
                                                                            if (errors === _errs27) {
                                                                                if (typeof data12 === 'string') {
                                                                                    if (func2(data12) < 1) {
                                                                                        validate59.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/connection/name',
                                                                                                schemaPath: 'urn:wisepipe-common-connection:Connection/properties/name/minLength',
                                                                                                keyword: 'minLength',
                                                                                                params: { limit: 1 },
                                                                                                message: 'must NOT have fewer than 1 characters'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    validate59.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/connection/name',
                                                                                            schemaPath: 'urn:wisepipe-common-connection:Connection/properties/name/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'string' },
                                                                                            message: 'must be string'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            var valid5 = _errs27 === errors;
                                                                        }
                                                                        else {
                                                                            var valid5 = true;
                                                                        }
                                                                        if (valid5) {
                                                                            if (data9.source !== undefined) {
                                                                                let data13 = data9.source;
                                                                                const _errs29 = errors;
                                                                                if (errors === _errs29) {
                                                                                    if (typeof data13 === 'string') {
                                                                                        if (func2(data13) < 1) {
                                                                                            validate59.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/connection/source',
                                                                                                    schemaPath: 'urn:wisepipe-common-connection:Connection/properties/source/minLength',
                                                                                                    keyword: 'minLength',
                                                                                                    params: { limit: 1 },
                                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                    else {
                                                                                        validate59.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/connection/source',
                                                                                                schemaPath: 'urn:wisepipe-common-connection:Connection/properties/source/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'string' },
                                                                                                message: 'must be string'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                var valid5 = _errs29 === errors;
                                                                            }
                                                                            else {
                                                                                var valid5 = true;
                                                                            }
                                                                            if (valid5) {
                                                                                if (data9.failedOnLastTry !== undefined) {
                                                                                    const _errs31 = errors;
                                                                                    if (typeof data9.failedOnLastTry !== 'boolean') {
                                                                                        validate59.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/connection/failedOnLastTry',
                                                                                                schemaPath: 'urn:wisepipe-common-connection:Connection/properties/failedOnLastTry/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'boolean' },
                                                                                                message: 'must be boolean'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                    var valid5 = _errs31 === errors;
                                                                                }
                                                                                else {
                                                                                    var valid5 = true;
                                                                                }
                                                                                if (valid5) {
                                                                                    if (data9.isDiscoveryFail !== undefined) {
                                                                                        const _errs33 = errors;
                                                                                        if (typeof data9.isDiscoveryFail !== 'boolean') {
                                                                                            validate59.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/connection/isDiscoveryFail',
                                                                                                    schemaPath: 'urn:wisepipe-common-connection:Connection/properties/isDiscoveryFail/type',
                                                                                                    keyword: 'type',
                                                                                                    params: { type: 'boolean' },
                                                                                                    message: 'must be boolean'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                        var valid5 = _errs33 === errors;
                                                                                    }
                                                                                    else {
                                                                                        var valid5 = true;
                                                                                    }
                                                                                    if (valid5) {
                                                                                        if (data9.verificationErrorMessage !== undefined) {
                                                                                            const _errs35 = errors;
                                                                                            if (typeof data9.verificationErrorMessage !== 'string') {
                                                                                                validate59.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/connection/verificationErrorMessage',
                                                                                                        schemaPath: 'urn:wisepipe-common-connection:Connection/properties/verificationErrorMessage/type',
                                                                                                        keyword: 'type',
                                                                                                        params: { type: 'string' },
                                                                                                        message: 'must be string'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                            var valid5 = _errs35 === errors;
                                                                                        }
                                                                                        else {
                                                                                            var valid5 = true;
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                        else {
                                                            validate59.errors = [
                                                                {
                                                                    instancePath: instancePath + '/connection',
                                                                    schemaPath: 'urn:wisepipe-common-connection:Connection/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'object' },
                                                                    message: 'must be object'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid2 = _errs20 === errors;
                                                }
                                                else {
                                                    var valid2 = true;
                                                }
                                                if (valid2) {
                                                    if (data.catalog !== undefined) {
                                                        let data17 = data.catalog;
                                                        const _errs37 = errors;
                                                        if (errors === _errs37) {
                                                            if (Array.isArray(data17)) {
                                                                var valid7 = true;
                                                                const len0 = data17.length;
                                                                for (let i0 = 0; i0 < len0; i0++) {
                                                                    const _errs39 = errors;
                                                                    if (!validate55(data17[i0], {
                                                                        instancePath: instancePath + '/catalog/' + i0,
                                                                        parentData: data17,
                                                                        parentDataProperty: i0,
                                                                        rootData
                                                                    })) {
                                                                        vErrors = vErrors === null ? validate55.errors : vErrors.concat(validate55.errors);
                                                                        errors = vErrors.length;
                                                                    }
                                                                    var valid7 = _errs39 === errors;
                                                                    if (!valid7) {
                                                                        break;
                                                                    }
                                                                }
                                                                if (valid7) {
                                                                    let i1 = data17.length;
                                                                    let j0;
                                                                    if (i1 > 1) {
                                                                        outer0: for (; i1--;) {
                                                                            for (j0 = i1; j0--;) {
                                                                                if (func0(data17[i1], data17[j0])) {
                                                                                    validate59.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/catalog',
                                                                                            schemaPath: '#/properties/catalog/uniqueItems',
                                                                                            keyword: 'uniqueItems',
                                                                                            params: { i: i1, j: j0 },
                                                                                            message: 'must NOT have duplicate items (items ## ' +
                                                                                                j0 +
                                                                                                ' and ' +
                                                                                                i1 +
                                                                                                ' are identical)'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                    break outer0;
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                            else {
                                                                validate59.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/catalog',
                                                                        schemaPath: '#/properties/catalog/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'array' },
                                                                        message: 'must be array'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid2 = _errs37 === errors;
                                                    }
                                                    else {
                                                        var valid2 = true;
                                                    }
                                                    if (valid2) {
                                                        if (data.error !== undefined) {
                                                            let data19 = data.error;
                                                            const _errs40 = errors;
                                                            if (!(data19 && typeof data19 == 'object' && !Array.isArray(data19))) {
                                                                validate59.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/error',
                                                                        schemaPath: '#/properties/error/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'object' },
                                                                        message: 'must be object'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid2 = _errs40 === errors;
                                                        }
                                                        else {
                                                            var valid2 = true;
                                                        }
                                                        if (valid2) {
                                                            if (data.extractionParameters !== undefined) {
                                                                const _errs42 = errors;
                                                                if (!validate30(data.extractionParameters, {
                                                                    instancePath: instancePath + '/extractionParameters',
                                                                    parentData: data,
                                                                    parentDataProperty: 'extractionParameters',
                                                                    rootData
                                                                })) {
                                                                    vErrors = vErrors === null ? validate30.errors : vErrors.concat(validate30.errors);
                                                                    errors = vErrors.length;
                                                                }
                                                                var valid2 = _errs42 === errors;
                                                            }
                                                            else {
                                                                var valid2 = true;
                                                            }
                                                            if (valid2) {
                                                                if (data.catalogS3Url !== undefined) {
                                                                    let data21 = data.catalogS3Url;
                                                                    const _errs43 = errors;
                                                                    const _errs44 = errors;
                                                                    if (errors === _errs44) {
                                                                        if (data21 && typeof data21 == 'object' && !Array.isArray(data21)) {
                                                                            let missing3;
                                                                            if ((data21.bucket === undefined && (missing3 = 'bucket')) ||
                                                                                (data21.key === undefined && (missing3 = 'key'))) {
                                                                                validate59.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/catalogS3Url',
                                                                                        schemaPath: 'urn:wisepipe-common:S3File/required',
                                                                                        keyword: 'required',
                                                                                        params: { missingProperty: missing3 },
                                                                                        message: "must have required property '" + missing3 + "'"
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            else {
                                                                                if (data21.bucket !== undefined) {
                                                                                    let data22 = data21.bucket;
                                                                                    const _errs46 = errors;
                                                                                    if (errors === _errs46) {
                                                                                        if (typeof data22 === 'string') {
                                                                                            if (func2(data22) < 1) {
                                                                                                validate59.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/catalogS3Url/bucket',
                                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                                                                        keyword: 'minLength',
                                                                                                        params: { limit: 1 },
                                                                                                        message: 'must NOT have fewer than 1 characters'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                        }
                                                                                        else {
                                                                                            validate59.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/catalogS3Url/bucket',
                                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                                                                    keyword: 'type',
                                                                                                    params: { type: 'string' },
                                                                                                    message: 'must be string'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                    var valid10 = _errs46 === errors;
                                                                                }
                                                                                else {
                                                                                    var valid10 = true;
                                                                                }
                                                                                if (valid10) {
                                                                                    if (data21.key !== undefined) {
                                                                                        let data23 = data21.key;
                                                                                        const _errs48 = errors;
                                                                                        if (errors === _errs48) {
                                                                                            if (typeof data23 === 'string') {
                                                                                                if (func2(data23) < 1) {
                                                                                                    validate59.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/catalogS3Url/key',
                                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                                                                            keyword: 'minLength',
                                                                                                            params: { limit: 1 },
                                                                                                            message: 'must NOT have fewer than 1 characters'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                            else {
                                                                                                validate59.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/catalogS3Url/key',
                                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                                                                        keyword: 'type',
                                                                                                        params: { type: 'string' },
                                                                                                        message: 'must be string'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                        }
                                                                                        var valid10 = _errs48 === errors;
                                                                                    }
                                                                                    else {
                                                                                        var valid10 = true;
                                                                                    }
                                                                                    if (valid10) {
                                                                                        if (data21.uploadID !== undefined) {
                                                                                            let data24 = data21.uploadID;
                                                                                            const _errs50 = errors;
                                                                                            if (errors === _errs50) {
                                                                                                if (typeof data24 === 'string') {
                                                                                                    const b64min2 = Math.ceil((4 * 9) / 3);
                                                                                                    const b64max2 = Math.ceil((4 * 9) / 3) + 3;
                                                                                                    if (func194(data24) < b64min2 || func194(data24) > b64max2) {
                                                                                                        validate59.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/catalogS3Url/uploadID',
                                                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                                keyword: 'uid',
                                                                                                                params: {
                                                                                                                    error: 'encoded',
                                                                                                                    b64min: b64min2,
                                                                                                                    b64max: b64max2,
                                                                                                                    length: func194(data24)
                                                                                                                },
                                                                                                                message: 'length must be between ' +
                                                                                                                    b64min2 +
                                                                                                                    ' and ' +
                                                                                                                    b64max2 +
                                                                                                                    ', but is ' +
                                                                                                                    func194(data24)
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                    else {
                                                                                                        const decoded2 = func195(data24);
                                                                                                        if (decoded2.length !== 9) {
                                                                                                            validate59.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/catalogS3Url/uploadID',
                                                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                                    keyword: 'uid',
                                                                                                                    params: { error: 'decoded' },
                                                                                                                    message: 'must decode to 9 bytes'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                        else {
                                                                                                            const encoded2 = func196(decoded2);
                                                                                                            if (func197(encoded2) !== func197(data24)) {
                                                                                                                validate59.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/catalogS3Url/uploadID',
                                                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                                        keyword: 'uid',
                                                                                                                        params: { error: 'ambiguous' },
                                                                                                                        message: 'encoding is ambiguous'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                                else {
                                                                                                    validate59.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/catalogS3Url/uploadID',
                                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                                                                            keyword: 'type',
                                                                                                            params: { type: 'string' },
                                                                                                            message: 'must be string'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                            var valid10 = _errs50 === errors;
                                                                                        }
                                                                                        else {
                                                                                            var valid10 = true;
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                        else {
                                                                            validate59.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/catalogS3Url',
                                                                                    schemaPath: 'urn:wisepipe-common:S3File/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'object' },
                                                                                    message: 'must be object'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    var valid2 = _errs43 === errors;
                                                                }
                                                                else {
                                                                    var valid2 = true;
                                                                }
                                                                if (valid2) {
                                                                    if (data.importID !== undefined) {
                                                                        let data25 = data.importID;
                                                                        const _errs52 = errors;
                                                                        if (errors === _errs52) {
                                                                            if (typeof data25 === 'string') {
                                                                                const b64min3 = Math.ceil((4 * 9) / 3);
                                                                                const b64max3 = Math.ceil((4 * 9) / 3) + 3;
                                                                                if (func198(data25) < b64min3 || func198(data25) > b64max3) {
                                                                                    validate59.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/importID',
                                                                                            schemaPath: '#/properties/importID/uid',
                                                                                            keyword: 'uid',
                                                                                            params: {
                                                                                                error: 'encoded',
                                                                                                b64min: b64min3,
                                                                                                b64max: b64max3,
                                                                                                length: func198(data25)
                                                                                            },
                                                                                            message: 'length must be between ' +
                                                                                                b64min3 +
                                                                                                ' and ' +
                                                                                                b64max3 +
                                                                                                ', but is ' +
                                                                                                func198(data25)
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                                else {
                                                                                    const decoded3 = func199(data25);
                                                                                    if (decoded3.length !== 9) {
                                                                                        validate59.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/importID',
                                                                                                schemaPath: '#/properties/importID/uid',
                                                                                                keyword: 'uid',
                                                                                                params: { error: 'decoded' },
                                                                                                message: 'must decode to 9 bytes'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                    else {
                                                                                        const encoded3 = func200(decoded3);
                                                                                        if (func201(encoded3) !== func201(data25)) {
                                                                                            validate59.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/importID',
                                                                                                    schemaPath: '#/properties/importID/uid',
                                                                                                    keyword: 'uid',
                                                                                                    params: { error: 'ambiguous' },
                                                                                                    message: 'encoding is ambiguous'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                            else {
                                                                                validate59.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/importID',
                                                                                        schemaPath: '#/properties/importID/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        var valid2 = _errs52 === errors;
                                                                    }
                                                                    else {
                                                                        var valid2 = true;
                                                                    }
                                                                    if (valid2) {
                                                                        if (data.columnsToUpdateS3Url !== undefined) {
                                                                            let data26 = data.columnsToUpdateS3Url;
                                                                            const _errs54 = errors;
                                                                            const _errs55 = errors;
                                                                            if (errors === _errs55) {
                                                                                if (data26 && typeof data26 == 'object' && !Array.isArray(data26)) {
                                                                                    let missing4;
                                                                                    if ((data26.bucket === undefined && (missing4 = 'bucket')) ||
                                                                                        (data26.key === undefined && (missing4 = 'key'))) {
                                                                                        validate59.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/columnsToUpdateS3Url',
                                                                                                schemaPath: 'urn:wisepipe-common:S3File/required',
                                                                                                keyword: 'required',
                                                                                                params: { missingProperty: missing4 },
                                                                                                message: "must have required property '" + missing4 + "'"
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                    else {
                                                                                        if (data26.bucket !== undefined) {
                                                                                            let data27 = data26.bucket;
                                                                                            const _errs57 = errors;
                                                                                            if (errors === _errs57) {
                                                                                                if (typeof data27 === 'string') {
                                                                                                    if (func2(data27) < 1) {
                                                                                                        validate59.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/columnsToUpdateS3Url/bucket',
                                                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                                                                                keyword: 'minLength',
                                                                                                                params: { limit: 1 },
                                                                                                                message: 'must NOT have fewer than 1 characters'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                }
                                                                                                else {
                                                                                                    validate59.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/columnsToUpdateS3Url/bucket',
                                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                                                                            keyword: 'type',
                                                                                                            params: { type: 'string' },
                                                                                                            message: 'must be string'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                            var valid14 = _errs57 === errors;
                                                                                        }
                                                                                        else {
                                                                                            var valid14 = true;
                                                                                        }
                                                                                        if (valid14) {
                                                                                            if (data26.key !== undefined) {
                                                                                                let data28 = data26.key;
                                                                                                const _errs59 = errors;
                                                                                                if (errors === _errs59) {
                                                                                                    if (typeof data28 === 'string') {
                                                                                                        if (func2(data28) < 1) {
                                                                                                            validate59.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/columnsToUpdateS3Url/key',
                                                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                                                                                    keyword: 'minLength',
                                                                                                                    params: { limit: 1 },
                                                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                    }
                                                                                                    else {
                                                                                                        validate59.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/columnsToUpdateS3Url/key',
                                                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                                                                                keyword: 'type',
                                                                                                                params: { type: 'string' },
                                                                                                                message: 'must be string'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                }
                                                                                                var valid14 = _errs59 === errors;
                                                                                            }
                                                                                            else {
                                                                                                var valid14 = true;
                                                                                            }
                                                                                            if (valid14) {
                                                                                                if (data26.uploadID !== undefined) {
                                                                                                    let data29 = data26.uploadID;
                                                                                                    const _errs61 = errors;
                                                                                                    if (errors === _errs61) {
                                                                                                        if (typeof data29 === 'string') {
                                                                                                            const b64min4 = Math.ceil((4 * 9) / 3);
                                                                                                            const b64max4 = Math.ceil((4 * 9) / 3) + 3;
                                                                                                            if (func204(data29) < b64min4 || func204(data29) > b64max4) {
                                                                                                                validate59.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/columnsToUpdateS3Url/uploadID',
                                                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                                        keyword: 'uid',
                                                                                                                        params: {
                                                                                                                            error: 'encoded',
                                                                                                                            b64min: b64min4,
                                                                                                                            b64max: b64max4,
                                                                                                                            length: func204(data29)
                                                                                                                        },
                                                                                                                        message: 'length must be between ' +
                                                                                                                            b64min4 +
                                                                                                                            ' and ' +
                                                                                                                            b64max4 +
                                                                                                                            ', but is ' +
                                                                                                                            func204(data29)
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                            else {
                                                                                                                const decoded4 = func205(data29);
                                                                                                                if (decoded4.length !== 9) {
                                                                                                                    validate59.errors = [
                                                                                                                        {
                                                                                                                            instancePath: instancePath + '/columnsToUpdateS3Url/uploadID',
                                                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                                            keyword: 'uid',
                                                                                                                            params: { error: 'decoded' },
                                                                                                                            message: 'must decode to 9 bytes'
                                                                                                                        }
                                                                                                                    ];
                                                                                                                    return false;
                                                                                                                }
                                                                                                                else {
                                                                                                                    const encoded4 = func206(decoded4);
                                                                                                                    if (func207(encoded4) !== func207(data29)) {
                                                                                                                        validate59.errors = [
                                                                                                                            {
                                                                                                                                instancePath: instancePath + '/columnsToUpdateS3Url/uploadID',
                                                                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                                                keyword: 'uid',
                                                                                                                                params: { error: 'ambiguous' },
                                                                                                                                message: 'encoding is ambiguous'
                                                                                                                            }
                                                                                                                        ];
                                                                                                                        return false;
                                                                                                                    }
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                        else {
                                                                                                            validate59.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/columnsToUpdateS3Url/uploadID',
                                                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                                                                                    keyword: 'type',
                                                                                                                    params: { type: 'string' },
                                                                                                                    message: 'must be string'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                    }
                                                                                                    var valid14 = _errs61 === errors;
                                                                                                }
                                                                                                else {
                                                                                                    var valid14 = true;
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    validate59.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/columnsToUpdateS3Url',
                                                                                            schemaPath: 'urn:wisepipe-common:S3File/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'object' },
                                                                                            message: 'must be object'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            var valid2 = _errs54 === errors;
                                                                        }
                                                                        else {
                                                                            var valid2 = true;
                                                                        }
                                                                        if (valid2) {
                                                                            if (data.sourceFileName !== undefined) {
                                                                                const _errs63 = errors;
                                                                                if (typeof data.sourceFileName !== 'string') {
                                                                                    validate59.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/sourceFileName',
                                                                                            schemaPath: '#/properties/sourceFileName/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'string' },
                                                                                            message: 'must be string'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                                var valid2 = _errs63 === errors;
                                                                            }
                                                                            else {
                                                                                var valid2 = true;
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate59.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate59.errors = vErrors;
    return errors === 0;
}
const schema99 = {
    $id: 'urn:wisepipe-common-data:ImportDiscoveryTaskEnv',
    type: 'object',
    properties: {
        stage: { type: 'string', minLength: 1 },
        apiUrl: { type: 'string', format: 'uri' },
        s3DataBucket: { type: 'string', minLength: 1 },
        googleClientIDParam: { type: 'string', minLength: 1 },
        googleClientSecretParam: { type: 'string', minLength: 1 },
        googleSheetsImportClientIDParam: { type: 'string', minLength: 1 },
        googleSheetsImportClientSecretParam: { type: 'string', minLength: 1 },
        googleAdWordsDevTokenParam: { type: 'string', minLength: 1 },
        salesforceClientIDParam: { type: 'string', minLength: 1 },
        salesforceClientSecretParam: { type: 'string', minLength: 1 },
        hubspotClientIDParam: { type: 'string', minLength: 1 },
        hubspotClientSecretParam: { type: 'string', minLength: 1 },
        dynamicsClientIDParam: { type: 'string', minLength: 1 },
        dynamicsClientSecretParam: { type: 'string', minLength: 1 },
        onedriveClientIDParam: { type: 'string', minLength: 1 },
        onedriveClientSecretParam: { type: 'string', minLength: 1 },
        encryptionSecretName: { type: 'string', minLength: 1 },
        connection: { $ref: 'urn:wisepipe-common-connection:Connection' },
        credentials: { $ref: 'urn:wisepipe-common:Credentials' }
    },
    required: [
        'stage',
        'apiUrl',
        's3DataBucket',
        'googleClientIDParam',
        'googleClientSecretParam',
        'googleSheetsImportClientIDParam',
        'googleSheetsImportClientSecretParam',
        'googleAdWordsDevTokenParam',
        'salesforceClientIDParam',
        'salesforceClientSecretParam',
        'hubspotClientIDParam',
        'hubspotClientSecretParam',
        'dynamicsClientIDParam',
        'dynamicsClientSecretParam'
    ]
};
const func224 = ucs2length;
const func225 = base64urlToBuffer;
const func226 = base64urlEncode;
const func227 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const formats40 = formatWrapper.uri;
function validate64(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:ImportDiscoveryTaskEnv" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.stage === undefined && (missing0 = 'stage')) ||
                (data.apiUrl === undefined && (missing0 = 'apiUrl')) ||
                (data.s3DataBucket === undefined && (missing0 = 's3DataBucket')) ||
                (data.googleClientIDParam === undefined && (missing0 = 'googleClientIDParam')) ||
                (data.googleClientSecretParam === undefined && (missing0 = 'googleClientSecretParam')) ||
                (data.googleSheetsImportClientIDParam === undefined && (missing0 = 'googleSheetsImportClientIDParam')) ||
                (data.googleSheetsImportClientSecretParam === undefined &&
                    (missing0 = 'googleSheetsImportClientSecretParam')) ||
                (data.googleAdWordsDevTokenParam === undefined && (missing0 = 'googleAdWordsDevTokenParam')) ||
                (data.salesforceClientIDParam === undefined && (missing0 = 'salesforceClientIDParam')) ||
                (data.salesforceClientSecretParam === undefined && (missing0 = 'salesforceClientSecretParam')) ||
                (data.hubspotClientIDParam === undefined && (missing0 = 'hubspotClientIDParam')) ||
                (data.hubspotClientSecretParam === undefined && (missing0 = 'hubspotClientSecretParam')) ||
                (data.dynamicsClientIDParam === undefined && (missing0 = 'dynamicsClientIDParam')) ||
                (data.dynamicsClientSecretParam === undefined && (missing0 = 'dynamicsClientSecretParam'))) {
                validate64.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.stage !== undefined) {
                    let data0 = data.stage;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate64.errors = [
                                    {
                                        instancePath: instancePath + '/stage',
                                        schemaPath: '#/properties/stage/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate64.errors = [
                                {
                                    instancePath: instancePath + '/stage',
                                    schemaPath: '#/properties/stage/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.apiUrl !== undefined) {
                        let data1 = data.apiUrl;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (errors === _errs3) {
                                if (typeof data1 === 'string') {
                                    if (!formats40(data1)) {
                                        validate64.errors = [
                                            {
                                                instancePath: instancePath + '/apiUrl',
                                                schemaPath: '#/properties/apiUrl/format',
                                                keyword: 'format',
                                                params: { format: 'uri' },
                                                message: 'must match format "' + 'uri' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate64.errors = [
                                        {
                                            instancePath: instancePath + '/apiUrl',
                                            schemaPath: '#/properties/apiUrl/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.s3DataBucket !== undefined) {
                            let data2 = data.s3DataBucket;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate64.errors = [
                                            {
                                                instancePath: instancePath + '/s3DataBucket',
                                                schemaPath: '#/properties/s3DataBucket/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate64.errors = [
                                        {
                                            instancePath: instancePath + '/s3DataBucket',
                                            schemaPath: '#/properties/s3DataBucket/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.googleClientIDParam !== undefined) {
                                let data3 = data.googleClientIDParam;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 === 'string') {
                                        if (func2(data3) < 1) {
                                            validate64.errors = [
                                                {
                                                    instancePath: instancePath + '/googleClientIDParam',
                                                    schemaPath: '#/properties/googleClientIDParam/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate64.errors = [
                                            {
                                                instancePath: instancePath + '/googleClientIDParam',
                                                schemaPath: '#/properties/googleClientIDParam/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.googleClientSecretParam !== undefined) {
                                    let data4 = data.googleClientSecretParam;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (typeof data4 === 'string') {
                                            if (func2(data4) < 1) {
                                                validate64.errors = [
                                                    {
                                                        instancePath: instancePath + '/googleClientSecretParam',
                                                        schemaPath: '#/properties/googleClientSecretParam/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate64.errors = [
                                                {
                                                    instancePath: instancePath + '/googleClientSecretParam',
                                                    schemaPath: '#/properties/googleClientSecretParam/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.googleSheetsImportClientIDParam !== undefined) {
                                        let data5 = data.googleSheetsImportClientIDParam;
                                        const _errs11 = errors;
                                        if (errors === _errs11) {
                                            if (typeof data5 === 'string') {
                                                if (func2(data5) < 1) {
                                                    validate64.errors = [
                                                        {
                                                            instancePath: instancePath + '/googleSheetsImportClientIDParam',
                                                            schemaPath: '#/properties/googleSheetsImportClientIDParam/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate64.errors = [
                                                    {
                                                        instancePath: instancePath + '/googleSheetsImportClientIDParam',
                                                        schemaPath: '#/properties/googleSheetsImportClientIDParam/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.googleSheetsImportClientSecretParam !== undefined) {
                                            let data6 = data.googleSheetsImportClientSecretParam;
                                            const _errs13 = errors;
                                            if (errors === _errs13) {
                                                if (typeof data6 === 'string') {
                                                    if (func2(data6) < 1) {
                                                        validate64.errors = [
                                                            {
                                                                instancePath: instancePath + '/googleSheetsImportClientSecretParam',
                                                                schemaPath: '#/properties/googleSheetsImportClientSecretParam/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate64.errors = [
                                                        {
                                                            instancePath: instancePath + '/googleSheetsImportClientSecretParam',
                                                            schemaPath: '#/properties/googleSheetsImportClientSecretParam/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs13 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.googleAdWordsDevTokenParam !== undefined) {
                                                let data7 = data.googleAdWordsDevTokenParam;
                                                const _errs15 = errors;
                                                if (errors === _errs15) {
                                                    if (typeof data7 === 'string') {
                                                        if (func2(data7) < 1) {
                                                            validate64.errors = [
                                                                {
                                                                    instancePath: instancePath + '/googleAdWordsDevTokenParam',
                                                                    schemaPath: '#/properties/googleAdWordsDevTokenParam/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate64.errors = [
                                                            {
                                                                instancePath: instancePath + '/googleAdWordsDevTokenParam',
                                                                schemaPath: '#/properties/googleAdWordsDevTokenParam/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid0 = _errs15 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (data.salesforceClientIDParam !== undefined) {
                                                    let data8 = data.salesforceClientIDParam;
                                                    const _errs17 = errors;
                                                    if (errors === _errs17) {
                                                        if (typeof data8 === 'string') {
                                                            if (func2(data8) < 1) {
                                                                validate64.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/salesforceClientIDParam',
                                                                        schemaPath: '#/properties/salesforceClientIDParam/minLength',
                                                                        keyword: 'minLength',
                                                                        params: { limit: 1 },
                                                                        message: 'must NOT have fewer than 1 characters'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate64.errors = [
                                                                {
                                                                    instancePath: instancePath + '/salesforceClientIDParam',
                                                                    schemaPath: '#/properties/salesforceClientIDParam/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid0 = _errs17 === errors;
                                                }
                                                else {
                                                    var valid0 = true;
                                                }
                                                if (valid0) {
                                                    if (data.salesforceClientSecretParam !== undefined) {
                                                        let data9 = data.salesforceClientSecretParam;
                                                        const _errs19 = errors;
                                                        if (errors === _errs19) {
                                                            if (typeof data9 === 'string') {
                                                                if (func2(data9) < 1) {
                                                                    validate64.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/salesforceClientSecretParam',
                                                                            schemaPath: '#/properties/salesforceClientSecretParam/minLength',
                                                                            keyword: 'minLength',
                                                                            params: { limit: 1 },
                                                                            message: 'must NOT have fewer than 1 characters'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            else {
                                                                validate64.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/salesforceClientSecretParam',
                                                                        schemaPath: '#/properties/salesforceClientSecretParam/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid0 = _errs19 === errors;
                                                    }
                                                    else {
                                                        var valid0 = true;
                                                    }
                                                    if (valid0) {
                                                        if (data.hubspotClientIDParam !== undefined) {
                                                            let data10 = data.hubspotClientIDParam;
                                                            const _errs21 = errors;
                                                            if (errors === _errs21) {
                                                                if (typeof data10 === 'string') {
                                                                    if (func2(data10) < 1) {
                                                                        validate64.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/hubspotClientIDParam',
                                                                                schemaPath: '#/properties/hubspotClientIDParam/minLength',
                                                                                keyword: 'minLength',
                                                                                params: { limit: 1 },
                                                                                message: 'must NOT have fewer than 1 characters'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                else {
                                                                    validate64.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/hubspotClientIDParam',
                                                                            schemaPath: '#/properties/hubspotClientIDParam/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid0 = _errs21 === errors;
                                                        }
                                                        else {
                                                            var valid0 = true;
                                                        }
                                                        if (valid0) {
                                                            if (data.hubspotClientSecretParam !== undefined) {
                                                                let data11 = data.hubspotClientSecretParam;
                                                                const _errs23 = errors;
                                                                if (errors === _errs23) {
                                                                    if (typeof data11 === 'string') {
                                                                        if (func2(data11) < 1) {
                                                                            validate64.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/hubspotClientSecretParam',
                                                                                    schemaPath: '#/properties/hubspotClientSecretParam/minLength',
                                                                                    keyword: 'minLength',
                                                                                    params: { limit: 1 },
                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate64.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/hubspotClientSecretParam',
                                                                                schemaPath: '#/properties/hubspotClientSecretParam/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                var valid0 = _errs23 === errors;
                                                            }
                                                            else {
                                                                var valid0 = true;
                                                            }
                                                            if (valid0) {
                                                                if (data.dynamicsClientIDParam !== undefined) {
                                                                    let data12 = data.dynamicsClientIDParam;
                                                                    const _errs25 = errors;
                                                                    if (errors === _errs25) {
                                                                        if (typeof data12 === 'string') {
                                                                            if (func2(data12) < 1) {
                                                                                validate64.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/dynamicsClientIDParam',
                                                                                        schemaPath: '#/properties/dynamicsClientIDParam/minLength',
                                                                                        keyword: 'minLength',
                                                                                        params: { limit: 1 },
                                                                                        message: 'must NOT have fewer than 1 characters'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        else {
                                                                            validate64.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/dynamicsClientIDParam',
                                                                                    schemaPath: '#/properties/dynamicsClientIDParam/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'string' },
                                                                                    message: 'must be string'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    var valid0 = _errs25 === errors;
                                                                }
                                                                else {
                                                                    var valid0 = true;
                                                                }
                                                                if (valid0) {
                                                                    if (data.dynamicsClientSecretParam !== undefined) {
                                                                        let data13 = data.dynamicsClientSecretParam;
                                                                        const _errs27 = errors;
                                                                        if (errors === _errs27) {
                                                                            if (typeof data13 === 'string') {
                                                                                if (func2(data13) < 1) {
                                                                                    validate64.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/dynamicsClientSecretParam',
                                                                                            schemaPath: '#/properties/dynamicsClientSecretParam/minLength',
                                                                                            keyword: 'minLength',
                                                                                            params: { limit: 1 },
                                                                                            message: 'must NOT have fewer than 1 characters'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            else {
                                                                                validate64.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/dynamicsClientSecretParam',
                                                                                        schemaPath: '#/properties/dynamicsClientSecretParam/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        var valid0 = _errs27 === errors;
                                                                    }
                                                                    else {
                                                                        var valid0 = true;
                                                                    }
                                                                    if (valid0) {
                                                                        if (data.onedriveClientIDParam !== undefined) {
                                                                            let data14 = data.onedriveClientIDParam;
                                                                            const _errs29 = errors;
                                                                            if (errors === _errs29) {
                                                                                if (typeof data14 === 'string') {
                                                                                    if (func2(data14) < 1) {
                                                                                        validate64.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/onedriveClientIDParam',
                                                                                                schemaPath: '#/properties/onedriveClientIDParam/minLength',
                                                                                                keyword: 'minLength',
                                                                                                params: { limit: 1 },
                                                                                                message: 'must NOT have fewer than 1 characters'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    validate64.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/onedriveClientIDParam',
                                                                                            schemaPath: '#/properties/onedriveClientIDParam/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'string' },
                                                                                            message: 'must be string'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            var valid0 = _errs29 === errors;
                                                                        }
                                                                        else {
                                                                            var valid0 = true;
                                                                        }
                                                                        if (valid0) {
                                                                            if (data.onedriveClientSecretParam !== undefined) {
                                                                                let data15 = data.onedriveClientSecretParam;
                                                                                const _errs31 = errors;
                                                                                if (errors === _errs31) {
                                                                                    if (typeof data15 === 'string') {
                                                                                        if (func2(data15) < 1) {
                                                                                            validate64.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/onedriveClientSecretParam',
                                                                                                    schemaPath: '#/properties/onedriveClientSecretParam/minLength',
                                                                                                    keyword: 'minLength',
                                                                                                    params: { limit: 1 },
                                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                    else {
                                                                                        validate64.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/onedriveClientSecretParam',
                                                                                                schemaPath: '#/properties/onedriveClientSecretParam/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'string' },
                                                                                                message: 'must be string'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                var valid0 = _errs31 === errors;
                                                                            }
                                                                            else {
                                                                                var valid0 = true;
                                                                            }
                                                                            if (valid0) {
                                                                                if (data.encryptionSecretName !== undefined) {
                                                                                    let data16 = data.encryptionSecretName;
                                                                                    const _errs33 = errors;
                                                                                    if (errors === _errs33) {
                                                                                        if (typeof data16 === 'string') {
                                                                                            if (func2(data16) < 1) {
                                                                                                validate64.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/encryptionSecretName',
                                                                                                        schemaPath: '#/properties/encryptionSecretName/minLength',
                                                                                                        keyword: 'minLength',
                                                                                                        params: { limit: 1 },
                                                                                                        message: 'must NOT have fewer than 1 characters'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                        }
                                                                                        else {
                                                                                            validate64.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/encryptionSecretName',
                                                                                                    schemaPath: '#/properties/encryptionSecretName/type',
                                                                                                    keyword: 'type',
                                                                                                    params: { type: 'string' },
                                                                                                    message: 'must be string'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                    var valid0 = _errs33 === errors;
                                                                                }
                                                                                else {
                                                                                    var valid0 = true;
                                                                                }
                                                                                if (valid0) {
                                                                                    if (data.connection !== undefined) {
                                                                                        let data17 = data.connection;
                                                                                        const _errs35 = errors;
                                                                                        const _errs36 = errors;
                                                                                        if (errors === _errs36) {
                                                                                            if (data17 && typeof data17 == 'object' && !Array.isArray(data17)) {
                                                                                                let missing1;
                                                                                                if ((data17.connectionType === undefined &&
                                                                                                    (missing1 = 'connectionType')) ||
                                                                                                    (data17.name === undefined && (missing1 = 'name'))) {
                                                                                                    validate64.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/connection',
                                                                                                            schemaPath: 'urn:wisepipe-common-connection:Connection/required',
                                                                                                            keyword: 'required',
                                                                                                            params: { missingProperty: missing1 },
                                                                                                            message: "must have required property '" + missing1 + "'"
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                                else {
                                                                                                    if (data17.connectionID !== undefined) {
                                                                                                        let data18 = data17.connectionID;
                                                                                                        const _errs38 = errors;
                                                                                                        if (errors === _errs38) {
                                                                                                            if (typeof data18 === 'string') {
                                                                                                                const b64min0 = Math.ceil((4 * 9) / 3);
                                                                                                                const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                                                                                                if (func224(data18) < b64min0 || func224(data18) > b64max0) {
                                                                                                                    validate64.errors = [
                                                                                                                        {
                                                                                                                            instancePath: instancePath + '/connection/connectionID',
                                                                                                                            schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionID/uid',
                                                                                                                            keyword: 'uid',
                                                                                                                            params: {
                                                                                                                                error: 'encoded',
                                                                                                                                b64min: b64min0,
                                                                                                                                b64max: b64max0,
                                                                                                                                length: func224(data18)
                                                                                                                            },
                                                                                                                            message: 'length must be between ' +
                                                                                                                                b64min0 +
                                                                                                                                ' and ' +
                                                                                                                                b64max0 +
                                                                                                                                ', but is ' +
                                                                                                                                func224(data18)
                                                                                                                        }
                                                                                                                    ];
                                                                                                                    return false;
                                                                                                                }
                                                                                                                else {
                                                                                                                    const decoded0 = func225(data18);
                                                                                                                    if (decoded0.length !== 9) {
                                                                                                                        validate64.errors = [
                                                                                                                            {
                                                                                                                                instancePath: instancePath + '/connection/connectionID',
                                                                                                                                schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionID/uid',
                                                                                                                                keyword: 'uid',
                                                                                                                                params: { error: 'decoded' },
                                                                                                                                message: 'must decode to 9 bytes'
                                                                                                                            }
                                                                                                                        ];
                                                                                                                        return false;
                                                                                                                    }
                                                                                                                    else {
                                                                                                                        const encoded0 = func226(decoded0);
                                                                                                                        if (func227(encoded0) !== func227(data18)) {
                                                                                                                            validate64.errors = [
                                                                                                                                {
                                                                                                                                    instancePath: instancePath + '/connection/connectionID',
                                                                                                                                    schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionID/uid',
                                                                                                                                    keyword: 'uid',
                                                                                                                                    params: { error: 'ambiguous' },
                                                                                                                                    message: 'encoding is ambiguous'
                                                                                                                                }
                                                                                                                            ];
                                                                                                                            return false;
                                                                                                                        }
                                                                                                                    }
                                                                                                                }
                                                                                                            }
                                                                                                            else {
                                                                                                                validate64.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/connection/connectionID',
                                                                                                                        schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionID/type',
                                                                                                                        keyword: 'type',
                                                                                                                        params: { type: 'string' },
                                                                                                                        message: 'must be string'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                        }
                                                                                                        var valid2 = _errs38 === errors;
                                                                                                    }
                                                                                                    else {
                                                                                                        var valid2 = true;
                                                                                                    }
                                                                                                    if (valid2) {
                                                                                                        if (data17.connectionType !== undefined) {
                                                                                                            let data19 = data17.connectionType;
                                                                                                            const _errs40 = errors;
                                                                                                            if (typeof data19 !== 'string') {
                                                                                                                validate64.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/connection/connectionType',
                                                                                                                        schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionType/type',
                                                                                                                        keyword: 'type',
                                                                                                                        params: { type: 'string' },
                                                                                                                        message: 'must be string'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                            if (!(data19 === 'google' ||
                                                                                                                data19 === 'gsheetsImport' ||
                                                                                                                data19 === 'gsheetsExport' ||
                                                                                                                data19 === 'shopify' ||
                                                                                                                data19 === 'salesForce' ||
                                                                                                                data19 === 'postgreSql' ||
                                                                                                                data19 === 'icm' ||
                                                                                                                data19 === 'tq-postgres' ||
                                                                                                                data19 === 'mySql' ||
                                                                                                                data19 === 'msSql' ||
                                                                                                                data19 === 'oracle' ||
                                                                                                                data19 === 'amazonRedshift' ||
                                                                                                                data19 === 'amazonAurora' ||
                                                                                                                data19 === 'amazonS3' ||
                                                                                                                data19 === 'amazonS3Export' ||
                                                                                                                data19 === 'tqp' ||
                                                                                                                data19 === 'hubspot' ||
                                                                                                                data19 === 'symon' ||
                                                                                                                data19 === 'snowflake' ||
                                                                                                                data19 === 'dynamics' ||
                                                                                                                data19 === 'agentSync' ||
                                                                                                                data19 === 'workday' ||
                                                                                                                data19 === 'workdayRaaS' ||
                                                                                                                data19 === 'workdayExport' ||
                                                                                                                data19 === 'tableau' ||
                                                                                                                data19 === 'sftp' ||
                                                                                                                data19 === 'powerbi' ||
                                                                                                                data19 === 'rest' ||
                                                                                                                data19 === 'gong' ||
                                                                                                                data19 === 'netSuite' ||
                                                                                                                data19 === 'oneDrive' ||
                                                                                                                data19 === 'oneDriveExport' ||
                                                                                                                data19 === 'sapSuccessFactors' ||
                                                                                                                data19 === 'sapCrm' ||
                                                                                                                data19 === 'ukg' ||
                                                                                                                data19 === 'oracleHcm' ||
                                                                                                                data19 === 'Adp' ||
                                                                                                                data19 === 'dynamics365Sales' ||
                                                                                                                data19 === 'ceridianDayforce' ||
                                                                                                                data19 === 'oracleCrm' ||
                                                                                                                data19 === 'oracleErpCloud' ||
                                                                                                                data19 === 'sageIntacct' ||
                                                                                                                data19 === 'bambooHr' ||
                                                                                                                data19 === 'sapErp' ||
                                                                                                                data19 === 'googleCloudPlatformCloudStorage' ||
                                                                                                                data19 === 'sas' ||
                                                                                                                data19 === 'dropbox' ||
                                                                                                                data19 === 'googleDrive' ||
                                                                                                                data19 === 'jira' ||
                                                                                                                data19 === 'monday' ||
                                                                                                                data19 === 'zuora' ||
                                                                                                                data19 === 'adobeAnalytics' ||
                                                                                                                data19 === 'zoomInfo' ||
                                                                                                                data19 === 'marketo' ||
                                                                                                                data19 === 'activeCampaign' ||
                                                                                                                data19 === 'mailchimp' ||
                                                                                                                data19 === 'infor' ||
                                                                                                                data19 === 'cornerstoneOnDemand' ||
                                                                                                                data19 === 'gusto' ||
                                                                                                                data19 === 'paychexFlex' ||
                                                                                                                data19 === 'zendesk' ||
                                                                                                                data19 === 'serviceNow' ||
                                                                                                                data19 === 'zohoCrm' ||
                                                                                                                data19 === 'pipedrive' ||
                                                                                                                data19 === 'quickBooks' ||
                                                                                                                data19 === 'xero' ||
                                                                                                                data19 === 'freshbooks' ||
                                                                                                                data19 === 'zohoBooks' ||
                                                                                                                data19 === 'waveFinancial')) {
                                                                                                                validate64.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/connection/connectionType',
                                                                                                                        schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionType/enum',
                                                                                                                        keyword: 'enum',
                                                                                                                        params: {
                                                                                                                            allowedValues: schema41.properties.connectionType.enum
                                                                                                                        },
                                                                                                                        message: 'must be equal to one of the allowed values'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                            var valid2 = _errs40 === errors;
                                                                                                        }
                                                                                                        else {
                                                                                                            var valid2 = true;
                                                                                                        }
                                                                                                        if (valid2) {
                                                                                                            if (data17.name !== undefined) {
                                                                                                                let data20 = data17.name;
                                                                                                                const _errs42 = errors;
                                                                                                                if (errors === _errs42) {
                                                                                                                    if (typeof data20 === 'string') {
                                                                                                                        if (func2(data20) < 1) {
                                                                                                                            validate64.errors = [
                                                                                                                                {
                                                                                                                                    instancePath: instancePath + '/connection/name',
                                                                                                                                    schemaPath: 'urn:wisepipe-common-connection:Connection/properties/name/minLength',
                                                                                                                                    keyword: 'minLength',
                                                                                                                                    params: { limit: 1 },
                                                                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                                                                }
                                                                                                                            ];
                                                                                                                            return false;
                                                                                                                        }
                                                                                                                    }
                                                                                                                    else {
                                                                                                                        validate64.errors = [
                                                                                                                            {
                                                                                                                                instancePath: instancePath + '/connection/name',
                                                                                                                                schemaPath: 'urn:wisepipe-common-connection:Connection/properties/name/type',
                                                                                                                                keyword: 'type',
                                                                                                                                params: { type: 'string' },
                                                                                                                                message: 'must be string'
                                                                                                                            }
                                                                                                                        ];
                                                                                                                        return false;
                                                                                                                    }
                                                                                                                }
                                                                                                                var valid2 = _errs42 === errors;
                                                                                                            }
                                                                                                            else {
                                                                                                                var valid2 = true;
                                                                                                            }
                                                                                                            if (valid2) {
                                                                                                                if (data17.source !== undefined) {
                                                                                                                    let data21 = data17.source;
                                                                                                                    const _errs44 = errors;
                                                                                                                    if (errors === _errs44) {
                                                                                                                        if (typeof data21 === 'string') {
                                                                                                                            if (func2(data21) < 1) {
                                                                                                                                validate64.errors = [
                                                                                                                                    {
                                                                                                                                        instancePath: instancePath + '/connection/source',
                                                                                                                                        schemaPath: 'urn:wisepipe-common-connection:Connection/properties/source/minLength',
                                                                                                                                        keyword: 'minLength',
                                                                                                                                        params: { limit: 1 },
                                                                                                                                        message: 'must NOT have fewer than 1 characters'
                                                                                                                                    }
                                                                                                                                ];
                                                                                                                                return false;
                                                                                                                            }
                                                                                                                        }
                                                                                                                        else {
                                                                                                                            validate64.errors = [
                                                                                                                                {
                                                                                                                                    instancePath: instancePath + '/connection/source',
                                                                                                                                    schemaPath: 'urn:wisepipe-common-connection:Connection/properties/source/type',
                                                                                                                                    keyword: 'type',
                                                                                                                                    params: { type: 'string' },
                                                                                                                                    message: 'must be string'
                                                                                                                                }
                                                                                                                            ];
                                                                                                                            return false;
                                                                                                                        }
                                                                                                                    }
                                                                                                                    var valid2 = _errs44 === errors;
                                                                                                                }
                                                                                                                else {
                                                                                                                    var valid2 = true;
                                                                                                                }
                                                                                                                if (valid2) {
                                                                                                                    if (data17.failedOnLastTry !== undefined) {
                                                                                                                        const _errs46 = errors;
                                                                                                                        if (typeof data17.failedOnLastTry !== 'boolean') {
                                                                                                                            validate64.errors = [
                                                                                                                                {
                                                                                                                                    instancePath: instancePath + '/connection/failedOnLastTry',
                                                                                                                                    schemaPath: 'urn:wisepipe-common-connection:Connection/properties/failedOnLastTry/type',
                                                                                                                                    keyword: 'type',
                                                                                                                                    params: { type: 'boolean' },
                                                                                                                                    message: 'must be boolean'
                                                                                                                                }
                                                                                                                            ];
                                                                                                                            return false;
                                                                                                                        }
                                                                                                                        var valid2 = _errs46 === errors;
                                                                                                                    }
                                                                                                                    else {
                                                                                                                        var valid2 = true;
                                                                                                                    }
                                                                                                                    if (valid2) {
                                                                                                                        if (data17.isDiscoveryFail !== undefined) {
                                                                                                                            const _errs48 = errors;
                                                                                                                            if (typeof data17.isDiscoveryFail !== 'boolean') {
                                                                                                                                validate64.errors = [
                                                                                                                                    {
                                                                                                                                        instancePath: instancePath + '/connection/isDiscoveryFail',
                                                                                                                                        schemaPath: 'urn:wisepipe-common-connection:Connection/properties/isDiscoveryFail/type',
                                                                                                                                        keyword: 'type',
                                                                                                                                        params: { type: 'boolean' },
                                                                                                                                        message: 'must be boolean'
                                                                                                                                    }
                                                                                                                                ];
                                                                                                                                return false;
                                                                                                                            }
                                                                                                                            var valid2 = _errs48 === errors;
                                                                                                                        }
                                                                                                                        else {
                                                                                                                            var valid2 = true;
                                                                                                                        }
                                                                                                                        if (valid2) {
                                                                                                                            if (data17.verificationErrorMessage !== undefined) {
                                                                                                                                const _errs50 = errors;
                                                                                                                                if (typeof data17.verificationErrorMessage !== 'string') {
                                                                                                                                    validate64.errors = [
                                                                                                                                        {
                                                                                                                                            instancePath: instancePath +
                                                                                                                                                '/connection/verificationErrorMessage',
                                                                                                                                            schemaPath: 'urn:wisepipe-common-connection:Connection/properties/verificationErrorMessage/type',
                                                                                                                                            keyword: 'type',
                                                                                                                                            params: { type: 'string' },
                                                                                                                                            message: 'must be string'
                                                                                                                                        }
                                                                                                                                    ];
                                                                                                                                    return false;
                                                                                                                                }
                                                                                                                                var valid2 = _errs50 === errors;
                                                                                                                            }
                                                                                                                            else {
                                                                                                                                var valid2 = true;
                                                                                                                            }
                                                                                                                        }
                                                                                                                    }
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                            else {
                                                                                                validate64.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/connection',
                                                                                                        schemaPath: 'urn:wisepipe-common-connection:Connection/type',
                                                                                                        keyword: 'type',
                                                                                                        params: { type: 'object' },
                                                                                                        message: 'must be object'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                        }
                                                                                        var valid0 = _errs35 === errors;
                                                                                    }
                                                                                    else {
                                                                                        var valid0 = true;
                                                                                    }
                                                                                    if (valid0) {
                                                                                        if (data.credentials !== undefined) {
                                                                                            let data25 = data.credentials;
                                                                                            const _errs52 = errors;
                                                                                            const _errs53 = errors;
                                                                                            if (errors === _errs53) {
                                                                                                if (data25 && typeof data25 == 'object' && !Array.isArray(data25)) {
                                                                                                    let missing2;
                                                                                                    if (data25.credentialsType === undefined &&
                                                                                                        (missing2 = 'credentialsType')) {
                                                                                                        validate64.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/credentials',
                                                                                                                schemaPath: 'urn:wisepipe-common:Credentials/required',
                                                                                                                keyword: 'required',
                                                                                                                params: { missingProperty: missing2 },
                                                                                                                message: "must have required property '" + missing2 + "'"
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                    else {
                                                                                                        if (data25.credentialsType !== undefined) {
                                                                                                            let data26 = data25.credentialsType;
                                                                                                            if (typeof data26 !== 'string') {
                                                                                                                validate64.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/credentials/credentialsType',
                                                                                                                        schemaPath: 'urn:wisepipe-common:Credentials/properties/credentialsType/type',
                                                                                                                        keyword: 'type',
                                                                                                                        params: { type: 'string' },
                                                                                                                        message: 'must be string'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                            if (!(data26 === 'oauth' ||
                                                                                                                data26 === 'userPassword' ||
                                                                                                                data26 === 's3Credentials' ||
                                                                                                                data26 === 'apiKey' ||
                                                                                                                data26 === 'symon' ||
                                                                                                                data26 === 'awsRoleAssumption' ||
                                                                                                                data26 === 'rest' ||
                                                                                                                data26 === 'tokenBasedAuthentication')) {
                                                                                                                validate64.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/credentials/credentialsType',
                                                                                                                        schemaPath: 'urn:wisepipe-common:Credentials/properties/credentialsType/enum',
                                                                                                                        keyword: 'enum',
                                                                                                                        params: {
                                                                                                                            allowedValues: schema42.properties.credentialsType.enum
                                                                                                                        },
                                                                                                                        message: 'must be equal to one of the allowed values'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                                else {
                                                                                                    validate64.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/credentials',
                                                                                                            schemaPath: 'urn:wisepipe-common:Credentials/type',
                                                                                                            keyword: 'type',
                                                                                                            params: { type: 'object' },
                                                                                                            message: 'must be object'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                            var valid0 = _errs52 === errors;
                                                                                        }
                                                                                        else {
                                                                                            var valid0 = true;
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate64.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate64.errors = vErrors;
    return errors === 0;
}
function validate58(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:ImportDiscoveryInput" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.discovery !== undefined) {
                const _errs1 = errors;
                if (!validate59(data.discovery, {
                    instancePath: instancePath + '/discovery',
                    parentData: data,
                    parentDataProperty: 'discovery',
                    rootData
                })) {
                    vErrors = vErrors === null ? validate59.errors : vErrors.concat(validate59.errors);
                    errors = vErrors.length;
                }
                var valid0 = _errs1 === errors;
            }
            else {
                var valid0 = true;
            }
            if (valid0) {
                if (data.discoveryEnv !== undefined) {
                    const _errs2 = errors;
                    if (!validate64(data.discoveryEnv, {
                        instancePath: instancePath + '/discoveryEnv',
                        parentData: data,
                        parentDataProperty: 'discoveryEnv',
                        rootData
                    })) {
                        vErrors = vErrors === null ? validate64.errors : vErrors.concat(validate64.errors);
                        errors = vErrors.length;
                    }
                    var valid0 = _errs2 === errors;
                }
                else {
                    var valid0 = true;
                }
            }
        }
        else {
            validate58.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate58.errors = vErrors;
    return errors === 0;
}
export const importDiscoveryRequestSchemaValidation = validate66;
const schema102 = {
    $id: 'urn:wisepipe-common-data:ImportDiscoveryRequest',
    type: 'object',
    properties: {
        importID: { type: 'string', uid: 9 },
        connectionID: { type: 'string', uid: 9 },
        importConfig: { $ref: 'urn:wisepipe-common-data:ImportConfig' }
    },
    required: ['importConfig']
};
const func230 = ucs2length;
const func231 = base64urlToBuffer;
const func232 = base64urlEncode;
const func233 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func234 = ucs2length;
const func235 = base64urlToBuffer;
const func236 = base64urlEncode;
const func237 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate66(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:ImportDiscoveryRequest" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.importConfig === undefined && (missing0 = 'importConfig')) {
                validate66.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.importID !== undefined) {
                    let data0 = data.importID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 9) / 3);
                            const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                            if (func230(data0) < b64min0 || func230(data0) > b64max0) {
                                validate66.errors = [
                                    {
                                        instancePath: instancePath + '/importID',
                                        schemaPath: '#/properties/importID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func230(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func230(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func231(data0);
                                if (decoded0.length !== 9) {
                                    validate66.errors = [
                                        {
                                            instancePath: instancePath + '/importID',
                                            schemaPath: '#/properties/importID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 9 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func232(decoded0);
                                    if (func233(encoded0) !== func233(data0)) {
                                        validate66.errors = [
                                            {
                                                instancePath: instancePath + '/importID',
                                                schemaPath: '#/properties/importID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate66.errors = [
                                {
                                    instancePath: instancePath + '/importID',
                                    schemaPath: '#/properties/importID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.connectionID !== undefined) {
                        let data1 = data.connectionID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                const b64min1 = Math.ceil((4 * 9) / 3);
                                const b64max1 = Math.ceil((4 * 9) / 3) + 3;
                                if (func234(data1) < b64min1 || func234(data1) > b64max1) {
                                    validate66.errors = [
                                        {
                                            instancePath: instancePath + '/connectionID',
                                            schemaPath: '#/properties/connectionID/uid',
                                            keyword: 'uid',
                                            params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func234(data1) },
                                            message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func234(data1)
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const decoded1 = func235(data1);
                                    if (decoded1.length !== 9) {
                                        validate66.errors = [
                                            {
                                                instancePath: instancePath + '/connectionID',
                                                schemaPath: '#/properties/connectionID/uid',
                                                keyword: 'uid',
                                                params: { error: 'decoded' },
                                                message: 'must decode to 9 bytes'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const encoded1 = func236(decoded1);
                                        if (func237(encoded1) !== func237(data1)) {
                                            validate66.errors = [
                                                {
                                                    instancePath: instancePath + '/connectionID',
                                                    schemaPath: '#/properties/connectionID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'ambiguous' },
                                                    message: 'encoding is ambiguous'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            else {
                                validate66.errors = [
                                    {
                                        instancePath: instancePath + '/connectionID',
                                        schemaPath: '#/properties/connectionID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.importConfig !== undefined) {
                            const _errs5 = errors;
                            if (!validate44(data.importConfig, {
                                instancePath: instancePath + '/importConfig',
                                parentData: data,
                                parentDataProperty: 'importConfig',
                                rootData
                            })) {
                                vErrors = vErrors === null ? validate44.errors : vErrors.concat(validate44.errors);
                                errors = vErrors.length;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate66.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate66.errors = vErrors;
    return errors === 0;
}
export const importDiscoveryTaskEnvSchemaValidation = validate64;
export const importDiscoveryTaskSchemaValidation = validate59;
export const importFileMarkedForDeletionSchemaValidation = validate68;
const schema103 = {
    $id: 'urn:wisepipe-common-data:ImportFileMarkedForDeletion',
    type: 'object',
    properties: { fileKey: { type: 'string', minLength: 1 }, expiresTimestamp: { type: 'number' } },
    required: ['fileKey', 'expiresTimestamp']
};
function validate68(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:ImportFileMarkedForDeletion" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.fileKey === undefined && (missing0 = 'fileKey')) ||
                (data.expiresTimestamp === undefined && (missing0 = 'expiresTimestamp'))) {
                validate68.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.fileKey !== undefined) {
                    let data0 = data.fileKey;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate68.errors = [
                                    {
                                        instancePath: instancePath + '/fileKey',
                                        schemaPath: '#/properties/fileKey/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate68.errors = [
                                {
                                    instancePath: instancePath + '/fileKey',
                                    schemaPath: '#/properties/fileKey/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.expiresTimestamp !== undefined) {
                        const _errs3 = errors;
                        if (!(typeof data.expiresTimestamp == 'number')) {
                            validate68.errors = [
                                {
                                    instancePath: instancePath + '/expiresTimestamp',
                                    schemaPath: '#/properties/expiresTimestamp/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate68.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate68.errors = vErrors;
    return errors === 0;
}
export const importFilterOperandSchemaValidation = validate69;
function validate69(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:ImportFilterOperand" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.operandType !== undefined) {
            if ('column' !== data.operandType) {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    let ifClause0;
    if (_valid0) {
        const _errs4 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.name === undefined && (missing0 = 'name')) {
                validate69.errors = [
                    {
                        instancePath,
                        schemaPath: '#/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs4 === errors;
        valid0 = _valid0;
        ifClause0 = 'then';
    }
    else {
        const _errs5 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if ((data.litType === undefined && (missing1 = 'litType')) ||
                (data.value === undefined && (missing1 = 'value'))) {
                validate69.errors = [
                    {
                        instancePath,
                        schemaPath: '#/else/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs5 === errors;
        valid0 = _valid0;
        ifClause0 = 'else';
    }
    if (!valid0) {
        const err1 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: ifClause0 },
            message: 'must match "' + ifClause0 + '" schema'
        };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
        validate69.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing2;
            if (data.operandType === undefined && (missing2 = 'operandType')) {
                validate69.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing2 },
                        message: "must have required property '" + missing2 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.operandType !== undefined) {
                    let data1 = data.operandType;
                    const _errs6 = errors;
                    if (typeof data1 !== 'string') {
                        validate69.errors = [
                            {
                                instancePath: instancePath + '/operandType',
                                schemaPath: '#/properties/operandType/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data1 === 'column' || data1 === 'literal')) {
                        validate69.errors = [
                            {
                                instancePath: instancePath + '/operandType',
                                schemaPath: '#/properties/operandType/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema85.properties.operandType.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid2 = _errs6 === errors;
                }
                else {
                    var valid2 = true;
                }
                if (valid2) {
                    if (data.name !== undefined) {
                        const _errs8 = errors;
                        if (typeof data.name !== 'string') {
                            validate69.errors = [
                                {
                                    instancePath: instancePath + '/name',
                                    schemaPath: '#/properties/name/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid2 = _errs8 === errors;
                    }
                    else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.litType !== undefined) {
                            let data3 = data.litType;
                            const _errs10 = errors;
                            if (typeof data3 !== 'string') {
                                validate69.errors = [
                                    {
                                        instancePath: instancePath + '/litType',
                                        schemaPath: '#/properties/litType/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            if (!(data3 === 'string' || data3 === 'number' || data3 === 'date' || data3 === 'boolean')) {
                                validate69.errors = [
                                    {
                                        instancePath: instancePath + '/litType',
                                        schemaPath: '#/properties/litType/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema85.properties.litType.enum },
                                        message: 'must be equal to one of the allowed values'
                                    }
                                ];
                                return false;
                            }
                            var valid2 = _errs10 === errors;
                        }
                        else {
                            var valid2 = true;
                        }
                        if (valid2) {
                            if (data.value !== undefined) {
                                const _errs12 = errors;
                                if (typeof data.value !== 'string') {
                                    validate69.errors = [
                                        {
                                            instancePath: instancePath + '/value',
                                            schemaPath: '#/properties/value/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                var valid2 = _errs12 === errors;
                            }
                            else {
                                var valid2 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate69.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate69.errors = vErrors;
    return errors === 0;
}
export const importFilterSchemaValidation = validate45;
export const importInputSchemaValidation = validate70;
const schema105 = {
    $id: 'urn:wisepipe-common-data:ImportInput',
    type: 'object',
    properties: {
        importTask: { $ref: 'urn:wisepipe-common-data:ImportTask' },
        importTaskEnv: { $ref: 'urn:wisepipe-common-data:ImportTaskEnv' }
    },
    required: []
};
const schema106 = {
    $id: 'urn:wisepipe-common-data:ImportTask',
    type: 'object',
    properties: {
        userID: { type: 'string', format: 'uuid' },
        userName: { type: 'string' },
        userEmail: { type: 'string' },
        orgID: { type: 'string', format: 'uuid' },
        orgPlan: { type: 'string', enum: ['Social', 'Enterprise', 'Integration', 'Temp', 'Starter', 'Professional'] },
        importID: { type: 'string', uid: 9 },
        operation: { type: 'string', enum: ['new', 'append', 'overwrite'] },
        originID: { type: 'string', uid: 9 },
        firstDataSourceID: { type: 'string', uid: 9 },
        csvExtractionFolder: { $ref: 'urn:wisepipe-common:S3File' },
        status: { type: 'string', enum: ['waiting', 'running', 'completed', 'failed', 'cancelled'] },
        startTime: { type: 'string', format: 'date-time' },
        endTime: { type: 'string', format: 'date-time' },
        error: { type: 'object' },
        isParquet: { type: 'boolean' },
        multipartCopyObjects: { type: 'array', items: { $ref: 'urn:wisepipe-common-data:MultipartCopyObject' } },
        fileSize: { type: 'number' },
        generateSampleFiles: { type: 'boolean' },
        sampleFilesGenerated: { type: 'boolean' },
        quickImport: { type: 'boolean' },
        dataCategory: { type: 'string', enum: ['dataSource', 'unitTestDataSource', 'unitTestSnapshot'] },
        importFileCopyFolder: { $ref: 'urn:wisepipe-common:S3File' },
        sourceFileName: { type: 'string' },
        isDecimalOrg: { type: 'boolean' }
    },
    if: { properties: { status: { const: 'completed' } } },
    then: { required: ['endTime'] },
    else: {
        if: { properties: { status: { const: 'cancelled' } } },
        then: { required: ['endTime'] },
        else: { if: { properties: { status: { const: 'failed' } } }, then: { required: ['error', 'endTime'] } }
    },
    required: ['userID', 'orgID', 'importID', 'operation', 'originID', 'csvExtractionFolder', 'status', 'startTime']
};
const func239 = ucs2length;
const func240 = base64urlToBuffer;
const func241 = base64urlEncode;
const func242 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func243 = ucs2length;
const func244 = base64urlToBuffer;
const func245 = base64urlEncode;
const func246 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func247 = ucs2length;
const func248 = base64urlToBuffer;
const func249 = base64urlEncode;
const func250 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func253 = ucs2length;
const func254 = base64urlToBuffer;
const func255 = base64urlEncode;
const func256 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func271 = ucs2length;
const func272 = base64urlToBuffer;
const func273 = base64urlEncode;
const func274 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const schema108 = {
    $id: 'urn:wisepipe-common-data:MultipartCopyObject',
    type: 'object',
    properties: {
        source: { $ref: 'urn:wisepipe-common:S3File' },
        destination: { $ref: 'urn:wisepipe-common:S3File' },
        fileSize: { type: 'number', minimum: 0 }
    },
    required: ['source', 'destination', 'fileSize']
};
const func259 = ucs2length;
const func260 = base64urlToBuffer;
const func261 = base64urlEncode;
const func262 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func265 = ucs2length;
const func266 = base64urlToBuffer;
const func267 = base64urlEncode;
const func268 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate72(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:MultipartCopyObject" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.source === undefined && (missing0 = 'source')) ||
                (data.destination === undefined && (missing0 = 'destination')) ||
                (data.fileSize === undefined && (missing0 = 'fileSize'))) {
                validate72.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.source !== undefined) {
                    let data0 = data.source;
                    const _errs1 = errors;
                    const _errs2 = errors;
                    if (errors === _errs2) {
                        if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                            let missing1;
                            if ((data0.bucket === undefined && (missing1 = 'bucket')) ||
                                (data0.key === undefined && (missing1 = 'key'))) {
                                validate72.errors = [
                                    {
                                        instancePath: instancePath + '/source',
                                        schemaPath: 'urn:wisepipe-common:S3File/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing1 },
                                        message: "must have required property '" + missing1 + "'"
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0.bucket !== undefined) {
                                    let data1 = data0.bucket;
                                    const _errs4 = errors;
                                    if (errors === _errs4) {
                                        if (typeof data1 === 'string') {
                                            if (func2(data1) < 1) {
                                                validate72.errors = [
                                                    {
                                                        instancePath: instancePath + '/source/bucket',
                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate72.errors = [
                                                {
                                                    instancePath: instancePath + '/source/bucket',
                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid2 = _errs4 === errors;
                                }
                                else {
                                    var valid2 = true;
                                }
                                if (valid2) {
                                    if (data0.key !== undefined) {
                                        let data2 = data0.key;
                                        const _errs6 = errors;
                                        if (errors === _errs6) {
                                            if (typeof data2 === 'string') {
                                                if (func2(data2) < 1) {
                                                    validate72.errors = [
                                                        {
                                                            instancePath: instancePath + '/source/key',
                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate72.errors = [
                                                    {
                                                        instancePath: instancePath + '/source/key',
                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid2 = _errs6 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                    if (valid2) {
                                        if (data0.uploadID !== undefined) {
                                            let data3 = data0.uploadID;
                                            const _errs8 = errors;
                                            if (errors === _errs8) {
                                                if (typeof data3 === 'string') {
                                                    const b64min0 = Math.ceil((4 * 9) / 3);
                                                    const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                                    if (func259(data3) < b64min0 || func259(data3) > b64max0) {
                                                        validate72.errors = [
                                                            {
                                                                instancePath: instancePath + '/source/uploadID',
                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                keyword: 'uid',
                                                                params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func259(data3) },
                                                                message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func259(data3)
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        const decoded0 = func260(data3);
                                                        if (decoded0.length !== 9) {
                                                            validate72.errors = [
                                                                {
                                                                    instancePath: instancePath + '/source/uploadID',
                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                    keyword: 'uid',
                                                                    params: { error: 'decoded' },
                                                                    message: 'must decode to 9 bytes'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            const encoded0 = func261(decoded0);
                                                            if (func262(encoded0) !== func262(data3)) {
                                                                validate72.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/source/uploadID',
                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                        keyword: 'uid',
                                                                        params: { error: 'ambiguous' },
                                                                        message: 'encoding is ambiguous'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate72.errors = [
                                                        {
                                                            instancePath: instancePath + '/source/uploadID',
                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid2 = _errs8 === errors;
                                        }
                                        else {
                                            var valid2 = true;
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate72.errors = [
                                {
                                    instancePath: instancePath + '/source',
                                    schemaPath: 'urn:wisepipe-common:S3File/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.destination !== undefined) {
                        let data4 = data.destination;
                        const _errs10 = errors;
                        const _errs11 = errors;
                        if (errors === _errs11) {
                            if (data4 && typeof data4 == 'object' && !Array.isArray(data4)) {
                                let missing2;
                                if ((data4.bucket === undefined && (missing2 = 'bucket')) ||
                                    (data4.key === undefined && (missing2 = 'key'))) {
                                    validate72.errors = [
                                        {
                                            instancePath: instancePath + '/destination',
                                            schemaPath: 'urn:wisepipe-common:S3File/required',
                                            keyword: 'required',
                                            params: { missingProperty: missing2 },
                                            message: "must have required property '" + missing2 + "'"
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (data4.bucket !== undefined) {
                                        let data5 = data4.bucket;
                                        const _errs13 = errors;
                                        if (errors === _errs13) {
                                            if (typeof data5 === 'string') {
                                                if (func2(data5) < 1) {
                                                    validate72.errors = [
                                                        {
                                                            instancePath: instancePath + '/destination/bucket',
                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate72.errors = [
                                                    {
                                                        instancePath: instancePath + '/destination/bucket',
                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid5 = _errs13 === errors;
                                    }
                                    else {
                                        var valid5 = true;
                                    }
                                    if (valid5) {
                                        if (data4.key !== undefined) {
                                            let data6 = data4.key;
                                            const _errs15 = errors;
                                            if (errors === _errs15) {
                                                if (typeof data6 === 'string') {
                                                    if (func2(data6) < 1) {
                                                        validate72.errors = [
                                                            {
                                                                instancePath: instancePath + '/destination/key',
                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate72.errors = [
                                                        {
                                                            instancePath: instancePath + '/destination/key',
                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid5 = _errs15 === errors;
                                        }
                                        else {
                                            var valid5 = true;
                                        }
                                        if (valid5) {
                                            if (data4.uploadID !== undefined) {
                                                let data7 = data4.uploadID;
                                                const _errs17 = errors;
                                                if (errors === _errs17) {
                                                    if (typeof data7 === 'string') {
                                                        const b64min1 = Math.ceil((4 * 9) / 3);
                                                        const b64max1 = Math.ceil((4 * 9) / 3) + 3;
                                                        if (func265(data7) < b64min1 || func265(data7) > b64max1) {
                                                            validate72.errors = [
                                                                {
                                                                    instancePath: instancePath + '/destination/uploadID',
                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                    keyword: 'uid',
                                                                    params: {
                                                                        error: 'encoded',
                                                                        b64min: b64min1,
                                                                        b64max: b64max1,
                                                                        length: func265(data7)
                                                                    },
                                                                    message: 'length must be between ' +
                                                                        b64min1 +
                                                                        ' and ' +
                                                                        b64max1 +
                                                                        ', but is ' +
                                                                        func265(data7)
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            const decoded1 = func266(data7);
                                                            if (decoded1.length !== 9) {
                                                                validate72.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/destination/uploadID',
                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                        keyword: 'uid',
                                                                        params: { error: 'decoded' },
                                                                        message: 'must decode to 9 bytes'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            else {
                                                                const encoded1 = func267(decoded1);
                                                                if (func268(encoded1) !== func268(data7)) {
                                                                    validate72.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/destination/uploadID',
                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                            keyword: 'uid',
                                                                            params: { error: 'ambiguous' },
                                                                            message: 'encoding is ambiguous'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate72.errors = [
                                                            {
                                                                instancePath: instancePath + '/destination/uploadID',
                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid5 = _errs17 === errors;
                                            }
                                            else {
                                                var valid5 = true;
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                validate72.errors = [
                                    {
                                        instancePath: instancePath + '/destination',
                                        schemaPath: 'urn:wisepipe-common:S3File/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs10 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.fileSize !== undefined) {
                            let data8 = data.fileSize;
                            const _errs19 = errors;
                            if (errors === _errs19) {
                                if (typeof data8 == 'number') {
                                    if (data8 < 0 || isNaN(data8)) {
                                        validate72.errors = [
                                            {
                                                instancePath: instancePath + '/fileSize',
                                                schemaPath: '#/properties/fileSize/minimum',
                                                keyword: 'minimum',
                                                params: { comparison: '>=', limit: 0 },
                                                message: 'must be >= 0'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate72.errors = [
                                        {
                                            instancePath: instancePath + '/fileSize',
                                            schemaPath: '#/properties/fileSize/type',
                                            keyword: 'type',
                                            params: { type: 'number' },
                                            message: 'must be number'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs19 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate72.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate72.errors = vErrors;
    return errors === 0;
}
function validate71(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:ImportTask" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.status !== undefined) {
            if ('completed' !== data.status) {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    let ifClause0;
    if (_valid0) {
        const _errs4 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.endTime === undefined && (missing0 = 'endTime')) {
                validate71.errors = [
                    {
                        instancePath,
                        schemaPath: '#/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs4 === errors;
        valid0 = _valid0;
        ifClause0 = 'then';
    }
    else {
        const _errs5 = errors;
        const _errs6 = errors;
        let valid2 = true;
        const _errs7 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.status !== undefined) {
                if ('cancelled' !== data.status) {
                    const err1 = {};
                    if (vErrors === null) {
                        vErrors = [err1];
                    }
                    else {
                        vErrors.push(err1);
                    }
                    errors++;
                }
            }
        }
        var _valid1 = _errs7 === errors;
        errors = _errs6;
        if (vErrors !== null) {
            if (_errs6) {
                vErrors.length = _errs6;
            }
            else {
                vErrors = null;
            }
        }
        let ifClause1;
        if (_valid1) {
            const _errs9 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                let missing1;
                if (data.endTime === undefined && (missing1 = 'endTime')) {
                    validate71.errors = [
                        {
                            instancePath,
                            schemaPath: '#/else/then/required',
                            keyword: 'required',
                            params: { missingProperty: missing1 },
                            message: "must have required property '" + missing1 + "'"
                        }
                    ];
                    return false;
                }
            }
            var _valid1 = _errs9 === errors;
            valid2 = _valid1;
            ifClause1 = 'then';
        }
        else {
            const _errs10 = errors;
            const _errs11 = errors;
            let valid4 = true;
            const _errs12 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                if (data.status !== undefined) {
                    if ('failed' !== data.status) {
                        const err2 = {};
                        if (vErrors === null) {
                            vErrors = [err2];
                        }
                        else {
                            vErrors.push(err2);
                        }
                        errors++;
                    }
                }
            }
            var _valid2 = _errs12 === errors;
            errors = _errs11;
            if (vErrors !== null) {
                if (_errs11) {
                    vErrors.length = _errs11;
                }
                else {
                    vErrors = null;
                }
            }
            if (_valid2) {
                const _errs14 = errors;
                if (data && typeof data == 'object' && !Array.isArray(data)) {
                    let missing2;
                    if ((data.error === undefined && (missing2 = 'error')) ||
                        (data.endTime === undefined && (missing2 = 'endTime'))) {
                        validate71.errors = [
                            {
                                instancePath,
                                schemaPath: '#/else/else/then/required',
                                keyword: 'required',
                                params: { missingProperty: missing2 },
                                message: "must have required property '" + missing2 + "'"
                            }
                        ];
                        return false;
                    }
                }
                var _valid2 = _errs14 === errors;
                valid4 = _valid2;
            }
            if (!valid4) {
                const err3 = {
                    instancePath,
                    schemaPath: '#/else/else/if',
                    keyword: 'if',
                    params: { failingKeyword: 'then' },
                    message: 'must match "then" schema'
                };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
                validate71.errors = vErrors;
                return false;
            }
            var _valid1 = _errs10 === errors;
            valid2 = _valid1;
            ifClause1 = 'else';
        }
        if (!valid2) {
            const err4 = {
                instancePath,
                schemaPath: '#/else/if',
                keyword: 'if',
                params: { failingKeyword: ifClause1 },
                message: 'must match "' + ifClause1 + '" schema'
            };
            if (vErrors === null) {
                vErrors = [err4];
            }
            else {
                vErrors.push(err4);
            }
            errors++;
            validate71.errors = vErrors;
            return false;
        }
        var _valid0 = _errs5 === errors;
        valid0 = _valid0;
        ifClause0 = 'else';
    }
    if (!valid0) {
        const err5 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: ifClause0 },
            message: 'must match "' + ifClause0 + '" schema'
        };
        if (vErrors === null) {
            vErrors = [err5];
        }
        else {
            vErrors.push(err5);
        }
        errors++;
        validate71.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing3;
            if ((data.userID === undefined && (missing3 = 'userID')) ||
                (data.orgID === undefined && (missing3 = 'orgID')) ||
                (data.importID === undefined && (missing3 = 'importID')) ||
                (data.operation === undefined && (missing3 = 'operation')) ||
                (data.originID === undefined && (missing3 = 'originID')) ||
                (data.csvExtractionFolder === undefined && (missing3 = 'csvExtractionFolder')) ||
                (data.status === undefined && (missing3 = 'status')) ||
                (data.startTime === undefined && (missing3 = 'startTime'))) {
                validate71.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing3 },
                        message: "must have required property '" + missing3 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.userID !== undefined) {
                    let data3 = data.userID;
                    const _errs15 = errors;
                    if (errors === _errs15) {
                        if (errors === _errs15) {
                            if (typeof data3 === 'string') {
                                if (!formats4.test(data3)) {
                                    validate71.errors = [
                                        {
                                            instancePath: instancePath + '/userID',
                                            schemaPath: '#/properties/userID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate71.errors = [
                                    {
                                        instancePath: instancePath + '/userID',
                                        schemaPath: '#/properties/userID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid6 = _errs15 === errors;
                }
                else {
                    var valid6 = true;
                }
                if (valid6) {
                    if (data.userName !== undefined) {
                        const _errs17 = errors;
                        if (typeof data.userName !== 'string') {
                            validate71.errors = [
                                {
                                    instancePath: instancePath + '/userName',
                                    schemaPath: '#/properties/userName/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid6 = _errs17 === errors;
                    }
                    else {
                        var valid6 = true;
                    }
                    if (valid6) {
                        if (data.userEmail !== undefined) {
                            const _errs19 = errors;
                            if (typeof data.userEmail !== 'string') {
                                validate71.errors = [
                                    {
                                        instancePath: instancePath + '/userEmail',
                                        schemaPath: '#/properties/userEmail/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            var valid6 = _errs19 === errors;
                        }
                        else {
                            var valid6 = true;
                        }
                        if (valid6) {
                            if (data.orgID !== undefined) {
                                let data6 = data.orgID;
                                const _errs21 = errors;
                                if (errors === _errs21) {
                                    if (errors === _errs21) {
                                        if (typeof data6 === 'string') {
                                            if (!formats4.test(data6)) {
                                                validate71.errors = [
                                                    {
                                                        instancePath: instancePath + '/orgID',
                                                        schemaPath: '#/properties/orgID/format',
                                                        keyword: 'format',
                                                        params: { format: 'uuid' },
                                                        message: 'must match format "' + 'uuid' + '"'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate71.errors = [
                                                {
                                                    instancePath: instancePath + '/orgID',
                                                    schemaPath: '#/properties/orgID/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                var valid6 = _errs21 === errors;
                            }
                            else {
                                var valid6 = true;
                            }
                            if (valid6) {
                                if (data.orgPlan !== undefined) {
                                    let data7 = data.orgPlan;
                                    const _errs23 = errors;
                                    if (typeof data7 !== 'string') {
                                        validate71.errors = [
                                            {
                                                instancePath: instancePath + '/orgPlan',
                                                schemaPath: '#/properties/orgPlan/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    if (!(data7 === 'Social' ||
                                        data7 === 'Enterprise' ||
                                        data7 === 'Integration' ||
                                        data7 === 'Temp' ||
                                        data7 === 'Starter' ||
                                        data7 === 'Professional')) {
                                        validate71.errors = [
                                            {
                                                instancePath: instancePath + '/orgPlan',
                                                schemaPath: '#/properties/orgPlan/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema106.properties.orgPlan.enum },
                                                message: 'must be equal to one of the allowed values'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid6 = _errs23 === errors;
                                }
                                else {
                                    var valid6 = true;
                                }
                                if (valid6) {
                                    if (data.importID !== undefined) {
                                        let data8 = data.importID;
                                        const _errs25 = errors;
                                        if (errors === _errs25) {
                                            if (typeof data8 === 'string') {
                                                const b64min0 = Math.ceil((4 * 9) / 3);
                                                const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                                if (func239(data8) < b64min0 || func239(data8) > b64max0) {
                                                    validate71.errors = [
                                                        {
                                                            instancePath: instancePath + '/importID',
                                                            schemaPath: '#/properties/importID/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func239(data8) },
                                                            message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func239(data8)
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    const decoded0 = func240(data8);
                                                    if (decoded0.length !== 9) {
                                                        validate71.errors = [
                                                            {
                                                                instancePath: instancePath + '/importID',
                                                                schemaPath: '#/properties/importID/uid',
                                                                keyword: 'uid',
                                                                params: { error: 'decoded' },
                                                                message: 'must decode to 9 bytes'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        const encoded0 = func241(decoded0);
                                                        if (func242(encoded0) !== func242(data8)) {
                                                            validate71.errors = [
                                                                {
                                                                    instancePath: instancePath + '/importID',
                                                                    schemaPath: '#/properties/importID/uid',
                                                                    keyword: 'uid',
                                                                    params: { error: 'ambiguous' },
                                                                    message: 'encoding is ambiguous'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate71.errors = [
                                                    {
                                                        instancePath: instancePath + '/importID',
                                                        schemaPath: '#/properties/importID/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid6 = _errs25 === errors;
                                    }
                                    else {
                                        var valid6 = true;
                                    }
                                    if (valid6) {
                                        if (data.operation !== undefined) {
                                            let data9 = data.operation;
                                            const _errs27 = errors;
                                            if (typeof data9 !== 'string') {
                                                validate71.errors = [
                                                    {
                                                        instancePath: instancePath + '/operation',
                                                        schemaPath: '#/properties/operation/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                            if (!(data9 === 'new' || data9 === 'append' || data9 === 'overwrite')) {
                                                validate71.errors = [
                                                    {
                                                        instancePath: instancePath + '/operation',
                                                        schemaPath: '#/properties/operation/enum',
                                                        keyword: 'enum',
                                                        params: { allowedValues: schema106.properties.operation.enum },
                                                        message: 'must be equal to one of the allowed values'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid6 = _errs27 === errors;
                                        }
                                        else {
                                            var valid6 = true;
                                        }
                                        if (valid6) {
                                            if (data.originID !== undefined) {
                                                let data10 = data.originID;
                                                const _errs29 = errors;
                                                if (errors === _errs29) {
                                                    if (typeof data10 === 'string') {
                                                        const b64min1 = Math.ceil((4 * 9) / 3);
                                                        const b64max1 = Math.ceil((4 * 9) / 3) + 3;
                                                        if (func243(data10) < b64min1 || func243(data10) > b64max1) {
                                                            validate71.errors = [
                                                                {
                                                                    instancePath: instancePath + '/originID',
                                                                    schemaPath: '#/properties/originID/uid',
                                                                    keyword: 'uid',
                                                                    params: {
                                                                        error: 'encoded',
                                                                        b64min: b64min1,
                                                                        b64max: b64max1,
                                                                        length: func243(data10)
                                                                    },
                                                                    message: 'length must be between ' +
                                                                        b64min1 +
                                                                        ' and ' +
                                                                        b64max1 +
                                                                        ', but is ' +
                                                                        func243(data10)
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            const decoded1 = func244(data10);
                                                            if (decoded1.length !== 9) {
                                                                validate71.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/originID',
                                                                        schemaPath: '#/properties/originID/uid',
                                                                        keyword: 'uid',
                                                                        params: { error: 'decoded' },
                                                                        message: 'must decode to 9 bytes'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            else {
                                                                const encoded1 = func245(decoded1);
                                                                if (func246(encoded1) !== func246(data10)) {
                                                                    validate71.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/originID',
                                                                            schemaPath: '#/properties/originID/uid',
                                                                            keyword: 'uid',
                                                                            params: { error: 'ambiguous' },
                                                                            message: 'encoding is ambiguous'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate71.errors = [
                                                            {
                                                                instancePath: instancePath + '/originID',
                                                                schemaPath: '#/properties/originID/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid6 = _errs29 === errors;
                                            }
                                            else {
                                                var valid6 = true;
                                            }
                                            if (valid6) {
                                                if (data.firstDataSourceID !== undefined) {
                                                    let data11 = data.firstDataSourceID;
                                                    const _errs31 = errors;
                                                    if (errors === _errs31) {
                                                        if (typeof data11 === 'string') {
                                                            const b64min2 = Math.ceil((4 * 9) / 3);
                                                            const b64max2 = Math.ceil((4 * 9) / 3) + 3;
                                                            if (func247(data11) < b64min2 || func247(data11) > b64max2) {
                                                                validate71.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/firstDataSourceID',
                                                                        schemaPath: '#/properties/firstDataSourceID/uid',
                                                                        keyword: 'uid',
                                                                        params: {
                                                                            error: 'encoded',
                                                                            b64min: b64min2,
                                                                            b64max: b64max2,
                                                                            length: func247(data11)
                                                                        },
                                                                        message: 'length must be between ' +
                                                                            b64min2 +
                                                                            ' and ' +
                                                                            b64max2 +
                                                                            ', but is ' +
                                                                            func247(data11)
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            else {
                                                                const decoded2 = func248(data11);
                                                                if (decoded2.length !== 9) {
                                                                    validate71.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/firstDataSourceID',
                                                                            schemaPath: '#/properties/firstDataSourceID/uid',
                                                                            keyword: 'uid',
                                                                            params: { error: 'decoded' },
                                                                            message: 'must decode to 9 bytes'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                else {
                                                                    const encoded2 = func249(decoded2);
                                                                    if (func250(encoded2) !== func250(data11)) {
                                                                        validate71.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/firstDataSourceID',
                                                                                schemaPath: '#/properties/firstDataSourceID/uid',
                                                                                keyword: 'uid',
                                                                                params: { error: 'ambiguous' },
                                                                                message: 'encoding is ambiguous'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                        else {
                                                            validate71.errors = [
                                                                {
                                                                    instancePath: instancePath + '/firstDataSourceID',
                                                                    schemaPath: '#/properties/firstDataSourceID/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid6 = _errs31 === errors;
                                                }
                                                else {
                                                    var valid6 = true;
                                                }
                                                if (valid6) {
                                                    if (data.csvExtractionFolder !== undefined) {
                                                        let data12 = data.csvExtractionFolder;
                                                        const _errs33 = errors;
                                                        const _errs34 = errors;
                                                        if (errors === _errs34) {
                                                            if (data12 && typeof data12 == 'object' && !Array.isArray(data12)) {
                                                                let missing4;
                                                                if ((data12.bucket === undefined && (missing4 = 'bucket')) ||
                                                                    (data12.key === undefined && (missing4 = 'key'))) {
                                                                    validate71.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/csvExtractionFolder',
                                                                            schemaPath: 'urn:wisepipe-common:S3File/required',
                                                                            keyword: 'required',
                                                                            params: { missingProperty: missing4 },
                                                                            message: "must have required property '" + missing4 + "'"
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                else {
                                                                    if (data12.bucket !== undefined) {
                                                                        let data13 = data12.bucket;
                                                                        const _errs36 = errors;
                                                                        if (errors === _errs36) {
                                                                            if (typeof data13 === 'string') {
                                                                                if (func2(data13) < 1) {
                                                                                    validate71.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/csvExtractionFolder/bucket',
                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                                                            keyword: 'minLength',
                                                                                            params: { limit: 1 },
                                                                                            message: 'must NOT have fewer than 1 characters'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            else {
                                                                                validate71.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/csvExtractionFolder/bucket',
                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        var valid11 = _errs36 === errors;
                                                                    }
                                                                    else {
                                                                        var valid11 = true;
                                                                    }
                                                                    if (valid11) {
                                                                        if (data12.key !== undefined) {
                                                                            let data14 = data12.key;
                                                                            const _errs38 = errors;
                                                                            if (errors === _errs38) {
                                                                                if (typeof data14 === 'string') {
                                                                                    if (func2(data14) < 1) {
                                                                                        validate71.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/csvExtractionFolder/key',
                                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                                                                keyword: 'minLength',
                                                                                                params: { limit: 1 },
                                                                                                message: 'must NOT have fewer than 1 characters'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    validate71.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/csvExtractionFolder/key',
                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'string' },
                                                                                            message: 'must be string'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            var valid11 = _errs38 === errors;
                                                                        }
                                                                        else {
                                                                            var valid11 = true;
                                                                        }
                                                                        if (valid11) {
                                                                            if (data12.uploadID !== undefined) {
                                                                                let data15 = data12.uploadID;
                                                                                const _errs40 = errors;
                                                                                if (errors === _errs40) {
                                                                                    if (typeof data15 === 'string') {
                                                                                        const b64min3 = Math.ceil((4 * 9) / 3);
                                                                                        const b64max3 = Math.ceil((4 * 9) / 3) + 3;
                                                                                        if (func253(data15) < b64min3 || func253(data15) > b64max3) {
                                                                                            validate71.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/csvExtractionFolder/uploadID',
                                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                    keyword: 'uid',
                                                                                                    params: {
                                                                                                        error: 'encoded',
                                                                                                        b64min: b64min3,
                                                                                                        b64max: b64max3,
                                                                                                        length: func253(data15)
                                                                                                    },
                                                                                                    message: 'length must be between ' +
                                                                                                        b64min3 +
                                                                                                        ' and ' +
                                                                                                        b64max3 +
                                                                                                        ', but is ' +
                                                                                                        func253(data15)
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                        else {
                                                                                            const decoded3 = func254(data15);
                                                                                            if (decoded3.length !== 9) {
                                                                                                validate71.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/csvExtractionFolder/uploadID',
                                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                        keyword: 'uid',
                                                                                                        params: { error: 'decoded' },
                                                                                                        message: 'must decode to 9 bytes'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                            else {
                                                                                                const encoded3 = func255(decoded3);
                                                                                                if (func256(encoded3) !== func256(data15)) {
                                                                                                    validate71.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/csvExtractionFolder/uploadID',
                                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                            keyword: 'uid',
                                                                                                            params: { error: 'ambiguous' },
                                                                                                            message: 'encoding is ambiguous'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                    else {
                                                                                        validate71.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/csvExtractionFolder/uploadID',
                                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'string' },
                                                                                                message: 'must be string'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                var valid11 = _errs40 === errors;
                                                                            }
                                                                            else {
                                                                                var valid11 = true;
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                            else {
                                                                validate71.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/csvExtractionFolder',
                                                                        schemaPath: 'urn:wisepipe-common:S3File/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'object' },
                                                                        message: 'must be object'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid6 = _errs33 === errors;
                                                    }
                                                    else {
                                                        var valid6 = true;
                                                    }
                                                    if (valid6) {
                                                        if (data.status !== undefined) {
                                                            let data16 = data.status;
                                                            const _errs42 = errors;
                                                            if (typeof data16 !== 'string') {
                                                                validate71.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/status',
                                                                        schemaPath: '#/properties/status/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            if (!(data16 === 'waiting' ||
                                                                data16 === 'running' ||
                                                                data16 === 'completed' ||
                                                                data16 === 'failed' ||
                                                                data16 === 'cancelled')) {
                                                                validate71.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/status',
                                                                        schemaPath: '#/properties/status/enum',
                                                                        keyword: 'enum',
                                                                        params: { allowedValues: schema106.properties.status.enum },
                                                                        message: 'must be equal to one of the allowed values'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid6 = _errs42 === errors;
                                                        }
                                                        else {
                                                            var valid6 = true;
                                                        }
                                                        if (valid6) {
                                                            if (data.startTime !== undefined) {
                                                                let data17 = data.startTime;
                                                                const _errs44 = errors;
                                                                if (errors === _errs44) {
                                                                    if (errors === _errs44) {
                                                                        if (typeof data17 === 'string') {
                                                                            if (!formats0.validate(data17)) {
                                                                                validate71.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/startTime',
                                                                                        schemaPath: '#/properties/startTime/format',
                                                                                        keyword: 'format',
                                                                                        params: { format: 'date-time' },
                                                                                        message: 'must match format "' + 'date-time' + '"'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        else {
                                                                            validate71.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/startTime',
                                                                                    schemaPath: '#/properties/startTime/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'string' },
                                                                                    message: 'must be string'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                }
                                                                var valid6 = _errs44 === errors;
                                                            }
                                                            else {
                                                                var valid6 = true;
                                                            }
                                                            if (valid6) {
                                                                if (data.endTime !== undefined) {
                                                                    let data18 = data.endTime;
                                                                    const _errs46 = errors;
                                                                    if (errors === _errs46) {
                                                                        if (errors === _errs46) {
                                                                            if (typeof data18 === 'string') {
                                                                                if (!formats0.validate(data18)) {
                                                                                    validate71.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/endTime',
                                                                                            schemaPath: '#/properties/endTime/format',
                                                                                            keyword: 'format',
                                                                                            params: { format: 'date-time' },
                                                                                            message: 'must match format "' + 'date-time' + '"'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            else {
                                                                                validate71.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/endTime',
                                                                                        schemaPath: '#/properties/endTime/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                    }
                                                                    var valid6 = _errs46 === errors;
                                                                }
                                                                else {
                                                                    var valid6 = true;
                                                                }
                                                                if (valid6) {
                                                                    if (data.error !== undefined) {
                                                                        let data19 = data.error;
                                                                        const _errs48 = errors;
                                                                        if (!(data19 && typeof data19 == 'object' && !Array.isArray(data19))) {
                                                                            validate71.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/error',
                                                                                    schemaPath: '#/properties/error/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'object' },
                                                                                    message: 'must be object'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        var valid6 = _errs48 === errors;
                                                                    }
                                                                    else {
                                                                        var valid6 = true;
                                                                    }
                                                                    if (valid6) {
                                                                        if (data.isParquet !== undefined) {
                                                                            const _errs50 = errors;
                                                                            if (typeof data.isParquet !== 'boolean') {
                                                                                validate71.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/isParquet',
                                                                                        schemaPath: '#/properties/isParquet/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'boolean' },
                                                                                        message: 'must be boolean'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            var valid6 = _errs50 === errors;
                                                                        }
                                                                        else {
                                                                            var valid6 = true;
                                                                        }
                                                                        if (valid6) {
                                                                            if (data.multipartCopyObjects !== undefined) {
                                                                                let data21 = data.multipartCopyObjects;
                                                                                const _errs52 = errors;
                                                                                if (errors === _errs52) {
                                                                                    if (Array.isArray(data21)) {
                                                                                        var valid13 = true;
                                                                                        const len0 = data21.length;
                                                                                        for (let i0 = 0; i0 < len0; i0++) {
                                                                                            const _errs54 = errors;
                                                                                            if (!validate72(data21[i0], {
                                                                                                instancePath: instancePath + '/multipartCopyObjects/' + i0,
                                                                                                parentData: data21,
                                                                                                parentDataProperty: i0,
                                                                                                rootData
                                                                                            })) {
                                                                                                vErrors =
                                                                                                    vErrors === null
                                                                                                        ? validate72.errors
                                                                                                        : vErrors.concat(validate72.errors);
                                                                                                errors = vErrors.length;
                                                                                            }
                                                                                            var valid13 = _errs54 === errors;
                                                                                            if (!valid13) {
                                                                                                break;
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                    else {
                                                                                        validate71.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/multipartCopyObjects',
                                                                                                schemaPath: '#/properties/multipartCopyObjects/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'array' },
                                                                                                message: 'must be array'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                var valid6 = _errs52 === errors;
                                                                            }
                                                                            else {
                                                                                var valid6 = true;
                                                                            }
                                                                            if (valid6) {
                                                                                if (data.fileSize !== undefined) {
                                                                                    const _errs55 = errors;
                                                                                    if (!(typeof data.fileSize == 'number')) {
                                                                                        validate71.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/fileSize',
                                                                                                schemaPath: '#/properties/fileSize/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'number' },
                                                                                                message: 'must be number'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                    var valid6 = _errs55 === errors;
                                                                                }
                                                                                else {
                                                                                    var valid6 = true;
                                                                                }
                                                                                if (valid6) {
                                                                                    if (data.generateSampleFiles !== undefined) {
                                                                                        const _errs57 = errors;
                                                                                        if (typeof data.generateSampleFiles !== 'boolean') {
                                                                                            validate71.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/generateSampleFiles',
                                                                                                    schemaPath: '#/properties/generateSampleFiles/type',
                                                                                                    keyword: 'type',
                                                                                                    params: { type: 'boolean' },
                                                                                                    message: 'must be boolean'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                        var valid6 = _errs57 === errors;
                                                                                    }
                                                                                    else {
                                                                                        var valid6 = true;
                                                                                    }
                                                                                    if (valid6) {
                                                                                        if (data.sampleFilesGenerated !== undefined) {
                                                                                            const _errs59 = errors;
                                                                                            if (typeof data.sampleFilesGenerated !== 'boolean') {
                                                                                                validate71.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/sampleFilesGenerated',
                                                                                                        schemaPath: '#/properties/sampleFilesGenerated/type',
                                                                                                        keyword: 'type',
                                                                                                        params: { type: 'boolean' },
                                                                                                        message: 'must be boolean'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                            var valid6 = _errs59 === errors;
                                                                                        }
                                                                                        else {
                                                                                            var valid6 = true;
                                                                                        }
                                                                                        if (valid6) {
                                                                                            if (data.quickImport !== undefined) {
                                                                                                const _errs61 = errors;
                                                                                                if (typeof data.quickImport !== 'boolean') {
                                                                                                    validate71.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/quickImport',
                                                                                                            schemaPath: '#/properties/quickImport/type',
                                                                                                            keyword: 'type',
                                                                                                            params: { type: 'boolean' },
                                                                                                            message: 'must be boolean'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                                var valid6 = _errs61 === errors;
                                                                                            }
                                                                                            else {
                                                                                                var valid6 = true;
                                                                                            }
                                                                                            if (valid6) {
                                                                                                if (data.dataCategory !== undefined) {
                                                                                                    let data27 = data.dataCategory;
                                                                                                    const _errs63 = errors;
                                                                                                    if (typeof data27 !== 'string') {
                                                                                                        validate71.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/dataCategory',
                                                                                                                schemaPath: '#/properties/dataCategory/type',
                                                                                                                keyword: 'type',
                                                                                                                params: { type: 'string' },
                                                                                                                message: 'must be string'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                    if (!(data27 === 'dataSource' ||
                                                                                                        data27 === 'unitTestDataSource' ||
                                                                                                        data27 === 'unitTestSnapshot')) {
                                                                                                        validate71.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/dataCategory',
                                                                                                                schemaPath: '#/properties/dataCategory/enum',
                                                                                                                keyword: 'enum',
                                                                                                                params: {
                                                                                                                    allowedValues: schema106.properties.dataCategory.enum
                                                                                                                },
                                                                                                                message: 'must be equal to one of the allowed values'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                    var valid6 = _errs63 === errors;
                                                                                                }
                                                                                                else {
                                                                                                    var valid6 = true;
                                                                                                }
                                                                                                if (valid6) {
                                                                                                    if (data.importFileCopyFolder !== undefined) {
                                                                                                        let data28 = data.importFileCopyFolder;
                                                                                                        const _errs65 = errors;
                                                                                                        const _errs66 = errors;
                                                                                                        if (errors === _errs66) {
                                                                                                            if (data28 &&
                                                                                                                typeof data28 == 'object' &&
                                                                                                                !Array.isArray(data28)) {
                                                                                                                let missing5;
                                                                                                                if ((data28.bucket === undefined && (missing5 = 'bucket')) ||
                                                                                                                    (data28.key === undefined && (missing5 = 'key'))) {
                                                                                                                    validate71.errors = [
                                                                                                                        {
                                                                                                                            instancePath: instancePath + '/importFileCopyFolder',
                                                                                                                            schemaPath: 'urn:wisepipe-common:S3File/required',
                                                                                                                            keyword: 'required',
                                                                                                                            params: { missingProperty: missing5 },
                                                                                                                            message: "must have required property '" + missing5 + "'"
                                                                                                                        }
                                                                                                                    ];
                                                                                                                    return false;
                                                                                                                }
                                                                                                                else {
                                                                                                                    if (data28.bucket !== undefined) {
                                                                                                                        let data29 = data28.bucket;
                                                                                                                        const _errs68 = errors;
                                                                                                                        if (errors === _errs68) {
                                                                                                                            if (typeof data29 === 'string') {
                                                                                                                                if (func2(data29) < 1) {
                                                                                                                                    validate71.errors = [
                                                                                                                                        {
                                                                                                                                            instancePath: instancePath + '/importFileCopyFolder/bucket',
                                                                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                                                                                                            keyword: 'minLength',
                                                                                                                                            params: { limit: 1 },
                                                                                                                                            message: 'must NOT have fewer than 1 characters'
                                                                                                                                        }
                                                                                                                                    ];
                                                                                                                                    return false;
                                                                                                                                }
                                                                                                                            }
                                                                                                                            else {
                                                                                                                                validate71.errors = [
                                                                                                                                    {
                                                                                                                                        instancePath: instancePath + '/importFileCopyFolder/bucket',
                                                                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                                                                                                        keyword: 'type',
                                                                                                                                        params: { type: 'string' },
                                                                                                                                        message: 'must be string'
                                                                                                                                    }
                                                                                                                                ];
                                                                                                                                return false;
                                                                                                                            }
                                                                                                                        }
                                                                                                                        var valid15 = _errs68 === errors;
                                                                                                                    }
                                                                                                                    else {
                                                                                                                        var valid15 = true;
                                                                                                                    }
                                                                                                                    if (valid15) {
                                                                                                                        if (data28.key !== undefined) {
                                                                                                                            let data30 = data28.key;
                                                                                                                            const _errs70 = errors;
                                                                                                                            if (errors === _errs70) {
                                                                                                                                if (typeof data30 === 'string') {
                                                                                                                                    if (func2(data30) < 1) {
                                                                                                                                        validate71.errors = [
                                                                                                                                            {
                                                                                                                                                instancePath: instancePath + '/importFileCopyFolder/key',
                                                                                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                                                                                                                keyword: 'minLength',
                                                                                                                                                params: { limit: 1 },
                                                                                                                                                message: 'must NOT have fewer than 1 characters'
                                                                                                                                            }
                                                                                                                                        ];
                                                                                                                                        return false;
                                                                                                                                    }
                                                                                                                                }
                                                                                                                                else {
                                                                                                                                    validate71.errors = [
                                                                                                                                        {
                                                                                                                                            instancePath: instancePath + '/importFileCopyFolder/key',
                                                                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                                                                                                            keyword: 'type',
                                                                                                                                            params: { type: 'string' },
                                                                                                                                            message: 'must be string'
                                                                                                                                        }
                                                                                                                                    ];
                                                                                                                                    return false;
                                                                                                                                }
                                                                                                                            }
                                                                                                                            var valid15 = _errs70 === errors;
                                                                                                                        }
                                                                                                                        else {
                                                                                                                            var valid15 = true;
                                                                                                                        }
                                                                                                                        if (valid15) {
                                                                                                                            if (data28.uploadID !== undefined) {
                                                                                                                                let data31 = data28.uploadID;
                                                                                                                                const _errs72 = errors;
                                                                                                                                if (errors === _errs72) {
                                                                                                                                    if (typeof data31 === 'string') {
                                                                                                                                        const b64min4 = Math.ceil((4 * 9) / 3);
                                                                                                                                        const b64max4 = Math.ceil((4 * 9) / 3) + 3;
                                                                                                                                        if (func271(data31) < b64min4 ||
                                                                                                                                            func271(data31) > b64max4) {
                                                                                                                                            validate71.errors = [
                                                                                                                                                {
                                                                                                                                                    instancePath: instancePath +
                                                                                                                                                        '/importFileCopyFolder/uploadID',
                                                                                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                                                                    keyword: 'uid',
                                                                                                                                                    params: {
                                                                                                                                                        error: 'encoded',
                                                                                                                                                        b64min: b64min4,
                                                                                                                                                        b64max: b64max4,
                                                                                                                                                        length: func271(data31)
                                                                                                                                                    },
                                                                                                                                                    message: 'length must be between ' +
                                                                                                                                                        b64min4 +
                                                                                                                                                        ' and ' +
                                                                                                                                                        b64max4 +
                                                                                                                                                        ', but is ' +
                                                                                                                                                        func271(data31)
                                                                                                                                                }
                                                                                                                                            ];
                                                                                                                                            return false;
                                                                                                                                        }
                                                                                                                                        else {
                                                                                                                                            const decoded4 = func272(data31);
                                                                                                                                            if (decoded4.length !== 9) {
                                                                                                                                                validate71.errors = [
                                                                                                                                                    {
                                                                                                                                                        instancePath: instancePath +
                                                                                                                                                            '/importFileCopyFolder/uploadID',
                                                                                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                                                                        keyword: 'uid',
                                                                                                                                                        params: { error: 'decoded' },
                                                                                                                                                        message: 'must decode to 9 bytes'
                                                                                                                                                    }
                                                                                                                                                ];
                                                                                                                                                return false;
                                                                                                                                            }
                                                                                                                                            else {
                                                                                                                                                const encoded4 = func273(decoded4);
                                                                                                                                                if (func274(encoded4) !== func274(data31)) {
                                                                                                                                                    validate71.errors = [
                                                                                                                                                        {
                                                                                                                                                            instancePath: instancePath +
                                                                                                                                                                '/importFileCopyFolder/uploadID',
                                                                                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                                                                            keyword: 'uid',
                                                                                                                                                            params: { error: 'ambiguous' },
                                                                                                                                                            message: 'encoding is ambiguous'
                                                                                                                                                        }
                                                                                                                                                    ];
                                                                                                                                                    return false;
                                                                                                                                                }
                                                                                                                                            }
                                                                                                                                        }
                                                                                                                                    }
                                                                                                                                    else {
                                                                                                                                        validate71.errors = [
                                                                                                                                            {
                                                                                                                                                instancePath: instancePath +
                                                                                                                                                    '/importFileCopyFolder/uploadID',
                                                                                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                                                                                                                keyword: 'type',
                                                                                                                                                params: { type: 'string' },
                                                                                                                                                message: 'must be string'
                                                                                                                                            }
                                                                                                                                        ];
                                                                                                                                        return false;
                                                                                                                                    }
                                                                                                                                }
                                                                                                                                var valid15 = _errs72 === errors;
                                                                                                                            }
                                                                                                                            else {
                                                                                                                                var valid15 = true;
                                                                                                                            }
                                                                                                                        }
                                                                                                                    }
                                                                                                                }
                                                                                                            }
                                                                                                            else {
                                                                                                                validate71.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/importFileCopyFolder',
                                                                                                                        schemaPath: 'urn:wisepipe-common:S3File/type',
                                                                                                                        keyword: 'type',
                                                                                                                        params: { type: 'object' },
                                                                                                                        message: 'must be object'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                        }
                                                                                                        var valid6 = _errs65 === errors;
                                                                                                    }
                                                                                                    else {
                                                                                                        var valid6 = true;
                                                                                                    }
                                                                                                    if (valid6) {
                                                                                                        if (data.sourceFileName !== undefined) {
                                                                                                            const _errs74 = errors;
                                                                                                            if (typeof data.sourceFileName !== 'string') {
                                                                                                                validate71.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/sourceFileName',
                                                                                                                        schemaPath: '#/properties/sourceFileName/type',
                                                                                                                        keyword: 'type',
                                                                                                                        params: { type: 'string' },
                                                                                                                        message: 'must be string'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                            var valid6 = _errs74 === errors;
                                                                                                        }
                                                                                                        else {
                                                                                                            var valid6 = true;
                                                                                                        }
                                                                                                        if (valid6) {
                                                                                                            if (data.isDecimalOrg !== undefined) {
                                                                                                                const _errs76 = errors;
                                                                                                                if (typeof data.isDecimalOrg !== 'boolean') {
                                                                                                                    validate71.errors = [
                                                                                                                        {
                                                                                                                            instancePath: instancePath + '/isDecimalOrg',
                                                                                                                            schemaPath: '#/properties/isDecimalOrg/type',
                                                                                                                            keyword: 'type',
                                                                                                                            params: { type: 'boolean' },
                                                                                                                            message: 'must be boolean'
                                                                                                                        }
                                                                                                                    ];
                                                                                                                    return false;
                                                                                                                }
                                                                                                                var valid6 = _errs76 === errors;
                                                                                                            }
                                                                                                            else {
                                                                                                                var valid6 = true;
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate71.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate71.errors = vErrors;
    return errors === 0;
}
const schema112 = {
    $id: 'urn:wisepipe-common-data:ImportTaskEnv',
    type: 'object',
    properties: {
        stage: { type: 'string', minLength: 1 },
        apiUrl: { type: 'string', format: 'uri' },
        s3DataBucket: { type: 'string', minLength: 1 },
        googleClientIDParam: { type: 'string', minLength: 1 },
        googleClientSecretParam: { type: 'string', minLength: 1 },
        googleSheetsImportClientIDParam: { type: 'string', minLength: 1 },
        googleSheetsImportClientSecretParam: { type: 'string', minLength: 1 },
        googleAdWordsDevTokenParam: { type: 'string', minLength: 1 },
        salesforceClientIDParam: { type: 'string', minLength: 1 },
        salesforceClientSecretParam: { type: 'string', minLength: 1 },
        hubspotClientIDParam: { type: 'string', minLength: 1 },
        hubspotClientSecretParam: { type: 'string', minLength: 1 },
        dynamicsClientIDParam: { type: 'string', minLength: 1 },
        dynamicsClientSecretParam: { type: 'string', minLength: 1 },
        onedriveClientIDParam: { type: 'string', minLength: 1 },
        onedriveClientSecretParam: { type: 'string', minLength: 1 },
        originModel: { $ref: 'urn:wisepipe-common-data:OriginModel' },
        connection: { $ref: 'urn:wisepipe-common-connection:Connection' },
        credentials: { $ref: 'urn:wisepipe-common:Credentials' },
        awsS3credentials: { $ref: 'urn:wisepipe-common-auth:AwsCredentials' },
        tempS3UploadFolder: { $ref: 'urn:wisepipe-common:S3File' },
        taskAuthInfo: { $ref: 'urn:wisepipe-common-auth:TaskAuthInfo' },
        transient: { type: 'boolean' },
        encryptionSecretName: { type: 'string', minLength: 1 },
        oldDataSources: { type: 'array', items: { $ref: 'urn:wisepipe-common-data:DataSource' } }
    },
    required: [
        'stage',
        'apiUrl',
        's3DataBucket',
        'originModel',
        'googleClientIDParam',
        'googleClientSecretParam',
        'googleSheetsImportClientIDParam',
        'googleSheetsImportClientSecretParam',
        'googleAdWordsDevTokenParam',
        'salesforceClientIDParam',
        'salesforceClientSecretParam',
        'hubspotClientIDParam',
        'hubspotClientSecretParam',
        'dynamicsClientIDParam',
        'dynamicsClientSecretParam',
        'transient'
    ]
};
const schema119 = {
    $id: 'urn:wisepipe-common-auth:TaskAuthInfo',
    type: 'object',
    properties: {
        orgID: { type: 'string', format: 'uuid' },
        userID: { type: 'string', format: 'uuid' },
        taskID: { type: 'string' },
        taskAuthToken: { type: 'string' },
        expiration: { type: 'integer' },
        endpoint: { type: 'string' }
    },
    required: ['orgID', 'userID', 'taskID', 'taskAuthToken', 'expiration']
};
const func311 = ucs2length;
const func312 = base64urlToBuffer;
const func313 = base64urlEncode;
const func314 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func322 = ucs2length;
const func323 = base64urlToBuffer;
const func324 = base64urlEncode;
const func325 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const schema113 = {
    $id: 'urn:wisepipe-common-data:OriginModel',
    type: 'object',
    properties: {
        orgID: { type: 'string', minLength: 1 },
        originID: { type: 'string', uid: 9 },
        name: { type: 'string', minLength: 1 },
        config: { $ref: 'urn:wisepipe-common-data:ImportConfig' },
        s3Folder: { $ref: 'urn:wisepipe-common:S3File' },
        discoveryID: { type: 'string', uid: 9 },
        streamID: { type: 'string', minLength: 1 },
        connectionID: { type: 'string', uid: 9 },
        hidden: { type: 'boolean' }
    },
    required: ['orgID', 'originID', 'name', 'config', 's3Folder']
};
const func291 = ucs2length;
const func292 = base64urlToBuffer;
const func293 = base64urlEncode;
const func294 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func298 = ucs2length;
const func299 = base64urlToBuffer;
const func300 = base64urlEncode;
const func301 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func302 = ucs2length;
const func303 = base64urlToBuffer;
const func304 = base64urlEncode;
const func305 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func307 = ucs2length;
const func308 = base64urlToBuffer;
const func309 = base64urlEncode;
const func310 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate76(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:OriginModel" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.orgID === undefined && (missing0 = 'orgID')) ||
                (data.originID === undefined && (missing0 = 'originID')) ||
                (data.name === undefined && (missing0 = 'name')) ||
                (data.config === undefined && (missing0 = 'config')) ||
                (data.s3Folder === undefined && (missing0 = 's3Folder'))) {
                validate76.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.orgID !== undefined) {
                    let data0 = data.orgID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate76.errors = [
                                    {
                                        instancePath: instancePath + '/orgID',
                                        schemaPath: '#/properties/orgID/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate76.errors = [
                                {
                                    instancePath: instancePath + '/orgID',
                                    schemaPath: '#/properties/orgID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.originID !== undefined) {
                        let data1 = data.originID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                const b64min0 = Math.ceil((4 * 9) / 3);
                                const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                if (func291(data1) < b64min0 || func291(data1) > b64max0) {
                                    validate76.errors = [
                                        {
                                            instancePath: instancePath + '/originID',
                                            schemaPath: '#/properties/originID/uid',
                                            keyword: 'uid',
                                            params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func291(data1) },
                                            message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func291(data1)
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const decoded0 = func292(data1);
                                    if (decoded0.length !== 9) {
                                        validate76.errors = [
                                            {
                                                instancePath: instancePath + '/originID',
                                                schemaPath: '#/properties/originID/uid',
                                                keyword: 'uid',
                                                params: { error: 'decoded' },
                                                message: 'must decode to 9 bytes'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const encoded0 = func293(decoded0);
                                        if (func294(encoded0) !== func294(data1)) {
                                            validate76.errors = [
                                                {
                                                    instancePath: instancePath + '/originID',
                                                    schemaPath: '#/properties/originID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'ambiguous' },
                                                    message: 'encoding is ambiguous'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            else {
                                validate76.errors = [
                                    {
                                        instancePath: instancePath + '/originID',
                                        schemaPath: '#/properties/originID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.name !== undefined) {
                            let data2 = data.name;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate76.errors = [
                                            {
                                                instancePath: instancePath + '/name',
                                                schemaPath: '#/properties/name/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate76.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.config !== undefined) {
                                const _errs7 = errors;
                                if (!validate44(data.config, {
                                    instancePath: instancePath + '/config',
                                    parentData: data,
                                    parentDataProperty: 'config',
                                    rootData
                                })) {
                                    vErrors = vErrors === null ? validate44.errors : vErrors.concat(validate44.errors);
                                    errors = vErrors.length;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.s3Folder !== undefined) {
                                    let data4 = data.s3Folder;
                                    const _errs8 = errors;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (data4 && typeof data4 == 'object' && !Array.isArray(data4)) {
                                            let missing1;
                                            if ((data4.bucket === undefined && (missing1 = 'bucket')) ||
                                                (data4.key === undefined && (missing1 = 'key'))) {
                                                validate76.errors = [
                                                    {
                                                        instancePath: instancePath + '/s3Folder',
                                                        schemaPath: 'urn:wisepipe-common:S3File/required',
                                                        keyword: 'required',
                                                        params: { missingProperty: missing1 },
                                                        message: "must have required property '" + missing1 + "'"
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (data4.bucket !== undefined) {
                                                    let data5 = data4.bucket;
                                                    const _errs11 = errors;
                                                    if (errors === _errs11) {
                                                        if (typeof data5 === 'string') {
                                                            if (func2(data5) < 1) {
                                                                validate76.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/s3Folder/bucket',
                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                                        keyword: 'minLength',
                                                                        params: { limit: 1 },
                                                                        message: 'must NOT have fewer than 1 characters'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate76.errors = [
                                                                {
                                                                    instancePath: instancePath + '/s3Folder/bucket',
                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid3 = _errs11 === errors;
                                                }
                                                else {
                                                    var valid3 = true;
                                                }
                                                if (valid3) {
                                                    if (data4.key !== undefined) {
                                                        let data6 = data4.key;
                                                        const _errs13 = errors;
                                                        if (errors === _errs13) {
                                                            if (typeof data6 === 'string') {
                                                                if (func2(data6) < 1) {
                                                                    validate76.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/s3Folder/key',
                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                                            keyword: 'minLength',
                                                                            params: { limit: 1 },
                                                                            message: 'must NOT have fewer than 1 characters'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            else {
                                                                validate76.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/s3Folder/key',
                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid3 = _errs13 === errors;
                                                    }
                                                    else {
                                                        var valid3 = true;
                                                    }
                                                    if (valid3) {
                                                        if (data4.uploadID !== undefined) {
                                                            let data7 = data4.uploadID;
                                                            const _errs15 = errors;
                                                            if (errors === _errs15) {
                                                                if (typeof data7 === 'string') {
                                                                    const b64min1 = Math.ceil((4 * 9) / 3);
                                                                    const b64max1 = Math.ceil((4 * 9) / 3) + 3;
                                                                    if (func298(data7) < b64min1 || func298(data7) > b64max1) {
                                                                        validate76.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/s3Folder/uploadID',
                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                keyword: 'uid',
                                                                                params: {
                                                                                    error: 'encoded',
                                                                                    b64min: b64min1,
                                                                                    b64max: b64max1,
                                                                                    length: func298(data7)
                                                                                },
                                                                                message: 'length must be between ' +
                                                                                    b64min1 +
                                                                                    ' and ' +
                                                                                    b64max1 +
                                                                                    ', but is ' +
                                                                                    func298(data7)
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    else {
                                                                        const decoded1 = func299(data7);
                                                                        if (decoded1.length !== 9) {
                                                                            validate76.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/s3Folder/uploadID',
                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                    keyword: 'uid',
                                                                                    params: { error: 'decoded' },
                                                                                    message: 'must decode to 9 bytes'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        else {
                                                                            const encoded1 = func300(decoded1);
                                                                            if (func301(encoded1) !== func301(data7)) {
                                                                                validate76.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/s3Folder/uploadID',
                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                        keyword: 'uid',
                                                                                        params: { error: 'ambiguous' },
                                                                                        message: 'encoding is ambiguous'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                                else {
                                                                    validate76.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/s3Folder/uploadID',
                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid3 = _errs15 === errors;
                                                        }
                                                        else {
                                                            var valid3 = true;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate76.errors = [
                                                {
                                                    instancePath: instancePath + '/s3Folder',
                                                    schemaPath: 'urn:wisepipe-common:S3File/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs8 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.discoveryID !== undefined) {
                                        let data8 = data.discoveryID;
                                        const _errs17 = errors;
                                        if (errors === _errs17) {
                                            if (typeof data8 === 'string') {
                                                const b64min2 = Math.ceil((4 * 9) / 3);
                                                const b64max2 = Math.ceil((4 * 9) / 3) + 3;
                                                if (func302(data8) < b64min2 || func302(data8) > b64max2) {
                                                    validate76.errors = [
                                                        {
                                                            instancePath: instancePath + '/discoveryID',
                                                            schemaPath: '#/properties/discoveryID/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'encoded', b64min: b64min2, b64max: b64max2, length: func302(data8) },
                                                            message: 'length must be between ' + b64min2 + ' and ' + b64max2 + ', but is ' + func302(data8)
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    const decoded2 = func303(data8);
                                                    if (decoded2.length !== 9) {
                                                        validate76.errors = [
                                                            {
                                                                instancePath: instancePath + '/discoveryID',
                                                                schemaPath: '#/properties/discoveryID/uid',
                                                                keyword: 'uid',
                                                                params: { error: 'decoded' },
                                                                message: 'must decode to 9 bytes'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        const encoded2 = func304(decoded2);
                                                        if (func305(encoded2) !== func305(data8)) {
                                                            validate76.errors = [
                                                                {
                                                                    instancePath: instancePath + '/discoveryID',
                                                                    schemaPath: '#/properties/discoveryID/uid',
                                                                    keyword: 'uid',
                                                                    params: { error: 'ambiguous' },
                                                                    message: 'encoding is ambiguous'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate76.errors = [
                                                    {
                                                        instancePath: instancePath + '/discoveryID',
                                                        schemaPath: '#/properties/discoveryID/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs17 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.streamID !== undefined) {
                                            let data9 = data.streamID;
                                            const _errs19 = errors;
                                            if (errors === _errs19) {
                                                if (typeof data9 === 'string') {
                                                    if (func2(data9) < 1) {
                                                        validate76.errors = [
                                                            {
                                                                instancePath: instancePath + '/streamID',
                                                                schemaPath: '#/properties/streamID/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate76.errors = [
                                                        {
                                                            instancePath: instancePath + '/streamID',
                                                            schemaPath: '#/properties/streamID/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs19 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.connectionID !== undefined) {
                                                let data10 = data.connectionID;
                                                const _errs21 = errors;
                                                if (errors === _errs21) {
                                                    if (typeof data10 === 'string') {
                                                        const b64min3 = Math.ceil((4 * 9) / 3);
                                                        const b64max3 = Math.ceil((4 * 9) / 3) + 3;
                                                        if (func307(data10) < b64min3 || func307(data10) > b64max3) {
                                                            validate76.errors = [
                                                                {
                                                                    instancePath: instancePath + '/connectionID',
                                                                    schemaPath: '#/properties/connectionID/uid',
                                                                    keyword: 'uid',
                                                                    params: {
                                                                        error: 'encoded',
                                                                        b64min: b64min3,
                                                                        b64max: b64max3,
                                                                        length: func307(data10)
                                                                    },
                                                                    message: 'length must be between ' +
                                                                        b64min3 +
                                                                        ' and ' +
                                                                        b64max3 +
                                                                        ', but is ' +
                                                                        func307(data10)
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            const decoded3 = func308(data10);
                                                            if (decoded3.length !== 9) {
                                                                validate76.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/connectionID',
                                                                        schemaPath: '#/properties/connectionID/uid',
                                                                        keyword: 'uid',
                                                                        params: { error: 'decoded' },
                                                                        message: 'must decode to 9 bytes'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            else {
                                                                const encoded3 = func309(decoded3);
                                                                if (func310(encoded3) !== func310(data10)) {
                                                                    validate76.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/connectionID',
                                                                            schemaPath: '#/properties/connectionID/uid',
                                                                            keyword: 'uid',
                                                                            params: { error: 'ambiguous' },
                                                                            message: 'encoding is ambiguous'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate76.errors = [
                                                            {
                                                                instancePath: instancePath + '/connectionID',
                                                                schemaPath: '#/properties/connectionID/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid0 = _errs21 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (data.hidden !== undefined) {
                                                    const _errs23 = errors;
                                                    if (typeof data.hidden !== 'boolean') {
                                                        validate76.errors = [
                                                            {
                                                                instancePath: instancePath + '/hidden',
                                                                schemaPath: '#/properties/hidden/type',
                                                                keyword: 'type',
                                                                params: { type: 'boolean' },
                                                                message: 'must be boolean'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid0 = _errs23 === errors;
                                                }
                                                else {
                                                    var valid0 = true;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate76.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate76.errors = vErrors;
    return errors === 0;
}
function validate75(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:ImportTaskEnv" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.stage === undefined && (missing0 = 'stage')) ||
                (data.apiUrl === undefined && (missing0 = 'apiUrl')) ||
                (data.s3DataBucket === undefined && (missing0 = 's3DataBucket')) ||
                (data.originModel === undefined && (missing0 = 'originModel')) ||
                (data.googleClientIDParam === undefined && (missing0 = 'googleClientIDParam')) ||
                (data.googleClientSecretParam === undefined && (missing0 = 'googleClientSecretParam')) ||
                (data.googleSheetsImportClientIDParam === undefined && (missing0 = 'googleSheetsImportClientIDParam')) ||
                (data.googleSheetsImportClientSecretParam === undefined &&
                    (missing0 = 'googleSheetsImportClientSecretParam')) ||
                (data.googleAdWordsDevTokenParam === undefined && (missing0 = 'googleAdWordsDevTokenParam')) ||
                (data.salesforceClientIDParam === undefined && (missing0 = 'salesforceClientIDParam')) ||
                (data.salesforceClientSecretParam === undefined && (missing0 = 'salesforceClientSecretParam')) ||
                (data.hubspotClientIDParam === undefined && (missing0 = 'hubspotClientIDParam')) ||
                (data.hubspotClientSecretParam === undefined && (missing0 = 'hubspotClientSecretParam')) ||
                (data.dynamicsClientIDParam === undefined && (missing0 = 'dynamicsClientIDParam')) ||
                (data.dynamicsClientSecretParam === undefined && (missing0 = 'dynamicsClientSecretParam')) ||
                (data.transient === undefined && (missing0 = 'transient'))) {
                validate75.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.stage !== undefined) {
                    let data0 = data.stage;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate75.errors = [
                                    {
                                        instancePath: instancePath + '/stage',
                                        schemaPath: '#/properties/stage/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate75.errors = [
                                {
                                    instancePath: instancePath + '/stage',
                                    schemaPath: '#/properties/stage/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.apiUrl !== undefined) {
                        let data1 = data.apiUrl;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (errors === _errs3) {
                                if (typeof data1 === 'string') {
                                    if (!formats40(data1)) {
                                        validate75.errors = [
                                            {
                                                instancePath: instancePath + '/apiUrl',
                                                schemaPath: '#/properties/apiUrl/format',
                                                keyword: 'format',
                                                params: { format: 'uri' },
                                                message: 'must match format "' + 'uri' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate75.errors = [
                                        {
                                            instancePath: instancePath + '/apiUrl',
                                            schemaPath: '#/properties/apiUrl/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.s3DataBucket !== undefined) {
                            let data2 = data.s3DataBucket;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate75.errors = [
                                            {
                                                instancePath: instancePath + '/s3DataBucket',
                                                schemaPath: '#/properties/s3DataBucket/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate75.errors = [
                                        {
                                            instancePath: instancePath + '/s3DataBucket',
                                            schemaPath: '#/properties/s3DataBucket/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.googleClientIDParam !== undefined) {
                                let data3 = data.googleClientIDParam;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 === 'string') {
                                        if (func2(data3) < 1) {
                                            validate75.errors = [
                                                {
                                                    instancePath: instancePath + '/googleClientIDParam',
                                                    schemaPath: '#/properties/googleClientIDParam/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate75.errors = [
                                            {
                                                instancePath: instancePath + '/googleClientIDParam',
                                                schemaPath: '#/properties/googleClientIDParam/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.googleClientSecretParam !== undefined) {
                                    let data4 = data.googleClientSecretParam;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (typeof data4 === 'string') {
                                            if (func2(data4) < 1) {
                                                validate75.errors = [
                                                    {
                                                        instancePath: instancePath + '/googleClientSecretParam',
                                                        schemaPath: '#/properties/googleClientSecretParam/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate75.errors = [
                                                {
                                                    instancePath: instancePath + '/googleClientSecretParam',
                                                    schemaPath: '#/properties/googleClientSecretParam/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.googleSheetsImportClientIDParam !== undefined) {
                                        let data5 = data.googleSheetsImportClientIDParam;
                                        const _errs11 = errors;
                                        if (errors === _errs11) {
                                            if (typeof data5 === 'string') {
                                                if (func2(data5) < 1) {
                                                    validate75.errors = [
                                                        {
                                                            instancePath: instancePath + '/googleSheetsImportClientIDParam',
                                                            schemaPath: '#/properties/googleSheetsImportClientIDParam/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate75.errors = [
                                                    {
                                                        instancePath: instancePath + '/googleSheetsImportClientIDParam',
                                                        schemaPath: '#/properties/googleSheetsImportClientIDParam/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.googleSheetsImportClientSecretParam !== undefined) {
                                            let data6 = data.googleSheetsImportClientSecretParam;
                                            const _errs13 = errors;
                                            if (errors === _errs13) {
                                                if (typeof data6 === 'string') {
                                                    if (func2(data6) < 1) {
                                                        validate75.errors = [
                                                            {
                                                                instancePath: instancePath + '/googleSheetsImportClientSecretParam',
                                                                schemaPath: '#/properties/googleSheetsImportClientSecretParam/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate75.errors = [
                                                        {
                                                            instancePath: instancePath + '/googleSheetsImportClientSecretParam',
                                                            schemaPath: '#/properties/googleSheetsImportClientSecretParam/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs13 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.googleAdWordsDevTokenParam !== undefined) {
                                                let data7 = data.googleAdWordsDevTokenParam;
                                                const _errs15 = errors;
                                                if (errors === _errs15) {
                                                    if (typeof data7 === 'string') {
                                                        if (func2(data7) < 1) {
                                                            validate75.errors = [
                                                                {
                                                                    instancePath: instancePath + '/googleAdWordsDevTokenParam',
                                                                    schemaPath: '#/properties/googleAdWordsDevTokenParam/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate75.errors = [
                                                            {
                                                                instancePath: instancePath + '/googleAdWordsDevTokenParam',
                                                                schemaPath: '#/properties/googleAdWordsDevTokenParam/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid0 = _errs15 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (data.salesforceClientIDParam !== undefined) {
                                                    let data8 = data.salesforceClientIDParam;
                                                    const _errs17 = errors;
                                                    if (errors === _errs17) {
                                                        if (typeof data8 === 'string') {
                                                            if (func2(data8) < 1) {
                                                                validate75.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/salesforceClientIDParam',
                                                                        schemaPath: '#/properties/salesforceClientIDParam/minLength',
                                                                        keyword: 'minLength',
                                                                        params: { limit: 1 },
                                                                        message: 'must NOT have fewer than 1 characters'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate75.errors = [
                                                                {
                                                                    instancePath: instancePath + '/salesforceClientIDParam',
                                                                    schemaPath: '#/properties/salesforceClientIDParam/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid0 = _errs17 === errors;
                                                }
                                                else {
                                                    var valid0 = true;
                                                }
                                                if (valid0) {
                                                    if (data.salesforceClientSecretParam !== undefined) {
                                                        let data9 = data.salesforceClientSecretParam;
                                                        const _errs19 = errors;
                                                        if (errors === _errs19) {
                                                            if (typeof data9 === 'string') {
                                                                if (func2(data9) < 1) {
                                                                    validate75.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/salesforceClientSecretParam',
                                                                            schemaPath: '#/properties/salesforceClientSecretParam/minLength',
                                                                            keyword: 'minLength',
                                                                            params: { limit: 1 },
                                                                            message: 'must NOT have fewer than 1 characters'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            else {
                                                                validate75.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/salesforceClientSecretParam',
                                                                        schemaPath: '#/properties/salesforceClientSecretParam/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid0 = _errs19 === errors;
                                                    }
                                                    else {
                                                        var valid0 = true;
                                                    }
                                                    if (valid0) {
                                                        if (data.hubspotClientIDParam !== undefined) {
                                                            let data10 = data.hubspotClientIDParam;
                                                            const _errs21 = errors;
                                                            if (errors === _errs21) {
                                                                if (typeof data10 === 'string') {
                                                                    if (func2(data10) < 1) {
                                                                        validate75.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/hubspotClientIDParam',
                                                                                schemaPath: '#/properties/hubspotClientIDParam/minLength',
                                                                                keyword: 'minLength',
                                                                                params: { limit: 1 },
                                                                                message: 'must NOT have fewer than 1 characters'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                else {
                                                                    validate75.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/hubspotClientIDParam',
                                                                            schemaPath: '#/properties/hubspotClientIDParam/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid0 = _errs21 === errors;
                                                        }
                                                        else {
                                                            var valid0 = true;
                                                        }
                                                        if (valid0) {
                                                            if (data.hubspotClientSecretParam !== undefined) {
                                                                let data11 = data.hubspotClientSecretParam;
                                                                const _errs23 = errors;
                                                                if (errors === _errs23) {
                                                                    if (typeof data11 === 'string') {
                                                                        if (func2(data11) < 1) {
                                                                            validate75.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/hubspotClientSecretParam',
                                                                                    schemaPath: '#/properties/hubspotClientSecretParam/minLength',
                                                                                    keyword: 'minLength',
                                                                                    params: { limit: 1 },
                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate75.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/hubspotClientSecretParam',
                                                                                schemaPath: '#/properties/hubspotClientSecretParam/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                var valid0 = _errs23 === errors;
                                                            }
                                                            else {
                                                                var valid0 = true;
                                                            }
                                                            if (valid0) {
                                                                if (data.dynamicsClientIDParam !== undefined) {
                                                                    let data12 = data.dynamicsClientIDParam;
                                                                    const _errs25 = errors;
                                                                    if (errors === _errs25) {
                                                                        if (typeof data12 === 'string') {
                                                                            if (func2(data12) < 1) {
                                                                                validate75.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/dynamicsClientIDParam',
                                                                                        schemaPath: '#/properties/dynamicsClientIDParam/minLength',
                                                                                        keyword: 'minLength',
                                                                                        params: { limit: 1 },
                                                                                        message: 'must NOT have fewer than 1 characters'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        else {
                                                                            validate75.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/dynamicsClientIDParam',
                                                                                    schemaPath: '#/properties/dynamicsClientIDParam/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'string' },
                                                                                    message: 'must be string'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    var valid0 = _errs25 === errors;
                                                                }
                                                                else {
                                                                    var valid0 = true;
                                                                }
                                                                if (valid0) {
                                                                    if (data.dynamicsClientSecretParam !== undefined) {
                                                                        let data13 = data.dynamicsClientSecretParam;
                                                                        const _errs27 = errors;
                                                                        if (errors === _errs27) {
                                                                            if (typeof data13 === 'string') {
                                                                                if (func2(data13) < 1) {
                                                                                    validate75.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/dynamicsClientSecretParam',
                                                                                            schemaPath: '#/properties/dynamicsClientSecretParam/minLength',
                                                                                            keyword: 'minLength',
                                                                                            params: { limit: 1 },
                                                                                            message: 'must NOT have fewer than 1 characters'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            else {
                                                                                validate75.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/dynamicsClientSecretParam',
                                                                                        schemaPath: '#/properties/dynamicsClientSecretParam/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        var valid0 = _errs27 === errors;
                                                                    }
                                                                    else {
                                                                        var valid0 = true;
                                                                    }
                                                                    if (valid0) {
                                                                        if (data.onedriveClientIDParam !== undefined) {
                                                                            let data14 = data.onedriveClientIDParam;
                                                                            const _errs29 = errors;
                                                                            if (errors === _errs29) {
                                                                                if (typeof data14 === 'string') {
                                                                                    if (func2(data14) < 1) {
                                                                                        validate75.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/onedriveClientIDParam',
                                                                                                schemaPath: '#/properties/onedriveClientIDParam/minLength',
                                                                                                keyword: 'minLength',
                                                                                                params: { limit: 1 },
                                                                                                message: 'must NOT have fewer than 1 characters'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    validate75.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/onedriveClientIDParam',
                                                                                            schemaPath: '#/properties/onedriveClientIDParam/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'string' },
                                                                                            message: 'must be string'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            var valid0 = _errs29 === errors;
                                                                        }
                                                                        else {
                                                                            var valid0 = true;
                                                                        }
                                                                        if (valid0) {
                                                                            if (data.onedriveClientSecretParam !== undefined) {
                                                                                let data15 = data.onedriveClientSecretParam;
                                                                                const _errs31 = errors;
                                                                                if (errors === _errs31) {
                                                                                    if (typeof data15 === 'string') {
                                                                                        if (func2(data15) < 1) {
                                                                                            validate75.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/onedriveClientSecretParam',
                                                                                                    schemaPath: '#/properties/onedriveClientSecretParam/minLength',
                                                                                                    keyword: 'minLength',
                                                                                                    params: { limit: 1 },
                                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                    else {
                                                                                        validate75.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/onedriveClientSecretParam',
                                                                                                schemaPath: '#/properties/onedriveClientSecretParam/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'string' },
                                                                                                message: 'must be string'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                var valid0 = _errs31 === errors;
                                                                            }
                                                                            else {
                                                                                var valid0 = true;
                                                                            }
                                                                            if (valid0) {
                                                                                if (data.originModel !== undefined) {
                                                                                    const _errs33 = errors;
                                                                                    if (!validate76(data.originModel, {
                                                                                        instancePath: instancePath + '/originModel',
                                                                                        parentData: data,
                                                                                        parentDataProperty: 'originModel',
                                                                                        rootData
                                                                                    })) {
                                                                                        vErrors =
                                                                                            vErrors === null ? validate76.errors : vErrors.concat(validate76.errors);
                                                                                        errors = vErrors.length;
                                                                                    }
                                                                                    var valid0 = _errs33 === errors;
                                                                                }
                                                                                else {
                                                                                    var valid0 = true;
                                                                                }
                                                                                if (valid0) {
                                                                                    if (data.connection !== undefined) {
                                                                                        let data17 = data.connection;
                                                                                        const _errs34 = errors;
                                                                                        const _errs35 = errors;
                                                                                        if (errors === _errs35) {
                                                                                            if (data17 && typeof data17 == 'object' && !Array.isArray(data17)) {
                                                                                                let missing1;
                                                                                                if ((data17.connectionType === undefined &&
                                                                                                    (missing1 = 'connectionType')) ||
                                                                                                    (data17.name === undefined && (missing1 = 'name'))) {
                                                                                                    validate75.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/connection',
                                                                                                            schemaPath: 'urn:wisepipe-common-connection:Connection/required',
                                                                                                            keyword: 'required',
                                                                                                            params: { missingProperty: missing1 },
                                                                                                            message: "must have required property '" + missing1 + "'"
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                                else {
                                                                                                    if (data17.connectionID !== undefined) {
                                                                                                        let data18 = data17.connectionID;
                                                                                                        const _errs37 = errors;
                                                                                                        if (errors === _errs37) {
                                                                                                            if (typeof data18 === 'string') {
                                                                                                                const b64min0 = Math.ceil((4 * 9) / 3);
                                                                                                                const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                                                                                                if (func311(data18) < b64min0 || func311(data18) > b64max0) {
                                                                                                                    validate75.errors = [
                                                                                                                        {
                                                                                                                            instancePath: instancePath + '/connection/connectionID',
                                                                                                                            schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionID/uid',
                                                                                                                            keyword: 'uid',
                                                                                                                            params: {
                                                                                                                                error: 'encoded',
                                                                                                                                b64min: b64min0,
                                                                                                                                b64max: b64max0,
                                                                                                                                length: func311(data18)
                                                                                                                            },
                                                                                                                            message: 'length must be between ' +
                                                                                                                                b64min0 +
                                                                                                                                ' and ' +
                                                                                                                                b64max0 +
                                                                                                                                ', but is ' +
                                                                                                                                func311(data18)
                                                                                                                        }
                                                                                                                    ];
                                                                                                                    return false;
                                                                                                                }
                                                                                                                else {
                                                                                                                    const decoded0 = func312(data18);
                                                                                                                    if (decoded0.length !== 9) {
                                                                                                                        validate75.errors = [
                                                                                                                            {
                                                                                                                                instancePath: instancePath + '/connection/connectionID',
                                                                                                                                schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionID/uid',
                                                                                                                                keyword: 'uid',
                                                                                                                                params: { error: 'decoded' },
                                                                                                                                message: 'must decode to 9 bytes'
                                                                                                                            }
                                                                                                                        ];
                                                                                                                        return false;
                                                                                                                    }
                                                                                                                    else {
                                                                                                                        const encoded0 = func313(decoded0);
                                                                                                                        if (func314(encoded0) !== func314(data18)) {
                                                                                                                            validate75.errors = [
                                                                                                                                {
                                                                                                                                    instancePath: instancePath + '/connection/connectionID',
                                                                                                                                    schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionID/uid',
                                                                                                                                    keyword: 'uid',
                                                                                                                                    params: { error: 'ambiguous' },
                                                                                                                                    message: 'encoding is ambiguous'
                                                                                                                                }
                                                                                                                            ];
                                                                                                                            return false;
                                                                                                                        }
                                                                                                                    }
                                                                                                                }
                                                                                                            }
                                                                                                            else {
                                                                                                                validate75.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/connection/connectionID',
                                                                                                                        schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionID/type',
                                                                                                                        keyword: 'type',
                                                                                                                        params: { type: 'string' },
                                                                                                                        message: 'must be string'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                        }
                                                                                                        var valid2 = _errs37 === errors;
                                                                                                    }
                                                                                                    else {
                                                                                                        var valid2 = true;
                                                                                                    }
                                                                                                    if (valid2) {
                                                                                                        if (data17.connectionType !== undefined) {
                                                                                                            let data19 = data17.connectionType;
                                                                                                            const _errs39 = errors;
                                                                                                            if (typeof data19 !== 'string') {
                                                                                                                validate75.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/connection/connectionType',
                                                                                                                        schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionType/type',
                                                                                                                        keyword: 'type',
                                                                                                                        params: { type: 'string' },
                                                                                                                        message: 'must be string'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                            if (!(data19 === 'google' ||
                                                                                                                data19 === 'gsheetsImport' ||
                                                                                                                data19 === 'gsheetsExport' ||
                                                                                                                data19 === 'shopify' ||
                                                                                                                data19 === 'salesForce' ||
                                                                                                                data19 === 'postgreSql' ||
                                                                                                                data19 === 'icm' ||
                                                                                                                data19 === 'tq-postgres' ||
                                                                                                                data19 === 'mySql' ||
                                                                                                                data19 === 'msSql' ||
                                                                                                                data19 === 'oracle' ||
                                                                                                                data19 === 'amazonRedshift' ||
                                                                                                                data19 === 'amazonAurora' ||
                                                                                                                data19 === 'amazonS3' ||
                                                                                                                data19 === 'amazonS3Export' ||
                                                                                                                data19 === 'tqp' ||
                                                                                                                data19 === 'hubspot' ||
                                                                                                                data19 === 'symon' ||
                                                                                                                data19 === 'snowflake' ||
                                                                                                                data19 === 'dynamics' ||
                                                                                                                data19 === 'agentSync' ||
                                                                                                                data19 === 'workday' ||
                                                                                                                data19 === 'workdayRaaS' ||
                                                                                                                data19 === 'workdayExport' ||
                                                                                                                data19 === 'tableau' ||
                                                                                                                data19 === 'sftp' ||
                                                                                                                data19 === 'powerbi' ||
                                                                                                                data19 === 'rest' ||
                                                                                                                data19 === 'gong' ||
                                                                                                                data19 === 'netSuite' ||
                                                                                                                data19 === 'oneDrive' ||
                                                                                                                data19 === 'oneDriveExport' ||
                                                                                                                data19 === 'sapSuccessFactors' ||
                                                                                                                data19 === 'sapCrm' ||
                                                                                                                data19 === 'ukg' ||
                                                                                                                data19 === 'oracleHcm' ||
                                                                                                                data19 === 'Adp' ||
                                                                                                                data19 === 'dynamics365Sales' ||
                                                                                                                data19 === 'ceridianDayforce' ||
                                                                                                                data19 === 'oracleCrm' ||
                                                                                                                data19 === 'oracleErpCloud' ||
                                                                                                                data19 === 'sageIntacct' ||
                                                                                                                data19 === 'bambooHr' ||
                                                                                                                data19 === 'sapErp' ||
                                                                                                                data19 === 'googleCloudPlatformCloudStorage' ||
                                                                                                                data19 === 'sas' ||
                                                                                                                data19 === 'dropbox' ||
                                                                                                                data19 === 'googleDrive' ||
                                                                                                                data19 === 'jira' ||
                                                                                                                data19 === 'monday' ||
                                                                                                                data19 === 'zuora' ||
                                                                                                                data19 === 'adobeAnalytics' ||
                                                                                                                data19 === 'zoomInfo' ||
                                                                                                                data19 === 'marketo' ||
                                                                                                                data19 === 'activeCampaign' ||
                                                                                                                data19 === 'mailchimp' ||
                                                                                                                data19 === 'infor' ||
                                                                                                                data19 === 'cornerstoneOnDemand' ||
                                                                                                                data19 === 'gusto' ||
                                                                                                                data19 === 'paychexFlex' ||
                                                                                                                data19 === 'zendesk' ||
                                                                                                                data19 === 'serviceNow' ||
                                                                                                                data19 === 'zohoCrm' ||
                                                                                                                data19 === 'pipedrive' ||
                                                                                                                data19 === 'quickBooks' ||
                                                                                                                data19 === 'xero' ||
                                                                                                                data19 === 'freshbooks' ||
                                                                                                                data19 === 'zohoBooks' ||
                                                                                                                data19 === 'waveFinancial')) {
                                                                                                                validate75.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/connection/connectionType',
                                                                                                                        schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionType/enum',
                                                                                                                        keyword: 'enum',
                                                                                                                        params: {
                                                                                                                            allowedValues: schema41.properties.connectionType.enum
                                                                                                                        },
                                                                                                                        message: 'must be equal to one of the allowed values'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                            var valid2 = _errs39 === errors;
                                                                                                        }
                                                                                                        else {
                                                                                                            var valid2 = true;
                                                                                                        }
                                                                                                        if (valid2) {
                                                                                                            if (data17.name !== undefined) {
                                                                                                                let data20 = data17.name;
                                                                                                                const _errs41 = errors;
                                                                                                                if (errors === _errs41) {
                                                                                                                    if (typeof data20 === 'string') {
                                                                                                                        if (func2(data20) < 1) {
                                                                                                                            validate75.errors = [
                                                                                                                                {
                                                                                                                                    instancePath: instancePath + '/connection/name',
                                                                                                                                    schemaPath: 'urn:wisepipe-common-connection:Connection/properties/name/minLength',
                                                                                                                                    keyword: 'minLength',
                                                                                                                                    params: { limit: 1 },
                                                                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                                                                }
                                                                                                                            ];
                                                                                                                            return false;
                                                                                                                        }
                                                                                                                    }
                                                                                                                    else {
                                                                                                                        validate75.errors = [
                                                                                                                            {
                                                                                                                                instancePath: instancePath + '/connection/name',
                                                                                                                                schemaPath: 'urn:wisepipe-common-connection:Connection/properties/name/type',
                                                                                                                                keyword: 'type',
                                                                                                                                params: { type: 'string' },
                                                                                                                                message: 'must be string'
                                                                                                                            }
                                                                                                                        ];
                                                                                                                        return false;
                                                                                                                    }
                                                                                                                }
                                                                                                                var valid2 = _errs41 === errors;
                                                                                                            }
                                                                                                            else {
                                                                                                                var valid2 = true;
                                                                                                            }
                                                                                                            if (valid2) {
                                                                                                                if (data17.source !== undefined) {
                                                                                                                    let data21 = data17.source;
                                                                                                                    const _errs43 = errors;
                                                                                                                    if (errors === _errs43) {
                                                                                                                        if (typeof data21 === 'string') {
                                                                                                                            if (func2(data21) < 1) {
                                                                                                                                validate75.errors = [
                                                                                                                                    {
                                                                                                                                        instancePath: instancePath + '/connection/source',
                                                                                                                                        schemaPath: 'urn:wisepipe-common-connection:Connection/properties/source/minLength',
                                                                                                                                        keyword: 'minLength',
                                                                                                                                        params: { limit: 1 },
                                                                                                                                        message: 'must NOT have fewer than 1 characters'
                                                                                                                                    }
                                                                                                                                ];
                                                                                                                                return false;
                                                                                                                            }
                                                                                                                        }
                                                                                                                        else {
                                                                                                                            validate75.errors = [
                                                                                                                                {
                                                                                                                                    instancePath: instancePath + '/connection/source',
                                                                                                                                    schemaPath: 'urn:wisepipe-common-connection:Connection/properties/source/type',
                                                                                                                                    keyword: 'type',
                                                                                                                                    params: { type: 'string' },
                                                                                                                                    message: 'must be string'
                                                                                                                                }
                                                                                                                            ];
                                                                                                                            return false;
                                                                                                                        }
                                                                                                                    }
                                                                                                                    var valid2 = _errs43 === errors;
                                                                                                                }
                                                                                                                else {
                                                                                                                    var valid2 = true;
                                                                                                                }
                                                                                                                if (valid2) {
                                                                                                                    if (data17.failedOnLastTry !== undefined) {
                                                                                                                        const _errs45 = errors;
                                                                                                                        if (typeof data17.failedOnLastTry !== 'boolean') {
                                                                                                                            validate75.errors = [
                                                                                                                                {
                                                                                                                                    instancePath: instancePath + '/connection/failedOnLastTry',
                                                                                                                                    schemaPath: 'urn:wisepipe-common-connection:Connection/properties/failedOnLastTry/type',
                                                                                                                                    keyword: 'type',
                                                                                                                                    params: { type: 'boolean' },
                                                                                                                                    message: 'must be boolean'
                                                                                                                                }
                                                                                                                            ];
                                                                                                                            return false;
                                                                                                                        }
                                                                                                                        var valid2 = _errs45 === errors;
                                                                                                                    }
                                                                                                                    else {
                                                                                                                        var valid2 = true;
                                                                                                                    }
                                                                                                                    if (valid2) {
                                                                                                                        if (data17.isDiscoveryFail !== undefined) {
                                                                                                                            const _errs47 = errors;
                                                                                                                            if (typeof data17.isDiscoveryFail !== 'boolean') {
                                                                                                                                validate75.errors = [
                                                                                                                                    {
                                                                                                                                        instancePath: instancePath + '/connection/isDiscoveryFail',
                                                                                                                                        schemaPath: 'urn:wisepipe-common-connection:Connection/properties/isDiscoveryFail/type',
                                                                                                                                        keyword: 'type',
                                                                                                                                        params: { type: 'boolean' },
                                                                                                                                        message: 'must be boolean'
                                                                                                                                    }
                                                                                                                                ];
                                                                                                                                return false;
                                                                                                                            }
                                                                                                                            var valid2 = _errs47 === errors;
                                                                                                                        }
                                                                                                                        else {
                                                                                                                            var valid2 = true;
                                                                                                                        }
                                                                                                                        if (valid2) {
                                                                                                                            if (data17.verificationErrorMessage !== undefined) {
                                                                                                                                const _errs49 = errors;
                                                                                                                                if (typeof data17.verificationErrorMessage !== 'string') {
                                                                                                                                    validate75.errors = [
                                                                                                                                        {
                                                                                                                                            instancePath: instancePath +
                                                                                                                                                '/connection/verificationErrorMessage',
                                                                                                                                            schemaPath: 'urn:wisepipe-common-connection:Connection/properties/verificationErrorMessage/type',
                                                                                                                                            keyword: 'type',
                                                                                                                                            params: { type: 'string' },
                                                                                                                                            message: 'must be string'
                                                                                                                                        }
                                                                                                                                    ];
                                                                                                                                    return false;
                                                                                                                                }
                                                                                                                                var valid2 = _errs49 === errors;
                                                                                                                            }
                                                                                                                            else {
                                                                                                                                var valid2 = true;
                                                                                                                            }
                                                                                                                        }
                                                                                                                    }
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                            else {
                                                                                                validate75.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/connection',
                                                                                                        schemaPath: 'urn:wisepipe-common-connection:Connection/type',
                                                                                                        keyword: 'type',
                                                                                                        params: { type: 'object' },
                                                                                                        message: 'must be object'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                        }
                                                                                        var valid0 = _errs34 === errors;
                                                                                    }
                                                                                    else {
                                                                                        var valid0 = true;
                                                                                    }
                                                                                    if (valid0) {
                                                                                        if (data.credentials !== undefined) {
                                                                                            let data25 = data.credentials;
                                                                                            const _errs51 = errors;
                                                                                            const _errs52 = errors;
                                                                                            if (errors === _errs52) {
                                                                                                if (data25 && typeof data25 == 'object' && !Array.isArray(data25)) {
                                                                                                    let missing2;
                                                                                                    if (data25.credentialsType === undefined &&
                                                                                                        (missing2 = 'credentialsType')) {
                                                                                                        validate75.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/credentials',
                                                                                                                schemaPath: 'urn:wisepipe-common:Credentials/required',
                                                                                                                keyword: 'required',
                                                                                                                params: { missingProperty: missing2 },
                                                                                                                message: "must have required property '" + missing2 + "'"
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                    else {
                                                                                                        if (data25.credentialsType !== undefined) {
                                                                                                            let data26 = data25.credentialsType;
                                                                                                            if (typeof data26 !== 'string') {
                                                                                                                validate75.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/credentials/credentialsType',
                                                                                                                        schemaPath: 'urn:wisepipe-common:Credentials/properties/credentialsType/type',
                                                                                                                        keyword: 'type',
                                                                                                                        params: { type: 'string' },
                                                                                                                        message: 'must be string'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                            if (!(data26 === 'oauth' ||
                                                                                                                data26 === 'userPassword' ||
                                                                                                                data26 === 's3Credentials' ||
                                                                                                                data26 === 'apiKey' ||
                                                                                                                data26 === 'symon' ||
                                                                                                                data26 === 'awsRoleAssumption' ||
                                                                                                                data26 === 'rest' ||
                                                                                                                data26 === 'tokenBasedAuthentication')) {
                                                                                                                validate75.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/credentials/credentialsType',
                                                                                                                        schemaPath: 'urn:wisepipe-common:Credentials/properties/credentialsType/enum',
                                                                                                                        keyword: 'enum',
                                                                                                                        params: {
                                                                                                                            allowedValues: schema42.properties.credentialsType.enum
                                                                                                                        },
                                                                                                                        message: 'must be equal to one of the allowed values'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                                else {
                                                                                                    validate75.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/credentials',
                                                                                                            schemaPath: 'urn:wisepipe-common:Credentials/type',
                                                                                                            keyword: 'type',
                                                                                                            params: { type: 'object' },
                                                                                                            message: 'must be object'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                            var valid0 = _errs51 === errors;
                                                                                        }
                                                                                        else {
                                                                                            var valid0 = true;
                                                                                        }
                                                                                        if (valid0) {
                                                                                            if (data.awsS3credentials !== undefined) {
                                                                                                let data27 = data.awsS3credentials;
                                                                                                const _errs56 = errors;
                                                                                                const _errs57 = errors;
                                                                                                if (errors === _errs57) {
                                                                                                    if (data27 && typeof data27 == 'object' && !Array.isArray(data27)) {
                                                                                                        let missing3;
                                                                                                        if ((data27.identityID === undefined && (missing3 = 'identityID')) ||
                                                                                                            (data27.accessKeyID === undefined &&
                                                                                                                (missing3 = 'accessKeyID')) ||
                                                                                                            (data27.secretKey === undefined && (missing3 = 'secretKey')) ||
                                                                                                            (data27.sessionToken === undefined &&
                                                                                                                (missing3 = 'sessionToken')) ||
                                                                                                            (data27.expiration === undefined && (missing3 = 'expiration')) ||
                                                                                                            (data27.region === undefined && (missing3 = 'region'))) {
                                                                                                            validate75.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/awsS3credentials',
                                                                                                                    schemaPath: 'urn:wisepipe-common-auth:AwsCredentials/required',
                                                                                                                    keyword: 'required',
                                                                                                                    params: { missingProperty: missing3 },
                                                                                                                    message: "must have required property '" + missing3 + "'"
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                        else {
                                                                                                            if (data27.identityID !== undefined) {
                                                                                                                let data28 = data27.identityID;
                                                                                                                const _errs59 = errors;
                                                                                                                if (errors === _errs59) {
                                                                                                                    if (typeof data28 === 'string') {
                                                                                                                        if (!pattern0.test(data28)) {
                                                                                                                            validate75.errors = [
                                                                                                                                {
                                                                                                                                    instancePath: instancePath + '/awsS3credentials/identityID',
                                                                                                                                    schemaPath: 'urn:wisepipe-common-auth:AwsCredentials/properties/identityID/pattern',
                                                                                                                                    keyword: 'pattern',
                                                                                                                                    params: { pattern: '[\\w-]+:[0-9a-f-]+' },
                                                                                                                                    message: 'must match pattern "' + '[\\w-]+:[0-9a-f-]+' + '"'
                                                                                                                                }
                                                                                                                            ];
                                                                                                                            return false;
                                                                                                                        }
                                                                                                                    }
                                                                                                                    else {
                                                                                                                        validate75.errors = [
                                                                                                                            {
                                                                                                                                instancePath: instancePath + '/awsS3credentials/identityID',
                                                                                                                                schemaPath: 'urn:wisepipe-common-auth:AwsCredentials/properties/identityID/type',
                                                                                                                                keyword: 'type',
                                                                                                                                params: { type: 'string' },
                                                                                                                                message: 'must be string'
                                                                                                                            }
                                                                                                                        ];
                                                                                                                        return false;
                                                                                                                    }
                                                                                                                }
                                                                                                                var valid7 = _errs59 === errors;
                                                                                                            }
                                                                                                            else {
                                                                                                                var valid7 = true;
                                                                                                            }
                                                                                                            if (valid7) {
                                                                                                                if (data27.accessKeyID !== undefined) {
                                                                                                                    let data29 = data27.accessKeyID;
                                                                                                                    const _errs61 = errors;
                                                                                                                    if (errors === _errs61) {
                                                                                                                        if (typeof data29 === 'string') {
                                                                                                                            if (func2(data29) < 1) {
                                                                                                                                validate75.errors = [
                                                                                                                                    {
                                                                                                                                        instancePath: instancePath + '/awsS3credentials/accessKeyID',
                                                                                                                                        schemaPath: 'urn:wisepipe-common-auth:AwsCredentials/properties/accessKeyID/minLength',
                                                                                                                                        keyword: 'minLength',
                                                                                                                                        params: { limit: 1 },
                                                                                                                                        message: 'must NOT have fewer than 1 characters'
                                                                                                                                    }
                                                                                                                                ];
                                                                                                                                return false;
                                                                                                                            }
                                                                                                                            else {
                                                                                                                                if (!pattern1.test(data29)) {
                                                                                                                                    validate75.errors = [
                                                                                                                                        {
                                                                                                                                            instancePath: instancePath + '/awsS3credentials/accessKeyID',
                                                                                                                                            schemaPath: 'urn:wisepipe-common-auth:AwsCredentials/properties/accessKeyID/pattern',
                                                                                                                                            keyword: 'pattern',
                                                                                                                                            params: { pattern: '[\\w]+' },
                                                                                                                                            message: 'must match pattern "' + '[\\w]+' + '"'
                                                                                                                                        }
                                                                                                                                    ];
                                                                                                                                    return false;
                                                                                                                                }
                                                                                                                            }
                                                                                                                        }
                                                                                                                        else {
                                                                                                                            validate75.errors = [
                                                                                                                                {
                                                                                                                                    instancePath: instancePath + '/awsS3credentials/accessKeyID',
                                                                                                                                    schemaPath: 'urn:wisepipe-common-auth:AwsCredentials/properties/accessKeyID/type',
                                                                                                                                    keyword: 'type',
                                                                                                                                    params: { type: 'string' },
                                                                                                                                    message: 'must be string'
                                                                                                                                }
                                                                                                                            ];
                                                                                                                            return false;
                                                                                                                        }
                                                                                                                    }
                                                                                                                    var valid7 = _errs61 === errors;
                                                                                                                }
                                                                                                                else {
                                                                                                                    var valid7 = true;
                                                                                                                }
                                                                                                                if (valid7) {
                                                                                                                    if (data27.secretKey !== undefined) {
                                                                                                                        let data30 = data27.secretKey;
                                                                                                                        const _errs63 = errors;
                                                                                                                        if (errors === _errs63) {
                                                                                                                            if (typeof data30 === 'string') {
                                                                                                                                if (func2(data30) < 1) {
                                                                                                                                    validate75.errors = [
                                                                                                                                        {
                                                                                                                                            instancePath: instancePath + '/awsS3credentials/secretKey',
                                                                                                                                            schemaPath: 'urn:wisepipe-common-auth:AwsCredentials/properties/secretKey/minLength',
                                                                                                                                            keyword: 'minLength',
                                                                                                                                            params: { limit: 1 },
                                                                                                                                            message: 'must NOT have fewer than 1 characters'
                                                                                                                                        }
                                                                                                                                    ];
                                                                                                                                    return false;
                                                                                                                                }
                                                                                                                            }
                                                                                                                            else {
                                                                                                                                validate75.errors = [
                                                                                                                                    {
                                                                                                                                        instancePath: instancePath + '/awsS3credentials/secretKey',
                                                                                                                                        schemaPath: 'urn:wisepipe-common-auth:AwsCredentials/properties/secretKey/type',
                                                                                                                                        keyword: 'type',
                                                                                                                                        params: { type: 'string' },
                                                                                                                                        message: 'must be string'
                                                                                                                                    }
                                                                                                                                ];
                                                                                                                                return false;
                                                                                                                            }
                                                                                                                        }
                                                                                                                        var valid7 = _errs63 === errors;
                                                                                                                    }
                                                                                                                    else {
                                                                                                                        var valid7 = true;
                                                                                                                    }
                                                                                                                    if (valid7) {
                                                                                                                        if (data27.sessionToken !== undefined) {
                                                                                                                            let data31 = data27.sessionToken;
                                                                                                                            const _errs65 = errors;
                                                                                                                            if (errors === _errs65) {
                                                                                                                                if (typeof data31 === 'string') {
                                                                                                                                    if (func2(data31) < 1) {
                                                                                                                                        validate75.errors = [
                                                                                                                                            {
                                                                                                                                                instancePath: instancePath +
                                                                                                                                                    '/awsS3credentials/sessionToken',
                                                                                                                                                schemaPath: 'urn:wisepipe-common-auth:AwsCredentials/properties/sessionToken/minLength',
                                                                                                                                                keyword: 'minLength',
                                                                                                                                                params: { limit: 1 },
                                                                                                                                                message: 'must NOT have fewer than 1 characters'
                                                                                                                                            }
                                                                                                                                        ];
                                                                                                                                        return false;
                                                                                                                                    }
                                                                                                                                }
                                                                                                                                else {
                                                                                                                                    validate75.errors = [
                                                                                                                                        {
                                                                                                                                            instancePath: instancePath + '/awsS3credentials/sessionToken',
                                                                                                                                            schemaPath: 'urn:wisepipe-common-auth:AwsCredentials/properties/sessionToken/type',
                                                                                                                                            keyword: 'type',
                                                                                                                                            params: { type: 'string' },
                                                                                                                                            message: 'must be string'
                                                                                                                                        }
                                                                                                                                    ];
                                                                                                                                    return false;
                                                                                                                                }
                                                                                                                            }
                                                                                                                            var valid7 = _errs65 === errors;
                                                                                                                        }
                                                                                                                        else {
                                                                                                                            var valid7 = true;
                                                                                                                        }
                                                                                                                        if (valid7) {
                                                                                                                            if (data27.expiration !== undefined) {
                                                                                                                                let data32 = data27.expiration;
                                                                                                                                const _errs67 = errors;
                                                                                                                                if (errors === _errs67) {
                                                                                                                                    if (errors === _errs67) {
                                                                                                                                        if (typeof data32 === 'string') {
                                                                                                                                            if (!formats0.validate(data32)) {
                                                                                                                                                validate75.errors = [
                                                                                                                                                    {
                                                                                                                                                        instancePath: instancePath +
                                                                                                                                                            '/awsS3credentials/expiration',
                                                                                                                                                        schemaPath: 'urn:wisepipe-common-auth:AwsCredentials/properties/expiration/format',
                                                                                                                                                        keyword: 'format',
                                                                                                                                                        params: { format: 'date-time' },
                                                                                                                                                        message: 'must match format "' + 'date-time' + '"'
                                                                                                                                                    }
                                                                                                                                                ];
                                                                                                                                                return false;
                                                                                                                                            }
                                                                                                                                        }
                                                                                                                                        else {
                                                                                                                                            validate75.errors = [
                                                                                                                                                {
                                                                                                                                                    instancePath: instancePath +
                                                                                                                                                        '/awsS3credentials/expiration',
                                                                                                                                                    schemaPath: 'urn:wisepipe-common-auth:AwsCredentials/properties/expiration/type',
                                                                                                                                                    keyword: 'type',
                                                                                                                                                    params: { type: 'string' },
                                                                                                                                                    message: 'must be string'
                                                                                                                                                }
                                                                                                                                            ];
                                                                                                                                            return false;
                                                                                                                                        }
                                                                                                                                    }
                                                                                                                                }
                                                                                                                                var valid7 = _errs67 === errors;
                                                                                                                            }
                                                                                                                            else {
                                                                                                                                var valid7 = true;
                                                                                                                            }
                                                                                                                            if (valid7) {
                                                                                                                                if (data27.region !== undefined) {
                                                                                                                                    const _errs69 = errors;
                                                                                                                                    if (typeof data27.region !== 'string') {
                                                                                                                                        validate75.errors = [
                                                                                                                                            {
                                                                                                                                                instancePath: instancePath + '/awsS3credentials/region',
                                                                                                                                                schemaPath: 'urn:wisepipe-common-auth:AwsCredentials/properties/region/type',
                                                                                                                                                keyword: 'type',
                                                                                                                                                params: { type: 'string' },
                                                                                                                                                message: 'must be string'
                                                                                                                                            }
                                                                                                                                        ];
                                                                                                                                        return false;
                                                                                                                                    }
                                                                                                                                    var valid7 = _errs69 === errors;
                                                                                                                                }
                                                                                                                                else {
                                                                                                                                    var valid7 = true;
                                                                                                                                }
                                                                                                                            }
                                                                                                                        }
                                                                                                                    }
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                    else {
                                                                                                        validate75.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/awsS3credentials',
                                                                                                                schemaPath: 'urn:wisepipe-common-auth:AwsCredentials/type',
                                                                                                                keyword: 'type',
                                                                                                                params: { type: 'object' },
                                                                                                                message: 'must be object'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                }
                                                                                                var valid0 = _errs56 === errors;
                                                                                            }
                                                                                            else {
                                                                                                var valid0 = true;
                                                                                            }
                                                                                            if (valid0) {
                                                                                                if (data.tempS3UploadFolder !== undefined) {
                                                                                                    let data34 = data.tempS3UploadFolder;
                                                                                                    const _errs71 = errors;
                                                                                                    const _errs72 = errors;
                                                                                                    if (errors === _errs72) {
                                                                                                        if (data34 && typeof data34 == 'object' && !Array.isArray(data34)) {
                                                                                                            let missing4;
                                                                                                            if ((data34.bucket === undefined && (missing4 = 'bucket')) ||
                                                                                                                (data34.key === undefined && (missing4 = 'key'))) {
                                                                                                                validate75.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/tempS3UploadFolder',
                                                                                                                        schemaPath: 'urn:wisepipe-common:S3File/required',
                                                                                                                        keyword: 'required',
                                                                                                                        params: { missingProperty: missing4 },
                                                                                                                        message: "must have required property '" + missing4 + "'"
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                            else {
                                                                                                                if (data34.bucket !== undefined) {
                                                                                                                    let data35 = data34.bucket;
                                                                                                                    const _errs74 = errors;
                                                                                                                    if (errors === _errs74) {
                                                                                                                        if (typeof data35 === 'string') {
                                                                                                                            if (func2(data35) < 1) {
                                                                                                                                validate75.errors = [
                                                                                                                                    {
                                                                                                                                        instancePath: instancePath + '/tempS3UploadFolder/bucket',
                                                                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                                                                                                        keyword: 'minLength',
                                                                                                                                        params: { limit: 1 },
                                                                                                                                        message: 'must NOT have fewer than 1 characters'
                                                                                                                                    }
                                                                                                                                ];
                                                                                                                                return false;
                                                                                                                            }
                                                                                                                        }
                                                                                                                        else {
                                                                                                                            validate75.errors = [
                                                                                                                                {
                                                                                                                                    instancePath: instancePath + '/tempS3UploadFolder/bucket',
                                                                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                                                                                                    keyword: 'type',
                                                                                                                                    params: { type: 'string' },
                                                                                                                                    message: 'must be string'
                                                                                                                                }
                                                                                                                            ];
                                                                                                                            return false;
                                                                                                                        }
                                                                                                                    }
                                                                                                                    var valid9 = _errs74 === errors;
                                                                                                                }
                                                                                                                else {
                                                                                                                    var valid9 = true;
                                                                                                                }
                                                                                                                if (valid9) {
                                                                                                                    if (data34.key !== undefined) {
                                                                                                                        let data36 = data34.key;
                                                                                                                        const _errs76 = errors;
                                                                                                                        if (errors === _errs76) {
                                                                                                                            if (typeof data36 === 'string') {
                                                                                                                                if (func2(data36) < 1) {
                                                                                                                                    validate75.errors = [
                                                                                                                                        {
                                                                                                                                            instancePath: instancePath + '/tempS3UploadFolder/key',
                                                                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                                                                                                            keyword: 'minLength',
                                                                                                                                            params: { limit: 1 },
                                                                                                                                            message: 'must NOT have fewer than 1 characters'
                                                                                                                                        }
                                                                                                                                    ];
                                                                                                                                    return false;
                                                                                                                                }
                                                                                                                            }
                                                                                                                            else {
                                                                                                                                validate75.errors = [
                                                                                                                                    {
                                                                                                                                        instancePath: instancePath + '/tempS3UploadFolder/key',
                                                                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                                                                                                        keyword: 'type',
                                                                                                                                        params: { type: 'string' },
                                                                                                                                        message: 'must be string'
                                                                                                                                    }
                                                                                                                                ];
                                                                                                                                return false;
                                                                                                                            }
                                                                                                                        }
                                                                                                                        var valid9 = _errs76 === errors;
                                                                                                                    }
                                                                                                                    else {
                                                                                                                        var valid9 = true;
                                                                                                                    }
                                                                                                                    if (valid9) {
                                                                                                                        if (data34.uploadID !== undefined) {
                                                                                                                            let data37 = data34.uploadID;
                                                                                                                            const _errs78 = errors;
                                                                                                                            if (errors === _errs78) {
                                                                                                                                if (typeof data37 === 'string') {
                                                                                                                                    const b64min1 = Math.ceil((4 * 9) / 3);
                                                                                                                                    const b64max1 = Math.ceil((4 * 9) / 3) + 3;
                                                                                                                                    if (func322(data37) < b64min1 ||
                                                                                                                                        func322(data37) > b64max1) {
                                                                                                                                        validate75.errors = [
                                                                                                                                            {
                                                                                                                                                instancePath: instancePath + '/tempS3UploadFolder/uploadID',
                                                                                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                                                                keyword: 'uid',
                                                                                                                                                params: {
                                                                                                                                                    error: 'encoded',
                                                                                                                                                    b64min: b64min1,
                                                                                                                                                    b64max: b64max1,
                                                                                                                                                    length: func322(data37)
                                                                                                                                                },
                                                                                                                                                message: 'length must be between ' +
                                                                                                                                                    b64min1 +
                                                                                                                                                    ' and ' +
                                                                                                                                                    b64max1 +
                                                                                                                                                    ', but is ' +
                                                                                                                                                    func322(data37)
                                                                                                                                            }
                                                                                                                                        ];
                                                                                                                                        return false;
                                                                                                                                    }
                                                                                                                                    else {
                                                                                                                                        const decoded1 = func323(data37);
                                                                                                                                        if (decoded1.length !== 9) {
                                                                                                                                            validate75.errors = [
                                                                                                                                                {
                                                                                                                                                    instancePath: instancePath +
                                                                                                                                                        '/tempS3UploadFolder/uploadID',
                                                                                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                                                                    keyword: 'uid',
                                                                                                                                                    params: { error: 'decoded' },
                                                                                                                                                    message: 'must decode to 9 bytes'
                                                                                                                                                }
                                                                                                                                            ];
                                                                                                                                            return false;
                                                                                                                                        }
                                                                                                                                        else {
                                                                                                                                            const encoded1 = func324(decoded1);
                                                                                                                                            if (func325(encoded1) !== func325(data37)) {
                                                                                                                                                validate75.errors = [
                                                                                                                                                    {
                                                                                                                                                        instancePath: instancePath +
                                                                                                                                                            '/tempS3UploadFolder/uploadID',
                                                                                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                                                                        keyword: 'uid',
                                                                                                                                                        params: { error: 'ambiguous' },
                                                                                                                                                        message: 'encoding is ambiguous'
                                                                                                                                                    }
                                                                                                                                                ];
                                                                                                                                                return false;
                                                                                                                                            }
                                                                                                                                        }
                                                                                                                                    }
                                                                                                                                }
                                                                                                                                else {
                                                                                                                                    validate75.errors = [
                                                                                                                                        {
                                                                                                                                            instancePath: instancePath + '/tempS3UploadFolder/uploadID',
                                                                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                                                                                                            keyword: 'type',
                                                                                                                                            params: { type: 'string' },
                                                                                                                                            message: 'must be string'
                                                                                                                                        }
                                                                                                                                    ];
                                                                                                                                    return false;
                                                                                                                                }
                                                                                                                            }
                                                                                                                            var valid9 = _errs78 === errors;
                                                                                                                        }
                                                                                                                        else {
                                                                                                                            var valid9 = true;
                                                                                                                        }
                                                                                                                    }
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                        else {
                                                                                                            validate75.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/tempS3UploadFolder',
                                                                                                                    schemaPath: 'urn:wisepipe-common:S3File/type',
                                                                                                                    keyword: 'type',
                                                                                                                    params: { type: 'object' },
                                                                                                                    message: 'must be object'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                    }
                                                                                                    var valid0 = _errs71 === errors;
                                                                                                }
                                                                                                else {
                                                                                                    var valid0 = true;
                                                                                                }
                                                                                                if (valid0) {
                                                                                                    if (data.taskAuthInfo !== undefined) {
                                                                                                        let data38 = data.taskAuthInfo;
                                                                                                        const _errs80 = errors;
                                                                                                        const _errs81 = errors;
                                                                                                        if (errors === _errs81) {
                                                                                                            if (data38 &&
                                                                                                                typeof data38 == 'object' &&
                                                                                                                !Array.isArray(data38)) {
                                                                                                                let missing5;
                                                                                                                if ((data38.orgID === undefined && (missing5 = 'orgID')) ||
                                                                                                                    (data38.userID === undefined && (missing5 = 'userID')) ||
                                                                                                                    (data38.taskID === undefined && (missing5 = 'taskID')) ||
                                                                                                                    (data38.taskAuthToken === undefined &&
                                                                                                                        (missing5 = 'taskAuthToken')) ||
                                                                                                                    (data38.expiration === undefined && (missing5 = 'expiration'))) {
                                                                                                                    validate75.errors = [
                                                                                                                        {
                                                                                                                            instancePath: instancePath + '/taskAuthInfo',
                                                                                                                            schemaPath: 'urn:wisepipe-common-auth:TaskAuthInfo/required',
                                                                                                                            keyword: 'required',
                                                                                                                            params: { missingProperty: missing5 },
                                                                                                                            message: "must have required property '" + missing5 + "'"
                                                                                                                        }
                                                                                                                    ];
                                                                                                                    return false;
                                                                                                                }
                                                                                                                else {
                                                                                                                    if (data38.orgID !== undefined) {
                                                                                                                        let data39 = data38.orgID;
                                                                                                                        const _errs83 = errors;
                                                                                                                        if (errors === _errs83) {
                                                                                                                            if (errors === _errs83) {
                                                                                                                                if (typeof data39 === 'string') {
                                                                                                                                    if (!formats4.test(data39)) {
                                                                                                                                        validate75.errors = [
                                                                                                                                            {
                                                                                                                                                instancePath: instancePath + '/taskAuthInfo/orgID',
                                                                                                                                                schemaPath: 'urn:wisepipe-common-auth:TaskAuthInfo/properties/orgID/format',
                                                                                                                                                keyword: 'format',
                                                                                                                                                params: { format: 'uuid' },
                                                                                                                                                message: 'must match format "' + 'uuid' + '"'
                                                                                                                                            }
                                                                                                                                        ];
                                                                                                                                        return false;
                                                                                                                                    }
                                                                                                                                }
                                                                                                                                else {
                                                                                                                                    validate75.errors = [
                                                                                                                                        {
                                                                                                                                            instancePath: instancePath + '/taskAuthInfo/orgID',
                                                                                                                                            schemaPath: 'urn:wisepipe-common-auth:TaskAuthInfo/properties/orgID/type',
                                                                                                                                            keyword: 'type',
                                                                                                                                            params: { type: 'string' },
                                                                                                                                            message: 'must be string'
                                                                                                                                        }
                                                                                                                                    ];
                                                                                                                                    return false;
                                                                                                                                }
                                                                                                                            }
                                                                                                                        }
                                                                                                                        var valid12 = _errs83 === errors;
                                                                                                                    }
                                                                                                                    else {
                                                                                                                        var valid12 = true;
                                                                                                                    }
                                                                                                                    if (valid12) {
                                                                                                                        if (data38.userID !== undefined) {
                                                                                                                            let data40 = data38.userID;
                                                                                                                            const _errs85 = errors;
                                                                                                                            if (errors === _errs85) {
                                                                                                                                if (errors === _errs85) {
                                                                                                                                    if (typeof data40 === 'string') {
                                                                                                                                        if (!formats4.test(data40)) {
                                                                                                                                            validate75.errors = [
                                                                                                                                                {
                                                                                                                                                    instancePath: instancePath + '/taskAuthInfo/userID',
                                                                                                                                                    schemaPath: 'urn:wisepipe-common-auth:TaskAuthInfo/properties/userID/format',
                                                                                                                                                    keyword: 'format',
                                                                                                                                                    params: { format: 'uuid' },
                                                                                                                                                    message: 'must match format "' + 'uuid' + '"'
                                                                                                                                                }
                                                                                                                                            ];
                                                                                                                                            return false;
                                                                                                                                        }
                                                                                                                                    }
                                                                                                                                    else {
                                                                                                                                        validate75.errors = [
                                                                                                                                            {
                                                                                                                                                instancePath: instancePath + '/taskAuthInfo/userID',
                                                                                                                                                schemaPath: 'urn:wisepipe-common-auth:TaskAuthInfo/properties/userID/type',
                                                                                                                                                keyword: 'type',
                                                                                                                                                params: { type: 'string' },
                                                                                                                                                message: 'must be string'
                                                                                                                                            }
                                                                                                                                        ];
                                                                                                                                        return false;
                                                                                                                                    }
                                                                                                                                }
                                                                                                                            }
                                                                                                                            var valid12 = _errs85 === errors;
                                                                                                                        }
                                                                                                                        else {
                                                                                                                            var valid12 = true;
                                                                                                                        }
                                                                                                                        if (valid12) {
                                                                                                                            if (data38.taskID !== undefined) {
                                                                                                                                const _errs87 = errors;
                                                                                                                                if (typeof data38.taskID !== 'string') {
                                                                                                                                    validate75.errors = [
                                                                                                                                        {
                                                                                                                                            instancePath: instancePath + '/taskAuthInfo/taskID',
                                                                                                                                            schemaPath: 'urn:wisepipe-common-auth:TaskAuthInfo/properties/taskID/type',
                                                                                                                                            keyword: 'type',
                                                                                                                                            params: { type: 'string' },
                                                                                                                                            message: 'must be string'
                                                                                                                                        }
                                                                                                                                    ];
                                                                                                                                    return false;
                                                                                                                                }
                                                                                                                                var valid12 = _errs87 === errors;
                                                                                                                            }
                                                                                                                            else {
                                                                                                                                var valid12 = true;
                                                                                                                            }
                                                                                                                            if (valid12) {
                                                                                                                                if (data38.taskAuthToken !== undefined) {
                                                                                                                                    const _errs89 = errors;
                                                                                                                                    if (typeof data38.taskAuthToken !== 'string') {
                                                                                                                                        validate75.errors = [
                                                                                                                                            {
                                                                                                                                                instancePath: instancePath + '/taskAuthInfo/taskAuthToken',
                                                                                                                                                schemaPath: 'urn:wisepipe-common-auth:TaskAuthInfo/properties/taskAuthToken/type',
                                                                                                                                                keyword: 'type',
                                                                                                                                                params: { type: 'string' },
                                                                                                                                                message: 'must be string'
                                                                                                                                            }
                                                                                                                                        ];
                                                                                                                                        return false;
                                                                                                                                    }
                                                                                                                                    var valid12 = _errs89 === errors;
                                                                                                                                }
                                                                                                                                else {
                                                                                                                                    var valid12 = true;
                                                                                                                                }
                                                                                                                                if (valid12) {
                                                                                                                                    if (data38.expiration !== undefined) {
                                                                                                                                        let data43 = data38.expiration;
                                                                                                                                        const _errs91 = errors;
                                                                                                                                        if (!(typeof data43 == 'number' &&
                                                                                                                                            !(data43 % 1) &&
                                                                                                                                            !isNaN(data43))) {
                                                                                                                                            validate75.errors = [
                                                                                                                                                {
                                                                                                                                                    instancePath: instancePath + '/taskAuthInfo/expiration',
                                                                                                                                                    schemaPath: 'urn:wisepipe-common-auth:TaskAuthInfo/properties/expiration/type',
                                                                                                                                                    keyword: 'type',
                                                                                                                                                    params: { type: 'integer' },
                                                                                                                                                    message: 'must be integer'
                                                                                                                                                }
                                                                                                                                            ];
                                                                                                                                            return false;
                                                                                                                                        }
                                                                                                                                        var valid12 = _errs91 === errors;
                                                                                                                                    }
                                                                                                                                    else {
                                                                                                                                        var valid12 = true;
                                                                                                                                    }
                                                                                                                                    if (valid12) {
                                                                                                                                        if (data38.endpoint !== undefined) {
                                                                                                                                            const _errs93 = errors;
                                                                                                                                            if (typeof data38.endpoint !== 'string') {
                                                                                                                                                validate75.errors = [
                                                                                                                                                    {
                                                                                                                                                        instancePath: instancePath + '/taskAuthInfo/endpoint',
                                                                                                                                                        schemaPath: 'urn:wisepipe-common-auth:TaskAuthInfo/properties/endpoint/type',
                                                                                                                                                        keyword: 'type',
                                                                                                                                                        params: { type: 'string' },
                                                                                                                                                        message: 'must be string'
                                                                                                                                                    }
                                                                                                                                                ];
                                                                                                                                                return false;
                                                                                                                                            }
                                                                                                                                            var valid12 = _errs93 === errors;
                                                                                                                                        }
                                                                                                                                        else {
                                                                                                                                            var valid12 = true;
                                                                                                                                        }
                                                                                                                                    }
                                                                                                                                }
                                                                                                                            }
                                                                                                                        }
                                                                                                                    }
                                                                                                                }
                                                                                                            }
                                                                                                            else {
                                                                                                                validate75.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/taskAuthInfo',
                                                                                                                        schemaPath: 'urn:wisepipe-common-auth:TaskAuthInfo/type',
                                                                                                                        keyword: 'type',
                                                                                                                        params: { type: 'object' },
                                                                                                                        message: 'must be object'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                        }
                                                                                                        var valid0 = _errs80 === errors;
                                                                                                    }
                                                                                                    else {
                                                                                                        var valid0 = true;
                                                                                                    }
                                                                                                    if (valid0) {
                                                                                                        if (data.transient !== undefined) {
                                                                                                            const _errs95 = errors;
                                                                                                            if (typeof data.transient !== 'boolean') {
                                                                                                                validate75.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/transient',
                                                                                                                        schemaPath: '#/properties/transient/type',
                                                                                                                        keyword: 'type',
                                                                                                                        params: { type: 'boolean' },
                                                                                                                        message: 'must be boolean'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                            var valid0 = _errs95 === errors;
                                                                                                        }
                                                                                                        else {
                                                                                                            var valid0 = true;
                                                                                                        }
                                                                                                        if (valid0) {
                                                                                                            if (data.encryptionSecretName !== undefined) {
                                                                                                                let data46 = data.encryptionSecretName;
                                                                                                                const _errs97 = errors;
                                                                                                                if (errors === _errs97) {
                                                                                                                    if (typeof data46 === 'string') {
                                                                                                                        if (func2(data46) < 1) {
                                                                                                                            validate75.errors = [
                                                                                                                                {
                                                                                                                                    instancePath: instancePath + '/encryptionSecretName',
                                                                                                                                    schemaPath: '#/properties/encryptionSecretName/minLength',
                                                                                                                                    keyword: 'minLength',
                                                                                                                                    params: { limit: 1 },
                                                                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                                                                }
                                                                                                                            ];
                                                                                                                            return false;
                                                                                                                        }
                                                                                                                    }
                                                                                                                    else {
                                                                                                                        validate75.errors = [
                                                                                                                            {
                                                                                                                                instancePath: instancePath + '/encryptionSecretName',
                                                                                                                                schemaPath: '#/properties/encryptionSecretName/type',
                                                                                                                                keyword: 'type',
                                                                                                                                params: { type: 'string' },
                                                                                                                                message: 'must be string'
                                                                                                                            }
                                                                                                                        ];
                                                                                                                        return false;
                                                                                                                    }
                                                                                                                }
                                                                                                                var valid0 = _errs97 === errors;
                                                                                                            }
                                                                                                            else {
                                                                                                                var valid0 = true;
                                                                                                            }
                                                                                                            if (valid0) {
                                                                                                                if (data.oldDataSources !== undefined) {
                                                                                                                    let data47 = data.oldDataSources;
                                                                                                                    const _errs99 = errors;
                                                                                                                    if (errors === _errs99) {
                                                                                                                        if (Array.isArray(data47)) {
                                                                                                                            var valid13 = true;
                                                                                                                            const len0 = data47.length;
                                                                                                                            for (let i0 = 0; i0 < len0; i0++) {
                                                                                                                                const _errs101 = errors;
                                                                                                                                if (!validate25(data47[i0], {
                                                                                                                                    instancePath: instancePath + '/oldDataSources/' + i0,
                                                                                                                                    parentData: data47,
                                                                                                                                    parentDataProperty: i0,
                                                                                                                                    rootData
                                                                                                                                })) {
                                                                                                                                    vErrors =
                                                                                                                                        vErrors === null
                                                                                                                                            ? validate25.errors
                                                                                                                                            : vErrors.concat(validate25.errors);
                                                                                                                                    errors = vErrors.length;
                                                                                                                                }
                                                                                                                                var valid13 = _errs101 === errors;
                                                                                                                                if (!valid13) {
                                                                                                                                    break;
                                                                                                                                }
                                                                                                                            }
                                                                                                                        }
                                                                                                                        else {
                                                                                                                            validate75.errors = [
                                                                                                                                {
                                                                                                                                    instancePath: instancePath + '/oldDataSources',
                                                                                                                                    schemaPath: '#/properties/oldDataSources/type',
                                                                                                                                    keyword: 'type',
                                                                                                                                    params: { type: 'array' },
                                                                                                                                    message: 'must be array'
                                                                                                                                }
                                                                                                                            ];
                                                                                                                            return false;
                                                                                                                        }
                                                                                                                    }
                                                                                                                    var valid0 = _errs99 === errors;
                                                                                                                }
                                                                                                                else {
                                                                                                                    var valid0 = true;
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate75.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate75.errors = vErrors;
    return errors === 0;
}
function validate70(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:ImportInput" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.importTask !== undefined) {
                const _errs1 = errors;
                if (!validate71(data.importTask, {
                    instancePath: instancePath + '/importTask',
                    parentData: data,
                    parentDataProperty: 'importTask',
                    rootData
                })) {
                    vErrors = vErrors === null ? validate71.errors : vErrors.concat(validate71.errors);
                    errors = vErrors.length;
                }
                var valid0 = _errs1 === errors;
            }
            else {
                var valid0 = true;
            }
            if (valid0) {
                if (data.importTaskEnv !== undefined) {
                    const _errs2 = errors;
                    if (!validate75(data.importTaskEnv, {
                        instancePath: instancePath + '/importTaskEnv',
                        parentData: data,
                        parentDataProperty: 'importTaskEnv',
                        rootData
                    })) {
                        vErrors = vErrors === null ? validate75.errors : vErrors.concat(validate75.errors);
                        errors = vErrors.length;
                    }
                    var valid0 = _errs2 === errors;
                }
                else {
                    var valid0 = true;
                }
            }
        }
        else {
            validate70.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate70.errors = vErrors;
    return errors === 0;
}
export const importRefreshSchemaValidation = validate81;
const schema120 = {
    $id: 'urn:wisepipe-common-data:ImportRefresh',
    type: 'object',
    properties: { importID: { type: 'string', uid: 9 }, taskToken: { type: 'string', minLength: 1 } },
    required: ['importID']
};
const func327 = ucs2length;
const func328 = base64urlToBuffer;
const func329 = base64urlEncode;
const func330 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate81(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:ImportRefresh" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.importID === undefined && (missing0 = 'importID')) {
                validate81.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.importID !== undefined) {
                    let data0 = data.importID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 9) / 3);
                            const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                            if (func327(data0) < b64min0 || func327(data0) > b64max0) {
                                validate81.errors = [
                                    {
                                        instancePath: instancePath + '/importID',
                                        schemaPath: '#/properties/importID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func327(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func327(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func328(data0);
                                if (decoded0.length !== 9) {
                                    validate81.errors = [
                                        {
                                            instancePath: instancePath + '/importID',
                                            schemaPath: '#/properties/importID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 9 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func329(decoded0);
                                    if (func330(encoded0) !== func330(data0)) {
                                        validate81.errors = [
                                            {
                                                instancePath: instancePath + '/importID',
                                                schemaPath: '#/properties/importID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate81.errors = [
                                {
                                    instancePath: instancePath + '/importID',
                                    schemaPath: '#/properties/importID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.taskToken !== undefined) {
                        let data1 = data.taskToken;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate81.errors = [
                                        {
                                            instancePath: instancePath + '/taskToken',
                                            schemaPath: '#/properties/taskToken/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate81.errors = [
                                    {
                                        instancePath: instancePath + '/taskToken',
                                        schemaPath: '#/properties/taskToken/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate81.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate81.errors = vErrors;
    return errors === 0;
}
export const importStatusCheckingEventSchemaValidation = validate82;
const schema121 = {
    $id: 'urn:wisepipe-common-data:ImportStatusCheckingEvent',
    type: 'object',
    properties: {
        status: { type: 'string', enum: ['waiting', 'running', 'completed', 'failed', 'cancelled'] },
        importTask: { $ref: 'urn:wisepipe-common-data:ImportTask' }
    },
    required: ['status', 'importTask']
};
function validate82(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:ImportStatusCheckingEvent" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.status === undefined && (missing0 = 'status')) ||
                (data.importTask === undefined && (missing0 = 'importTask'))) {
                validate82.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.status !== undefined) {
                    let data0 = data.status;
                    const _errs1 = errors;
                    if (typeof data0 !== 'string') {
                        validate82.errors = [
                            {
                                instancePath: instancePath + '/status',
                                schemaPath: '#/properties/status/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'waiting' ||
                        data0 === 'running' ||
                        data0 === 'completed' ||
                        data0 === 'failed' ||
                        data0 === 'cancelled')) {
                        validate82.errors = [
                            {
                                instancePath: instancePath + '/status',
                                schemaPath: '#/properties/status/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema121.properties.status.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.importTask !== undefined) {
                        const _errs3 = errors;
                        if (!validate71(data.importTask, {
                            instancePath: instancePath + '/importTask',
                            parentData: data,
                            parentDataProperty: 'importTask',
                            rootData
                        })) {
                            vErrors = vErrors === null ? validate71.errors : vErrors.concat(validate71.errors);
                            errors = vErrors.length;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate82.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate82.errors = vErrors;
    return errors === 0;
}
export const importTaskEnvSchemaValidation = validate75;
export const importTaskSchemaValidation = validate71;
export const incentivesCalendarSchemaValidation = validate84;
const schema122 = {
    $id: 'urn:wisepipe-common-data:IncentivesCalendar',
    type: 'object',
    properties: {
        calendarID: { type: 'string', minLength: 1 },
        timeLevels: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-data:IncentivesTimeLevel' },
            uniqueItemProperties: ['order', 'level']
        },
        periods: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-data:IncentivesPeriod' },
            uniqueItemProperties: ['name']
        },
        lastModified: { type: 'string', format: 'date-time' },
        lastLockedPeriod: { type: 'string', minLength: 1 }
    },
    required: ['calendarID', 'timeLevels', 'periods', 'lastModified']
};
const schema123 = {
    $id: 'urn:wisepipe-common-data:IncentivesTimeLevel',
    type: 'object',
    properties: { order: { type: 'number', minimum: 0 }, level: { type: 'string', minLength: 1 } },
    required: ['order', 'level']
};
const schema124 = {
    $id: 'urn:wisepipe-common-data:IncentivesPeriod',
    type: 'object',
    properties: {
        name: { type: 'string', minLength: 1 },
        level: { type: 'string', minLength: 1 },
        parentPeriod: { type: 'string', minLength: 1 },
        start: { type: 'string', format: 'date' },
        end: { type: 'string', format: 'date' }
    },
    required: ['name', 'level', 'start', 'end']
};
const func334 = ajvEqual;
const func338 = ajvEqual;
const formats58 = formatWrapper.date;
function validate84(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:IncentivesCalendar" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.calendarID === undefined && (missing0 = 'calendarID')) ||
                (data.timeLevels === undefined && (missing0 = 'timeLevels')) ||
                (data.periods === undefined && (missing0 = 'periods')) ||
                (data.lastModified === undefined && (missing0 = 'lastModified'))) {
                validate84.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.calendarID !== undefined) {
                    let data0 = data.calendarID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate84.errors = [
                                    {
                                        instancePath: instancePath + '/calendarID',
                                        schemaPath: '#/properties/calendarID/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate84.errors = [
                                {
                                    instancePath: instancePath + '/calendarID',
                                    schemaPath: '#/properties/calendarID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.timeLevels !== undefined) {
                        let data1 = data.timeLevels;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (Array.isArray(data1)) {
                                var valid1 = true;
                                const len0 = data1.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data2 = data1[i0];
                                    const _errs5 = errors;
                                    const _errs6 = errors;
                                    if (errors === _errs6) {
                                        if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                            let missing1;
                                            if ((data2.order === undefined && (missing1 = 'order')) ||
                                                (data2.level === undefined && (missing1 = 'level'))) {
                                                validate84.errors = [
                                                    {
                                                        instancePath: instancePath + '/timeLevels/' + i0,
                                                        schemaPath: 'urn:wisepipe-common-data:IncentivesTimeLevel/required',
                                                        keyword: 'required',
                                                        params: { missingProperty: missing1 },
                                                        message: "must have required property '" + missing1 + "'"
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (data2.order !== undefined) {
                                                    let data3 = data2.order;
                                                    const _errs8 = errors;
                                                    if (errors === _errs8) {
                                                        if (typeof data3 == 'number') {
                                                            if (data3 < 0 || isNaN(data3)) {
                                                                validate84.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/timeLevels/' + i0 + '/order',
                                                                        schemaPath: 'urn:wisepipe-common-data:IncentivesTimeLevel/properties/order/minimum',
                                                                        keyword: 'minimum',
                                                                        params: { comparison: '>=', limit: 0 },
                                                                        message: 'must be >= 0'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate84.errors = [
                                                                {
                                                                    instancePath: instancePath + '/timeLevels/' + i0 + '/order',
                                                                    schemaPath: 'urn:wisepipe-common-data:IncentivesTimeLevel/properties/order/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'number' },
                                                                    message: 'must be number'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid3 = _errs8 === errors;
                                                }
                                                else {
                                                    var valid3 = true;
                                                }
                                                if (valid3) {
                                                    if (data2.level !== undefined) {
                                                        let data4 = data2.level;
                                                        const _errs10 = errors;
                                                        if (errors === _errs10) {
                                                            if (typeof data4 === 'string') {
                                                                if (func2(data4) < 1) {
                                                                    validate84.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/timeLevels/' + i0 + '/level',
                                                                            schemaPath: 'urn:wisepipe-common-data:IncentivesTimeLevel/properties/level/minLength',
                                                                            keyword: 'minLength',
                                                                            params: { limit: 1 },
                                                                            message: 'must NOT have fewer than 1 characters'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            else {
                                                                validate84.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/timeLevels/' + i0 + '/level',
                                                                        schemaPath: 'urn:wisepipe-common-data:IncentivesTimeLevel/properties/level/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid3 = _errs10 === errors;
                                                    }
                                                    else {
                                                        var valid3 = true;
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate84.errors = [
                                                {
                                                    instancePath: instancePath + '/timeLevels/' + i0,
                                                    schemaPath: 'urn:wisepipe-common-data:IncentivesTimeLevel/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid1 = _errs5 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                                if (valid1) {
                                    const keys0 = schema122.properties.timeLevels.uniqueItemProperties;
                                    let k0;
                                    let i1 = data1.length;
                                    let j0;
                                    if (i1 > 1) {
                                        outer0: for (k0 = 0; k0 < keys0.length; k0++) {
                                            let key0 = keys0[k0];
                                            for (i1 = data1.length; i1--;) {
                                                let x0 = data1[i1];
                                                if (!(x0 && typeof x0 == 'object' && !Array.isArray(x0))) {
                                                    continue;
                                                }
                                                for (j0 = i1; j0--;) {
                                                    let y0 = data1[j0];
                                                    if (y0 && typeof y0 == 'object' && !Array.isArray(y0) && func334(x0[key0], y0[key0])) {
                                                        validate84.errors = [
                                                            {
                                                                instancePath: instancePath + '/timeLevels',
                                                                schemaPath: '#/properties/timeLevels/uniqueItemProperties',
                                                                keyword: 'uniqueItemProperties',
                                                                params: {},
                                                                message: 'must pass "uniqueItemProperties" keyword validation'
                                                            }
                                                        ];
                                                        return false;
                                                        break outer0;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                validate84.errors = [
                                    {
                                        instancePath: instancePath + '/timeLevels',
                                        schemaPath: '#/properties/timeLevels/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.periods !== undefined) {
                            let data5 = data.periods;
                            const _errs12 = errors;
                            if (errors === _errs12) {
                                if (Array.isArray(data5)) {
                                    var valid5 = true;
                                    const len1 = data5.length;
                                    for (let i2 = 0; i2 < len1; i2++) {
                                        let data6 = data5[i2];
                                        const _errs14 = errors;
                                        const _errs15 = errors;
                                        if (errors === _errs15) {
                                            if (data6 && typeof data6 == 'object' && !Array.isArray(data6)) {
                                                let missing2;
                                                if ((data6.name === undefined && (missing2 = 'name')) ||
                                                    (data6.level === undefined && (missing2 = 'level')) ||
                                                    (data6.start === undefined && (missing2 = 'start')) ||
                                                    (data6.end === undefined && (missing2 = 'end'))) {
                                                    validate84.errors = [
                                                        {
                                                            instancePath: instancePath + '/periods/' + i2,
                                                            schemaPath: 'urn:wisepipe-common-data:IncentivesPeriod/required',
                                                            keyword: 'required',
                                                            params: { missingProperty: missing2 },
                                                            message: "must have required property '" + missing2 + "'"
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    if (data6.name !== undefined) {
                                                        let data7 = data6.name;
                                                        const _errs17 = errors;
                                                        if (errors === _errs17) {
                                                            if (typeof data7 === 'string') {
                                                                if (func2(data7) < 1) {
                                                                    validate84.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/periods/' + i2 + '/name',
                                                                            schemaPath: 'urn:wisepipe-common-data:IncentivesPeriod/properties/name/minLength',
                                                                            keyword: 'minLength',
                                                                            params: { limit: 1 },
                                                                            message: 'must NOT have fewer than 1 characters'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            else {
                                                                validate84.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/periods/' + i2 + '/name',
                                                                        schemaPath: 'urn:wisepipe-common-data:IncentivesPeriod/properties/name/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid7 = _errs17 === errors;
                                                    }
                                                    else {
                                                        var valid7 = true;
                                                    }
                                                    if (valid7) {
                                                        if (data6.level !== undefined) {
                                                            let data8 = data6.level;
                                                            const _errs19 = errors;
                                                            if (errors === _errs19) {
                                                                if (typeof data8 === 'string') {
                                                                    if (func2(data8) < 1) {
                                                                        validate84.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/periods/' + i2 + '/level',
                                                                                schemaPath: 'urn:wisepipe-common-data:IncentivesPeriod/properties/level/minLength',
                                                                                keyword: 'minLength',
                                                                                params: { limit: 1 },
                                                                                message: 'must NOT have fewer than 1 characters'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                else {
                                                                    validate84.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/periods/' + i2 + '/level',
                                                                            schemaPath: 'urn:wisepipe-common-data:IncentivesPeriod/properties/level/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid7 = _errs19 === errors;
                                                        }
                                                        else {
                                                            var valid7 = true;
                                                        }
                                                        if (valid7) {
                                                            if (data6.parentPeriod !== undefined) {
                                                                let data9 = data6.parentPeriod;
                                                                const _errs21 = errors;
                                                                if (errors === _errs21) {
                                                                    if (typeof data9 === 'string') {
                                                                        if (func2(data9) < 1) {
                                                                            validate84.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/periods/' + i2 + '/parentPeriod',
                                                                                    schemaPath: 'urn:wisepipe-common-data:IncentivesPeriod/properties/parentPeriod/minLength',
                                                                                    keyword: 'minLength',
                                                                                    params: { limit: 1 },
                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate84.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/periods/' + i2 + '/parentPeriod',
                                                                                schemaPath: 'urn:wisepipe-common-data:IncentivesPeriod/properties/parentPeriod/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                var valid7 = _errs21 === errors;
                                                            }
                                                            else {
                                                                var valid7 = true;
                                                            }
                                                            if (valid7) {
                                                                if (data6.start !== undefined) {
                                                                    let data10 = data6.start;
                                                                    const _errs23 = errors;
                                                                    if (errors === _errs23) {
                                                                        if (errors === _errs23) {
                                                                            if (typeof data10 === 'string') {
                                                                                if (!formats58.validate(data10)) {
                                                                                    validate84.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/periods/' + i2 + '/start',
                                                                                            schemaPath: 'urn:wisepipe-common-data:IncentivesPeriod/properties/start/format',
                                                                                            keyword: 'format',
                                                                                            params: { format: 'date' },
                                                                                            message: 'must match format "' + 'date' + '"'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            else {
                                                                                validate84.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/periods/' + i2 + '/start',
                                                                                        schemaPath: 'urn:wisepipe-common-data:IncentivesPeriod/properties/start/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                    }
                                                                    var valid7 = _errs23 === errors;
                                                                }
                                                                else {
                                                                    var valid7 = true;
                                                                }
                                                                if (valid7) {
                                                                    if (data6.end !== undefined) {
                                                                        let data11 = data6.end;
                                                                        const _errs25 = errors;
                                                                        if (errors === _errs25) {
                                                                            if (errors === _errs25) {
                                                                                if (typeof data11 === 'string') {
                                                                                    if (!formats58.validate(data11)) {
                                                                                        validate84.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/periods/' + i2 + '/end',
                                                                                                schemaPath: 'urn:wisepipe-common-data:IncentivesPeriod/properties/end/format',
                                                                                                keyword: 'format',
                                                                                                params: { format: 'date' },
                                                                                                message: 'must match format "' + 'date' + '"'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    validate84.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/periods/' + i2 + '/end',
                                                                                            schemaPath: 'urn:wisepipe-common-data:IncentivesPeriod/properties/end/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'string' },
                                                                                            message: 'must be string'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                        }
                                                                        var valid7 = _errs25 === errors;
                                                                    }
                                                                    else {
                                                                        var valid7 = true;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate84.errors = [
                                                    {
                                                        instancePath: instancePath + '/periods/' + i2,
                                                        schemaPath: 'urn:wisepipe-common-data:IncentivesPeriod/type',
                                                        keyword: 'type',
                                                        params: { type: 'object' },
                                                        message: 'must be object'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid5 = _errs14 === errors;
                                        if (!valid5) {
                                            break;
                                        }
                                    }
                                    if (valid5) {
                                        const keys1 = schema122.properties.periods.uniqueItemProperties;
                                        let k1;
                                        let i3 = data5.length;
                                        let j1;
                                        if (i3 > 1) {
                                            outer1: for (k1 = 0; k1 < keys1.length; k1++) {
                                                let key1 = keys1[k1];
                                                for (i3 = data5.length; i3--;) {
                                                    let x1 = data5[i3];
                                                    if (!(x1 && typeof x1 == 'object' && !Array.isArray(x1))) {
                                                        continue;
                                                    }
                                                    for (j1 = i3; j1--;) {
                                                        let y1 = data5[j1];
                                                        if (y1 && typeof y1 == 'object' && !Array.isArray(y1) && func338(x1[key1], y1[key1])) {
                                                            validate84.errors = [
                                                                {
                                                                    instancePath: instancePath + '/periods',
                                                                    schemaPath: '#/properties/periods/uniqueItemProperties',
                                                                    keyword: 'uniqueItemProperties',
                                                                    params: {},
                                                                    message: 'must pass "uniqueItemProperties" keyword validation'
                                                                }
                                                            ];
                                                            return false;
                                                            break outer1;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate84.errors = [
                                        {
                                            instancePath: instancePath + '/periods',
                                            schemaPath: '#/properties/periods/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs12 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.lastModified !== undefined) {
                                let data12 = data.lastModified;
                                const _errs27 = errors;
                                if (errors === _errs27) {
                                    if (errors === _errs27) {
                                        if (typeof data12 === 'string') {
                                            if (!formats0.validate(data12)) {
                                                validate84.errors = [
                                                    {
                                                        instancePath: instancePath + '/lastModified',
                                                        schemaPath: '#/properties/lastModified/format',
                                                        keyword: 'format',
                                                        params: { format: 'date-time' },
                                                        message: 'must match format "' + 'date-time' + '"'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate84.errors = [
                                                {
                                                    instancePath: instancePath + '/lastModified',
                                                    schemaPath: '#/properties/lastModified/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                var valid0 = _errs27 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.lastLockedPeriod !== undefined) {
                                    let data13 = data.lastLockedPeriod;
                                    const _errs29 = errors;
                                    if (errors === _errs29) {
                                        if (typeof data13 === 'string') {
                                            if (func2(data13) < 1) {
                                                validate84.errors = [
                                                    {
                                                        instancePath: instancePath + '/lastLockedPeriod',
                                                        schemaPath: '#/properties/lastLockedPeriod/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate84.errors = [
                                                {
                                                    instancePath: instancePath + '/lastLockedPeriod',
                                                    schemaPath: '#/properties/lastLockedPeriod/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs29 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate84.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate84.errors = vErrors;
    return errors === 0;
}
export const incentivesDataSourceSchemaValidation = validate85;
const schema125 = {
    $id: 'urn:wisepipe-common-data:IncentivesDataSource',
    type: 'object',
    properties: {
        dataSourceID: { type: 'string', pattern: '^([_\\p{L}][_\\p{L}0-9]*)$' },
        columns: { type: 'array', items: { $ref: 'urn:wisepipe-common-data:Column' }, uniqueItemProperties: ['name'] },
        lastModified: { type: 'string', format: 'date-time' },
        displayName: { type: 'string' }
    },
    required: ['dataSourceID', 'columns', 'lastModified']
};
const pattern5 = new RegExp('^([_\\p{L}][_\\p{L}0-9]*)$', 'u');
const func340 = ajvEqual;
function validate85(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:IncentivesDataSource" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.dataSourceID === undefined && (missing0 = 'dataSourceID')) ||
                (data.columns === undefined && (missing0 = 'columns')) ||
                (data.lastModified === undefined && (missing0 = 'lastModified'))) {
                validate85.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.dataSourceID !== undefined) {
                    let data0 = data.dataSourceID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (!pattern5.test(data0)) {
                                validate85.errors = [
                                    {
                                        instancePath: instancePath + '/dataSourceID',
                                        schemaPath: '#/properties/dataSourceID/pattern',
                                        keyword: 'pattern',
                                        params: { pattern: '^([_\\p{L}][_\\p{L}0-9]*)$' },
                                        message: 'must match pattern "' + '^([_\\p{L}][_\\p{L}0-9]*)$' + '"'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate85.errors = [
                                {
                                    instancePath: instancePath + '/dataSourceID',
                                    schemaPath: '#/properties/dataSourceID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.columns !== undefined) {
                        let data1 = data.columns;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (Array.isArray(data1)) {
                                var valid1 = true;
                                const len0 = data1.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    const _errs5 = errors;
                                    if (!validate17(data1[i0], {
                                        instancePath: instancePath + '/columns/' + i0,
                                        parentData: data1,
                                        parentDataProperty: i0,
                                        rootData
                                    })) {
                                        vErrors = vErrors === null ? validate17.errors : vErrors.concat(validate17.errors);
                                        errors = vErrors.length;
                                    }
                                    var valid1 = _errs5 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                                if (valid1) {
                                    const keys0 = schema125.properties.columns.uniqueItemProperties;
                                    let k0;
                                    let i1 = data1.length;
                                    let j0;
                                    if (i1 > 1) {
                                        outer0: for (k0 = 0; k0 < keys0.length; k0++) {
                                            let key0 = keys0[k0];
                                            for (i1 = data1.length; i1--;) {
                                                let x0 = data1[i1];
                                                if (!(x0 && typeof x0 == 'object' && !Array.isArray(x0))) {
                                                    continue;
                                                }
                                                for (j0 = i1; j0--;) {
                                                    let y0 = data1[j0];
                                                    if (y0 && typeof y0 == 'object' && !Array.isArray(y0) && func340(x0[key0], y0[key0])) {
                                                        validate85.errors = [
                                                            {
                                                                instancePath: instancePath + '/columns',
                                                                schemaPath: '#/properties/columns/uniqueItemProperties',
                                                                keyword: 'uniqueItemProperties',
                                                                params: {},
                                                                message: 'must pass "uniqueItemProperties" keyword validation'
                                                            }
                                                        ];
                                                        return false;
                                                        break outer0;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                validate85.errors = [
                                    {
                                        instancePath: instancePath + '/columns',
                                        schemaPath: '#/properties/columns/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.lastModified !== undefined) {
                            let data3 = data.lastModified;
                            const _errs6 = errors;
                            if (errors === _errs6) {
                                if (errors === _errs6) {
                                    if (typeof data3 === 'string') {
                                        if (!formats0.validate(data3)) {
                                            validate85.errors = [
                                                {
                                                    instancePath: instancePath + '/lastModified',
                                                    schemaPath: '#/properties/lastModified/format',
                                                    keyword: 'format',
                                                    params: { format: 'date-time' },
                                                    message: 'must match format "' + 'date-time' + '"'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate85.errors = [
                                            {
                                                instancePath: instancePath + '/lastModified',
                                                schemaPath: '#/properties/lastModified/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            var valid0 = _errs6 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.displayName !== undefined) {
                                const _errs8 = errors;
                                if (typeof data.displayName !== 'string') {
                                    validate85.errors = [
                                        {
                                            instancePath: instancePath + '/displayName',
                                            schemaPath: '#/properties/displayName/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs8 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate85.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate85.errors = vErrors;
    return errors === 0;
}
export const incentivesPeriodSchemaValidation = validate87;
function validate87(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:IncentivesPeriod" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.name === undefined && (missing0 = 'name')) ||
                (data.level === undefined && (missing0 = 'level')) ||
                (data.start === undefined && (missing0 = 'start')) ||
                (data.end === undefined && (missing0 = 'end'))) {
                validate87.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.name !== undefined) {
                    let data0 = data.name;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate87.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate87.errors = [
                                {
                                    instancePath: instancePath + '/name',
                                    schemaPath: '#/properties/name/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.level !== undefined) {
                        let data1 = data.level;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate87.errors = [
                                        {
                                            instancePath: instancePath + '/level',
                                            schemaPath: '#/properties/level/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate87.errors = [
                                    {
                                        instancePath: instancePath + '/level',
                                        schemaPath: '#/properties/level/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.parentPeriod !== undefined) {
                            let data2 = data.parentPeriod;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate87.errors = [
                                            {
                                                instancePath: instancePath + '/parentPeriod',
                                                schemaPath: '#/properties/parentPeriod/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate87.errors = [
                                        {
                                            instancePath: instancePath + '/parentPeriod',
                                            schemaPath: '#/properties/parentPeriod/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.start !== undefined) {
                                let data3 = data.start;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (errors === _errs7) {
                                        if (typeof data3 === 'string') {
                                            if (!formats58.validate(data3)) {
                                                validate87.errors = [
                                                    {
                                                        instancePath: instancePath + '/start',
                                                        schemaPath: '#/properties/start/format',
                                                        keyword: 'format',
                                                        params: { format: 'date' },
                                                        message: 'must match format "' + 'date' + '"'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate87.errors = [
                                                {
                                                    instancePath: instancePath + '/start',
                                                    schemaPath: '#/properties/start/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.end !== undefined) {
                                    let data4 = data.end;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (errors === _errs9) {
                                            if (typeof data4 === 'string') {
                                                if (!formats58.validate(data4)) {
                                                    validate87.errors = [
                                                        {
                                                            instancePath: instancePath + '/end',
                                                            schemaPath: '#/properties/end/format',
                                                            keyword: 'format',
                                                            params: { format: 'date' },
                                                            message: 'must match format "' + 'date' + '"'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate87.errors = [
                                                    {
                                                        instancePath: instancePath + '/end',
                                                        schemaPath: '#/properties/end/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate87.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate87.errors = vErrors;
    return errors === 0;
}
export const incentivesRoleAddPermissionSchemaValidation = validate88;
const schema127 = {
    $id: 'urn:wisepipe-common-data:IncentivesRoleAddPermission',
    type: 'object',
    properties: { pipeID: { type: 'string' }, permissionType: { type: 'string', enum: ['view', 'edit', 'run'] } },
    required: ['pipeID', 'permissionType']
};
function validate88(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:IncentivesRoleAddPermission" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.pipeID === undefined && (missing0 = 'pipeID')) ||
                (data.permissionType === undefined && (missing0 = 'permissionType'))) {
                validate88.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.pipeID !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.pipeID !== 'string') {
                        validate88.errors = [
                            {
                                instancePath: instancePath + '/pipeID',
                                schemaPath: '#/properties/pipeID/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.permissionType !== undefined) {
                        let data1 = data.permissionType;
                        const _errs3 = errors;
                        if (typeof data1 !== 'string') {
                            validate88.errors = [
                                {
                                    instancePath: instancePath + '/permissionType',
                                    schemaPath: '#/properties/permissionType/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data1 === 'view' || data1 === 'edit' || data1 === 'run')) {
                            validate88.errors = [
                                {
                                    instancePath: instancePath + '/permissionType',
                                    schemaPath: '#/properties/permissionType/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema127.properties.permissionType.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate88.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate88.errors = vErrors;
    return errors === 0;
}
export const incentivesRoleAssignSchemaValidation = validate89;
const schema128 = {
    $id: 'urn:wisepipe-common-data:IncentivesRoleAssign',
    type: 'object',
    properties: { userID: { type: 'string', format: 'uuid' } },
    required: ['userID']
};
function validate89(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:IncentivesRoleAssign" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.userID === undefined && (missing0 = 'userID')) {
                validate89.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.userID !== undefined) {
                    let data0 = data.userID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats4.test(data0)) {
                                    validate89.errors = [
                                        {
                                            instancePath: instancePath + '/userID',
                                            schemaPath: '#/properties/userID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate89.errors = [
                                    {
                                        instancePath: instancePath + '/userID',
                                        schemaPath: '#/properties/userID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate89.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate89.errors = vErrors;
    return errors === 0;
}
export const incentivesRoleCreateSchemaValidation = validate90;
const schema129 = {
    $id: 'urn:wisepipe-common-data:IncentivesRoleCreate',
    type: 'object',
    properties: {},
    required: []
};
function validate90(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:IncentivesRoleCreate" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate90.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate90.errors = vErrors;
    return errors === 0;
}
export const incentivesRoleDeletePermissionSchemaValidation = validate91;
const schema130 = {
    $id: 'urn:wisepipe-common-data:IncentivesRoleDeletePermission',
    type: 'object',
    properties: { pipeID: { type: 'string' }, permissionType: { type: 'string', enum: ['view', 'edit', 'run'] } },
    required: ['pipeID', 'permissionType']
};
function validate91(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:IncentivesRoleDeletePermission" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.pipeID === undefined && (missing0 = 'pipeID')) ||
                (data.permissionType === undefined && (missing0 = 'permissionType'))) {
                validate91.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.pipeID !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.pipeID !== 'string') {
                        validate91.errors = [
                            {
                                instancePath: instancePath + '/pipeID',
                                schemaPath: '#/properties/pipeID/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.permissionType !== undefined) {
                        let data1 = data.permissionType;
                        const _errs3 = errors;
                        if (typeof data1 !== 'string') {
                            validate91.errors = [
                                {
                                    instancePath: instancePath + '/permissionType',
                                    schemaPath: '#/properties/permissionType/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data1 === 'view' || data1 === 'edit' || data1 === 'run')) {
                            validate91.errors = [
                                {
                                    instancePath: instancePath + '/permissionType',
                                    schemaPath: '#/properties/permissionType/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema130.properties.permissionType.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate91.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate91.errors = vErrors;
    return errors === 0;
}
export const incentivesRoleDeleteSchemaValidation = validate92;
const schema131 = {
    $id: 'urn:wisepipe-common-data:IncentivesRoleDelete',
    type: 'object',
    properties: {},
    required: []
};
function validate92(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:IncentivesRoleDelete" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate92.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate92.errors = vErrors;
    return errors === 0;
}
export const incentivesRoleUnassignSchemaValidation = validate93;
const schema132 = {
    $id: 'urn:wisepipe-common-data:IncentivesRoleUnassign',
    type: 'object',
    properties: { userID: { type: 'string', format: 'uuid' } },
    required: ['userID']
};
function validate93(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:IncentivesRoleUnassign" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.userID === undefined && (missing0 = 'userID')) {
                validate93.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.userID !== undefined) {
                    let data0 = data.userID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats4.test(data0)) {
                                    validate93.errors = [
                                        {
                                            instancePath: instancePath + '/userID',
                                            schemaPath: '#/properties/userID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate93.errors = [
                                    {
                                        instancePath: instancePath + '/userID',
                                        schemaPath: '#/properties/userID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate93.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate93.errors = vErrors;
    return errors === 0;
}
export const incentivesRoleUpdateSchemaValidation = validate94;
const schema133 = {
    $id: 'urn:wisepipe-common-data:IncentivesRoleUpdate',
    type: 'object',
    properties: {
        orgID: { type: 'string', format: 'uuid' },
        roleID: { type: 'string', format: 'uuid' },
        incentivesRoleUpdateType: {
            type: 'string',
            enum: ['createRole', 'deleteRole', 'assignRole', 'unassignRole', 'addPermission', 'deletePermission']
        }
    },
    required: ['orgID', 'roleID', 'incentivesRoleUpdateType']
};
function validate94(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:IncentivesRoleUpdate" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.orgID === undefined && (missing0 = 'orgID')) ||
                (data.roleID === undefined && (missing0 = 'roleID')) ||
                (data.incentivesRoleUpdateType === undefined && (missing0 = 'incentivesRoleUpdateType'))) {
                validate94.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.orgID !== undefined) {
                    let data0 = data.orgID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats4.test(data0)) {
                                    validate94.errors = [
                                        {
                                            instancePath: instancePath + '/orgID',
                                            schemaPath: '#/properties/orgID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate94.errors = [
                                    {
                                        instancePath: instancePath + '/orgID',
                                        schemaPath: '#/properties/orgID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.roleID !== undefined) {
                        let data1 = data.roleID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (errors === _errs3) {
                                if (typeof data1 === 'string') {
                                    if (!formats4.test(data1)) {
                                        validate94.errors = [
                                            {
                                                instancePath: instancePath + '/roleID',
                                                schemaPath: '#/properties/roleID/format',
                                                keyword: 'format',
                                                params: { format: 'uuid' },
                                                message: 'must match format "' + 'uuid' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate94.errors = [
                                        {
                                            instancePath: instancePath + '/roleID',
                                            schemaPath: '#/properties/roleID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.incentivesRoleUpdateType !== undefined) {
                            let data2 = data.incentivesRoleUpdateType;
                            const _errs5 = errors;
                            if (typeof data2 !== 'string') {
                                validate94.errors = [
                                    {
                                        instancePath: instancePath + '/incentivesRoleUpdateType',
                                        schemaPath: '#/properties/incentivesRoleUpdateType/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            if (!(data2 === 'createRole' ||
                                data2 === 'deleteRole' ||
                                data2 === 'assignRole' ||
                                data2 === 'unassignRole' ||
                                data2 === 'addPermission' ||
                                data2 === 'deletePermission')) {
                                validate94.errors = [
                                    {
                                        instancePath: instancePath + '/incentivesRoleUpdateType',
                                        schemaPath: '#/properties/incentivesRoleUpdateType/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema133.properties.incentivesRoleUpdateType.enum },
                                        message: 'must be equal to one of the allowed values'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate94.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate94.errors = vErrors;
    return errors === 0;
}
export const incentivesTimeLevelSchemaValidation = validate95;
function validate95(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:IncentivesTimeLevel" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.order === undefined && (missing0 = 'order')) || (data.level === undefined && (missing0 = 'level'))) {
                validate95.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.order !== undefined) {
                    let data0 = data.order;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 == 'number') {
                            if (data0 < 0 || isNaN(data0)) {
                                validate95.errors = [
                                    {
                                        instancePath: instancePath + '/order',
                                        schemaPath: '#/properties/order/minimum',
                                        keyword: 'minimum',
                                        params: { comparison: '>=', limit: 0 },
                                        message: 'must be >= 0'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate95.errors = [
                                {
                                    instancePath: instancePath + '/order',
                                    schemaPath: '#/properties/order/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.level !== undefined) {
                        let data1 = data.level;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate95.errors = [
                                        {
                                            instancePath: instancePath + '/level',
                                            schemaPath: '#/properties/level/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate95.errors = [
                                    {
                                        instancePath: instancePath + '/level',
                                        schemaPath: '#/properties/level/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate95.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate95.errors = vErrors;
    return errors === 0;
}
export const msSqlImportConfigSchemaValidation = validate96;
const schema135 = {
    $id: 'urn:wisepipe-common-data:MsSqlImportConfig',
    type: 'object',
    properties: {
        user: { type: 'string', minLength: 1 },
        password: { type: 'string', minLength: 1 },
        host: { type: 'string', minLength: 1 },
        port: { type: 'number', minimum: 0 },
        database: { type: 'string', minLength: 1 },
        tables: { type: 'string' }
    },
    required: ['tables']
};
function validate96(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:MsSqlImportConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.tables === undefined && (missing0 = 'tables')) {
                validate96.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.user !== undefined) {
                    let data0 = data.user;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate96.errors = [
                                    {
                                        instancePath: instancePath + '/user',
                                        schemaPath: '#/properties/user/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate96.errors = [
                                {
                                    instancePath: instancePath + '/user',
                                    schemaPath: '#/properties/user/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.password !== undefined) {
                        let data1 = data.password;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate96.errors = [
                                        {
                                            instancePath: instancePath + '/password',
                                            schemaPath: '#/properties/password/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate96.errors = [
                                    {
                                        instancePath: instancePath + '/password',
                                        schemaPath: '#/properties/password/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.host !== undefined) {
                            let data2 = data.host;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate96.errors = [
                                            {
                                                instancePath: instancePath + '/host',
                                                schemaPath: '#/properties/host/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate96.errors = [
                                        {
                                            instancePath: instancePath + '/host',
                                            schemaPath: '#/properties/host/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.port !== undefined) {
                                let data3 = data.port;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 == 'number') {
                                        if (data3 < 0 || isNaN(data3)) {
                                            validate96.errors = [
                                                {
                                                    instancePath: instancePath + '/port',
                                                    schemaPath: '#/properties/port/minimum',
                                                    keyword: 'minimum',
                                                    params: { comparison: '>=', limit: 0 },
                                                    message: 'must be >= 0'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate96.errors = [
                                            {
                                                instancePath: instancePath + '/port',
                                                schemaPath: '#/properties/port/type',
                                                keyword: 'type',
                                                params: { type: 'number' },
                                                message: 'must be number'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.database !== undefined) {
                                    let data4 = data.database;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (typeof data4 === 'string') {
                                            if (func2(data4) < 1) {
                                                validate96.errors = [
                                                    {
                                                        instancePath: instancePath + '/database',
                                                        schemaPath: '#/properties/database/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate96.errors = [
                                                {
                                                    instancePath: instancePath + '/database',
                                                    schemaPath: '#/properties/database/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.tables !== undefined) {
                                        const _errs11 = errors;
                                        if (typeof data.tables !== 'string') {
                                            validate96.errors = [
                                                {
                                                    instancePath: instancePath + '/tables',
                                                    schemaPath: '#/properties/tables/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate96.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate96.errors = vErrors;
    return errors === 0;
}
export const multipartCopyObjectSchemaValidation = validate72;
export const mySqlImportConfigSchemaValidation = validate97;
const schema136 = {
    $id: 'urn:wisepipe-common-data:MySqlImportConfig',
    type: 'object',
    properties: {
        host: { type: 'string', minLength: 1 },
        port: { type: 'number', minimum: 0 },
        user: { type: 'string', minLength: 1 },
        password: { type: 'string', minLength: 1 },
        database: { type: 'string', minLength: 1 }
    },
    required: []
};
function validate97(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:MySqlImportConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.host !== undefined) {
                let data0 = data.host;
                const _errs1 = errors;
                if (errors === _errs1) {
                    if (typeof data0 === 'string') {
                        if (func2(data0) < 1) {
                            validate97.errors = [
                                {
                                    instancePath: instancePath + '/host',
                                    schemaPath: '#/properties/host/minLength',
                                    keyword: 'minLength',
                                    params: { limit: 1 },
                                    message: 'must NOT have fewer than 1 characters'
                                }
                            ];
                            return false;
                        }
                    }
                    else {
                        validate97.errors = [
                            {
                                instancePath: instancePath + '/host',
                                schemaPath: '#/properties/host/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                }
                var valid0 = _errs1 === errors;
            }
            else {
                var valid0 = true;
            }
            if (valid0) {
                if (data.port !== undefined) {
                    let data1 = data.port;
                    const _errs3 = errors;
                    if (errors === _errs3) {
                        if (typeof data1 == 'number') {
                            if (data1 < 0 || isNaN(data1)) {
                                validate97.errors = [
                                    {
                                        instancePath: instancePath + '/port',
                                        schemaPath: '#/properties/port/minimum',
                                        keyword: 'minimum',
                                        params: { comparison: '>=', limit: 0 },
                                        message: 'must be >= 0'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate97.errors = [
                                {
                                    instancePath: instancePath + '/port',
                                    schemaPath: '#/properties/port/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs3 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.user !== undefined) {
                        let data2 = data.user;
                        const _errs5 = errors;
                        if (errors === _errs5) {
                            if (typeof data2 === 'string') {
                                if (func2(data2) < 1) {
                                    validate97.errors = [
                                        {
                                            instancePath: instancePath + '/user',
                                            schemaPath: '#/properties/user/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate97.errors = [
                                    {
                                        instancePath: instancePath + '/user',
                                        schemaPath: '#/properties/user/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.password !== undefined) {
                            let data3 = data.password;
                            const _errs7 = errors;
                            if (errors === _errs7) {
                                if (typeof data3 === 'string') {
                                    if (func2(data3) < 1) {
                                        validate97.errors = [
                                            {
                                                instancePath: instancePath + '/password',
                                                schemaPath: '#/properties/password/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate97.errors = [
                                        {
                                            instancePath: instancePath + '/password',
                                            schemaPath: '#/properties/password/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs7 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.database !== undefined) {
                                let data4 = data.database;
                                const _errs9 = errors;
                                if (errors === _errs9) {
                                    if (typeof data4 === 'string') {
                                        if (func2(data4) < 1) {
                                            validate97.errors = [
                                                {
                                                    instancePath: instancePath + '/database',
                                                    schemaPath: '#/properties/database/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate97.errors = [
                                            {
                                                instancePath: instancePath + '/database',
                                                schemaPath: '#/properties/database/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs9 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate97.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate97.errors = vErrors;
    return errors === 0;
}
export const netSuiteImportConfigSchemaValidation = validate98;
const schema137 = {
    $id: 'urn:wisepipe-common-data:NetSuiteImportConfig',
    type: 'object',
    properties: { startDate: { type: 'string', format: 'date-time' } },
    required: ['startDate']
};
function validate98(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:NetSuiteImportConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.startDate === undefined && (missing0 = 'startDate')) {
                validate98.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.startDate !== undefined) {
                    let data0 = data.startDate;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats0.validate(data0)) {
                                    validate98.errors = [
                                        {
                                            instancePath: instancePath + '/startDate',
                                            schemaPath: '#/properties/startDate/format',
                                            keyword: 'format',
                                            params: { format: 'date-time' },
                                            message: 'must match format "' + 'date-time' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate98.errors = [
                                    {
                                        instancePath: instancePath + '/startDate',
                                        schemaPath: '#/properties/startDate/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate98.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate98.errors = vErrors;
    return errors === 0;
}
export const oneDriveImportConfigSchemaValidation = validate99;
const schema138 = {
    $id: 'urn:wisepipe-common-data:OneDriveImportConfig',
    type: 'object',
    properties: {
        filename: { type: 'string', minLength: 1 },
        filetype: { type: 'string', enum: ['.csv', '.xls', '.xlsx', '.txt'] },
        itemPath: { type: 'string', minLength: 1 },
        delimiter: { type: 'string', minLength: 1, maxLength: 1 },
        quotechar: { type: 'string', minLength: 1, maxLength: 1 },
        hasHeader: { type: 'boolean' },
        dataPreprocessConfig: { $ref: 'urn:wisepipe-common-data:DataPreprocessConfig' }
    },
    if: { properties: { filetype: { enum: ['.csv', '.txt'] } }, required: ['filetype'] },
    then: { required: ['delimiter', 'quotechar'] },
    required: ['filename', 'filetype', 'itemPath']
};
function validate99(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:OneDriveImportConfig" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        let missing0;
        if (data.filetype === undefined && (missing0 = 'filetype')) {
            const err0 = {};
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
        else {
            if (data.filetype !== undefined) {
                let data0 = data.filetype;
                if (!(data0 === '.csv' || data0 === '.txt')) {
                    const err1 = {};
                    if (vErrors === null) {
                        vErrors = [err1];
                    }
                    else {
                        vErrors.push(err1);
                    }
                    errors++;
                }
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs4 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if ((data.delimiter === undefined && (missing1 = 'delimiter')) ||
                (data.quotechar === undefined && (missing1 = 'quotechar'))) {
                validate99.errors = [
                    {
                        instancePath,
                        schemaPath: '#/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs4 === errors;
        valid0 = _valid0;
    }
    if (!valid0) {
        const err2 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err2];
        }
        else {
            vErrors.push(err2);
        }
        errors++;
        validate99.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing2;
            if ((data.filename === undefined && (missing2 = 'filename')) ||
                (data.filetype === undefined && (missing2 = 'filetype')) ||
                (data.itemPath === undefined && (missing2 = 'itemPath'))) {
                validate99.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing2 },
                        message: "must have required property '" + missing2 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.filename !== undefined) {
                    let data1 = data.filename;
                    const _errs5 = errors;
                    if (errors === _errs5) {
                        if (typeof data1 === 'string') {
                            if (func2(data1) < 1) {
                                validate99.errors = [
                                    {
                                        instancePath: instancePath + '/filename',
                                        schemaPath: '#/properties/filename/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate99.errors = [
                                {
                                    instancePath: instancePath + '/filename',
                                    schemaPath: '#/properties/filename/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid2 = _errs5 === errors;
                }
                else {
                    var valid2 = true;
                }
                if (valid2) {
                    if (data.filetype !== undefined) {
                        let data2 = data.filetype;
                        const _errs7 = errors;
                        if (typeof data2 !== 'string') {
                            validate99.errors = [
                                {
                                    instancePath: instancePath + '/filetype',
                                    schemaPath: '#/properties/filetype/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data2 === '.csv' || data2 === '.xls' || data2 === '.xlsx' || data2 === '.txt')) {
                            validate99.errors = [
                                {
                                    instancePath: instancePath + '/filetype',
                                    schemaPath: '#/properties/filetype/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema138.properties.filetype.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid2 = _errs7 === errors;
                    }
                    else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.itemPath !== undefined) {
                            let data3 = data.itemPath;
                            const _errs9 = errors;
                            if (errors === _errs9) {
                                if (typeof data3 === 'string') {
                                    if (func2(data3) < 1) {
                                        validate99.errors = [
                                            {
                                                instancePath: instancePath + '/itemPath',
                                                schemaPath: '#/properties/itemPath/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate99.errors = [
                                        {
                                            instancePath: instancePath + '/itemPath',
                                            schemaPath: '#/properties/itemPath/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid2 = _errs9 === errors;
                        }
                        else {
                            var valid2 = true;
                        }
                        if (valid2) {
                            if (data.delimiter !== undefined) {
                                let data4 = data.delimiter;
                                const _errs11 = errors;
                                if (errors === _errs11) {
                                    if (typeof data4 === 'string') {
                                        if (func2(data4) > 1) {
                                            validate99.errors = [
                                                {
                                                    instancePath: instancePath + '/delimiter',
                                                    schemaPath: '#/properties/delimiter/maxLength',
                                                    keyword: 'maxLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have more than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            if (func2(data4) < 1) {
                                                validate99.errors = [
                                                    {
                                                        instancePath: instancePath + '/delimiter',
                                                        schemaPath: '#/properties/delimiter/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                    else {
                                        validate99.errors = [
                                            {
                                                instancePath: instancePath + '/delimiter',
                                                schemaPath: '#/properties/delimiter/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid2 = _errs11 === errors;
                            }
                            else {
                                var valid2 = true;
                            }
                            if (valid2) {
                                if (data.quotechar !== undefined) {
                                    let data5 = data.quotechar;
                                    const _errs13 = errors;
                                    if (errors === _errs13) {
                                        if (typeof data5 === 'string') {
                                            if (func2(data5) > 1) {
                                                validate99.errors = [
                                                    {
                                                        instancePath: instancePath + '/quotechar',
                                                        schemaPath: '#/properties/quotechar/maxLength',
                                                        keyword: 'maxLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have more than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (func2(data5) < 1) {
                                                    validate99.errors = [
                                                        {
                                                            instancePath: instancePath + '/quotechar',
                                                            schemaPath: '#/properties/quotechar/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                        else {
                                            validate99.errors = [
                                                {
                                                    instancePath: instancePath + '/quotechar',
                                                    schemaPath: '#/properties/quotechar/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid2 = _errs13 === errors;
                                }
                                else {
                                    var valid2 = true;
                                }
                                if (valid2) {
                                    if (data.hasHeader !== undefined) {
                                        const _errs15 = errors;
                                        if (typeof data.hasHeader !== 'boolean') {
                                            validate99.errors = [
                                                {
                                                    instancePath: instancePath + '/hasHeader',
                                                    schemaPath: '#/properties/hasHeader/type',
                                                    keyword: 'type',
                                                    params: { type: 'boolean' },
                                                    message: 'must be boolean'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid2 = _errs15 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                    if (valid2) {
                                        if (data.dataPreprocessConfig !== undefined) {
                                            let data7 = data.dataPreprocessConfig;
                                            const _errs17 = errors;
                                            const _errs18 = errors;
                                            if (errors === _errs18) {
                                                if (data7 && typeof data7 == 'object' && !Array.isArray(data7)) {
                                                    let missing3;
                                                    if ((data7.skipHeaderRow === undefined && (missing3 = 'skipHeaderRow')) ||
                                                        (data7.skipFooterRow === undefined && (missing3 = 'skipFooterRow'))) {
                                                        validate99.errors = [
                                                            {
                                                                instancePath: instancePath + '/dataPreprocessConfig',
                                                                schemaPath: 'urn:wisepipe-common-data:DataPreprocessConfig/required',
                                                                keyword: 'required',
                                                                params: { missingProperty: missing3 },
                                                                message: "must have required property '" + missing3 + "'"
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        if (data7.skipHeaderRow !== undefined) {
                                                            let data8 = data7.skipHeaderRow;
                                                            const _errs20 = errors;
                                                            if (errors === _errs20) {
                                                                if (typeof data8 == 'number') {
                                                                    if (data8 > 100 || isNaN(data8)) {
                                                                        validate99.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/dataPreprocessConfig/skipHeaderRow',
                                                                                schemaPath: 'urn:wisepipe-common-data:DataPreprocessConfig/properties/skipHeaderRow/maximum',
                                                                                keyword: 'maximum',
                                                                                params: { comparison: '<=', limit: 100 },
                                                                                message: 'must be <= 100'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    else {
                                                                        if (data8 < 0 || isNaN(data8)) {
                                                                            validate99.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/dataPreprocessConfig/skipHeaderRow',
                                                                                    schemaPath: 'urn:wisepipe-common-data:DataPreprocessConfig/properties/skipHeaderRow/minimum',
                                                                                    keyword: 'minimum',
                                                                                    params: { comparison: '>=', limit: 0 },
                                                                                    message: 'must be >= 0'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                }
                                                                else {
                                                                    validate99.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/dataPreprocessConfig/skipHeaderRow',
                                                                            schemaPath: 'urn:wisepipe-common-data:DataPreprocessConfig/properties/skipHeaderRow/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'number' },
                                                                            message: 'must be number'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid4 = _errs20 === errors;
                                                        }
                                                        else {
                                                            var valid4 = true;
                                                        }
                                                        if (valid4) {
                                                            if (data7.skipFooterRow !== undefined) {
                                                                let data9 = data7.skipFooterRow;
                                                                const _errs22 = errors;
                                                                if (errors === _errs22) {
                                                                    if (typeof data9 == 'number') {
                                                                        if (data9 > 100 || isNaN(data9)) {
                                                                            validate99.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/dataPreprocessConfig/skipFooterRow',
                                                                                    schemaPath: 'urn:wisepipe-common-data:DataPreprocessConfig/properties/skipFooterRow/maximum',
                                                                                    keyword: 'maximum',
                                                                                    params: { comparison: '<=', limit: 100 },
                                                                                    message: 'must be <= 100'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        else {
                                                                            if (data9 < 0 || isNaN(data9)) {
                                                                                validate99.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/dataPreprocessConfig/skipFooterRow',
                                                                                        schemaPath: 'urn:wisepipe-common-data:DataPreprocessConfig/properties/skipFooterRow/minimum',
                                                                                        keyword: 'minimum',
                                                                                        params: { comparison: '>=', limit: 0 },
                                                                                        message: 'must be >= 0'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate99.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/dataPreprocessConfig/skipFooterRow',
                                                                                schemaPath: 'urn:wisepipe-common-data:DataPreprocessConfig/properties/skipFooterRow/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'number' },
                                                                                message: 'must be number'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                var valid4 = _errs22 === errors;
                                                            }
                                                            else {
                                                                var valid4 = true;
                                                            }
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate99.errors = [
                                                        {
                                                            instancePath: instancePath + '/dataPreprocessConfig',
                                                            schemaPath: 'urn:wisepipe-common-data:DataPreprocessConfig/type',
                                                            keyword: 'type',
                                                            params: { type: 'object' },
                                                            message: 'must be object'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid2 = _errs17 === errors;
                                        }
                                        else {
                                            var valid2 = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate99.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate99.errors = vErrors;
    return errors === 0;
}
export const oracleImportConfigSchemaValidation = validate100;
const schema140 = {
    $id: 'urn:wisepipe-common-data:OracleImportConfig',
    type: 'object',
    properties: {
        host: { type: 'string', minLength: 1 },
        port: { type: 'number', minimum: 0 },
        sid: { type: 'string', minLength: 1 },
        database: { type: 'string', minLength: 1 },
        user: { type: 'string', minLength: 1 },
        password: { type: 'string', minLength: 1 }
    },
    required: []
};
function validate100(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:OracleImportConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.host !== undefined) {
                let data0 = data.host;
                const _errs1 = errors;
                if (errors === _errs1) {
                    if (typeof data0 === 'string') {
                        if (func2(data0) < 1) {
                            validate100.errors = [
                                {
                                    instancePath: instancePath + '/host',
                                    schemaPath: '#/properties/host/minLength',
                                    keyword: 'minLength',
                                    params: { limit: 1 },
                                    message: 'must NOT have fewer than 1 characters'
                                }
                            ];
                            return false;
                        }
                    }
                    else {
                        validate100.errors = [
                            {
                                instancePath: instancePath + '/host',
                                schemaPath: '#/properties/host/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                }
                var valid0 = _errs1 === errors;
            }
            else {
                var valid0 = true;
            }
            if (valid0) {
                if (data.port !== undefined) {
                    let data1 = data.port;
                    const _errs3 = errors;
                    if (errors === _errs3) {
                        if (typeof data1 == 'number') {
                            if (data1 < 0 || isNaN(data1)) {
                                validate100.errors = [
                                    {
                                        instancePath: instancePath + '/port',
                                        schemaPath: '#/properties/port/minimum',
                                        keyword: 'minimum',
                                        params: { comparison: '>=', limit: 0 },
                                        message: 'must be >= 0'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate100.errors = [
                                {
                                    instancePath: instancePath + '/port',
                                    schemaPath: '#/properties/port/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs3 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.sid !== undefined) {
                        let data2 = data.sid;
                        const _errs5 = errors;
                        if (errors === _errs5) {
                            if (typeof data2 === 'string') {
                                if (func2(data2) < 1) {
                                    validate100.errors = [
                                        {
                                            instancePath: instancePath + '/sid',
                                            schemaPath: '#/properties/sid/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate100.errors = [
                                    {
                                        instancePath: instancePath + '/sid',
                                        schemaPath: '#/properties/sid/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.database !== undefined) {
                            let data3 = data.database;
                            const _errs7 = errors;
                            if (errors === _errs7) {
                                if (typeof data3 === 'string') {
                                    if (func2(data3) < 1) {
                                        validate100.errors = [
                                            {
                                                instancePath: instancePath + '/database',
                                                schemaPath: '#/properties/database/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate100.errors = [
                                        {
                                            instancePath: instancePath + '/database',
                                            schemaPath: '#/properties/database/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs7 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.user !== undefined) {
                                let data4 = data.user;
                                const _errs9 = errors;
                                if (errors === _errs9) {
                                    if (typeof data4 === 'string') {
                                        if (func2(data4) < 1) {
                                            validate100.errors = [
                                                {
                                                    instancePath: instancePath + '/user',
                                                    schemaPath: '#/properties/user/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate100.errors = [
                                            {
                                                instancePath: instancePath + '/user',
                                                schemaPath: '#/properties/user/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs9 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.password !== undefined) {
                                    let data5 = data.password;
                                    const _errs11 = errors;
                                    if (errors === _errs11) {
                                        if (typeof data5 === 'string') {
                                            if (func2(data5) < 1) {
                                                validate100.errors = [
                                                    {
                                                        instancePath: instancePath + '/password',
                                                        schemaPath: '#/properties/password/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate100.errors = [
                                                {
                                                    instancePath: instancePath + '/password',
                                                    schemaPath: '#/properties/password/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs11 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate100.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate100.errors = vErrors;
    return errors === 0;
}
export const originEventSchemaValidation = validate101;
const schema141 = {
    $id: 'urn:wisepipe-common-data:OriginEvent',
    type: 'object',
    properties: {
        orgID: { type: 'string', format: 'uuid' },
        originID: { type: 'string', uid: 9 },
        type: { type: 'string', enum: ['insert', 'update', 'remove'] }
    },
    required: ['orgID', 'originID', 'type']
};
const func364 = ucs2length;
const func365 = base64urlToBuffer;
const func366 = base64urlEncode;
const func367 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate101(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:OriginEvent" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.orgID === undefined && (missing0 = 'orgID')) ||
                (data.originID === undefined && (missing0 = 'originID')) ||
                (data.type === undefined && (missing0 = 'type'))) {
                validate101.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.orgID !== undefined) {
                    let data0 = data.orgID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats4.test(data0)) {
                                    validate101.errors = [
                                        {
                                            instancePath: instancePath + '/orgID',
                                            schemaPath: '#/properties/orgID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate101.errors = [
                                    {
                                        instancePath: instancePath + '/orgID',
                                        schemaPath: '#/properties/orgID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.originID !== undefined) {
                        let data1 = data.originID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                const b64min0 = Math.ceil((4 * 9) / 3);
                                const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                if (func364(data1) < b64min0 || func364(data1) > b64max0) {
                                    validate101.errors = [
                                        {
                                            instancePath: instancePath + '/originID',
                                            schemaPath: '#/properties/originID/uid',
                                            keyword: 'uid',
                                            params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func364(data1) },
                                            message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func364(data1)
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const decoded0 = func365(data1);
                                    if (decoded0.length !== 9) {
                                        validate101.errors = [
                                            {
                                                instancePath: instancePath + '/originID',
                                                schemaPath: '#/properties/originID/uid',
                                                keyword: 'uid',
                                                params: { error: 'decoded' },
                                                message: 'must decode to 9 bytes'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const encoded0 = func366(decoded0);
                                        if (func367(encoded0) !== func367(data1)) {
                                            validate101.errors = [
                                                {
                                                    instancePath: instancePath + '/originID',
                                                    schemaPath: '#/properties/originID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'ambiguous' },
                                                    message: 'encoding is ambiguous'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            else {
                                validate101.errors = [
                                    {
                                        instancePath: instancePath + '/originID',
                                        schemaPath: '#/properties/originID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.type !== undefined) {
                            let data2 = data.type;
                            const _errs5 = errors;
                            if (typeof data2 !== 'string') {
                                validate101.errors = [
                                    {
                                        instancePath: instancePath + '/type',
                                        schemaPath: '#/properties/type/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            if (!(data2 === 'insert' || data2 === 'update' || data2 === 'remove')) {
                                validate101.errors = [
                                    {
                                        instancePath: instancePath + '/type',
                                        schemaPath: '#/properties/type/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema141.properties.type.enum },
                                        message: 'must be equal to one of the allowed values'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate101.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate101.errors = vErrors;
    return errors === 0;
}
export const originModelSchemaValidation = validate76;
export const originPagedResponseWithTotalSchemaValidation = validate102;
const schema142 = {
    $id: 'urn:wisepipe-common-data:OriginPagedResponseWithTotal',
    type: 'object',
    properties: {
        records: { type: 'array', items: { $ref: 'urn:wisepipe-common-data:Origin' } },
        totalRecords: { type: 'number' },
        limit: { type: 'number' },
        offset: { type: 'number' }
    },
    required: ['limit', 'offset', 'totalRecords', 'records']
};
const schema143 = {
    $id: 'urn:wisepipe-common-data:Origin',
    type: 'object',
    properties: {
        orgID: { type: 'string', minLength: 1 },
        originID: { type: 'string', uid: 9 },
        name: { type: 'string', minLength: 1 },
        dataSources: { type: 'array', items: { $ref: 'urn:wisepipe-common-data:DataSource' } },
        config: { $ref: 'urn:wisepipe-common-data:ImportConfig' },
        discoveryID: { type: 'string', uid: 9 },
        streamID: { type: 'string', minLength: 1 },
        connectionID: { type: 'string', uid: 9 },
        hidden: { type: 'boolean' }
    },
    required: ['orgID', 'originID', 'name', 'dataSources', 'config']
};
const func369 = ucs2length;
const func370 = base64urlToBuffer;
const func371 = base64urlEncode;
const func372 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func374 = ucs2length;
const func375 = base64urlToBuffer;
const func376 = base64urlEncode;
const func377 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func379 = ucs2length;
const func380 = base64urlToBuffer;
const func381 = base64urlEncode;
const func382 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate103(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:Origin" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.orgID === undefined && (missing0 = 'orgID')) ||
                (data.originID === undefined && (missing0 = 'originID')) ||
                (data.name === undefined && (missing0 = 'name')) ||
                (data.dataSources === undefined && (missing0 = 'dataSources')) ||
                (data.config === undefined && (missing0 = 'config'))) {
                validate103.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.orgID !== undefined) {
                    let data0 = data.orgID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate103.errors = [
                                    {
                                        instancePath: instancePath + '/orgID',
                                        schemaPath: '#/properties/orgID/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate103.errors = [
                                {
                                    instancePath: instancePath + '/orgID',
                                    schemaPath: '#/properties/orgID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.originID !== undefined) {
                        let data1 = data.originID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                const b64min0 = Math.ceil((4 * 9) / 3);
                                const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                if (func369(data1) < b64min0 || func369(data1) > b64max0) {
                                    validate103.errors = [
                                        {
                                            instancePath: instancePath + '/originID',
                                            schemaPath: '#/properties/originID/uid',
                                            keyword: 'uid',
                                            params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func369(data1) },
                                            message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func369(data1)
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const decoded0 = func370(data1);
                                    if (decoded0.length !== 9) {
                                        validate103.errors = [
                                            {
                                                instancePath: instancePath + '/originID',
                                                schemaPath: '#/properties/originID/uid',
                                                keyword: 'uid',
                                                params: { error: 'decoded' },
                                                message: 'must decode to 9 bytes'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const encoded0 = func371(decoded0);
                                        if (func372(encoded0) !== func372(data1)) {
                                            validate103.errors = [
                                                {
                                                    instancePath: instancePath + '/originID',
                                                    schemaPath: '#/properties/originID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'ambiguous' },
                                                    message: 'encoding is ambiguous'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            else {
                                validate103.errors = [
                                    {
                                        instancePath: instancePath + '/originID',
                                        schemaPath: '#/properties/originID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.name !== undefined) {
                            let data2 = data.name;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate103.errors = [
                                            {
                                                instancePath: instancePath + '/name',
                                                schemaPath: '#/properties/name/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate103.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.dataSources !== undefined) {
                                let data3 = data.dataSources;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (Array.isArray(data3)) {
                                        var valid2 = true;
                                        const len0 = data3.length;
                                        for (let i0 = 0; i0 < len0; i0++) {
                                            const _errs9 = errors;
                                            if (!validate25(data3[i0], {
                                                instancePath: instancePath + '/dataSources/' + i0,
                                                parentData: data3,
                                                parentDataProperty: i0,
                                                rootData
                                            })) {
                                                vErrors = vErrors === null ? validate25.errors : vErrors.concat(validate25.errors);
                                                errors = vErrors.length;
                                            }
                                            var valid2 = _errs9 === errors;
                                            if (!valid2) {
                                                break;
                                            }
                                        }
                                    }
                                    else {
                                        validate103.errors = [
                                            {
                                                instancePath: instancePath + '/dataSources',
                                                schemaPath: '#/properties/dataSources/type',
                                                keyword: 'type',
                                                params: { type: 'array' },
                                                message: 'must be array'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.config !== undefined) {
                                    const _errs10 = errors;
                                    if (!validate44(data.config, {
                                        instancePath: instancePath + '/config',
                                        parentData: data,
                                        parentDataProperty: 'config',
                                        rootData
                                    })) {
                                        vErrors = vErrors === null ? validate44.errors : vErrors.concat(validate44.errors);
                                        errors = vErrors.length;
                                    }
                                    var valid0 = _errs10 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.discoveryID !== undefined) {
                                        let data6 = data.discoveryID;
                                        const _errs11 = errors;
                                        if (errors === _errs11) {
                                            if (typeof data6 === 'string') {
                                                const b64min1 = Math.ceil((4 * 9) / 3);
                                                const b64max1 = Math.ceil((4 * 9) / 3) + 3;
                                                if (func374(data6) < b64min1 || func374(data6) > b64max1) {
                                                    validate103.errors = [
                                                        {
                                                            instancePath: instancePath + '/discoveryID',
                                                            schemaPath: '#/properties/discoveryID/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func374(data6) },
                                                            message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func374(data6)
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    const decoded1 = func375(data6);
                                                    if (decoded1.length !== 9) {
                                                        validate103.errors = [
                                                            {
                                                                instancePath: instancePath + '/discoveryID',
                                                                schemaPath: '#/properties/discoveryID/uid',
                                                                keyword: 'uid',
                                                                params: { error: 'decoded' },
                                                                message: 'must decode to 9 bytes'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        const encoded1 = func376(decoded1);
                                                        if (func377(encoded1) !== func377(data6)) {
                                                            validate103.errors = [
                                                                {
                                                                    instancePath: instancePath + '/discoveryID',
                                                                    schemaPath: '#/properties/discoveryID/uid',
                                                                    keyword: 'uid',
                                                                    params: { error: 'ambiguous' },
                                                                    message: 'encoding is ambiguous'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate103.errors = [
                                                    {
                                                        instancePath: instancePath + '/discoveryID',
                                                        schemaPath: '#/properties/discoveryID/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.streamID !== undefined) {
                                            let data7 = data.streamID;
                                            const _errs13 = errors;
                                            if (errors === _errs13) {
                                                if (typeof data7 === 'string') {
                                                    if (func2(data7) < 1) {
                                                        validate103.errors = [
                                                            {
                                                                instancePath: instancePath + '/streamID',
                                                                schemaPath: '#/properties/streamID/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate103.errors = [
                                                        {
                                                            instancePath: instancePath + '/streamID',
                                                            schemaPath: '#/properties/streamID/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs13 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.connectionID !== undefined) {
                                                let data8 = data.connectionID;
                                                const _errs15 = errors;
                                                if (errors === _errs15) {
                                                    if (typeof data8 === 'string') {
                                                        const b64min2 = Math.ceil((4 * 9) / 3);
                                                        const b64max2 = Math.ceil((4 * 9) / 3) + 3;
                                                        if (func379(data8) < b64min2 || func379(data8) > b64max2) {
                                                            validate103.errors = [
                                                                {
                                                                    instancePath: instancePath + '/connectionID',
                                                                    schemaPath: '#/properties/connectionID/uid',
                                                                    keyword: 'uid',
                                                                    params: {
                                                                        error: 'encoded',
                                                                        b64min: b64min2,
                                                                        b64max: b64max2,
                                                                        length: func379(data8)
                                                                    },
                                                                    message: 'length must be between ' +
                                                                        b64min2 +
                                                                        ' and ' +
                                                                        b64max2 +
                                                                        ', but is ' +
                                                                        func379(data8)
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            const decoded2 = func380(data8);
                                                            if (decoded2.length !== 9) {
                                                                validate103.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/connectionID',
                                                                        schemaPath: '#/properties/connectionID/uid',
                                                                        keyword: 'uid',
                                                                        params: { error: 'decoded' },
                                                                        message: 'must decode to 9 bytes'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            else {
                                                                const encoded2 = func381(decoded2);
                                                                if (func382(encoded2) !== func382(data8)) {
                                                                    validate103.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/connectionID',
                                                                            schemaPath: '#/properties/connectionID/uid',
                                                                            keyword: 'uid',
                                                                            params: { error: 'ambiguous' },
                                                                            message: 'encoding is ambiguous'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate103.errors = [
                                                            {
                                                                instancePath: instancePath + '/connectionID',
                                                                schemaPath: '#/properties/connectionID/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid0 = _errs15 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (data.hidden !== undefined) {
                                                    const _errs17 = errors;
                                                    if (typeof data.hidden !== 'boolean') {
                                                        validate103.errors = [
                                                            {
                                                                instancePath: instancePath + '/hidden',
                                                                schemaPath: '#/properties/hidden/type',
                                                                keyword: 'type',
                                                                params: { type: 'boolean' },
                                                                message: 'must be boolean'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid0 = _errs17 === errors;
                                                }
                                                else {
                                                    var valid0 = true;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate103.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate103.errors = vErrors;
    return errors === 0;
}
function validate102(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:OriginPagedResponseWithTotal" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.limit === undefined && (missing0 = 'limit')) ||
                (data.offset === undefined && (missing0 = 'offset')) ||
                (data.totalRecords === undefined && (missing0 = 'totalRecords')) ||
                (data.records === undefined && (missing0 = 'records'))) {
                validate102.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.records !== undefined) {
                    let data0 = data.records;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            var valid1 = true;
                            const len0 = data0.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                                const _errs3 = errors;
                                if (!validate103(data0[i0], {
                                    instancePath: instancePath + '/records/' + i0,
                                    parentData: data0,
                                    parentDataProperty: i0,
                                    rootData
                                })) {
                                    vErrors = vErrors === null ? validate103.errors : vErrors.concat(validate103.errors);
                                    errors = vErrors.length;
                                }
                                var valid1 = _errs3 === errors;
                                if (!valid1) {
                                    break;
                                }
                            }
                        }
                        else {
                            validate102.errors = [
                                {
                                    instancePath: instancePath + '/records',
                                    schemaPath: '#/properties/records/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.totalRecords !== undefined) {
                        const _errs4 = errors;
                        if (!(typeof data.totalRecords == 'number')) {
                            validate102.errors = [
                                {
                                    instancePath: instancePath + '/totalRecords',
                                    schemaPath: '#/properties/totalRecords/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs4 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.limit !== undefined) {
                            const _errs6 = errors;
                            if (!(typeof data.limit == 'number')) {
                                validate102.errors = [
                                    {
                                        instancePath: instancePath + '/limit',
                                        schemaPath: '#/properties/limit/type',
                                        keyword: 'type',
                                        params: { type: 'number' },
                                        message: 'must be number'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs6 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.offset !== undefined) {
                                const _errs8 = errors;
                                if (!(typeof data.offset == 'number')) {
                                    validate102.errors = [
                                        {
                                            instancePath: instancePath + '/offset',
                                            schemaPath: '#/properties/offset/type',
                                            keyword: 'type',
                                            params: { type: 'number' },
                                            message: 'must be number'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs8 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate102.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate102.errors = vErrors;
    return errors === 0;
}
export const originRefreshSchemaValidation = validate107;
const schema144 = {
    $id: 'urn:wisepipe-common-data:OriginRefresh',
    type: 'object',
    properties: {
        importOperation: { type: 'string', enum: ['append', 'overwrite'] },
        importConfig: { $ref: 'urn:wisepipe-common-data:ImportConfig' }
    },
    required: ['importOperation']
};
function validate107(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:OriginRefresh" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.importOperation === undefined && (missing0 = 'importOperation')) {
                validate107.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.importOperation !== undefined) {
                    let data0 = data.importOperation;
                    const _errs1 = errors;
                    if (typeof data0 !== 'string') {
                        validate107.errors = [
                            {
                                instancePath: instancePath + '/importOperation',
                                schemaPath: '#/properties/importOperation/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'append' || data0 === 'overwrite')) {
                        validate107.errors = [
                            {
                                instancePath: instancePath + '/importOperation',
                                schemaPath: '#/properties/importOperation/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema144.properties.importOperation.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.importConfig !== undefined) {
                        const _errs3 = errors;
                        if (!validate44(data.importConfig, {
                            instancePath: instancePath + '/importConfig',
                            parentData: data,
                            parentDataProperty: 'importConfig',
                            rootData
                        })) {
                            vErrors = vErrors === null ? validate44.errors : vErrors.concat(validate44.errors);
                            errors = vErrors.length;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate107.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate107.errors = vErrors;
    return errors === 0;
}
export const originSchemaValidation = validate103;
export const parquetImportConfigSchemaValidation = validate109;
const schema145 = { $id: 'urn:wisepipe-common-data:ParquetImportConfig', type: 'object', properties: {}, required: [] };
function validate109(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:ParquetImportConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate109.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate109.errors = vErrors;
    return errors === 0;
}
export const periodColumnMetadataSchemaValidation = validate110;
function validate110(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:PeriodColumnMetadata" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.calendarID === undefined && (missing0 = 'calendarID')) ||
                (data.level === undefined && (missing0 = 'level'))) {
                validate110.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.calendarID !== undefined) {
                    let data0 = data.calendarID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate110.errors = [
                                    {
                                        instancePath: instancePath + '/calendarID',
                                        schemaPath: '#/properties/calendarID/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate110.errors = [
                                {
                                    instancePath: instancePath + '/calendarID',
                                    schemaPath: '#/properties/calendarID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.level !== undefined) {
                        let data1 = data.level;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate110.errors = [
                                        {
                                            instancePath: instancePath + '/level',
                                            schemaPath: '#/properties/level/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate110.errors = [
                                    {
                                        instancePath: instancePath + '/level',
                                        schemaPath: '#/properties/level/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate110.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate110.errors = vErrors;
    return errors === 0;
}
export const picklistColumnMetadataSchemaValidation = validate111;
function validate111(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:PicklistColumnMetadata" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.table === undefined && (missing0 = 'table')) || (data.column === undefined && (missing0 = 'column'))) {
                validate111.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.table !== undefined) {
                    let data0 = data.table;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate111.errors = [
                                    {
                                        instancePath: instancePath + '/table',
                                        schemaPath: '#/properties/table/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate111.errors = [
                                {
                                    instancePath: instancePath + '/table',
                                    schemaPath: '#/properties/table/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.column !== undefined) {
                        let data1 = data.column;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate111.errors = [
                                        {
                                            instancePath: instancePath + '/column',
                                            schemaPath: '#/properties/column/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate111.errors = [
                                    {
                                        instancePath: instancePath + '/column',
                                        schemaPath: '#/properties/column/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate111.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate111.errors = vErrors;
    return errors === 0;
}
export const postgreSqlImportConfigSchemaValidation = validate112;
const schema148 = {
    $id: 'urn:wisepipe-common-data:PostgreSqlImportConfig',
    type: 'object',
    properties: {
        host: { type: 'string', minLength: 1 },
        port: { type: 'number', minimum: 0 },
        user: { type: 'string', minLength: 1 },
        password: { type: 'string', minLength: 1 },
        database: { type: 'string', minLength: 1 }
    },
    required: []
};
function validate112(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:PostgreSqlImportConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.host !== undefined) {
                let data0 = data.host;
                const _errs1 = errors;
                if (errors === _errs1) {
                    if (typeof data0 === 'string') {
                        if (func2(data0) < 1) {
                            validate112.errors = [
                                {
                                    instancePath: instancePath + '/host',
                                    schemaPath: '#/properties/host/minLength',
                                    keyword: 'minLength',
                                    params: { limit: 1 },
                                    message: 'must NOT have fewer than 1 characters'
                                }
                            ];
                            return false;
                        }
                    }
                    else {
                        validate112.errors = [
                            {
                                instancePath: instancePath + '/host',
                                schemaPath: '#/properties/host/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                }
                var valid0 = _errs1 === errors;
            }
            else {
                var valid0 = true;
            }
            if (valid0) {
                if (data.port !== undefined) {
                    let data1 = data.port;
                    const _errs3 = errors;
                    if (errors === _errs3) {
                        if (typeof data1 == 'number') {
                            if (data1 < 0 || isNaN(data1)) {
                                validate112.errors = [
                                    {
                                        instancePath: instancePath + '/port',
                                        schemaPath: '#/properties/port/minimum',
                                        keyword: 'minimum',
                                        params: { comparison: '>=', limit: 0 },
                                        message: 'must be >= 0'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate112.errors = [
                                {
                                    instancePath: instancePath + '/port',
                                    schemaPath: '#/properties/port/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs3 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.user !== undefined) {
                        let data2 = data.user;
                        const _errs5 = errors;
                        if (errors === _errs5) {
                            if (typeof data2 === 'string') {
                                if (func2(data2) < 1) {
                                    validate112.errors = [
                                        {
                                            instancePath: instancePath + '/user',
                                            schemaPath: '#/properties/user/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate112.errors = [
                                    {
                                        instancePath: instancePath + '/user',
                                        schemaPath: '#/properties/user/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.password !== undefined) {
                            let data3 = data.password;
                            const _errs7 = errors;
                            if (errors === _errs7) {
                                if (typeof data3 === 'string') {
                                    if (func2(data3) < 1) {
                                        validate112.errors = [
                                            {
                                                instancePath: instancePath + '/password',
                                                schemaPath: '#/properties/password/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate112.errors = [
                                        {
                                            instancePath: instancePath + '/password',
                                            schemaPath: '#/properties/password/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs7 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.database !== undefined) {
                                let data4 = data.database;
                                const _errs9 = errors;
                                if (errors === _errs9) {
                                    if (typeof data4 === 'string') {
                                        if (func2(data4) < 1) {
                                            validate112.errors = [
                                                {
                                                    instancePath: instancePath + '/database',
                                                    schemaPath: '#/properties/database/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate112.errors = [
                                            {
                                                instancePath: instancePath + '/database',
                                                schemaPath: '#/properties/database/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs9 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate112.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate112.errors = vErrors;
    return errors === 0;
}
export const restImportConfigSchemaValidation = validate113;
const schema149 = {
    $id: 'urn:wisepipe-common-data:RestImportConfig',
    type: 'object',
    properties: {
        subType: {
            type: 'string',
            enum: [
                'netSuite',
                'sapSuccessFactors',
                'sapCrm',
                'ukg',
                'oracleHcm',
                'Adp',
                'dynamics365Sales',
                'ceridianDayforce',
                'oracleCrm',
                'oracleErpCloud',
                'sageIntacct',
                'bambooHr',
                'sapErp',
                'googleCloudPlatformCloudStorage',
                'sas',
                'oneDrive',
                'dropbox',
                'googleDrive',
                'jira',
                'monday',
                'zuora',
                'adobeAnalytics',
                'zoomInfo',
                'marketo',
                'activeCampaign',
                'mailchimp',
                'infor',
                'cornerstoneOnDemand',
                'gusto',
                'paychexFlex',
                'zendesk',
                'serviceNow',
                'zohoCrm',
                'pipedrive',
                'quickBooks',
                'xero',
                'freshbooks',
                'zohoBooks',
                'waveFinancial'
            ]
        }
    },
    required: []
};
function validate113(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:RestImportConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.subType !== undefined) {
                let data0 = data.subType;
                if (typeof data0 !== 'string') {
                    validate113.errors = [
                        {
                            instancePath: instancePath + '/subType',
                            schemaPath: '#/properties/subType/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string'
                        }
                    ];
                    return false;
                }
                if (!(data0 === 'netSuite' ||
                    data0 === 'sapSuccessFactors' ||
                    data0 === 'sapCrm' ||
                    data0 === 'ukg' ||
                    data0 === 'oracleHcm' ||
                    data0 === 'Adp' ||
                    data0 === 'dynamics365Sales' ||
                    data0 === 'ceridianDayforce' ||
                    data0 === 'oracleCrm' ||
                    data0 === 'oracleErpCloud' ||
                    data0 === 'sageIntacct' ||
                    data0 === 'bambooHr' ||
                    data0 === 'sapErp' ||
                    data0 === 'googleCloudPlatformCloudStorage' ||
                    data0 === 'sas' ||
                    data0 === 'oneDrive' ||
                    data0 === 'dropbox' ||
                    data0 === 'googleDrive' ||
                    data0 === 'jira' ||
                    data0 === 'monday' ||
                    data0 === 'zuora' ||
                    data0 === 'adobeAnalytics' ||
                    data0 === 'zoomInfo' ||
                    data0 === 'marketo' ||
                    data0 === 'activeCampaign' ||
                    data0 === 'mailchimp' ||
                    data0 === 'infor' ||
                    data0 === 'cornerstoneOnDemand' ||
                    data0 === 'gusto' ||
                    data0 === 'paychexFlex' ||
                    data0 === 'zendesk' ||
                    data0 === 'serviceNow' ||
                    data0 === 'zohoCrm' ||
                    data0 === 'pipedrive' ||
                    data0 === 'quickBooks' ||
                    data0 === 'xero' ||
                    data0 === 'freshbooks' ||
                    data0 === 'zohoBooks' ||
                    data0 === 'waveFinancial')) {
                    validate113.errors = [
                        {
                            instancePath: instancePath + '/subType',
                            schemaPath: '#/properties/subType/enum',
                            keyword: 'enum',
                            params: { allowedValues: schema149.properties.subType.enum },
                            message: 'must be equal to one of the allowed values'
                        }
                    ];
                    return false;
                }
            }
        }
        else {
            validate113.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate113.errors = vErrors;
    return errors === 0;
}
export const s3CsvImportConfigSchemaValidation = validate114;
const schema150 = {
    $id: 'urn:wisepipe-common-data:S3CsvImportConfig',
    type: 'object',
    properties: {
        delimiter: { type: 'string', minLength: 1, maxLength: 1 },
        quoteChar: { type: 'string', enum: ['"', "'"] },
        hasHeader: { type: 'boolean' },
        doDiscovery: { type: 'boolean' },
        dataPreprocessConfig: { $ref: 'urn:wisepipe-common-data:DataPreprocessConfig' }
    },
    required: ['hasHeader']
};
function validate114(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:S3CsvImportConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.hasHeader === undefined && (missing0 = 'hasHeader')) {
                validate114.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.delimiter !== undefined) {
                    let data0 = data.delimiter;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) > 1) {
                                validate114.errors = [
                                    {
                                        instancePath: instancePath + '/delimiter',
                                        schemaPath: '#/properties/delimiter/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have more than 1 characters'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (func2(data0) < 1) {
                                    validate114.errors = [
                                        {
                                            instancePath: instancePath + '/delimiter',
                                            schemaPath: '#/properties/delimiter/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate114.errors = [
                                {
                                    instancePath: instancePath + '/delimiter',
                                    schemaPath: '#/properties/delimiter/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.quoteChar !== undefined) {
                        let data1 = data.quoteChar;
                        const _errs3 = errors;
                        if (typeof data1 !== 'string') {
                            validate114.errors = [
                                {
                                    instancePath: instancePath + '/quoteChar',
                                    schemaPath: '#/properties/quoteChar/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data1 === '"' || data1 === "'")) {
                            validate114.errors = [
                                {
                                    instancePath: instancePath + '/quoteChar',
                                    schemaPath: '#/properties/quoteChar/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema150.properties.quoteChar.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.hasHeader !== undefined) {
                            const _errs5 = errors;
                            if (typeof data.hasHeader !== 'boolean') {
                                validate114.errors = [
                                    {
                                        instancePath: instancePath + '/hasHeader',
                                        schemaPath: '#/properties/hasHeader/type',
                                        keyword: 'type',
                                        params: { type: 'boolean' },
                                        message: 'must be boolean'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.doDiscovery !== undefined) {
                                const _errs7 = errors;
                                if (typeof data.doDiscovery !== 'boolean') {
                                    validate114.errors = [
                                        {
                                            instancePath: instancePath + '/doDiscovery',
                                            schemaPath: '#/properties/doDiscovery/type',
                                            keyword: 'type',
                                            params: { type: 'boolean' },
                                            message: 'must be boolean'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.dataPreprocessConfig !== undefined) {
                                    let data4 = data.dataPreprocessConfig;
                                    const _errs9 = errors;
                                    const _errs10 = errors;
                                    if (errors === _errs10) {
                                        if (data4 && typeof data4 == 'object' && !Array.isArray(data4)) {
                                            let missing1;
                                            if ((data4.skipHeaderRow === undefined && (missing1 = 'skipHeaderRow')) ||
                                                (data4.skipFooterRow === undefined && (missing1 = 'skipFooterRow'))) {
                                                validate114.errors = [
                                                    {
                                                        instancePath: instancePath + '/dataPreprocessConfig',
                                                        schemaPath: 'urn:wisepipe-common-data:DataPreprocessConfig/required',
                                                        keyword: 'required',
                                                        params: { missingProperty: missing1 },
                                                        message: "must have required property '" + missing1 + "'"
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (data4.skipHeaderRow !== undefined) {
                                                    let data5 = data4.skipHeaderRow;
                                                    const _errs12 = errors;
                                                    if (errors === _errs12) {
                                                        if (typeof data5 == 'number') {
                                                            if (data5 > 100 || isNaN(data5)) {
                                                                validate114.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/dataPreprocessConfig/skipHeaderRow',
                                                                        schemaPath: 'urn:wisepipe-common-data:DataPreprocessConfig/properties/skipHeaderRow/maximum',
                                                                        keyword: 'maximum',
                                                                        params: { comparison: '<=', limit: 100 },
                                                                        message: 'must be <= 100'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            else {
                                                                if (data5 < 0 || isNaN(data5)) {
                                                                    validate114.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/dataPreprocessConfig/skipHeaderRow',
                                                                            schemaPath: 'urn:wisepipe-common-data:DataPreprocessConfig/properties/skipHeaderRow/minimum',
                                                                            keyword: 'minimum',
                                                                            params: { comparison: '>=', limit: 0 },
                                                                            message: 'must be >= 0'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                        }
                                                        else {
                                                            validate114.errors = [
                                                                {
                                                                    instancePath: instancePath + '/dataPreprocessConfig/skipHeaderRow',
                                                                    schemaPath: 'urn:wisepipe-common-data:DataPreprocessConfig/properties/skipHeaderRow/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'number' },
                                                                    message: 'must be number'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid2 = _errs12 === errors;
                                                }
                                                else {
                                                    var valid2 = true;
                                                }
                                                if (valid2) {
                                                    if (data4.skipFooterRow !== undefined) {
                                                        let data6 = data4.skipFooterRow;
                                                        const _errs14 = errors;
                                                        if (errors === _errs14) {
                                                            if (typeof data6 == 'number') {
                                                                if (data6 > 100 || isNaN(data6)) {
                                                                    validate114.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/dataPreprocessConfig/skipFooterRow',
                                                                            schemaPath: 'urn:wisepipe-common-data:DataPreprocessConfig/properties/skipFooterRow/maximum',
                                                                            keyword: 'maximum',
                                                                            params: { comparison: '<=', limit: 100 },
                                                                            message: 'must be <= 100'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                else {
                                                                    if (data6 < 0 || isNaN(data6)) {
                                                                        validate114.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/dataPreprocessConfig/skipFooterRow',
                                                                                schemaPath: 'urn:wisepipe-common-data:DataPreprocessConfig/properties/skipFooterRow/minimum',
                                                                                keyword: 'minimum',
                                                                                params: { comparison: '>=', limit: 0 },
                                                                                message: 'must be >= 0'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                            }
                                                            else {
                                                                validate114.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/dataPreprocessConfig/skipFooterRow',
                                                                        schemaPath: 'urn:wisepipe-common-data:DataPreprocessConfig/properties/skipFooterRow/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'number' },
                                                                        message: 'must be number'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid2 = _errs14 === errors;
                                                    }
                                                    else {
                                                        var valid2 = true;
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate114.errors = [
                                                {
                                                    instancePath: instancePath + '/dataPreprocessConfig',
                                                    schemaPath: 'urn:wisepipe-common-data:DataPreprocessConfig/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate114.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate114.errors = vErrors;
    return errors === 0;
}
export const s3FileSchemaValidation = validate115;
const func395 = ucs2length;
const func396 = base64urlToBuffer;
const func397 = base64urlEncode;
const func398 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate115(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common:S3File" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.bucket === undefined && (missing0 = 'bucket')) || (data.key === undefined && (missing0 = 'key'))) {
                validate115.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.bucket !== undefined) {
                    let data0 = data.bucket;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate115.errors = [
                                    {
                                        instancePath: instancePath + '/bucket',
                                        schemaPath: '#/properties/bucket/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate115.errors = [
                                {
                                    instancePath: instancePath + '/bucket',
                                    schemaPath: '#/properties/bucket/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.key !== undefined) {
                        let data1 = data.key;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate115.errors = [
                                        {
                                            instancePath: instancePath + '/key',
                                            schemaPath: '#/properties/key/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate115.errors = [
                                    {
                                        instancePath: instancePath + '/key',
                                        schemaPath: '#/properties/key/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.uploadID !== undefined) {
                            let data2 = data.uploadID;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    const b64min0 = Math.ceil((4 * 9) / 3);
                                    const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                    if (func395(data2) < b64min0 || func395(data2) > b64max0) {
                                        validate115.errors = [
                                            {
                                                instancePath: instancePath + '/uploadID',
                                                schemaPath: '#/properties/uploadID/uid',
                                                keyword: 'uid',
                                                params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func395(data2) },
                                                message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func395(data2)
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const decoded0 = func396(data2);
                                        if (decoded0.length !== 9) {
                                            validate115.errors = [
                                                {
                                                    instancePath: instancePath + '/uploadID',
                                                    schemaPath: '#/properties/uploadID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'decoded' },
                                                    message: 'must decode to 9 bytes'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const encoded0 = func397(decoded0);
                                            if (func398(encoded0) !== func398(data2)) {
                                                validate115.errors = [
                                                    {
                                                        instancePath: instancePath + '/uploadID',
                                                        schemaPath: '#/properties/uploadID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'ambiguous' },
                                                        message: 'encoding is ambiguous'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate115.errors = [
                                        {
                                            instancePath: instancePath + '/uploadID',
                                            schemaPath: '#/properties/uploadID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate115.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate115.errors = vErrors;
    return errors === 0;
}
export const s3ParquetImportConfigSchemaValidation = validate116;
const schema153 = { $id: 'urn:wisepipe-common-data:S3ParquetImportConfig', type: 'object' };
function validate116(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:S3ParquetImportConfig" */ let vErrors = null;
    let errors = 0;
    if (!(data && typeof data == 'object' && !Array.isArray(data))) {
        validate116.errors = [
            { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
        ];
        return false;
    }
    validate116.errors = vErrors;
    return errors === 0;
}
export const salesForceImportConfigSchemaValidation = validate117;
const schema154 = {
    $id: 'urn:wisepipe-common-data:SalesForceImportConfig',
    type: 'object',
    properties: {
        startDate: { type: 'string', format: 'date-time' },
        sourceType: { type: 'string', enum: ['object', 'report'] },
        objectName: { type: 'string', minLength: 1 },
        reportId: { type: 'string', minLength: 1 }
    },
    if: { properties: { sourceType: { const: 'object' } }, required: ['sourceType'] },
    then: { required: ['objectName'] },
    else: {
        if: { properties: { sourceType: { const: 'report' } }, required: ['sourceType'] },
        then: { required: ['reportId'] }
    },
    required: ['startDate']
};
function validate117(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:SalesForceImportConfig" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        let missing0;
        if (data.sourceType === undefined && (missing0 = 'sourceType')) {
            const err0 = {};
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
        else {
            if (data.sourceType !== undefined) {
                if ('object' !== data.sourceType) {
                    const err1 = {};
                    if (vErrors === null) {
                        vErrors = [err1];
                    }
                    else {
                        vErrors.push(err1);
                    }
                    errors++;
                }
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    let ifClause0;
    if (_valid0) {
        const _errs4 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if (data.objectName === undefined && (missing1 = 'objectName')) {
                validate117.errors = [
                    {
                        instancePath,
                        schemaPath: '#/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs4 === errors;
        valid0 = _valid0;
        ifClause0 = 'then';
    }
    else {
        const _errs5 = errors;
        const _errs6 = errors;
        let valid2 = true;
        const _errs7 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing2;
            if (data.sourceType === undefined && (missing2 = 'sourceType')) {
                const err2 = {};
                if (vErrors === null) {
                    vErrors = [err2];
                }
                else {
                    vErrors.push(err2);
                }
                errors++;
            }
            else {
                if (data.sourceType !== undefined) {
                    if ('report' !== data.sourceType) {
                        const err3 = {};
                        if (vErrors === null) {
                            vErrors = [err3];
                        }
                        else {
                            vErrors.push(err3);
                        }
                        errors++;
                    }
                }
            }
        }
        var _valid1 = _errs7 === errors;
        errors = _errs6;
        if (vErrors !== null) {
            if (_errs6) {
                vErrors.length = _errs6;
            }
            else {
                vErrors = null;
            }
        }
        if (_valid1) {
            const _errs9 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                let missing3;
                if (data.reportId === undefined && (missing3 = 'reportId')) {
                    validate117.errors = [
                        {
                            instancePath,
                            schemaPath: '#/else/then/required',
                            keyword: 'required',
                            params: { missingProperty: missing3 },
                            message: "must have required property '" + missing3 + "'"
                        }
                    ];
                    return false;
                }
            }
            var _valid1 = _errs9 === errors;
            valid2 = _valid1;
        }
        if (!valid2) {
            const err4 = {
                instancePath,
                schemaPath: '#/else/if',
                keyword: 'if',
                params: { failingKeyword: 'then' },
                message: 'must match "then" schema'
            };
            if (vErrors === null) {
                vErrors = [err4];
            }
            else {
                vErrors.push(err4);
            }
            errors++;
            validate117.errors = vErrors;
            return false;
        }
        var _valid0 = _errs5 === errors;
        valid0 = _valid0;
        ifClause0 = 'else';
    }
    if (!valid0) {
        const err5 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: ifClause0 },
            message: 'must match "' + ifClause0 + '" schema'
        };
        if (vErrors === null) {
            vErrors = [err5];
        }
        else {
            vErrors.push(err5);
        }
        errors++;
        validate117.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing4;
            if (data.startDate === undefined && (missing4 = 'startDate')) {
                validate117.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing4 },
                        message: "must have required property '" + missing4 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.startDate !== undefined) {
                    let data2 = data.startDate;
                    const _errs10 = errors;
                    if (errors === _errs10) {
                        if (errors === _errs10) {
                            if (typeof data2 === 'string') {
                                if (!formats0.validate(data2)) {
                                    validate117.errors = [
                                        {
                                            instancePath: instancePath + '/startDate',
                                            schemaPath: '#/properties/startDate/format',
                                            keyword: 'format',
                                            params: { format: 'date-time' },
                                            message: 'must match format "' + 'date-time' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate117.errors = [
                                    {
                                        instancePath: instancePath + '/startDate',
                                        schemaPath: '#/properties/startDate/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid4 = _errs10 === errors;
                }
                else {
                    var valid4 = true;
                }
                if (valid4) {
                    if (data.sourceType !== undefined) {
                        let data3 = data.sourceType;
                        const _errs12 = errors;
                        if (typeof data3 !== 'string') {
                            validate117.errors = [
                                {
                                    instancePath: instancePath + '/sourceType',
                                    schemaPath: '#/properties/sourceType/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data3 === 'object' || data3 === 'report')) {
                            validate117.errors = [
                                {
                                    instancePath: instancePath + '/sourceType',
                                    schemaPath: '#/properties/sourceType/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema154.properties.sourceType.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid4 = _errs12 === errors;
                    }
                    else {
                        var valid4 = true;
                    }
                    if (valid4) {
                        if (data.objectName !== undefined) {
                            let data4 = data.objectName;
                            const _errs14 = errors;
                            if (errors === _errs14) {
                                if (typeof data4 === 'string') {
                                    if (func2(data4) < 1) {
                                        validate117.errors = [
                                            {
                                                instancePath: instancePath + '/objectName',
                                                schemaPath: '#/properties/objectName/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate117.errors = [
                                        {
                                            instancePath: instancePath + '/objectName',
                                            schemaPath: '#/properties/objectName/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid4 = _errs14 === errors;
                        }
                        else {
                            var valid4 = true;
                        }
                        if (valid4) {
                            if (data.reportId !== undefined) {
                                let data5 = data.reportId;
                                const _errs16 = errors;
                                if (errors === _errs16) {
                                    if (typeof data5 === 'string') {
                                        if (func2(data5) < 1) {
                                            validate117.errors = [
                                                {
                                                    instancePath: instancePath + '/reportId',
                                                    schemaPath: '#/properties/reportId/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate117.errors = [
                                            {
                                                instancePath: instancePath + '/reportId',
                                                schemaPath: '#/properties/reportId/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid4 = _errs16 === errors;
                            }
                            else {
                                var valid4 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate117.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate117.errors = vErrors;
    return errors === 0;
}
export const sftpImportConfigSchemaValidation = validate118;
const schema155 = {
    $id: 'urn:wisepipe-common-data:SftpImportConfig',
    type: 'object',
    properties: {
        filepath: { type: 'string' },
        filename: { type: 'string' },
        prefix: { type: 'string', minLength: 0 },
        filetype: { type: 'string', enum: ['.csv', '.xls', '.xlsx', '.txt', '.fwf', '.pgp', '.gpg'] },
        useEncryption: { type: 'boolean' },
        delimiter: { type: 'string', minLength: 1, maxLength: 1 },
        quotechar: { type: 'string', minLength: 1, maxLength: 1 },
        hasHeader: { type: 'boolean' },
        dataPreprocessConfig: { $ref: 'urn:wisepipe-common-data:DataPreprocessConfig' },
        columnConfiguration: { $ref: 'urn:wisepipe-common-data:FwfColumnConfiguration' },
        dynamic: { type: 'string', enum: ['oldestModified', 'newestModified'] }
    },
    required: ['filepath', 'filename', 'prefix', 'filetype']
};
function validate118(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:SftpImportConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.filepath === undefined && (missing0 = 'filepath')) ||
                (data.filename === undefined && (missing0 = 'filename')) ||
                (data.prefix === undefined && (missing0 = 'prefix')) ||
                (data.filetype === undefined && (missing0 = 'filetype'))) {
                validate118.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.filepath !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.filepath !== 'string') {
                        validate118.errors = [
                            {
                                instancePath: instancePath + '/filepath',
                                schemaPath: '#/properties/filepath/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.filename !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.filename !== 'string') {
                            validate118.errors = [
                                {
                                    instancePath: instancePath + '/filename',
                                    schemaPath: '#/properties/filename/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.prefix !== undefined) {
                            let data2 = data.prefix;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 0) {
                                        validate118.errors = [
                                            {
                                                instancePath: instancePath + '/prefix',
                                                schemaPath: '#/properties/prefix/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 0 },
                                                message: 'must NOT have fewer than 0 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate118.errors = [
                                        {
                                            instancePath: instancePath + '/prefix',
                                            schemaPath: '#/properties/prefix/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.filetype !== undefined) {
                                let data3 = data.filetype;
                                const _errs7 = errors;
                                if (typeof data3 !== 'string') {
                                    validate118.errors = [
                                        {
                                            instancePath: instancePath + '/filetype',
                                            schemaPath: '#/properties/filetype/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                if (!(data3 === '.csv' ||
                                    data3 === '.xls' ||
                                    data3 === '.xlsx' ||
                                    data3 === '.txt' ||
                                    data3 === '.fwf' ||
                                    data3 === '.pgp' ||
                                    data3 === '.gpg')) {
                                    validate118.errors = [
                                        {
                                            instancePath: instancePath + '/filetype',
                                            schemaPath: '#/properties/filetype/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema155.properties.filetype.enum },
                                            message: 'must be equal to one of the allowed values'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.useEncryption !== undefined) {
                                    const _errs9 = errors;
                                    if (typeof data.useEncryption !== 'boolean') {
                                        validate118.errors = [
                                            {
                                                instancePath: instancePath + '/useEncryption',
                                                schemaPath: '#/properties/useEncryption/type',
                                                keyword: 'type',
                                                params: { type: 'boolean' },
                                                message: 'must be boolean'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.delimiter !== undefined) {
                                        let data5 = data.delimiter;
                                        const _errs11 = errors;
                                        if (errors === _errs11) {
                                            if (typeof data5 === 'string') {
                                                if (func2(data5) > 1) {
                                                    validate118.errors = [
                                                        {
                                                            instancePath: instancePath + '/delimiter',
                                                            schemaPath: '#/properties/delimiter/maxLength',
                                                            keyword: 'maxLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have more than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    if (func2(data5) < 1) {
                                                        validate118.errors = [
                                                            {
                                                                instancePath: instancePath + '/delimiter',
                                                                schemaPath: '#/properties/delimiter/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                            }
                                            else {
                                                validate118.errors = [
                                                    {
                                                        instancePath: instancePath + '/delimiter',
                                                        schemaPath: '#/properties/delimiter/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.quotechar !== undefined) {
                                            let data6 = data.quotechar;
                                            const _errs13 = errors;
                                            if (errors === _errs13) {
                                                if (typeof data6 === 'string') {
                                                    if (func2(data6) > 1) {
                                                        validate118.errors = [
                                                            {
                                                                instancePath: instancePath + '/quotechar',
                                                                schemaPath: '#/properties/quotechar/maxLength',
                                                                keyword: 'maxLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have more than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        if (func2(data6) < 1) {
                                                            validate118.errors = [
                                                                {
                                                                    instancePath: instancePath + '/quotechar',
                                                                    schemaPath: '#/properties/quotechar/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate118.errors = [
                                                        {
                                                            instancePath: instancePath + '/quotechar',
                                                            schemaPath: '#/properties/quotechar/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs13 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.hasHeader !== undefined) {
                                                const _errs15 = errors;
                                                if (typeof data.hasHeader !== 'boolean') {
                                                    validate118.errors = [
                                                        {
                                                            instancePath: instancePath + '/hasHeader',
                                                            schemaPath: '#/properties/hasHeader/type',
                                                            keyword: 'type',
                                                            params: { type: 'boolean' },
                                                            message: 'must be boolean'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid0 = _errs15 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (data.dataPreprocessConfig !== undefined) {
                                                    let data8 = data.dataPreprocessConfig;
                                                    const _errs17 = errors;
                                                    const _errs18 = errors;
                                                    if (errors === _errs18) {
                                                        if (data8 && typeof data8 == 'object' && !Array.isArray(data8)) {
                                                            let missing1;
                                                            if ((data8.skipHeaderRow === undefined && (missing1 = 'skipHeaderRow')) ||
                                                                (data8.skipFooterRow === undefined && (missing1 = 'skipFooterRow'))) {
                                                                validate118.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/dataPreprocessConfig',
                                                                        schemaPath: 'urn:wisepipe-common-data:DataPreprocessConfig/required',
                                                                        keyword: 'required',
                                                                        params: { missingProperty: missing1 },
                                                                        message: "must have required property '" + missing1 + "'"
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            else {
                                                                if (data8.skipHeaderRow !== undefined) {
                                                                    let data9 = data8.skipHeaderRow;
                                                                    const _errs20 = errors;
                                                                    if (errors === _errs20) {
                                                                        if (typeof data9 == 'number') {
                                                                            if (data9 > 100 || isNaN(data9)) {
                                                                                validate118.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/dataPreprocessConfig/skipHeaderRow',
                                                                                        schemaPath: 'urn:wisepipe-common-data:DataPreprocessConfig/properties/skipHeaderRow/maximum',
                                                                                        keyword: 'maximum',
                                                                                        params: { comparison: '<=', limit: 100 },
                                                                                        message: 'must be <= 100'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            else {
                                                                                if (data9 < 0 || isNaN(data9)) {
                                                                                    validate118.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/dataPreprocessConfig/skipHeaderRow',
                                                                                            schemaPath: 'urn:wisepipe-common-data:DataPreprocessConfig/properties/skipHeaderRow/minimum',
                                                                                            keyword: 'minimum',
                                                                                            params: { comparison: '>=', limit: 0 },
                                                                                            message: 'must be >= 0'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                        }
                                                                        else {
                                                                            validate118.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/dataPreprocessConfig/skipHeaderRow',
                                                                                    schemaPath: 'urn:wisepipe-common-data:DataPreprocessConfig/properties/skipHeaderRow/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'number' },
                                                                                    message: 'must be number'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    var valid2 = _errs20 === errors;
                                                                }
                                                                else {
                                                                    var valid2 = true;
                                                                }
                                                                if (valid2) {
                                                                    if (data8.skipFooterRow !== undefined) {
                                                                        let data10 = data8.skipFooterRow;
                                                                        const _errs22 = errors;
                                                                        if (errors === _errs22) {
                                                                            if (typeof data10 == 'number') {
                                                                                if (data10 > 100 || isNaN(data10)) {
                                                                                    validate118.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/dataPreprocessConfig/skipFooterRow',
                                                                                            schemaPath: 'urn:wisepipe-common-data:DataPreprocessConfig/properties/skipFooterRow/maximum',
                                                                                            keyword: 'maximum',
                                                                                            params: { comparison: '<=', limit: 100 },
                                                                                            message: 'must be <= 100'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                                else {
                                                                                    if (data10 < 0 || isNaN(data10)) {
                                                                                        validate118.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/dataPreprocessConfig/skipFooterRow',
                                                                                                schemaPath: 'urn:wisepipe-common-data:DataPreprocessConfig/properties/skipFooterRow/minimum',
                                                                                                keyword: 'minimum',
                                                                                                params: { comparison: '>=', limit: 0 },
                                                                                                message: 'must be >= 0'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                            }
                                                                            else {
                                                                                validate118.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/dataPreprocessConfig/skipFooterRow',
                                                                                        schemaPath: 'urn:wisepipe-common-data:DataPreprocessConfig/properties/skipFooterRow/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'number' },
                                                                                        message: 'must be number'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        var valid2 = _errs22 === errors;
                                                                    }
                                                                    else {
                                                                        var valid2 = true;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                        else {
                                                            validate118.errors = [
                                                                {
                                                                    instancePath: instancePath + '/dataPreprocessConfig',
                                                                    schemaPath: 'urn:wisepipe-common-data:DataPreprocessConfig/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'object' },
                                                                    message: 'must be object'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid0 = _errs17 === errors;
                                                }
                                                else {
                                                    var valid0 = true;
                                                }
                                                if (valid0) {
                                                    if (data.columnConfiguration !== undefined) {
                                                        let data11 = data.columnConfiguration;
                                                        const _errs24 = errors;
                                                        const _errs25 = errors;
                                                        if (errors === _errs25) {
                                                            if (data11 && typeof data11 == 'object' && !Array.isArray(data11)) {
                                                                let missing2;
                                                                if (data11.columnSpecs === undefined && (missing2 = 'columnSpecs')) {
                                                                    validate118.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/columnConfiguration',
                                                                            schemaPath: 'urn:wisepipe-common-data:FwfColumnConfiguration/required',
                                                                            keyword: 'required',
                                                                            params: { missingProperty: missing2 },
                                                                            message: "must have required property '" + missing2 + "'"
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                else {
                                                                    if (data11.columnSpecs !== undefined) {
                                                                        let data12 = data11.columnSpecs;
                                                                        const _errs27 = errors;
                                                                        if (errors === _errs27) {
                                                                            if (Array.isArray(data12)) {
                                                                                var valid5 = true;
                                                                                const len0 = data12.length;
                                                                                for (let i0 = 0; i0 < len0; i0++) {
                                                                                    let data13 = data12[i0];
                                                                                    const _errs29 = errors;
                                                                                    if (errors === _errs29) {
                                                                                        if (Array.isArray(data13)) {
                                                                                            var valid6 = true;
                                                                                            const len1 = data13.length;
                                                                                            for (let i1 = 0; i1 < len1; i1++) {
                                                                                                const _errs31 = errors;
                                                                                                if (!(typeof data13[i1] == 'number')) {
                                                                                                    validate118.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath +
                                                                                                                '/columnConfiguration/columnSpecs/' +
                                                                                                                i0 +
                                                                                                                '/' +
                                                                                                                i1,
                                                                                                            schemaPath: 'urn:wisepipe-common-data:FwfColumnConfiguration/properties/columnSpecs/items/items/type',
                                                                                                            keyword: 'type',
                                                                                                            params: { type: 'number' },
                                                                                                            message: 'must be number'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                                var valid6 = _errs31 === errors;
                                                                                                if (!valid6) {
                                                                                                    break;
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                        else {
                                                                                            validate118.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/columnConfiguration/columnSpecs/' + i0,
                                                                                                    schemaPath: 'urn:wisepipe-common-data:FwfColumnConfiguration/properties/columnSpecs/items/type',
                                                                                                    keyword: 'type',
                                                                                                    params: { type: 'array' },
                                                                                                    message: 'must be array'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                    var valid5 = _errs29 === errors;
                                                                                    if (!valid5) {
                                                                                        break;
                                                                                    }
                                                                                }
                                                                            }
                                                                            else {
                                                                                validate118.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/columnConfiguration/columnSpecs',
                                                                                        schemaPath: 'urn:wisepipe-common-data:FwfColumnConfiguration/properties/columnSpecs/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'array' },
                                                                                        message: 'must be array'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        var valid4 = _errs27 === errors;
                                                                    }
                                                                    else {
                                                                        var valid4 = true;
                                                                    }
                                                                    if (valid4) {
                                                                        if (data11.columnsToRename !== undefined) {
                                                                            let data15 = data11.columnsToRename;
                                                                            const _errs33 = errors;
                                                                            if (errors === _errs33) {
                                                                                if (Array.isArray(data15)) {
                                                                                    var valid7 = true;
                                                                                    const len2 = data15.length;
                                                                                    for (let i2 = 0; i2 < len2; i2++) {
                                                                                        let data16 = data15[i2];
                                                                                        const _errs35 = errors;
                                                                                        if (errors === _errs35) {
                                                                                            if (Array.isArray(data16)) {
                                                                                                var valid8 = true;
                                                                                                const len3 = data16.length;
                                                                                                for (let i3 = 0; i3 < len3; i3++) {
                                                                                                    const _errs37 = errors;
                                                                                                    if (typeof data16[i3] !== 'string') {
                                                                                                        validate118.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath +
                                                                                                                    '/columnConfiguration/columnsToRename/' +
                                                                                                                    i2 +
                                                                                                                    '/' +
                                                                                                                    i3,
                                                                                                                schemaPath: 'urn:wisepipe-common-data:FwfColumnConfiguration/properties/columnsToRename/items/items/type',
                                                                                                                keyword: 'type',
                                                                                                                params: { type: 'string' },
                                                                                                                message: 'must be string'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                    var valid8 = _errs37 === errors;
                                                                                                    if (!valid8) {
                                                                                                        break;
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                            else {
                                                                                                validate118.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/columnConfiguration/columnsToRename/' + i2,
                                                                                                        schemaPath: 'urn:wisepipe-common-data:FwfColumnConfiguration/properties/columnsToRename/items/type',
                                                                                                        keyword: 'type',
                                                                                                        params: { type: 'array' },
                                                                                                        message: 'must be array'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                        }
                                                                                        var valid7 = _errs35 === errors;
                                                                                        if (!valid7) {
                                                                                            break;
                                                                                        }
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    validate118.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/columnConfiguration/columnsToRename',
                                                                                            schemaPath: 'urn:wisepipe-common-data:FwfColumnConfiguration/properties/columnsToRename/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'array' },
                                                                                            message: 'must be array'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            var valid4 = _errs33 === errors;
                                                                        }
                                                                        else {
                                                                            var valid4 = true;
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                            else {
                                                                validate118.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/columnConfiguration',
                                                                        schemaPath: 'urn:wisepipe-common-data:FwfColumnConfiguration/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'object' },
                                                                        message: 'must be object'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid0 = _errs24 === errors;
                                                    }
                                                    else {
                                                        var valid0 = true;
                                                    }
                                                    if (valid0) {
                                                        if (data.dynamic !== undefined) {
                                                            let data18 = data.dynamic;
                                                            const _errs39 = errors;
                                                            if (typeof data18 !== 'string') {
                                                                validate118.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/dynamic',
                                                                        schemaPath: '#/properties/dynamic/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            if (!(data18 === 'oldestModified' || data18 === 'newestModified')) {
                                                                validate118.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/dynamic',
                                                                        schemaPath: '#/properties/dynamic/enum',
                                                                        keyword: 'enum',
                                                                        params: { allowedValues: schema155.properties.dynamic.enum },
                                                                        message: 'must be equal to one of the allowed values'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid0 = _errs39 === errors;
                                                        }
                                                        else {
                                                            var valid0 = true;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate118.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate118.errors = vErrors;
    return errors === 0;
}
export const shopifyImportConfigSchemaValidation = validate119;
const schema158 = {
    $id: 'urn:wisepipe-common-data:ShopifyImportConfig',
    type: 'object',
    properties: { shop: { type: 'string', minLength: 1 }, startDate: { type: 'string', format: 'date-time' } },
    required: ['startDate']
};
function validate119(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:ShopifyImportConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.startDate === undefined && (missing0 = 'startDate')) {
                validate119.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.shop !== undefined) {
                    let data0 = data.shop;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate119.errors = [
                                    {
                                        instancePath: instancePath + '/shop',
                                        schemaPath: '#/properties/shop/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate119.errors = [
                                {
                                    instancePath: instancePath + '/shop',
                                    schemaPath: '#/properties/shop/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.startDate !== undefined) {
                        let data1 = data.startDate;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (errors === _errs3) {
                                if (typeof data1 === 'string') {
                                    if (!formats0.validate(data1)) {
                                        validate119.errors = [
                                            {
                                                instancePath: instancePath + '/startDate',
                                                schemaPath: '#/properties/startDate/format',
                                                keyword: 'format',
                                                params: { format: 'date-time' },
                                                message: 'must match format "' + 'date-time' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate119.errors = [
                                        {
                                            instancePath: instancePath + '/startDate',
                                            schemaPath: '#/properties/startDate/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate119.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate119.errors = vErrors;
    return errors === 0;
}
export const snapshotImportTaskSchemaValidation = validate120;
const schema159 = {
    $id: 'urn:wisepipe-common-data:SnapshotImportTask',
    type: 'object',
    properties: { unitTestID: { type: 'string', uid: 9 } },
    required: ['unitTestID']
};
const func407 = ucs2length;
const func408 = base64urlToBuffer;
const func409 = base64urlEncode;
const func410 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate120(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:SnapshotImportTask" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.unitTestID === undefined && (missing0 = 'unitTestID')) {
                validate120.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.unitTestID !== undefined) {
                    let data0 = data.unitTestID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 9) / 3);
                            const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                            if (func407(data0) < b64min0 || func407(data0) > b64max0) {
                                validate120.errors = [
                                    {
                                        instancePath: instancePath + '/unitTestID',
                                        schemaPath: '#/properties/unitTestID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func407(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func407(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func408(data0);
                                if (decoded0.length !== 9) {
                                    validate120.errors = [
                                        {
                                            instancePath: instancePath + '/unitTestID',
                                            schemaPath: '#/properties/unitTestID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 9 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func409(decoded0);
                                    if (func410(encoded0) !== func410(data0)) {
                                        validate120.errors = [
                                            {
                                                instancePath: instancePath + '/unitTestID',
                                                schemaPath: '#/properties/unitTestID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate120.errors = [
                                {
                                    instancePath: instancePath + '/unitTestID',
                                    schemaPath: '#/properties/unitTestID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate120.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate120.errors = vErrors;
    return errors === 0;
}
export const snowflakeImportConfigSchemaValidation = validate121;
const schema160 = {
    $id: 'urn:wisepipe-common-data:SnowflakeImportConfig',
    type: 'object',
    properties: { table: { type: 'string' }, useS3Unload: { type: 'boolean' } },
    required: ['table']
};
function validate121(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:SnowflakeImportConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.table === undefined && (missing0 = 'table')) {
                validate121.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.table !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.table !== 'string') {
                        validate121.errors = [
                            {
                                instancePath: instancePath + '/table',
                                schemaPath: '#/properties/table/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.useS3Unload !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.useS3Unload !== 'boolean') {
                            validate121.errors = [
                                {
                                    instancePath: instancePath + '/useS3Unload',
                                    schemaPath: '#/properties/useS3Unload/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate121.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate121.errors = vErrors;
    return errors === 0;
}
export const sparkFieldSchemaValidation = validate122;
const schema161 = {
    $id: 'urn:wisepipe-common-data:SparkField',
    type: 'object',
    properties: {
        name: { type: 'string', minLength: 1 },
        type: { type: 'string', enum: ['double', 'timestamp', 'string', 'boolean', 'decimal'] },
        nullable: { type: 'boolean' },
        metadata: { type: 'object' }
    },
    required: ['name', 'nullable', 'type']
};
function validate122(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:SparkField" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.name === undefined && (missing0 = 'name')) ||
                (data.nullable === undefined && (missing0 = 'nullable')) ||
                (data.type === undefined && (missing0 = 'type'))) {
                validate122.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.name !== undefined) {
                    let data0 = data.name;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate122.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate122.errors = [
                                {
                                    instancePath: instancePath + '/name',
                                    schemaPath: '#/properties/name/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.type !== undefined) {
                        let data1 = data.type;
                        const _errs3 = errors;
                        if (typeof data1 !== 'string') {
                            validate122.errors = [
                                {
                                    instancePath: instancePath + '/type',
                                    schemaPath: '#/properties/type/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data1 === 'double' ||
                            data1 === 'timestamp' ||
                            data1 === 'string' ||
                            data1 === 'boolean' ||
                            data1 === 'decimal')) {
                            validate122.errors = [
                                {
                                    instancePath: instancePath + '/type',
                                    schemaPath: '#/properties/type/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema161.properties.type.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.nullable !== undefined) {
                            const _errs5 = errors;
                            if (typeof data.nullable !== 'boolean') {
                                validate122.errors = [
                                    {
                                        instancePath: instancePath + '/nullable',
                                        schemaPath: '#/properties/nullable/type',
                                        keyword: 'type',
                                        params: { type: 'boolean' },
                                        message: 'must be boolean'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.metadata !== undefined) {
                                let data3 = data.metadata;
                                const _errs7 = errors;
                                if (!(data3 && typeof data3 == 'object' && !Array.isArray(data3))) {
                                    validate122.errors = [
                                        {
                                            instancePath: instancePath + '/metadata',
                                            schemaPath: '#/properties/metadata/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate122.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate122.errors = vErrors;
    return errors === 0;
}
export const sparkSchemaSchemaValidation = validate123;
const schema162 = {
    $id: 'urn:wisepipe-common-data:SparkSchema',
    type: 'object',
    properties: {
        fields: { type: 'array', items: { $ref: 'urn:wisepipe-common-data:SparkField' } },
        type: { type: 'string' }
    },
    required: ['fields', 'type']
};
function validate123(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:SparkSchema" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.fields === undefined && (missing0 = 'fields')) || (data.type === undefined && (missing0 = 'type'))) {
                validate123.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.fields !== undefined) {
                    let data0 = data.fields;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            var valid1 = true;
                            const len0 = data0.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                                let data1 = data0[i0];
                                const _errs3 = errors;
                                const _errs4 = errors;
                                if (errors === _errs4) {
                                    if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                        let missing1;
                                        if ((data1.name === undefined && (missing1 = 'name')) ||
                                            (data1.nullable === undefined && (missing1 = 'nullable')) ||
                                            (data1.type === undefined && (missing1 = 'type'))) {
                                            validate123.errors = [
                                                {
                                                    instancePath: instancePath + '/fields/' + i0,
                                                    schemaPath: 'urn:wisepipe-common-data:SparkField/required',
                                                    keyword: 'required',
                                                    params: { missingProperty: missing1 },
                                                    message: "must have required property '" + missing1 + "'"
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            if (data1.name !== undefined) {
                                                let data2 = data1.name;
                                                const _errs6 = errors;
                                                if (errors === _errs6) {
                                                    if (typeof data2 === 'string') {
                                                        if (func2(data2) < 1) {
                                                            validate123.errors = [
                                                                {
                                                                    instancePath: instancePath + '/fields/' + i0 + '/name',
                                                                    schemaPath: 'urn:wisepipe-common-data:SparkField/properties/name/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate123.errors = [
                                                            {
                                                                instancePath: instancePath + '/fields/' + i0 + '/name',
                                                                schemaPath: 'urn:wisepipe-common-data:SparkField/properties/name/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid3 = _errs6 === errors;
                                            }
                                            else {
                                                var valid3 = true;
                                            }
                                            if (valid3) {
                                                if (data1.type !== undefined) {
                                                    let data3 = data1.type;
                                                    const _errs8 = errors;
                                                    if (typeof data3 !== 'string') {
                                                        validate123.errors = [
                                                            {
                                                                instancePath: instancePath + '/fields/' + i0 + '/type',
                                                                schemaPath: 'urn:wisepipe-common-data:SparkField/properties/type/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    if (!(data3 === 'double' ||
                                                        data3 === 'timestamp' ||
                                                        data3 === 'string' ||
                                                        data3 === 'boolean' ||
                                                        data3 === 'decimal')) {
                                                        validate123.errors = [
                                                            {
                                                                instancePath: instancePath + '/fields/' + i0 + '/type',
                                                                schemaPath: 'urn:wisepipe-common-data:SparkField/properties/type/enum',
                                                                keyword: 'enum',
                                                                params: { allowedValues: schema161.properties.type.enum },
                                                                message: 'must be equal to one of the allowed values'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid3 = _errs8 === errors;
                                                }
                                                else {
                                                    var valid3 = true;
                                                }
                                                if (valid3) {
                                                    if (data1.nullable !== undefined) {
                                                        const _errs10 = errors;
                                                        if (typeof data1.nullable !== 'boolean') {
                                                            validate123.errors = [
                                                                {
                                                                    instancePath: instancePath + '/fields/' + i0 + '/nullable',
                                                                    schemaPath: 'urn:wisepipe-common-data:SparkField/properties/nullable/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'boolean' },
                                                                    message: 'must be boolean'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid3 = _errs10 === errors;
                                                    }
                                                    else {
                                                        var valid3 = true;
                                                    }
                                                    if (valid3) {
                                                        if (data1.metadata !== undefined) {
                                                            let data5 = data1.metadata;
                                                            const _errs12 = errors;
                                                            if (!(data5 && typeof data5 == 'object' && !Array.isArray(data5))) {
                                                                validate123.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/fields/' + i0 + '/metadata',
                                                                        schemaPath: 'urn:wisepipe-common-data:SparkField/properties/metadata/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'object' },
                                                                        message: 'must be object'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid3 = _errs12 === errors;
                                                        }
                                                        else {
                                                            var valid3 = true;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate123.errors = [
                                            {
                                                instancePath: instancePath + '/fields/' + i0,
                                                schemaPath: 'urn:wisepipe-common-data:SparkField/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid1 = _errs3 === errors;
                                if (!valid1) {
                                    break;
                                }
                            }
                        }
                        else {
                            validate123.errors = [
                                {
                                    instancePath: instancePath + '/fields',
                                    schemaPath: '#/properties/fields/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.type !== undefined) {
                        const _errs14 = errors;
                        if (typeof data.type !== 'string') {
                            validate123.errors = [
                                {
                                    instancePath: instancePath + '/type',
                                    schemaPath: '#/properties/type/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs14 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate123.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate123.errors = vErrors;
    return errors === 0;
}
export const symonImportConfigSchemaValidation = validate124;
const schema164 = {
    $id: 'urn:wisepipe-common-data:SymonImportConfig',
    type: 'object',
    properties: { s3File: { $ref: 'urn:wisepipe-common:S3File' } }
};
const func415 = ucs2length;
const func416 = base64urlToBuffer;
const func417 = base64urlEncode;
const func418 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate124(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:SymonImportConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.s3File !== undefined) {
                let data0 = data.s3File;
                const _errs2 = errors;
                if (errors === _errs2) {
                    if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                        let missing0;
                        if ((data0.bucket === undefined && (missing0 = 'bucket')) ||
                            (data0.key === undefined && (missing0 = 'key'))) {
                            validate124.errors = [
                                {
                                    instancePath: instancePath + '/s3File',
                                    schemaPath: 'urn:wisepipe-common:S3File/required',
                                    keyword: 'required',
                                    params: { missingProperty: missing0 },
                                    message: "must have required property '" + missing0 + "'"
                                }
                            ];
                            return false;
                        }
                        else {
                            if (data0.bucket !== undefined) {
                                let data1 = data0.bucket;
                                const _errs4 = errors;
                                if (errors === _errs4) {
                                    if (typeof data1 === 'string') {
                                        if (func2(data1) < 1) {
                                            validate124.errors = [
                                                {
                                                    instancePath: instancePath + '/s3File/bucket',
                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate124.errors = [
                                            {
                                                instancePath: instancePath + '/s3File/bucket',
                                                schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid2 = _errs4 === errors;
                            }
                            else {
                                var valid2 = true;
                            }
                            if (valid2) {
                                if (data0.key !== undefined) {
                                    let data2 = data0.key;
                                    const _errs6 = errors;
                                    if (errors === _errs6) {
                                        if (typeof data2 === 'string') {
                                            if (func2(data2) < 1) {
                                                validate124.errors = [
                                                    {
                                                        instancePath: instancePath + '/s3File/key',
                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate124.errors = [
                                                {
                                                    instancePath: instancePath + '/s3File/key',
                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid2 = _errs6 === errors;
                                }
                                else {
                                    var valid2 = true;
                                }
                                if (valid2) {
                                    if (data0.uploadID !== undefined) {
                                        let data3 = data0.uploadID;
                                        const _errs8 = errors;
                                        if (errors === _errs8) {
                                            if (typeof data3 === 'string') {
                                                const b64min0 = Math.ceil((4 * 9) / 3);
                                                const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                                if (func415(data3) < b64min0 || func415(data3) > b64max0) {
                                                    validate124.errors = [
                                                        {
                                                            instancePath: instancePath + '/s3File/uploadID',
                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func415(data3) },
                                                            message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func415(data3)
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    const decoded0 = func416(data3);
                                                    if (decoded0.length !== 9) {
                                                        validate124.errors = [
                                                            {
                                                                instancePath: instancePath + '/s3File/uploadID',
                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                keyword: 'uid',
                                                                params: { error: 'decoded' },
                                                                message: 'must decode to 9 bytes'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        const encoded0 = func417(decoded0);
                                                        if (func418(encoded0) !== func418(data3)) {
                                                            validate124.errors = [
                                                                {
                                                                    instancePath: instancePath + '/s3File/uploadID',
                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                    keyword: 'uid',
                                                                    params: { error: 'ambiguous' },
                                                                    message: 'encoding is ambiguous'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate124.errors = [
                                                    {
                                                        instancePath: instancePath + '/s3File/uploadID',
                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid2 = _errs8 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                }
                            }
                        }
                    }
                    else {
                        validate124.errors = [
                            {
                                instancePath: instancePath + '/s3File',
                                schemaPath: 'urn:wisepipe-common:S3File/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object'
                            }
                        ];
                        return false;
                    }
                }
            }
        }
        else {
            validate124.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate124.errors = vErrors;
    return errors === 0;
}
export const targetConfigSchemaValidation = validate125;
const schema166 = {
    $id: 'urn:wisepipe-common-data:TargetConfig',
    type: 'object',
    properties: {
        delimiter: { type: 'string' },
        s3_bucket: { type: 'string' },
        s3_prefix: { type: 'string' },
        quotechar: { type: 'string' },
        column_limit: { type: 'number' },
        clean_data: { type: 'boolean' },
        columns_to_update: {
            type: 'object',
            additionalProperties: {
                type: 'array',
                items: { $ref: 'urn:wisepipe-common-data:ColumnUpdate' },
                uniqueItems: true
            }
        },
        split_index: { type: 'integer', minimum: 0 },
        buffer_size: { type: 'integer', minimum: 1 },
        generate_sample_files: { type: 'boolean' },
        columns_to_rename: { type: 'array', items: { type: 'array', items: { type: 'string' } } },
        error_file_path: { type: 'string' },
        error_start_marker: { type: 'string' },
        error_end_marker: { type: 'string' },
        is_decimal_org: { type: 'boolean' }
    },
    required: [
        'delimiter',
        's3_bucket',
        's3_prefix',
        'quotechar',
        'column_limit',
        'error_file_path',
        'error_start_marker',
        'error_end_marker'
    ]
};
function validate125(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:TargetConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.delimiter === undefined && (missing0 = 'delimiter')) ||
                (data.s3_bucket === undefined && (missing0 = 's3_bucket')) ||
                (data.s3_prefix === undefined && (missing0 = 's3_prefix')) ||
                (data.quotechar === undefined && (missing0 = 'quotechar')) ||
                (data.column_limit === undefined && (missing0 = 'column_limit')) ||
                (data.error_file_path === undefined && (missing0 = 'error_file_path')) ||
                (data.error_start_marker === undefined && (missing0 = 'error_start_marker')) ||
                (data.error_end_marker === undefined && (missing0 = 'error_end_marker'))) {
                validate125.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.delimiter !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.delimiter !== 'string') {
                        validate125.errors = [
                            {
                                instancePath: instancePath + '/delimiter',
                                schemaPath: '#/properties/delimiter/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.s3_bucket !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.s3_bucket !== 'string') {
                            validate125.errors = [
                                {
                                    instancePath: instancePath + '/s3_bucket',
                                    schemaPath: '#/properties/s3_bucket/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.s3_prefix !== undefined) {
                            const _errs5 = errors;
                            if (typeof data.s3_prefix !== 'string') {
                                validate125.errors = [
                                    {
                                        instancePath: instancePath + '/s3_prefix',
                                        schemaPath: '#/properties/s3_prefix/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.quotechar !== undefined) {
                                const _errs7 = errors;
                                if (typeof data.quotechar !== 'string') {
                                    validate125.errors = [
                                        {
                                            instancePath: instancePath + '/quotechar',
                                            schemaPath: '#/properties/quotechar/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.column_limit !== undefined) {
                                    const _errs9 = errors;
                                    if (!(typeof data.column_limit == 'number')) {
                                        validate125.errors = [
                                            {
                                                instancePath: instancePath + '/column_limit',
                                                schemaPath: '#/properties/column_limit/type',
                                                keyword: 'type',
                                                params: { type: 'number' },
                                                message: 'must be number'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.clean_data !== undefined) {
                                        const _errs11 = errors;
                                        if (typeof data.clean_data !== 'boolean') {
                                            validate125.errors = [
                                                {
                                                    instancePath: instancePath + '/clean_data',
                                                    schemaPath: '#/properties/clean_data/type',
                                                    keyword: 'type',
                                                    params: { type: 'boolean' },
                                                    message: 'must be boolean'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.columns_to_update !== undefined) {
                                            let data6 = data.columns_to_update;
                                            const _errs13 = errors;
                                            if (errors === _errs13) {
                                                if (data6 && typeof data6 == 'object' && !Array.isArray(data6)) {
                                                    for (const key0 in data6) {
                                                        let data7 = data6[key0];
                                                        const _errs16 = errors;
                                                        if (errors === _errs16) {
                                                            if (Array.isArray(data7)) {
                                                                var valid2 = true;
                                                                const len0 = data7.length;
                                                                for (let i0 = 0; i0 < len0; i0++) {
                                                                    let data8 = data7[i0];
                                                                    const _errs18 = errors;
                                                                    const _errs19 = errors;
                                                                    const _errs21 = errors;
                                                                    let valid4 = true;
                                                                    const _errs22 = errors;
                                                                    if (data8 && typeof data8 == 'object' && !Array.isArray(data8)) {
                                                                        if (data8.columnUpdateType !== undefined) {
                                                                            if ('modify' !== data8.columnUpdateType) {
                                                                                const err0 = {};
                                                                                if (vErrors === null) {
                                                                                    vErrors = [err0];
                                                                                }
                                                                                else {
                                                                                    vErrors.push(err0);
                                                                                }
                                                                                errors++;
                                                                            }
                                                                        }
                                                                    }
                                                                    var _valid0 = _errs22 === errors;
                                                                    errors = _errs21;
                                                                    if (vErrors !== null) {
                                                                        if (_errs21) {
                                                                            vErrors.length = _errs21;
                                                                        }
                                                                        else {
                                                                            vErrors = null;
                                                                        }
                                                                    }
                                                                    if (_valid0) {
                                                                        const _errs24 = errors;
                                                                        const _errs25 = errors;
                                                                        let valid6 = true;
                                                                        const _errs26 = errors;
                                                                        if (data8 && typeof data8 == 'object' && !Array.isArray(data8)) {
                                                                            let missing1;
                                                                            if (data8.targetType === undefined && (missing1 = 'targetType')) {
                                                                                const err1 = {};
                                                                                if (vErrors === null) {
                                                                                    vErrors = [err1];
                                                                                }
                                                                                else {
                                                                                    vErrors.push(err1);
                                                                                }
                                                                                errors++;
                                                                            }
                                                                            else {
                                                                                if (data8.targetType !== undefined) {
                                                                                    if ('date' !== data8.targetType) {
                                                                                        const err2 = {};
                                                                                        if (vErrors === null) {
                                                                                            vErrors = [err2];
                                                                                        }
                                                                                        else {
                                                                                            vErrors.push(err2);
                                                                                        }
                                                                                        errors++;
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                        var _valid1 = _errs26 === errors;
                                                                        errors = _errs25;
                                                                        if (vErrors !== null) {
                                                                            if (_errs25) {
                                                                                vErrors.length = _errs25;
                                                                            }
                                                                            else {
                                                                                vErrors = null;
                                                                            }
                                                                        }
                                                                        if (_valid1) {
                                                                            const _errs28 = errors;
                                                                            if (data8 && typeof data8 == 'object' && !Array.isArray(data8)) {
                                                                                let missing2;
                                                                                if (data8.dateFormat === undefined && (missing2 = 'dateFormat')) {
                                                                                    validate125.errors = [
                                                                                        {
                                                                                            instancePath: instancePath +
                                                                                                '/columns_to_update/' +
                                                                                                key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                '/' +
                                                                                                i0,
                                                                                            schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/then/then/required',
                                                                                            keyword: 'required',
                                                                                            params: { missingProperty: missing2 },
                                                                                            message: "must have required property '" + missing2 + "'"
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            var _valid1 = _errs28 === errors;
                                                                            valid6 = _valid1;
                                                                        }
                                                                        if (!valid6) {
                                                                            const err3 = {
                                                                                instancePath: instancePath +
                                                                                    '/columns_to_update/' +
                                                                                    key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                    '/' +
                                                                                    i0,
                                                                                schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/then/if',
                                                                                keyword: 'if',
                                                                                params: { failingKeyword: 'then' },
                                                                                message: 'must match "then" schema'
                                                                            };
                                                                            if (vErrors === null) {
                                                                                vErrors = [err3];
                                                                            }
                                                                            else {
                                                                                vErrors.push(err3);
                                                                            }
                                                                            errors++;
                                                                            validate125.errors = vErrors;
                                                                            return false;
                                                                        }
                                                                        if (errors === _errs24) {
                                                                            if (data8 && typeof data8 == 'object' && !Array.isArray(data8)) {
                                                                                let missing3;
                                                                                if ((data8.type === undefined && (missing3 = 'type')) ||
                                                                                    (data8.targetType === undefined && (missing3 = 'targetType'))) {
                                                                                    validate125.errors = [
                                                                                        {
                                                                                            instancePath: instancePath +
                                                                                                '/columns_to_update/' +
                                                                                                key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                '/' +
                                                                                                i0,
                                                                                            schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/then/required',
                                                                                            keyword: 'required',
                                                                                            params: { missingProperty: missing3 },
                                                                                            message: "must have required property '" + missing3 + "'"
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                        }
                                                                        var _valid0 = _errs24 === errors;
                                                                        valid4 = _valid0;
                                                                    }
                                                                    if (!valid4) {
                                                                        const err4 = {
                                                                            instancePath: instancePath +
                                                                                '/columns_to_update/' +
                                                                                key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                '/' +
                                                                                i0,
                                                                            schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/if',
                                                                            keyword: 'if',
                                                                            params: { failingKeyword: 'then' },
                                                                            message: 'must match "then" schema'
                                                                        };
                                                                        if (vErrors === null) {
                                                                            vErrors = [err4];
                                                                        }
                                                                        else {
                                                                            vErrors.push(err4);
                                                                        }
                                                                        errors++;
                                                                        validate125.errors = vErrors;
                                                                        return false;
                                                                    }
                                                                    if (errors === _errs19) {
                                                                        if (data8 && typeof data8 == 'object' && !Array.isArray(data8)) {
                                                                            let missing4;
                                                                            if ((data8.column === undefined && (missing4 = 'column')) ||
                                                                                (data8.columnUpdateType === undefined && (missing4 = 'columnUpdateType'))) {
                                                                                validate125.errors = [
                                                                                    {
                                                                                        instancePath: instancePath +
                                                                                            '/columns_to_update/' +
                                                                                            key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                            '/' +
                                                                                            i0,
                                                                                        schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/required',
                                                                                        keyword: 'required',
                                                                                        params: { missingProperty: missing4 },
                                                                                        message: "must have required property '" + missing4 + "'"
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            else {
                                                                                if (data8.column !== undefined) {
                                                                                    const _errs29 = errors;
                                                                                    if (typeof data8.column !== 'string') {
                                                                                        validate125.errors = [
                                                                                            {
                                                                                                instancePath: instancePath +
                                                                                                    '/columns_to_update/' +
                                                                                                    key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                    '/' +
                                                                                                    i0 +
                                                                                                    '/column',
                                                                                                schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/properties/column/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'string' },
                                                                                                message: 'must be string'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                    var valid8 = _errs29 === errors;
                                                                                }
                                                                                else {
                                                                                    var valid8 = true;
                                                                                }
                                                                                if (valid8) {
                                                                                    if (data8.columnUpdateType !== undefined) {
                                                                                        let data12 = data8.columnUpdateType;
                                                                                        const _errs31 = errors;
                                                                                        if (typeof data12 !== 'string') {
                                                                                            validate125.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath +
                                                                                                        '/columns_to_update/' +
                                                                                                        key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                        '/' +
                                                                                                        i0 +
                                                                                                        '/columnUpdateType',
                                                                                                    schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/properties/columnUpdateType/type',
                                                                                                    keyword: 'type',
                                                                                                    params: { type: 'string' },
                                                                                                    message: 'must be string'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                        if (!(data12 === 'drop' || data12 === 'mask' || data12 === 'modify')) {
                                                                                            validate125.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath +
                                                                                                        '/columns_to_update/' +
                                                                                                        key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                        '/' +
                                                                                                        i0 +
                                                                                                        '/columnUpdateType',
                                                                                                    schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/properties/columnUpdateType/enum',
                                                                                                    keyword: 'enum',
                                                                                                    params: { allowedValues: schema40.properties.columnUpdateType.enum },
                                                                                                    message: 'must be equal to one of the allowed values'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                        var valid8 = _errs31 === errors;
                                                                                    }
                                                                                    else {
                                                                                        var valid8 = true;
                                                                                    }
                                                                                    if (valid8) {
                                                                                        if (data8.type !== undefined) {
                                                                                            let data13 = data8.type;
                                                                                            const _errs33 = errors;
                                                                                            if (typeof data13 !== 'string') {
                                                                                                validate125.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath +
                                                                                                            '/columns_to_update/' +
                                                                                                            key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                            '/' +
                                                                                                            i0 +
                                                                                                            '/type',
                                                                                                        schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/properties/type/type',
                                                                                                        keyword: 'type',
                                                                                                        params: { type: 'string' },
                                                                                                        message: 'must be string'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                            if (!(data13 === 'number' ||
                                                                                                data13 === 'string' ||
                                                                                                data13 === 'boolean' ||
                                                                                                data13 === 'date' ||
                                                                                                data13 === 'decimal')) {
                                                                                                validate125.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath +
                                                                                                            '/columns_to_update/' +
                                                                                                            key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                            '/' +
                                                                                                            i0 +
                                                                                                            '/type',
                                                                                                        schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/properties/type/enum',
                                                                                                        keyword: 'enum',
                                                                                                        params: { allowedValues: schema40.properties.type.enum },
                                                                                                        message: 'must be equal to one of the allowed values'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                            var valid8 = _errs33 === errors;
                                                                                        }
                                                                                        else {
                                                                                            var valid8 = true;
                                                                                        }
                                                                                        if (valid8) {
                                                                                            if (data8.targetType !== undefined) {
                                                                                                let data14 = data8.targetType;
                                                                                                const _errs35 = errors;
                                                                                                if (typeof data14 !== 'string') {
                                                                                                    validate125.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath +
                                                                                                                '/columns_to_update/' +
                                                                                                                key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                                '/' +
                                                                                                                i0 +
                                                                                                                '/targetType',
                                                                                                            schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/properties/targetType/type',
                                                                                                            keyword: 'type',
                                                                                                            params: { type: 'string' },
                                                                                                            message: 'must be string'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                                if (!(data14 === 'number' ||
                                                                                                    data14 === 'string' ||
                                                                                                    data14 === 'boolean' ||
                                                                                                    data14 === 'date' ||
                                                                                                    data14 === 'decimal')) {
                                                                                                    validate125.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath +
                                                                                                                '/columns_to_update/' +
                                                                                                                key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                                '/' +
                                                                                                                i0 +
                                                                                                                '/targetType',
                                                                                                            schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/properties/targetType/enum',
                                                                                                            keyword: 'enum',
                                                                                                            params: { allowedValues: schema40.properties.targetType.enum },
                                                                                                            message: 'must be equal to one of the allowed values'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                                var valid8 = _errs35 === errors;
                                                                                            }
                                                                                            else {
                                                                                                var valid8 = true;
                                                                                            }
                                                                                            if (valid8) {
                                                                                                if (data8.dateFormat !== undefined) {
                                                                                                    let data15 = data8.dateFormat;
                                                                                                    const _errs37 = errors;
                                                                                                    if (errors === _errs37) {
                                                                                                        if (typeof data15 === 'string') {
                                                                                                            if (func2(data15) < 1) {
                                                                                                                validate125.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath +
                                                                                                                            '/columns_to_update/' +
                                                                                                                            key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                                            '/' +
                                                                                                                            i0 +
                                                                                                                            '/dateFormat',
                                                                                                                        schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/properties/dateFormat/minLength',
                                                                                                                        keyword: 'minLength',
                                                                                                                        params: { limit: 1 },
                                                                                                                        message: 'must NOT have fewer than 1 characters'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                        }
                                                                                                        else {
                                                                                                            validate125.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath +
                                                                                                                        '/columns_to_update/' +
                                                                                                                        key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                                        '/' +
                                                                                                                        i0 +
                                                                                                                        '/dateFormat',
                                                                                                                    schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/properties/dateFormat/type',
                                                                                                                    keyword: 'type',
                                                                                                                    params: { type: 'string' },
                                                                                                                    message: 'must be string'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                    }
                                                                                                    var valid8 = _errs37 === errors;
                                                                                                }
                                                                                                else {
                                                                                                    var valid8 = true;
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                        else {
                                                                            validate125.errors = [
                                                                                {
                                                                                    instancePath: instancePath +
                                                                                        '/columns_to_update/' +
                                                                                        key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                        '/' +
                                                                                        i0,
                                                                                    schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'object' },
                                                                                    message: 'must be object'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    var valid2 = _errs18 === errors;
                                                                    if (!valid2) {
                                                                        break;
                                                                    }
                                                                }
                                                                if (valid2) {
                                                                    let i1 = data7.length;
                                                                    let j0;
                                                                    if (i1 > 1) {
                                                                        outer0: for (; i1--;) {
                                                                            for (j0 = i1; j0--;) {
                                                                                if (func0(data7[i1], data7[j0])) {
                                                                                    validate125.errors = [
                                                                                        {
                                                                                            instancePath: instancePath +
                                                                                                '/columns_to_update/' +
                                                                                                key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                                            schemaPath: '#/properties/columns_to_update/additionalProperties/uniqueItems',
                                                                                            keyword: 'uniqueItems',
                                                                                            params: { i: i1, j: j0 },
                                                                                            message: 'must NOT have duplicate items (items ## ' +
                                                                                                j0 +
                                                                                                ' and ' +
                                                                                                i1 +
                                                                                                ' are identical)'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                    break outer0;
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                            else {
                                                                validate125.errors = [
                                                                    {
                                                                        instancePath: instancePath +
                                                                            '/columns_to_update/' +
                                                                            key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                        schemaPath: '#/properties/columns_to_update/additionalProperties/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'array' },
                                                                        message: 'must be array'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid1 = _errs16 === errors;
                                                        if (!valid1) {
                                                            break;
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate125.errors = [
                                                        {
                                                            instancePath: instancePath + '/columns_to_update',
                                                            schemaPath: '#/properties/columns_to_update/type',
                                                            keyword: 'type',
                                                            params: { type: 'object' },
                                                            message: 'must be object'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs13 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.split_index !== undefined) {
                                                let data16 = data.split_index;
                                                const _errs39 = errors;
                                                if (!(typeof data16 == 'number' && !(data16 % 1) && !isNaN(data16))) {
                                                    validate125.errors = [
                                                        {
                                                            instancePath: instancePath + '/split_index',
                                                            schemaPath: '#/properties/split_index/type',
                                                            keyword: 'type',
                                                            params: { type: 'integer' },
                                                            message: 'must be integer'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                if (errors === _errs39) {
                                                    if (typeof data16 == 'number') {
                                                        if (data16 < 0 || isNaN(data16)) {
                                                            validate125.errors = [
                                                                {
                                                                    instancePath: instancePath + '/split_index',
                                                                    schemaPath: '#/properties/split_index/minimum',
                                                                    keyword: 'minimum',
                                                                    params: { comparison: '>=', limit: 0 },
                                                                    message: 'must be >= 0'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                                var valid0 = _errs39 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (data.buffer_size !== undefined) {
                                                    let data17 = data.buffer_size;
                                                    const _errs41 = errors;
                                                    if (!(typeof data17 == 'number' && !(data17 % 1) && !isNaN(data17))) {
                                                        validate125.errors = [
                                                            {
                                                                instancePath: instancePath + '/buffer_size',
                                                                schemaPath: '#/properties/buffer_size/type',
                                                                keyword: 'type',
                                                                params: { type: 'integer' },
                                                                message: 'must be integer'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    if (errors === _errs41) {
                                                        if (typeof data17 == 'number') {
                                                            if (data17 < 1 || isNaN(data17)) {
                                                                validate125.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/buffer_size',
                                                                        schemaPath: '#/properties/buffer_size/minimum',
                                                                        keyword: 'minimum',
                                                                        params: { comparison: '>=', limit: 1 },
                                                                        message: 'must be >= 1'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                    }
                                                    var valid0 = _errs41 === errors;
                                                }
                                                else {
                                                    var valid0 = true;
                                                }
                                                if (valid0) {
                                                    if (data.generate_sample_files !== undefined) {
                                                        const _errs43 = errors;
                                                        if (typeof data.generate_sample_files !== 'boolean') {
                                                            validate125.errors = [
                                                                {
                                                                    instancePath: instancePath + '/generate_sample_files',
                                                                    schemaPath: '#/properties/generate_sample_files/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'boolean' },
                                                                    message: 'must be boolean'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid0 = _errs43 === errors;
                                                    }
                                                    else {
                                                        var valid0 = true;
                                                    }
                                                    if (valid0) {
                                                        if (data.columns_to_rename !== undefined) {
                                                            let data19 = data.columns_to_rename;
                                                            const _errs45 = errors;
                                                            if (errors === _errs45) {
                                                                if (Array.isArray(data19)) {
                                                                    var valid10 = true;
                                                                    const len1 = data19.length;
                                                                    for (let i2 = 0; i2 < len1; i2++) {
                                                                        let data20 = data19[i2];
                                                                        const _errs47 = errors;
                                                                        if (errors === _errs47) {
                                                                            if (Array.isArray(data20)) {
                                                                                var valid11 = true;
                                                                                const len2 = data20.length;
                                                                                for (let i3 = 0; i3 < len2; i3++) {
                                                                                    const _errs49 = errors;
                                                                                    if (typeof data20[i3] !== 'string') {
                                                                                        validate125.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/columns_to_rename/' + i2 + '/' + i3,
                                                                                                schemaPath: '#/properties/columns_to_rename/items/items/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'string' },
                                                                                                message: 'must be string'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                    var valid11 = _errs49 === errors;
                                                                                    if (!valid11) {
                                                                                        break;
                                                                                    }
                                                                                }
                                                                            }
                                                                            else {
                                                                                validate125.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/columns_to_rename/' + i2,
                                                                                        schemaPath: '#/properties/columns_to_rename/items/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'array' },
                                                                                        message: 'must be array'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        var valid10 = _errs47 === errors;
                                                                        if (!valid10) {
                                                                            break;
                                                                        }
                                                                    }
                                                                }
                                                                else {
                                                                    validate125.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/columns_to_rename',
                                                                            schemaPath: '#/properties/columns_to_rename/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'array' },
                                                                            message: 'must be array'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid0 = _errs45 === errors;
                                                        }
                                                        else {
                                                            var valid0 = true;
                                                        }
                                                        if (valid0) {
                                                            if (data.error_file_path !== undefined) {
                                                                const _errs51 = errors;
                                                                if (typeof data.error_file_path !== 'string') {
                                                                    validate125.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/error_file_path',
                                                                            schemaPath: '#/properties/error_file_path/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid0 = _errs51 === errors;
                                                            }
                                                            else {
                                                                var valid0 = true;
                                                            }
                                                            if (valid0) {
                                                                if (data.error_start_marker !== undefined) {
                                                                    const _errs53 = errors;
                                                                    if (typeof data.error_start_marker !== 'string') {
                                                                        validate125.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/error_start_marker',
                                                                                schemaPath: '#/properties/error_start_marker/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    var valid0 = _errs53 === errors;
                                                                }
                                                                else {
                                                                    var valid0 = true;
                                                                }
                                                                if (valid0) {
                                                                    if (data.error_end_marker !== undefined) {
                                                                        const _errs55 = errors;
                                                                        if (typeof data.error_end_marker !== 'string') {
                                                                            validate125.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/error_end_marker',
                                                                                    schemaPath: '#/properties/error_end_marker/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'string' },
                                                                                    message: 'must be string'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        var valid0 = _errs55 === errors;
                                                                    }
                                                                    else {
                                                                        var valid0 = true;
                                                                    }
                                                                    if (valid0) {
                                                                        if (data.is_decimal_org !== undefined) {
                                                                            const _errs57 = errors;
                                                                            if (typeof data.is_decimal_org !== 'boolean') {
                                                                                validate125.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/is_decimal_org',
                                                                                        schemaPath: '#/properties/is_decimal_org/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'boolean' },
                                                                                        message: 'must be boolean'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            var valid0 = _errs57 === errors;
                                                                        }
                                                                        else {
                                                                            var valid0 = true;
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate125.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate125.errors = vErrors;
    return errors === 0;
}
export const taskAuthInfoSchemaValidation = validate126;
function validate126(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-auth:TaskAuthInfo" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.orgID === undefined && (missing0 = 'orgID')) ||
                (data.userID === undefined && (missing0 = 'userID')) ||
                (data.taskID === undefined && (missing0 = 'taskID')) ||
                (data.taskAuthToken === undefined && (missing0 = 'taskAuthToken')) ||
                (data.expiration === undefined && (missing0 = 'expiration'))) {
                validate126.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.orgID !== undefined) {
                    let data0 = data.orgID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats4.test(data0)) {
                                    validate126.errors = [
                                        {
                                            instancePath: instancePath + '/orgID',
                                            schemaPath: '#/properties/orgID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate126.errors = [
                                    {
                                        instancePath: instancePath + '/orgID',
                                        schemaPath: '#/properties/orgID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.userID !== undefined) {
                        let data1 = data.userID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (errors === _errs3) {
                                if (typeof data1 === 'string') {
                                    if (!formats4.test(data1)) {
                                        validate126.errors = [
                                            {
                                                instancePath: instancePath + '/userID',
                                                schemaPath: '#/properties/userID/format',
                                                keyword: 'format',
                                                params: { format: 'uuid' },
                                                message: 'must match format "' + 'uuid' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate126.errors = [
                                        {
                                            instancePath: instancePath + '/userID',
                                            schemaPath: '#/properties/userID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.taskID !== undefined) {
                            const _errs5 = errors;
                            if (typeof data.taskID !== 'string') {
                                validate126.errors = [
                                    {
                                        instancePath: instancePath + '/taskID',
                                        schemaPath: '#/properties/taskID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.taskAuthToken !== undefined) {
                                const _errs7 = errors;
                                if (typeof data.taskAuthToken !== 'string') {
                                    validate126.errors = [
                                        {
                                            instancePath: instancePath + '/taskAuthToken',
                                            schemaPath: '#/properties/taskAuthToken/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.expiration !== undefined) {
                                    let data4 = data.expiration;
                                    const _errs9 = errors;
                                    if (!(typeof data4 == 'number' && !(data4 % 1) && !isNaN(data4))) {
                                        validate126.errors = [
                                            {
                                                instancePath: instancePath + '/expiration',
                                                schemaPath: '#/properties/expiration/type',
                                                keyword: 'type',
                                                params: { type: 'integer' },
                                                message: 'must be integer'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.endpoint !== undefined) {
                                        const _errs11 = errors;
                                        if (typeof data.endpoint !== 'string') {
                                            validate126.errors = [
                                                {
                                                    instancePath: instancePath + '/endpoint',
                                                    schemaPath: '#/properties/endpoint/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate126.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate126.errors = vErrors;
    return errors === 0;
}
export const taskInputSchemaValidation = validate127;
function validate127(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-compute-activity-domain:TaskInput" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.type === undefined && (missing0 = 'type')) ||
                (data.id === undefined && (missing0 = 'id')) ||
                (data.orgID === undefined && (missing0 = 'orgID'))) {
                validate127.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.type !== undefined) {
                    let data0 = data.type;
                    const _errs1 = errors;
                    if (typeof data0 !== 'string') {
                        validate127.errors = [
                            {
                                instancePath: instancePath + '/type',
                                schemaPath: '#/properties/type/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'spark' ||
                        data0 === 'spark-v2' ||
                        data0 === 'python' ||
                        data0 === 'python-eks' ||
                        data0 === 'stepFunction')) {
                        validate127.errors = [
                            {
                                instancePath: instancePath + '/type',
                                schemaPath: '#/properties/type/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema81.properties.type.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.id !== undefined) {
                        let data1 = data.id;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) > 200) {
                                    validate127.errors = [
                                        {
                                            instancePath: instancePath + '/id',
                                            schemaPath: '#/properties/id/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 200 },
                                            message: 'must NOT have more than 200 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (func2(data1) < 1) {
                                        validate127.errors = [
                                            {
                                                instancePath: instancePath + '/id',
                                                schemaPath: '#/properties/id/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate127.errors = [
                                    {
                                        instancePath: instancePath + '/id',
                                        schemaPath: '#/properties/id/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.orgID !== undefined) {
                            let data2 = data.orgID;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (errors === _errs5) {
                                    if (typeof data2 === 'string') {
                                        if (!formats4.test(data2)) {
                                            validate127.errors = [
                                                {
                                                    instancePath: instancePath + '/orgID',
                                                    schemaPath: '#/properties/orgID/format',
                                                    keyword: 'format',
                                                    params: { format: 'uuid' },
                                                    message: 'must match format "' + 'uuid' + '"'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate127.errors = [
                                            {
                                                instancePath: instancePath + '/orgID',
                                                schemaPath: '#/properties/orgID/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.orgPlan !== undefined) {
                                let data3 = data.orgPlan;
                                const _errs7 = errors;
                                if (typeof data3 !== 'string') {
                                    validate127.errors = [
                                        {
                                            instancePath: instancePath + '/orgPlan',
                                            schemaPath: '#/properties/orgPlan/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                if (!(data3 === 'Social' ||
                                    data3 === 'Enterprise' ||
                                    data3 === 'Integration' ||
                                    data3 === 'Temp' ||
                                    data3 === 'Starter' ||
                                    data3 === 'Professional')) {
                                    validate127.errors = [
                                        {
                                            instancePath: instancePath + '/orgPlan',
                                            schemaPath: '#/properties/orgPlan/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema81.properties.orgPlan.enum },
                                            message: 'must be equal to one of the allowed values'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.highMemory !== undefined) {
                                    const _errs9 = errors;
                                    if (typeof data.highMemory !== 'boolean') {
                                        validate127.errors = [
                                            {
                                                instancePath: instancePath + '/highMemory',
                                                schemaPath: '#/properties/highMemory/type',
                                                keyword: 'type',
                                                params: { type: 'boolean' },
                                                message: 'must be boolean'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.enableUsagesStream !== undefined) {
                                        const _errs11 = errors;
                                        if (typeof data.enableUsagesStream !== 'boolean') {
                                            validate127.errors = [
                                                {
                                                    instancePath: instancePath + '/enableUsagesStream',
                                                    schemaPath: '#/properties/enableUsagesStream/type',
                                                    keyword: 'type',
                                                    params: { type: 'boolean' },
                                                    message: 'must be boolean'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.logGroup !== undefined) {
                                            const _errs13 = errors;
                                            if (typeof data.logGroup !== 'string') {
                                                validate127.errors = [
                                                    {
                                                        instancePath: instancePath + '/logGroup',
                                                        schemaPath: '#/properties/logGroup/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid0 = _errs13 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.logStreamPrefix !== undefined) {
                                                const _errs15 = errors;
                                                if (typeof data.logStreamPrefix !== 'string') {
                                                    validate127.errors = [
                                                        {
                                                            instancePath: instancePath + '/logStreamPrefix',
                                                            schemaPath: '#/properties/logStreamPrefix/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid0 = _errs15 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate127.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate127.errors = vErrors;
    return errors === 0;
}
export const tqpImportConfigSchemaValidation = validate128;
const schema170 = {
    $id: 'urn:wisepipe-common-data:TqpImportConfig',
    type: 'object',
    properties: {
        planningCycleId: { type: 'string', minLength: 1 },
        uuid: { type: 'string', format: 'uuid' },
        delimiter: { type: 'string', minLength: 1, maxLength: 1 },
        quotechar: { type: 'string', enum: ['"', "'"] }
    },
    required: ['planningCycleId']
};
function validate128(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:TqpImportConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.planningCycleId === undefined && (missing0 = 'planningCycleId')) {
                validate128.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.planningCycleId !== undefined) {
                    let data0 = data.planningCycleId;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate128.errors = [
                                    {
                                        instancePath: instancePath + '/planningCycleId',
                                        schemaPath: '#/properties/planningCycleId/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate128.errors = [
                                {
                                    instancePath: instancePath + '/planningCycleId',
                                    schemaPath: '#/properties/planningCycleId/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.uuid !== undefined) {
                        let data1 = data.uuid;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (errors === _errs3) {
                                if (typeof data1 === 'string') {
                                    if (!formats4.test(data1)) {
                                        validate128.errors = [
                                            {
                                                instancePath: instancePath + '/uuid',
                                                schemaPath: '#/properties/uuid/format',
                                                keyword: 'format',
                                                params: { format: 'uuid' },
                                                message: 'must match format "' + 'uuid' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate128.errors = [
                                        {
                                            instancePath: instancePath + '/uuid',
                                            schemaPath: '#/properties/uuid/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.delimiter !== undefined) {
                            let data2 = data.delimiter;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) > 1) {
                                        validate128.errors = [
                                            {
                                                instancePath: instancePath + '/delimiter',
                                                schemaPath: '#/properties/delimiter/maxLength',
                                                keyword: 'maxLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have more than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        if (func2(data2) < 1) {
                                            validate128.errors = [
                                                {
                                                    instancePath: instancePath + '/delimiter',
                                                    schemaPath: '#/properties/delimiter/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                else {
                                    validate128.errors = [
                                        {
                                            instancePath: instancePath + '/delimiter',
                                            schemaPath: '#/properties/delimiter/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.quotechar !== undefined) {
                                let data3 = data.quotechar;
                                const _errs7 = errors;
                                if (typeof data3 !== 'string') {
                                    validate128.errors = [
                                        {
                                            instancePath: instancePath + '/quotechar',
                                            schemaPath: '#/properties/quotechar/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                if (!(data3 === '"' || data3 === "'")) {
                                    validate128.errors = [
                                        {
                                            instancePath: instancePath + '/quotechar',
                                            schemaPath: '#/properties/quotechar/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema170.properties.quotechar.enum },
                                            message: 'must be equal to one of the allowed values'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate128.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate128.errors = vErrors;
    return errors === 0;
}
export const unitTestSnapshotImportEventSchemaValidation = validate129;
const schema171 = {
    $id: 'urn:wisepipe-common-data:UnitTestSnapshotImportEvent',
    type: 'object',
    properties: {
        orgID: { type: 'string', format: 'uuid' },
        userID: { type: 'string', format: 'uuid' },
        unitTestID: { type: 'string', uid: 9 },
        srcFileLocation: { $ref: 'urn:wisepipe-common:S3File' },
        taskToken: { type: 'string' }
    },
    required: ['orgID', 'userID', 'unitTestID', 'srcFileLocation', 'taskToken']
};
const func426 = ucs2length;
const func427 = base64urlToBuffer;
const func428 = base64urlEncode;
const func429 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func432 = ucs2length;
const func433 = base64urlToBuffer;
const func434 = base64urlEncode;
const func435 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate129(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:UnitTestSnapshotImportEvent" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.orgID === undefined && (missing0 = 'orgID')) ||
                (data.userID === undefined && (missing0 = 'userID')) ||
                (data.unitTestID === undefined && (missing0 = 'unitTestID')) ||
                (data.srcFileLocation === undefined && (missing0 = 'srcFileLocation')) ||
                (data.taskToken === undefined && (missing0 = 'taskToken'))) {
                validate129.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.orgID !== undefined) {
                    let data0 = data.orgID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats4.test(data0)) {
                                    validate129.errors = [
                                        {
                                            instancePath: instancePath + '/orgID',
                                            schemaPath: '#/properties/orgID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate129.errors = [
                                    {
                                        instancePath: instancePath + '/orgID',
                                        schemaPath: '#/properties/orgID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.userID !== undefined) {
                        let data1 = data.userID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (errors === _errs3) {
                                if (typeof data1 === 'string') {
                                    if (!formats4.test(data1)) {
                                        validate129.errors = [
                                            {
                                                instancePath: instancePath + '/userID',
                                                schemaPath: '#/properties/userID/format',
                                                keyword: 'format',
                                                params: { format: 'uuid' },
                                                message: 'must match format "' + 'uuid' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate129.errors = [
                                        {
                                            instancePath: instancePath + '/userID',
                                            schemaPath: '#/properties/userID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.unitTestID !== undefined) {
                            let data2 = data.unitTestID;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    const b64min0 = Math.ceil((4 * 9) / 3);
                                    const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                    if (func426(data2) < b64min0 || func426(data2) > b64max0) {
                                        validate129.errors = [
                                            {
                                                instancePath: instancePath + '/unitTestID',
                                                schemaPath: '#/properties/unitTestID/uid',
                                                keyword: 'uid',
                                                params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func426(data2) },
                                                message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func426(data2)
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const decoded0 = func427(data2);
                                        if (decoded0.length !== 9) {
                                            validate129.errors = [
                                                {
                                                    instancePath: instancePath + '/unitTestID',
                                                    schemaPath: '#/properties/unitTestID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'decoded' },
                                                    message: 'must decode to 9 bytes'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const encoded0 = func428(decoded0);
                                            if (func429(encoded0) !== func429(data2)) {
                                                validate129.errors = [
                                                    {
                                                        instancePath: instancePath + '/unitTestID',
                                                        schemaPath: '#/properties/unitTestID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'ambiguous' },
                                                        message: 'encoding is ambiguous'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate129.errors = [
                                        {
                                            instancePath: instancePath + '/unitTestID',
                                            schemaPath: '#/properties/unitTestID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.srcFileLocation !== undefined) {
                                let data3 = data.srcFileLocation;
                                const _errs7 = errors;
                                const _errs8 = errors;
                                if (errors === _errs8) {
                                    if (data3 && typeof data3 == 'object' && !Array.isArray(data3)) {
                                        let missing1;
                                        if ((data3.bucket === undefined && (missing1 = 'bucket')) ||
                                            (data3.key === undefined && (missing1 = 'key'))) {
                                            validate129.errors = [
                                                {
                                                    instancePath: instancePath + '/srcFileLocation',
                                                    schemaPath: 'urn:wisepipe-common:S3File/required',
                                                    keyword: 'required',
                                                    params: { missingProperty: missing1 },
                                                    message: "must have required property '" + missing1 + "'"
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            if (data3.bucket !== undefined) {
                                                let data4 = data3.bucket;
                                                const _errs10 = errors;
                                                if (errors === _errs10) {
                                                    if (typeof data4 === 'string') {
                                                        if (func2(data4) < 1) {
                                                            validate129.errors = [
                                                                {
                                                                    instancePath: instancePath + '/srcFileLocation/bucket',
                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate129.errors = [
                                                            {
                                                                instancePath: instancePath + '/srcFileLocation/bucket',
                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid3 = _errs10 === errors;
                                            }
                                            else {
                                                var valid3 = true;
                                            }
                                            if (valid3) {
                                                if (data3.key !== undefined) {
                                                    let data5 = data3.key;
                                                    const _errs12 = errors;
                                                    if (errors === _errs12) {
                                                        if (typeof data5 === 'string') {
                                                            if (func2(data5) < 1) {
                                                                validate129.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/srcFileLocation/key',
                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                                        keyword: 'minLength',
                                                                        params: { limit: 1 },
                                                                        message: 'must NOT have fewer than 1 characters'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate129.errors = [
                                                                {
                                                                    instancePath: instancePath + '/srcFileLocation/key',
                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid3 = _errs12 === errors;
                                                }
                                                else {
                                                    var valid3 = true;
                                                }
                                                if (valid3) {
                                                    if (data3.uploadID !== undefined) {
                                                        let data6 = data3.uploadID;
                                                        const _errs14 = errors;
                                                        if (errors === _errs14) {
                                                            if (typeof data6 === 'string') {
                                                                const b64min1 = Math.ceil((4 * 9) / 3);
                                                                const b64max1 = Math.ceil((4 * 9) / 3) + 3;
                                                                if (func432(data6) < b64min1 || func432(data6) > b64max1) {
                                                                    validate129.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/srcFileLocation/uploadID',
                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                            keyword: 'uid',
                                                                            params: {
                                                                                error: 'encoded',
                                                                                b64min: b64min1,
                                                                                b64max: b64max1,
                                                                                length: func432(data6)
                                                                            },
                                                                            message: 'length must be between ' +
                                                                                b64min1 +
                                                                                ' and ' +
                                                                                b64max1 +
                                                                                ', but is ' +
                                                                                func432(data6)
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                else {
                                                                    const decoded1 = func433(data6);
                                                                    if (decoded1.length !== 9) {
                                                                        validate129.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/srcFileLocation/uploadID',
                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                keyword: 'uid',
                                                                                params: { error: 'decoded' },
                                                                                message: 'must decode to 9 bytes'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    else {
                                                                        const encoded1 = func434(decoded1);
                                                                        if (func435(encoded1) !== func435(data6)) {
                                                                            validate129.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/srcFileLocation/uploadID',
                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                    keyword: 'uid',
                                                                                    params: { error: 'ambiguous' },
                                                                                    message: 'encoding is ambiguous'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                            else {
                                                                validate129.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/srcFileLocation/uploadID',
                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid3 = _errs14 === errors;
                                                    }
                                                    else {
                                                        var valid3 = true;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate129.errors = [
                                            {
                                                instancePath: instancePath + '/srcFileLocation',
                                                schemaPath: 'urn:wisepipe-common:S3File/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.taskToken !== undefined) {
                                    const _errs16 = errors;
                                    if (typeof data.taskToken !== 'string') {
                                        validate129.errors = [
                                            {
                                                instancePath: instancePath + '/taskToken',
                                                schemaPath: '#/properties/taskToken/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs16 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate129.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate129.errors = vErrors;
    return errors === 0;
}
export const workdayImportConfigSchemaValidation = validate130;
const schema173 = { $id: 'urn:wisepipe-common-data:WorkdayImportConfig', type: 'object', properties: {}, required: [] };
function validate130(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:WorkdayImportConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate130.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate130.errors = vErrors;
    return errors === 0;
}
export const workdayRaaSImportConfigSchemaValidation = validate131;
const schema174 = {
    $id: 'urn:wisepipe-common-data:WorkdayRaaSImportConfig',
    type: 'object',
    properties: { reportUrl: { type: 'string' }, reportName: { type: 'string' } },
    required: ['reportUrl', 'reportName']
};
function validate131(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:WorkdayRaaSImportConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.reportUrl === undefined && (missing0 = 'reportUrl')) ||
                (data.reportName === undefined && (missing0 = 'reportName'))) {
                validate131.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.reportUrl !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.reportUrl !== 'string') {
                        validate131.errors = [
                            {
                                instancePath: instancePath + '/reportUrl',
                                schemaPath: '#/properties/reportUrl/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.reportName !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.reportName !== 'string') {
                            validate131.errors = [
                                {
                                    instancePath: instancePath + '/reportName',
                                    schemaPath: '#/properties/reportName/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate131.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate131.errors = vErrors;
    return errors === 0;
}
//# sourceMappingURL=validations.generated.js.map